import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Amount: { input: any; output: any; }
  BankCardPin: { input: any; output: any; }
  BigDecimal: { input: any; output: any; }
  CardNumberMasked: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Email: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  FieldSet: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  Instant: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Long: { input: any; output: any; }
  Micros: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  PositiveFloat: { input: any; output: any; }
  ReferralCode: { input: any; output: any; }
  Short: { input: any; output: any; }
  StringKey: { input: any; output: any; }
  TickerSymbol: { input: any; output: any; }
  Time: { input: any; output: any; }
  URL: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
  Void: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

/** Ability record created downstream from EFT and program user agreements */
export type Ability = {
  __typename?: 'Ability';
  abilityType: AbilityType;
  createdAt: Scalars['DateTime']['output'];
  /** Internal ability ID */
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Acorns user ID */
  userId: Scalars['ID']['output'];
};

export enum AbilityType {
  Eft = 'EFT',
  Pricing_123 = 'PRICING_123'
}

export type AcceptUploadedDocumentInput = {
  documentRequestId: Scalars['ID']['input'];
  reviewerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Acceptance documents */
export type AcceptanceDocument = {
  __typename?: 'AcceptanceDocument';
  /** The ID of the acceptance document */
  acceptanceDocumentId?: Maybe<Scalars['ID']['output']>;
  /** The URL to the default version of the acceptance document */
  defaultUrl?: Maybe<Scalars['String']['output']>;
  /** The default version of the acceptance document */
  defaultVersion?: Maybe<Scalars['String']['output']>;
  /** Type of the AcceptanceDocument */
  documentType: Scalars['String']['output'];
  /** The ID of the required acceptance document version */
  id: Scalars['ID']['output'];
  /** Indicates whether the app should force the user to scroll to the bottom before accepting */
  mustScrollToBottom?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the document */
  name: Scalars['String']['output'];
  /** A string indicating a specific app feature that the acceptance of the document is required for using */
  requiredFor?: Maybe<Scalars['String']['output']>;
  /** The name of the summary for the required version of the document */
  summaryName?: Maybe<Scalars['String']['output']>;
  /** The URL to the summary text for the required version of the document */
  summaryUrl?: Maybe<Scalars['String']['output']>;
  /** The type of document (arbitrary right now) */
  type: Scalars['String']['output'];
  /** The URL to the required version of the document */
  url?: Maybe<Scalars['String']['output']>;
  /** The required version of the document */
  version?: Maybe<Scalars['String']['output']>;
};

/** Input type for an Acceptance Document */
export type AcceptanceDocumentInput = {
  /** The type of document */
  documentType: Scalars['String']['input'];
  /** The name of the document */
  name: Scalars['String']['input'];
};

/** Acceptance document not found. */
export type AcceptanceDocumentNotFoundException = {
  __typename?: 'AcceptanceDocumentNotFoundException';
  /** Inputed acceptance document id */
  acceptanceDocumentId?: Maybe<Scalars['ID']['output']>;
};

/** An individual edge within the paginated list of AcceptanceDocumentType */
export type AcceptanceDocumentTypeEdge = {
  __typename?: 'AcceptanceDocumentTypeEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The AcceptanceDocumentType record in the edge */
  node: AcceptanceDocument;
};

/** Relay style pagination information for AcceptanceDocumentType */
export type AcceptanceDocumentTypePagination = {
  __typename?: 'AcceptanceDocumentTypePagination';
  edges: Array<AcceptanceDocumentTypeEdge>;
  pageInfo: PageInfo;
};

/** Acceptance document version */
export type AcceptanceDocumentVersion = {
  __typename?: 'AcceptanceDocumentVersion';
  /** The filters for the acceptance document version */
  filters?: Maybe<Array<AcceptanceDocumentVersionFilter>>;
  /** The ID of the acceptance document version */
  id: Scalars['ID']['output'];
  /** A boolean that indicates if the version is or not the default */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the app should force the user to scroll to the bottom before accepting */
  mustScrollToBottom?: Maybe<Scalars['Boolean']['output']>;
  /** A string indicating a specific app feature that the acceptance of the document is required for using */
  requiredFor?: Maybe<Scalars['String']['output']>;
  /** The name of the summary for the acceptance document version */
  summaryName?: Maybe<Scalars['String']['output']>;
  /** The URL to the summary of the acceptance document version */
  summaryUrl?: Maybe<Scalars['String']['output']>;
  /** The URL to the acceptance document version */
  url?: Maybe<Scalars['String']['output']>;
  /** The version of the acceptance document */
  version: Scalars['String']['output'];
};

/** Acceptance document information for admin */
export type AcceptanceDocumentVersionFilter = {
  __typename?: 'AcceptanceDocumentVersionFilter';
  id: Scalars['ID']['output'];
  /** The app feature that the acceptance of the document is required for using */
  requiredFor: Scalars['String']['output'];
};

/** Acceptance document version filter not found. */
export type AcceptanceDocumentVersionFilterNotFoundException = {
  __typename?: 'AcceptanceDocumentVersionFilterNotFoundException';
  /** Inputed acceptance document version filter id */
  acceptanceDocumentVersionFilterId?: Maybe<Scalars['ID']['output']>;
};

/** Acceptance document version not found. */
export type AcceptanceDocumentVersionNotFoundException = {
  __typename?: 'AcceptanceDocumentVersionNotFoundException';
  /** Inputed acceptance document version id */
  acceptanceDocumentVersionId?: Maybe<Scalars['ID']['output']>;
};

/** Result of acceptance documents query */
export type AcceptanceDocumentsResult = AcceptanceDocumentTypePagination;

/** Individual accounts opened by a user at Acorns */
export type Account = TimestampsInterface & {
  __typename?: 'Account';
  accountHolders: Array<Scalars['String']['output']>;
  accountId: Scalars['String']['output'];
  /** Type of account */
  accountType: AccountType;
  bankAccountType: Scalars['String']['output'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Internal ID for account creator */
  creatorId: Scalars['ID']['output'];
  customerUuid: Scalars['UUID']['output'];
  emails: Array<PlaidEmail>;
  foundingSourceType: Scalars['String']['output'];
  /** Internal ID for account */
  id: Scalars['ID']['output'];
  internalFirstName: Scalars['String']['output'];
  internalLastName: Scalars['String']['output'];
  last4AccountNumber: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  officialName: Scalars['String']['output'];
  phoneNumbers: Array<PlaidPhoneNumber>;
  plaidAddresses: Array<PlaidAddress>;
  /** Status of account */
  status: AccountStatus;
  subtype?: Maybe<Scalars['String']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An achievement/milestone for an account; also used to determine account strength */
export type AccountAchievement = {
  __typename?: 'AccountAchievement';
  /** The type of achievement */
  achievement: AchievementItem;
  /** true if the achievement has been completed */
  completed: Scalars['Boolean']['output'];
  /** The date the achievement was earned */
  dateCompleted: Scalars['DateTime']['output'];
};

/** The account provided is already closed */
export type AccountAlreadyClosedException = {
  __typename?: 'AccountAlreadyClosedException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Investment account is already closed */
export type AccountClosedException = {
  __typename?: 'AccountClosedException';
  /** message */
  errorMessage?: Maybe<Scalars['String']['output']>;
};

/** Account already has true $0.00 balance. Liquidation is not required */
export type AccountDoesNotRequireLiquidationException = {
  __typename?: 'AccountDoesNotRequireLiquidationException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type AccountMoneyAssignmentInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  targetAccountId: Scalars['String']['input'];
};

/** When investment account id doesn't match with user */
export type AccountNotFoundException = {
  __typename?: 'AccountNotFoundException';
  /** message */
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type AccountPoints = {
  __typename?: 'AccountPoints';
  /**
   * detailed explanation about how points are earned
   * @deprecated Use detailsKey field instead
   */
  details: Scalars['String']['output'];
  /** key that maps to a detailed explanation about how points are earned */
  detailsKey: Scalars['StringKey']['output'];
  earned: Scalars['Int']['output'];
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']['output'];
  /**
   * summarized explanation about how points are earned
   * @deprecated Use summaryKey field instead
   */
  summary?: Maybe<Scalars['String']['output']>;
  /** key that maps to a summarized explanation about how points are earned */
  summaryKey?: Maybe<Scalars['StringKey']['output']>;
};

export type AccountPointsRule = {
  __typename?: 'AccountPointsRule';
  /**
   * detailed explanation about how points are earned
   * @deprecated Use detailsKey field instead
   */
  details: Scalars['String']['output'];
  /** key that maps to a detailed explanation about how points are earned */
  detailsKey: Scalars['StringKey']['output'];
  milestoneID: Scalars['ID']['output'];
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']['output'];
  /**
   * summarized explanation about how points are earned
   * @deprecated Use summaryKey field instead
   */
  summary?: Maybe<Scalars['String']['output']>;
  /** key that maps to a summarized explanation about how points are earned */
  summaryKey?: Maybe<Scalars['StringKey']['output']>;
};

export type AccountRequirement = {
  __typename?: 'AccountRequirement';
  actionable: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  status: AccountRequirementStatus;
  type: AccountRequirementType;
};

export enum AccountRequirementStatus {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING'
}

export enum AccountRequirementType {
  FundingSource = 'FUNDING_SOURCE',
  Liquidated = 'LIQUIDATED',
  NoPendingInvestments = 'NO_PENDING_INVESTMENTS',
  NoTransferringDividends = 'NO_TRANSFERRING_DIVIDENDS',
  NoTransferringInvestments = 'NO_TRANSFERRING_INVESTMENTS',
  RecurringDepositsDisabled = 'RECURRING_DEPOSITS_DISABLED',
  SelfDirectedPortfolioClosed = 'SELF_DIRECTED_PORTFOLIO_CLOSED',
  VerifiedFundingSource = 'VERIFIED_FUNDING_SOURCE'
}

export type AccountRequirements = {
  __typename?: 'AccountRequirements';
  close: Array<AccountRequirement>;
};

/** reflects the user's account setup progress */
export type AccountSetupMilestones = {
  __typename?: 'AccountSetupMilestones';
  /** optional copy to provide more info */
  descriptionKey?: Maybe<Scalars['StringKey']['output']>;
  /** account setup completion progress */
  groupProgress: DiscreteMilestoneProgress;
  /** list of milestones to show in account set up widget */
  milestones: Array<Milestone>;
};

export enum AccountStatus {
  /** Account has been closed */
  Closed = 'closed',
  /** Account closure is in progress */
  Inactive = 'inactive',
  /** Open account ready for use */
  Open = 'open',
  /** Account is in process of being opened or verified */
  Pending = 'pending'
}

/** A collection of account strength achievements */
export type AccountStrengthResult = {
  __typename?: 'AccountStrengthResult';
  /** A list of achievements */
  achievements: Array<AccountAchievement>;
  /** The percent of all achievements that are earned */
  percentage: Scalars['Float']['output'];
};

export enum AccountType {
  /** Core basic investment account */
  Basic = 'basic',
  /** Spend LSB checking account */
  Checking = 'checking',
  /** Later ROTH IRA account */
  RothIra = 'rothIra',
  /** Later SEP IRA account */
  SepIra = 'sepIra',
  /** Later traditional IRA account */
  TraditionalIra = 'traditionalIra',
  /** Uniform Gift to Minors Act */
  Ugma = 'ugma',
  /** Uniform Transfers to Minors Act */
  Utma = 'utma'
}

/** Account values over the reporting period */
export type AccountValue = {
  __typename?: 'AccountValue';
  /** The dollar amount of the account's balance */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The time of the associated account value */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export enum AccountVerificationIssueFilter {
  Address = 'ADDRESS',
  AddressFailOnly = 'ADDRESS_FAIL_ONLY',
  Deceased = 'DECEASED',
  Dob = 'DOB',
  LastName = 'LAST_NAME',
  PiOnly = 'PI_ONLY',
  Ssn = 'SSN',
  Watchlist = 'WATCHLIST'
}

/** Account Verification Item */
export type AccountVerificationItem = {
  __typename?: 'AccountVerificationItem';
  /** Full Residencial Address */
  address?: Maybe<Scalars['String']['output']>;
  identityVerificationResponses?: Maybe<Array<LegacyIdentityVerificationResponse>>;
  investmentAccounts?: Maybe<Array<InvestmentAccount>>;
  legacyUser?: Maybe<LegacyUser>;
};

export enum AccountVerificationPreApprovalFilter {
  Expedited = 'EXPEDITED',
  Regular = 'REGULAR'
}

/** Account Verification Queue Input */
export type AccountVerificationQueueFilterInput = {
  brokerDealerOrBackupWithHolding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Account Verification Issue Filter */
  issue?: InputMaybe<Array<AccountVerificationIssueFilter>>;
  /** Account Verification Pre Approval Filter */
  preApproval?: InputMaybe<Array<AccountVerificationPreApprovalFilter>>;
  /** Waiting Pre Approval Provider */
  provider?: InputMaybe<Array<WaitingPreApprovalProvider>>;
  /** Account Result Filter */
  result?: InputMaybe<Array<AccountVerificationResultFilter>>;
};

/** Account Verification Queue Input */
export type AccountVerificationQueueInput = {
  /** Account Verification Queue Input */
  filterInput?: InputMaybe<AccountVerificationQueueFilterInput>;
  /** Page request */
  page: Scalars['Int']['input'];
  /** Items per page */
  perPage: Scalars['Int']['input'];
  /** Account Verification Name */
  queue: AccountVerificationQueueName;
};

export enum AccountVerificationQueueName {
  /** Investment New Account */
  NewAccounts = 'NEW_ACCOUNTS',
  /** Investment approved */
  WaitingForPreapproval = 'WAITING_FOR_PREAPPROVAL',
  /** Investment pending authorization */
  Watchlist = 'WATCHLIST'
}

/** Account Verification Queue Response including list counter */
export type AccountVerificationQueueResponse = {
  __typename?: 'AccountVerificationQueueResponse';
  accountVerificationItems: Array<AccountVerificationItem>;
  counter: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
};

export enum AccountVerificationResultFilter {
  Fail = 'FAIL',
  Pass = 'PASS',
  Review = 'REVIEW'
}

export enum AchievementItem {
  /** String value for the achievement of account value greater than or equal to 10 */
  AccountValueGte10 = 'accountValueGte10',
  /** String value for the achievement of account value greater than or equal to 100 */
  AccountValueGte100 = 'accountValueGte100',
  /** String value for the achievement of having a recurring investment */
  AutomaticInvestmentOn = 'automaticInvestmentOn',
  /** String value for the achievement of automatic roundups enabled */
  AutomaticRoundupsOn = 'automaticRoundupsOn',
  /** String value for the achievement of funding source linked */
  FundingSourceLinked = 'fundingSourceLinked',
  /** String value for the achievement of multiple roundup accounts linked */
  MultipleRoundupAccountsLinked = 'multipleRoundupAccountsLinked',
  /** String value for the achievement of being marked as registration complete */
  RegistrationComplete = 'registrationComplete',
  /** String value for the achievement of round up accounts linked */
  RoundupAccountLinked = 'roundupAccountLinked'
}

export type AcornsEarlyUserDetails = {
  __typename?: 'AcornsEarlyUserDetails';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  credentialsExist: Scalars['Boolean']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Returned when there is negative values in allocations. */
export type AcornsValidationError = {
  __typename?: 'AcornsValidationError';
  message: Scalars['String']['output'];
};

export enum ActionOptions {
  Close = 'CLOSE',
  Lock = 'LOCK',
  MrdcReject = 'MRDC_REJECT',
  Pass = 'PASS'
}

export type ActivateOauthAppClientResult = OauthAppClient | OauthAppClientNotFoundException;

export type ActivateOauthAppResult = OauthApp | OauthAppNotFoundException;

export type ActiveReferralCampaignOutput = {
  __typename?: 'ActiveReferralCampaignOutput';
  campaigns: Array<Maybe<ReferralCampaignV2>>;
};

export type AddBankCustomerIdToAccountsError = {
  __typename?: 'AddBankCustomerIdToAccountsError';
  failureMessage: Scalars['String']['output'];
};

export type AddBankCustomerIdToAccountsInput = {
  userId: Scalars['ID']['input'];
};

export type AddBankCustomerIdToAccountsResult = AddBankCustomerIdToAccountsError | AddBankCustomerIdToAccountsSuccess;

export type AddBankCustomerIdToAccountsSuccess = {
  __typename?: 'AddBankCustomerIdToAccountsSuccess';
  userId: Scalars['ID']['output'];
};

export type AddDocumentUrlsInput = {
  documentRequestId: Scalars['ID']['input'];
  documents: Array<DocumentInput>;
  userId: Scalars['ID']['input'];
};

/** Bundle of user id and note for use in adding a note from backend */
export type AddNoteInput = {
  /** Body of note to add for user */
  body: Scalars['String']['input'];
  /** Categories to help admin user classify user notes */
  category?: InputMaybe<UserNoteCategories>;
  /** Title of note to add for user */
  title: Scalars['String']['input'];
  /** User id to add note to */
  userId: Scalars['ID']['input'];
};

/** Bundle of user id and note for use in adding a note from backend */
export type AddNoteMultipleUsersInput = {
  /** Body of note to add for user */
  body: Scalars['String']['input'];
  /** Categories to help admin user classify user notes */
  category?: InputMaybe<UserNoteCategories>;
  /** Title of note to add for user */
  title: Scalars['String']['input'];
  /** User ids to add notes to */
  userIds: Array<Scalars['ID']['input']>;
};

/** Response from document request */
export type AddNoteMultipleUsersResponse = {
  __typename?: 'AddNoteMultipleUsersResponse';
  body: Scalars['String']['output'];
  category?: Maybe<UserNoteCategories>;
  title: Scalars['String']['output'];
  userIds: Array<Scalars['ID']['output']>;
};

/** Response from document request */
export type AddNoteResponse = UserNotFoundException | UserNote;

export type AddOrRemoveUsersFromSpendWhitelistInput = {
  forceOpen?: InputMaybe<Scalars['Boolean']['input']>;
  shouldWhitelist: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
  whitelistType: SpendUserWhitelistType;
};

export type AddOrRemoveUsersFromSpendWhitelistPayload = {
  __typename?: 'AddOrRemoveUsersFromSpendWhitelistPayload';
  requestId: Scalars['ID']['output'];
};

export type AddPolicyInput = {
  name: Scalars['String']['input'];
};

export type AddPolicyResult = AddPolicySuccess | PoliciesRecordDoesNotExistException | PolicyNotAddedException;

export type AddPolicySuccess = {
  __typename?: 'AddPolicySuccess';
  policies?: Maybe<Array<Maybe<Policy>>>;
};

/** Failure for all Securities */
export type AddSecuritiesFailed = {
  __typename?: 'AddSecuritiesFailed';
  description: Scalars['String']['output'];
};

export type AddSecuritiesInput = {
  active: Scalars['Boolean']['input'];
  searchable: Scalars['Boolean']['input'];
  securitiesToAdd: Array<Scalars['TickerSymbol']['input']>;
};

export type AddSecuritiesResult = AddSecuritiesFailed | AddSecurityResults;

/** Failure for an individual Security */
export type AddSecurityFailed = {
  __typename?: 'AddSecurityFailed';
  description: Scalars['String']['output'];
};

export type AddSecurityResult = AddSecurityFailed | Fund | Stock;

export type AddSecurityResults = {
  __typename?: 'AddSecurityResults';
  results: Array<AddSecurityResult>;
};

/** Miscellaneous attributes and information about a user's address */
export type Address = TimestampsInterface & {
  __typename?: 'Address';
  /** Type of address */
  addressType: AddressType;
  /** City */
  city: Scalars['String']['output'];
  /** Country */
  country: Scalars['String']['output'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Internal ID for address */
  id: Scalars['ID']['output'];
  /** State */
  state: Scalars['String']['output'];
  /** First street address */
  street1: Scalars['String']['output'];
  /** Second street address */
  street2?: Maybe<Scalars['String']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Internal ID for user */
  userId: Scalars['ID']['output'];
  /** Address has been verified */
  verified: Scalars['Boolean']['output'];
  /** Zip code */
  zipCode: Scalars['String']['output'];
};

/** Address Document Requested Alert. */
export type AddressDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'AddressDocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

/** Changeable attributes for addresses */
export type AddressInput = {
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Street 1 */
  street1?: InputMaybe<Scalars['String']['input']>;
  /** Street 2 */
  street2?: InputMaybe<Scalars['String']['input']>;
  /** Zip code */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum AddressType {
  /** A billing address */
  Billing = 'billing',
  /** A mailing address */
  Mailing = 'mailing',
  /** A residential address */
  Residential = 'residential'
}

export type AddressVerification = {
  verificationStatus: VerificationStatus;
};

export type AdminActionDataEntity = {
  __typename?: 'AdminActionDataEntity';
  action?: Maybe<ActionOptions>;
  adminUserUuid?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  opsCodesUuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AdminActionError = {
  __typename?: 'AdminActionError';
  depositModelUuid: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  retryable: Scalars['Boolean']['output'];
};

export type AdminActionErrorActionAlreadyTaken = {
  __typename?: 'AdminActionErrorActionAlreadyTaken';
  adminActionUuid: Scalars['String']['output'];
  depositModelUuid: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type AdminActionErrorDepositModelNotFound = {
  __typename?: 'AdminActionErrorDepositModelNotFound';
  depositModelUuid: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type AdminActionInput = {
  depositModelUuid: Scalars['String']['input'];
  opsCodeUuids: Array<Scalars['String']['input']>;
};

export type AdminActionNoteInput = {
  body: Scalars['String']['input'];
  category?: InputMaybe<UserNoteCategories>;
  title: Scalars['String']['input'];
};

export type AdminActionResponse = AdminActionError | AdminActionErrorActionAlreadyTaken | AdminActionErrorDepositModelNotFound | AdminActionSuccess;

export type AdminActionSuccess = {
  __typename?: 'AdminActionSuccess';
  depositModels: Array<DepositModelDataEntity>;
};

export type AdminApp = {
  __typename?: 'AdminApp';
  name: Scalars['String']['output'];
  rootPath: Scalars['String']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AdminAppInput = {
  appName: Scalars['String']['input'];
};

export type AdminAppsInput = {
  roleNames: Array<Scalars['String']['input']>;
};

/** When an admin user with the provided id is not found */
export type AdminUserNotFound = {
  __typename?: 'AdminUserNotFound';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** An existing Acorns user that has referred friends to Acorns */
export type Advocate = {
  __typename?: 'Advocate';
  /** User's current eligible campaign */
  campaign?: Maybe<ReferralCampaignV2>;
  /** The content that supports and drives the user experience */
  experienceContent?: Maybe<ExperienceContent>;
  /**
   * A list of people that have used the advocate's share link
   * @deprecated No longer supported
   */
  friends?: Maybe<Array<Friend>>;
  /** The referral code associated with the advocate */
  referralCodes?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * An object with referral metrics for the advocate
   * @deprecated No longer supported
   */
  referralHistory?: Maybe<ReferralHistory>;
  /** UUID of the existing Acorns user */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** List of referral codes and friends that were referred by an existing Acorns user */
export type AdvocateFriendsStatuses = {
  __typename?: 'AdvocateFriendsStatuses';
  /** A list of people that have used the advocate's share link */
  friends?: Maybe<Array<Friend>>;
  /** The referral codes associated with the advocate */
  referralCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** User ID of the advocate */
  userId: Scalars['ID']['output'];
};

export type AdvocateV2 = {
  __typename?: 'AdvocateV2';
  userId?: Maybe<Scalars['ID']['output']>;
};

/** A card type for the action feed alert card. */
export type AlertCard = TimestampsInterface & {
  __typename?: 'AlertCard';
  /** The context of the card */
  context?: Maybe<Scalars['String']['output']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** The type of the card */
  type?: Maybe<Scalars['String']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Response from beneficiary alert hub alerts query */
export type AlertHubBeneficiaryAlert = MissingSsnBeneficiaryAlertItem | UnverifiedBeneficiarySsnAlertItem;

export type AlertMessage = Message & {
  __typename?: 'AlertMessage';
  body: MessageTextAsset;
  createdAt: Scalars['DateTime']['output'];
  deepLink?: Maybe<Scalars['URL']['output']>;
  externalId: Scalars['ID']['output'];
  icon?: Maybe<MessageVisualAsset>;
  id: Scalars['ID']['output'];
  isDismissed: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  messageCategory: MessageCategory;
  messageType: MessageType;
  platforms: Array<Platform>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  title: MessageTextAsset;
  trackingId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AllBankCardsFilter = {
  showNonActive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the allCheckPayments query */
export type AllCheckPaymentsResult = AuthorizationError | CheckPaymentConnection;

export type AllPastSpendItemsSchemaFilter = {
  pending?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AllSupportArticlesFilterInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Returned when the allocation amounts add up to over 100 */
export type AllocationAmountsSumExceedingMaxError = {
  __typename?: 'AllocationAmountsSumExceedingMaxError';
  message: Scalars['String']['output'];
};

export type AlreadyInReviewError = {
  __typename?: 'AlreadyInReviewError';
  depositModelUuid: Scalars['String']['output'];
};

export type AnswerChallengeResult = AnswerChallengeSuccess | AuthChallengeAnswerAttemptsExhaustedException | AuthChallengeAnswerIncorrectException | AuthChallengeExpiredException;

export type AnswerChallengeSuccess = {
  __typename?: 'AnswerChallengeSuccess';
  authenticatorId: Scalars['ID']['output'];
  deliveryType: ChallengeDeliveryType;
  userId: Scalars['ID']['output'];
};

export type ApplyPromoCodeResult = InvalidPromoCodeError | PromoCodeCustomer;

export type ApplyPromotionInput = {
  promotionId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type ApplyPromotionResult = PromotionConsumedError | PromotionExpiredError | PromotionNotFoundError | SubscriberIneligibleError | TierSubscription;

export type ApplyPromotionalWaiverInput = {
  monthsToWaive: Scalars['Int']['input'];
  promotion: WaiverPromotion_V2;
};

export type ApplyPromotionalWaiverResult = InvalidDateException | InvalidUserIdException | PromotionalWaiver_V2 | WaiverCreationException;

export type ApplyProvisionalWaiverResult = InvalidDateException | InvalidUserIdException | ProvisionalWaiver_V2 | WaiverCreationException;

/** Approve investment input type. */
export type ApproveInvestmentInput = {
  /** ID of the investment to approve. */
  investmentId: Scalars['ID']['input'];
};

export type ArchiveBankCardByCardIdInput = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ArchiveBankCardByCardIdPayload = {
  __typename?: 'ArchiveBankCardByCardIdPayload';
  id?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ArchiveBankCardInput = {
  userId: Scalars['ID']['input'];
};

export type ArchiveBankCardPayload = {
  __typename?: 'ArchiveBankCardPayload';
  id?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ArchiveCoreproCustomerInput = {
  archiveReason?: InputMaybe<ArchiveCoreproCustomerReason>;
  bankType: BankType;
  userId: Scalars['ID']['input'];
};

export type ArchiveCoreproCustomerPayload = {
  __typename?: 'ArchiveCoreproCustomerPayload';
  userId: Scalars['ID']['output'];
};

export enum ArchiveCoreproCustomerReason {
  AccountTakeoverFraud = 'AccountTakeoverFraud',
  BankDiscretion = 'BankDiscretion',
  FirstPartyFraud = 'FirstPartyFraud',
  NonActivity = 'NonActivity',
  Other = 'Other',
  SyntheticIdFraud = 'SyntheticIdFraud',
  ThirdPartyFraud = 'ThirdPartyFraud'
}

export type AssignAdminAppsInput = {
  appNames: Array<Scalars['String']['input']>;
  roleName: Scalars['String']['input'];
};

export type AssignAdminAppsResult = {
  __typename?: 'AssignAdminAppsResult';
  apps: Array<Scalars['String']['output']>;
};

/**  Type to represent the origin of a change in an audit log */
export type AuditLogChangeOrigin = {
  __typename?: 'AuditLogChangeOrigin';
  changedById?: Maybe<Scalars['String']['output']>;
  changedByType?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedByService?: Maybe<Scalars['String']['output']>;
};

/**  Type to represent a field change in an audit log */
export type AuditLogFieldChange = {
  __typename?: 'AuditLogFieldChange';
  field: Scalars['String']['output'];
  newValue: Scalars['String']['output'];
  oldValue: Scalars['String']['output'];
};

/**  Custom input type for filtering audit logs */
export type AuditLogFilterInput = {
  changedAtEnd?: InputMaybe<Scalars['String']['input']>;
  changedAtStart?: InputMaybe<Scalars['String']['input']>;
  entityCategory?: InputMaybe<Scalars['String']['input']>;
  fieldsChanged?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  relatedEntityId?: InputMaybe<Scalars['String']['input']>;
};

/**  AuditLogModel type */
export type AuditLogModel = {
  __typename?: 'AuditLogModel';
  /**  List of field change objects */
  changeOrigin?: Maybe<AuditLogChangeOrigin>;
  changedAt: Scalars['String']['output'];
  entityCategory: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  fieldsChanged: Array<AuditLogFieldChange>;
  id: Scalars['ID']['output'];
  /**  Object representing change origin details */
  metadata?: Maybe<Array<MetadataEntry>>;
  relatedEntityId?: Maybe<Scalars['String']['output']>;
  relatedEntityType?: Maybe<Scalars['String']['output']>;
};

export type AuthAlert = {
  type: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type AuthChallenge = {
  alternateAuthenticators: Array<AuthenticatorInfo>;
  challengeTrigger: ChallengeTriggers;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AuthChallengeAnswerAttemptsExhaustedException = {
  __typename?: 'AuthChallengeAnswerAttemptsExhaustedException';
  message?: Maybe<Scalars['String']['output']>;
};

export type AuthChallengeAnswerIncorrectException = {
  __typename?: 'AuthChallengeAnswerIncorrectException';
  message?: Maybe<Scalars['String']['output']>;
};

export type AuthChallengeExpiredException = {
  __typename?: 'AuthChallengeExpiredException';
  message?: Maybe<Scalars['String']['output']>;
};

export type AuthProfile = {
  __typename?: 'AuthProfile';
  /** the Authenticator that will be used for challenges by default. */
  defaultAuthenticator?: Maybe<Authenticator>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  loginAccess?: Maybe<LoginAccess>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  privateRelayUnverified?: Maybe<Scalars['Boolean']['output']>;
  requireLoginChallenge?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['ID']['output'];
};

export type AuthProfileAlreadyExistsException = {
  __typename?: 'AuthProfileAlreadyExistsException';
  message?: Maybe<Scalars['String']['output']>;
};

export type AuthProfileNotFoundException = {
  __typename?: 'AuthProfileNotFoundException';
  userId: Scalars['ID']['output'];
};

export type AuthSession = {
  __typename?: 'AuthSession';
  id: Scalars['ID']['output'];
  identityId: Scalars['ID']['output'];
  /** @deprecated No longer used */
  redirectUrl?: Maybe<Scalars['URL']['output']>;
  refreshToken?: Maybe<Scalars['ID']['output']>;
  token: Scalars['ID']['output'];
};

export type AuthTokenNotFoundException = {
  __typename?: 'AuthTokenNotFoundException';
  userId: Scalars['ID']['output'];
};

export enum AuthType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Push = 'PUSH'
}

export type AuthenticateForFeeNegotiationChallengeInput = {
  linkedAccountId: Scalars['ID']['input'];
  tfaInput: Scalars['String']['input'];
};

export type AuthenticateForFeeNegotiationChallengeMethodInput = {
  linkedAccountId: Scalars['ID']['input'];
  restart: Scalars['Boolean']['input'];
  tfaOption: Scalars['String']['input'];
  tfaType: TfaType;
};

export type AuthenticateForFeeNegotiationInput = {
  bankName: BankName;
  linkedAccountId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  reconnect: Scalars['Boolean']['input'];
  userName: Scalars['String']['input'];
};

export type AuthenticateForFeeNegotiationResult = AuthenticateForFeeNegotiationStatus | LinkedAccountNotFound | NegotiationServiceConnectionFailure;

export type AuthenticateForFeeNegotiationStatus = {
  __typename?: 'AuthenticateForFeeNegotiationStatus';
  credentialStatus: CredentialStatus;
  operationError?: Maybe<AutomationError>;
  operationStage: OperationStage;
  tfaMethod?: Maybe<Scalars['String']['output']>;
  tfaOptions?: Maybe<TfaOptions>;
  tfaStatus: TfaStatus;
  tfaType: TfaType;
};

export type AuthenticateInput = {
  email: Scalars['EmailAddress']['input'];
  password: Scalars['String']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  udid: Scalars['String']['input'];
};

export type AuthenticateNegotiationStatusResult = AuthenticateForFeeNegotiationStatus | LinkedAccountNotFound;

export type AuthenticateResult = AuthChallengeAnswerAttemptsExhaustedException | AuthChallengeAnswerIncorrectException | AuthChallengeExpiredException | AuthSession | AuthenticatorTypeAlreadyRegisteredException | AuthenticatorUnavailableException | ChallengeRateExceededException | DeviceBlockedException | EmailAuthChallenge | InvalidCredentialsException | LoginRateLimitedException | PhoneNumberOptedOutException | SmsAuthChallenge | UserLockedException | UserSuspendedException;

export type AuthenticationAlreadyUpgradedException = {
  __typename?: 'AuthenticationAlreadyUpgradedException';
  userId: Scalars['ID']['output'];
};

export type Authenticator = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastAuthenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  type: AuthType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AuthenticatorAlreadyDefaultException = {
  __typename?: 'AuthenticatorAlreadyDefaultException';
  message?: Maybe<Scalars['String']['output']>;
};

export type AuthenticatorInfo = {
  __typename?: 'AuthenticatorInfo';
  id: Scalars['ID']['output'];
  type: AuthType;
};

export type AuthenticatorNotFoundException = {
  __typename?: 'AuthenticatorNotFoundException';
  message?: Maybe<Scalars['String']['output']>;
};

export type AuthenticatorTypeAlreadyRegisteredException = {
  __typename?: 'AuthenticatorTypeAlreadyRegisteredException';
  message?: Maybe<Scalars['String']['output']>;
};

export type AuthenticatorUnavailableException = {
  __typename?: 'AuthenticatorUnavailableException';
  message?: Maybe<Scalars['String']['output']>;
};

export type AuthorizationError = {
  __typename?: 'AuthorizationError';
  requestId: Scalars['ID']['output'];
};

/** Auto Invest Changes Type */
export type AutoInvestChange = {
  __typename?: 'AutoInvestChange';
  autoInvestAmount?: Maybe<Scalars['String']['output']>;
  autoInvestAmountPreviousAmount?: Maybe<Scalars['String']['output']>;
  autoInvestFrequency?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  nextAutoInvestmentDate?: Maybe<Scalars['String']['output']>;
  objectChanges: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** An individual edge within the paginated list of AutoInvestChange */
export type AutoInvestChangeEdge = {
  __typename?: 'AutoInvestChangeEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The AutoInvestChange record in the edge */
  node: AutoInvestChange;
};

/** Relay style pagination information for AutoInvestChange */
export type AutoInvestChangePagination = {
  __typename?: 'AutoInvestChangePagination';
  edges: Array<AutoInvestChangeEdge>;
  pageInfo: PageInfo;
};

export type AutomationError = {
  __typename?: 'AutomationError';
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<AutomationErrorCode>;
};

export enum AutomationErrorCode {
  CttEx = 'CTT_EX',
  LogBlk = 'LOG_BLK',
  LogEx = 'LOG_EX',
  LogInv = 'LOG_INV',
  SttEx = 'STT_EX',
  SttRes = 'STT_RES',
  TfaInv = 'TFA_INV',
  TfaSelInv = 'TFA_SEL_INV',
  WfTfa = 'WF_TFA'
}

export type BackendJobBatch = {
  __typename?: 'BackendJobBatch';
  createdAt: Scalars['DateTime']['output'];
  failedJobs?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pendingJobs?: Maybe<Scalars['Int']['output']>;
  pendingPercentage?: Maybe<Scalars['Float']['output']>;
  processedJobs?: Maybe<Scalars['Int']['output']>;
  status: BackendJobBatchStatus;
  successPercentage?: Maybe<Scalars['Float']['output']>;
  totalJobs?: Maybe<Scalars['Int']['output']>;
  type: BackendJobBatchType;
};

export type BackendJobBatchAutomatedOrdersFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>;
  timeframe: BackendJobBatchTimeframe;
};

export type BackendJobBatchMoneyMovementFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>;
  timeframe: BackendJobBatchTimeframe;
};

export type BackendJobBatchOrdersFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>;
  timeframe: BackendJobBatchTimeframe;
};

export type BackendJobBatchProfitStarsFilterInput = {
  timeframe: BackendJobBatchTimeframe;
};

export enum BackendJobBatchStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Restarted = 'RESTARTED',
  Started = 'STARTED'
}

export type BackendJobBatchSummary = {
  __typename?: 'BackendJobBatchSummary';
  createdAt: Scalars['DateTime']['output'];
  customerCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  totalHoldingsAmount?: Maybe<Scalars['Float']['output']>;
  totalInvestmentAmount?: Maybe<Scalars['Float']['output']>;
  totalInvestmentCount?: Maybe<Scalars['Int']['output']>;
};

export type BackendJobBatchSummaryFilterInput = {
  jobBatchType: BackendJobBatchType;
  timeframe: BackendJobBatchTimeframe;
};

export enum BackendJobBatchTimeframe {
  LastSeven = 'LAST_SEVEN',
  LastThirty = 'LAST_THIRTY',
  Month = 'MONTH',
  Today = 'TODAY',
  Year = 'YEAR',
  Yesterday = 'YESTERDAY'
}

export enum BackendJobBatchType {
  AutomatedBuyOrderConfirm = 'AUTOMATED_BUY_ORDER_CONFIRM',
  AutomatedBuyOrderLock = 'AUTOMATED_BUY_ORDER_LOCK',
  AutomatedSellFeeOrderConfirm = 'AUTOMATED_SELL_FEE_ORDER_CONFIRM',
  AutomatedSellFeeOrderLock = 'AUTOMATED_SELL_FEE_ORDER_LOCK',
  BuyOrderConfirm = 'BUY_ORDER_CONFIRM',
  BuyOrderLock = 'BUY_ORDER_LOCK',
  ChargebackOrderLock = 'CHARGEBACK_ORDER_LOCK',
  ProfitStarsDeposits = 'PROFIT_STARS_DEPOSITS',
  RebalanceBuyOrderConfirm = 'REBALANCE_BUY_ORDER_CONFIRM',
  RebalanceBuyOrderLock = 'REBALANCE_BUY_ORDER_LOCK',
  RebalanceSellOrderConfirm = 'REBALANCE_SELL_ORDER_CONFIRM',
  RebalanceSellOrderLock = 'REBALANCE_SELL_ORDER_LOCK',
  SellFeeOrderConfirm = 'SELL_FEE_ORDER_CONFIRM',
  SellFeeOrderLock = 'SELL_FEE_ORDER_LOCK',
  TransferApproval = 'TRANSFER_APPROVAL'
}

/** Request either has missing or incorrect data */
export type BadRequestError = {
  __typename?: 'BadRequestError';
  message: Scalars['String']['output'];
};

export enum BadgeCategory {
  NewCustomer = 'NEW_CUSTOMER',
  Travel = 'TRAVEL'
}

export type BankAccount = {
  __typename?: 'BankAccount';
  accountHolderReferenceId: Scalars['ID']['output'];
  /** The name of the account */
  accountName: Scalars['String']['output'];
  /**
   * Balance available for immediate withdrawal.
   *
   * Settling a transaction for a DDA account will typically credit the
   * availableBalance immediately. However, savings or FBO accounts may have
   * a "deposit hold time" or a "new customer hold time", meaning there could be
   * a length of time between when the transaction is settled and the corresponding
   * funds are made available for withdrawal.
   */
  availableBalance: CurrencyAmount;
  availableBalanceAndIncomingBalance: CurrencyAmount;
  balance: CurrencyAmount;
  /** The bank that this account is associated with */
  bankType: BankType;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * The interest rates that are currently being offered
   * @deprecated Use bankInterestRates Query to get apy
   */
  currentAPY?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use balance */
  currentBalance: CurrencyAmount;
  /** Information related to the goals of the bank account */
  goals: BankAccountGoals;
  id: Scalars['ID']['output'];
  isEligible: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  /**
   * True if an account closure has been initiated but
   * was unsuccessful in automatically closing.
   */
  isPendingClosure?: Maybe<Scalars['Boolean']['output']>;
  lockReason?: Maybe<BankAccountLockReason>;
  number: Scalars['String']['output'];
  /**
   * Balance of pending deposit transactions. When a pending deposit transaction
   * settles, it will debit this balance. Deposit transactions which settle
   * immediately will never affect this balance.
   */
  pendingBalance: CurrencyAmount;
  referenceId: Scalars['ID']['output'];
  /**
   * The current status of the account and requirements
   * needed to be met to close the account
   */
  requirements: BankAccountRequirements;
  routingNumber: Scalars['String']['output'];
  status: BankAccountStatus;
  /**
   * Total balance of account, including funds that have holds placed on them. Represents all settled
   * transactions on the account to date. Balance of pending deposit transactions. When a pending deposit transaction settles, it will
   * debit this balance. Deposit transactions which settle immediately will never affect this
   * balance.
   */
  totalBalance: CurrencyAmount;
  type: BankAccountType;
  updatedAt: Scalars['DateTime']['output'];
};

export type BankAccountGoal = {
  __typename?: 'BankAccountGoal';
  amount: CurrencyAmount;
  name: Scalars['String']['output'];
  type: BankAccountGoalType;
};

export type BankAccountGoalInput = {
  amount: PositiveCurrencyAmountInput;
  type: BankAccountGoalType;
};

export enum BankAccountGoalType {
  EmergencySavings = 'EMERGENCY_SAVINGS'
}

export type BankAccountGoals = {
  __typename?: 'BankAccountGoals';
  currentGoal?: Maybe<BankAccountGoal>;
};

export enum BankAccountLockReason {
  Administrative = 'Administrative',
  CreditsOnly = 'CreditsOnly',
  Fraud = 'Fraud',
  Frozen = 'Frozen',
  Temporary = 'Temporary',
  Unknown = 'Unknown'
}

/**
 * Defines a list of requirements that must be met before a bank account
 * can be closed
 */
export type BankAccountRequirement = {
  __typename?: 'BankAccountRequirement';
  actionable: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  status: BankAccountRequirementStatus;
  type: BankAccountRequirementType;
};

export enum BankAccountRequirementStatus {
  ActionsRequired = 'ACTIONS_REQUIRED',
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING'
}

export enum BankAccountRequirementType {
  FundingSource = 'FUNDING_SOURCE',
  NoPendingTransfers = 'NO_PENDING_TRANSFERS',
  UnlockedCheckingAccount = 'UNLOCKED_CHECKING_ACCOUNT',
  VerifiedFundingSource = 'VERIFIED_FUNDING_SOURCE'
}

export type BankAccountRequirements = {
  __typename?: 'BankAccountRequirements';
  close: Array<BankAccountRequirement>;
};

export type BankAccountState = {
  __typename?: 'BankAccountState';
  accountType: BankAccountType;
  status: BankAccountStateStatus;
};

export type BankAccountStateResult = {
  __typename?: 'BankAccountStateResult';
  accounts: Array<BankAccountState>;
};

export enum BankAccountStateStatus {
  Closed = 'CLOSED',
  HardFailure = 'HARD_FAILURE',
  Locked = 'LOCKED',
  NotOpened = 'NOT_OPENED',
  Open = 'OPEN',
  Opening = 'OPENING',
  Reopening = 'REOPENING'
}

export enum BankAccountStatus {
  Closed = 'closed',
  Locked = 'locked',
  Open = 'open'
}

export enum BankAccountType {
  Save = 'save',
  Spend = 'spend'
}

export enum BankAdminDynamoDumpTableName {
  BankAggregates = 'bankAggregates',
  BankCardRequests = 'bankCardRequests',
  BankTransferAggregates = 'bankTransferAggregates',
  CardOrderAggregates = 'cardOrderAggregates',
  CheckDepositReturnedChecks = 'checkDepositReturnedChecks',
  CheckPaymentAggregates = 'checkPaymentAggregates',
  CohortReasons = 'cohortReasons',
  DailyBankCardsIssued = 'dailyBankCardsIssued',
  Hermes = 'hermes',
  MatchingRoundupsCountTable = 'matchingRoundupsCountTable',
  MatchingRoundupsInvestmentIntentTable = 'matchingRoundupsInvestmentIntentTable',
  MatchingRoundupsTransactionTable = 'matchingRoundupsTransactionTable',
  SpendUserWhitelist = 'spendUserWhitelist'
}

export type BankAdminSearchDynamoDb = {
  __typename?: 'BankAdminSearchDynamoDB';
  partitionKey: Scalars['String']['output'];
  records: Scalars['String']['output'];
  sortKey?: Maybe<Scalars['String']['output']>;
  tableName: BankAdminDynamoDumpTableName;
};

export type BankAdminSearchDynamoDbInput = {
  partitionKey: Scalars['String']['input'];
  sortKey?: InputMaybe<Scalars['String']['input']>;
  tableName: BankAdminDynamoDumpTableName;
};

export type BankAdminSearchDynamoDbResult = BankAdminSearchDynamoDb | ServiceError;

export type BankCard = {
  __typename?: 'BankCard';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  bankType: BankType;
  cardNumberMasked?: Maybe<Scalars['CardNumberMasked']['output']>;
  createdAt: Scalars['DateTime']['output'];
  digitalWalletTokens: Array<DigitalWalletToken>;
  expireMonth: Scalars['Int']['output'];
  expireYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDigitalOnly?: Maybe<Scalars['Boolean']['output']>;
  isDigitallyProvisioned: Scalars['Boolean']['output'];
  lockReason?: Maybe<BankCardLockReason>;
  lockTypeCode: BankCardLockTypeCode;
  paymentProcessor: BankCardPaymentProcessor;
  referenceId: Scalars['ID']['output'];
  status: BankCardStatus;
  tier: BankCardTier;
  type: BankCardType;
  userActivatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum BankCardHotlistReason {
  Fraud = 'fraud',
  Lost = 'lost',
  Stolen = 'stolen'
}

export enum BankCardLockReason {
  Admin = 'admin',
  Damage = 'damage',
  Fraud = 'fraud',
  Lost = 'lost',
  PinRetriesExceeded = 'pinRetriesExceeded',
  Stolen = 'stolen',
  Temporary = 'temporary',
  Unknown = 'unknown'
}

export enum BankCardLockTypeCode {
  Customer = 'customer',
  System = 'system',
  Unlocked = 'unlocked'
}

export enum BankCardMaterial {
  Steel = 'STEEL',
  Tungsten = 'TUNGSTEN'
}

export type BankCardOrder = {
  __typename?: 'BankCardOrder';
  addressVerification?: Maybe<BankCardOrderAddressVerification>;
  bankCardTier?: Maybe<BankCardTier>;
  bankType?: Maybe<BankType>;
  cardOrderStatus: BankCardOrderStatus;
  createdAt?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<BankCardOrderFailureReason>;
  fundingInitiated?: Maybe<Scalars['Boolean']['output']>;
  fundingSourceVerification?: Maybe<BankCardOrderFundingSourceVerification>;
  identityVerification?: Maybe<BankCardOrderIdentityVerification>;
  /**
   * Verification results for this customer contained reasons that we consider high risk,
   * irrespective of the decision returned by our KYC vendor.
   *
   * The purpose of this field is to surface that risk to related backend services.
   * Front end clients should confirm with banking team before using.
   */
  isKycHighRisk?: Maybe<Scalars['Boolean']['output']>;
  kycStatus?: Maybe<KycStatus>;
  prefundVerification?: Maybe<BankCardOrderPrefundVerification>;
  requestVersion?: Maybe<RequestVersions>;
};

export type BankCardOrderAddressVerification = AddressVerification & {
  __typename?: 'BankCardOrderAddressVerification';
  actionRequired?: Maybe<BankCardOrderAddressVerificationActions>;
  status: BankCardOrderVerificationStatus;
  verificationStatus: VerificationStatus;
};

export enum BankCardOrderAddressVerificationActions {
  UploadDocuments = 'uploadDocuments'
}

export enum BankCardOrderFailureReason {
  AddressFailure = 'ADDRESS_FAILURE',
  Expired = 'EXPIRED',
  FundingSourceFailure = 'FUNDING_SOURCE_FAILURE',
  IdentityFailure = 'IDENTITY_FAILURE',
  PrefundFailure = 'PREFUND_FAILURE'
}

export type BankCardOrderFundingSourceVerification = {
  __typename?: 'BankCardOrderFundingSourceVerification';
  actionRequired?: Maybe<BankCardOrderFundingSourceVerificationActions>;
  pendingReason?: Maybe<BankCardOrderFundingSourceVerificationPendingReason>;
  status: BankCardOrderVerificationStatus;
};

export enum BankCardOrderFundingSourceVerificationActions {
  HandleFrozenFundingSource = 'handleFrozenFundingSource',
  LinkFundingSource = 'linkFundingSource',
  SubmitRdVs = 'submitRDVs',
  UploadDocuments = 'uploadDocuments'
}

export enum BankCardOrderFundingSourceVerificationPendingReason {
  DocumentsUnderReview = 'documentsUnderReview',
  RdvsInitiated = 'rdvsInitiated',
  RdvsPending = 'rdvsPending'
}

export type BankCardOrderIdentityVerification = IdentityVerification & {
  __typename?: 'BankCardOrderIdentityVerification';
  actionRequired?: Maybe<BankCardOrderIdentityVerificationActions>;
  /**
   * If the user can re-attempt identity verification
   *
   * They may have reached the max configured allowed attempts, or need manual approval due to suspected fraud or risk
   */
  canRetry?: Maybe<Scalars['Boolean']['output']>;
  documentUploadUrl?: Maybe<Scalars['String']['output']>;
  status: BankCardOrderVerificationStatus;
  verificationStatus: VerificationStatus;
};

export enum BankCardOrderIdentityVerificationActions {
  UploadDocuments = 'uploadDocuments'
}

export type BankCardOrderPrefundVerification = {
  __typename?: 'BankCardOrderPrefundVerification';
  actionRequired?: Maybe<BankCardOrderPrefundVerificationActions>;
  status: BankCardOrderVerificationStatus;
};

export enum BankCardOrderPrefundVerificationActions {
  CreateBankTransfer = 'createBankTransfer'
}

export enum BankCardOrderStatus {
  Accepted = 'accepted',
  ActionRequired = 'actionRequired',
  Failure = 'failure',
  NotOrdered = 'notOrdered',
  Pending = 'pending',
  Success = 'success'
}

export enum BankCardOrderVerificationStatus {
  ActionRequired = 'actionRequired',
  ActionRequiredDueToFailure = 'actionRequiredDueToFailure',
  Failure = 'failure',
  Pending = 'pending',
  Success = 'success'
}

export type BankCardPanDisplayPayload = {
  __typename?: 'BankCardPanDisplayPayload';
  bankCard: BankCard;
  token: Scalars['String']['output'];
};

export type BankCardPanDisplayResult = BankCardPanDisplayPayload;

export enum BankCardPaymentProcessor {
  Dps = 'DPS',
  Shazam = 'SHAZAM'
}

export type BankCardPrefundTransfer = {
  /** Amount (either $0 or between $25, $500) to transfer after bank account is created. */
  amount: PositiveCurrencyAmountInput;
};

export type BankCardProvisioningDetailsPayload = {
  __typename?: 'BankCardProvisioningDetailsPayload';
  cardNumberMasked?: Maybe<Scalars['CardNumberMasked']['output']>;
  token: Scalars['String']['output'];
};

export type BankCardProvisioningDetailsResult = BankCardProvisioningDetailsPayload;

export type BankCardReissue = {
  __typename?: 'BankCardReissue';
  bankCardRequest?: Maybe<BankCardRequest>;
  bankType: BankType;
  reissueBankCardEligibility: ReissueBankCardEligibility;
};

export enum BankCardReissueReason {
  Damage = 'damage',
  Fraud = 'fraud',
  Lost = 'lost',
  Stolen = 'stolen'
}

export type BankCardRequest = {
  __typename?: 'BankCardRequest';
  /** tag for new bank card */
  id: Scalars['ID']['output'];
  /** True when new bank card has been activated */
  isActivated: Scalars['Boolean']['output'];
  isReissue: Scalars['Boolean']['output'];
  /** Issued date for new bank card */
  issuedDate?: Maybe<Scalars['Date']['output']>;
  /** The mailing address used to ship the reissued card */
  mailingAddress?: Maybe<BankCardRequestMailingAddress>;
  previousBankCardId?: Maybe<Scalars['ID']['output']>;
  /** The tier level of the card. */
  previousBankCardTier?: Maybe<BankCardTier>;
  /** Reason for requesting a new bank card */
  reason: BankCardRequestReason;
  /** Additional information pertaining to the request */
  reasonComment?: Maybe<Scalars['String']['output']>;
  /** Date associated with reason (Date lost, date stolen, etc) */
  reasonDate?: Maybe<Scalars['Date']['output']>;
  requestedDate: Scalars['Date']['output'];
  status: BankCardRequestStatus;
  userId: Scalars['ID']['output'];
};

export type BankCardRequestMailingAddress = {
  __typename?: 'BankCardRequestMailingAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export enum BankCardRequestReason {
  Damaged = 'DAMAGED',
  DeliveryIssue = 'DELIVERY_ISSUE',
  Lost = 'LOST',
  NewAccount = 'NEW_ACCOUNT',
  Other = 'OTHER',
  Stolen = 'STOLEN'
}

export enum BankCardRequestStatus {
  Approved = 'APPROVED',
  Issued = 'ISSUED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export enum BankCardShippingSpeed {
  Expedited = 'EXPEDITED',
  Slow = 'SLOW',
  Standard = 'STANDARD'
}

export enum BankCardStatus {
  Archived = 'archived',
  Denied = 'denied',
  DigitalActivePhysicalInitiated = 'digitalActivePhysicalInitiated',
  DigitalActivePhysicalPending = 'digitalActivePhysicalPending',
  Expired = 'expired',
  Hotlisted = 'hotlisted',
  Initiated = 'initiated',
  Pending = 'pending',
  PendingVerification = 'pendingVerification',
  Reissued = 'reissued',
  Verified = 'verified'
}

export enum BankCardTemporaryLockReason {
  Damage = 'damage',
  Fraud = 'fraud',
  Temporary = 'temporary',
  Unknown = 'unknown'
}

export enum BankCardTier {
  MightyOak = 'mightyOak',
  Oak = 'oak',
  PremiumOak = 'premiumOak',
  VipReissue = 'vipReissue'
}

export enum BankCardType {
  Credit = 'credit',
  Debit = 'debit'
}

export type BankConnection = {
  __typename?: 'BankConnection';
  accountStatus?: Maybe<BankConnectionStatus>;
  bank: Scalars['String']['output'];
  eligible?: Maybe<Scalars['Boolean']['output']>;
  lastSubmissionDate?: Maybe<Scalars['DateTime']['output']>;
  linkedAccountId: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['URL']['output']>;
  negotiationType?: Maybe<NegotiationType>;
  nextSubmissionDate?: Maybe<Scalars['DateTime']['output']>;
  totalNegotiableFees?: Maybe<MonetaryAmount>;
};

export enum BankConnectionStatus {
  Eligible = 'ELIGIBLE',
  IneligibleCooldown = 'INELIGIBLE_COOLDOWN',
  IneligibleNotsupported = 'INELIGIBLE_NOTSUPPORTED',
  IneligibleThreshold = 'INELIGIBLE_THRESHOLD',
  Lowertier = 'LOWERTIER',
  Pending = 'PENDING'
}

/**
 * The internal representation of addresses, specific to bank accounts. This is
 * the format stored in our partner's API
 */
export type BankCustomerAddress = {
  __typename?: 'BankCustomerAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  addressLine4?: Maybe<Scalars['String']['output']>;
  addressType: BankCustomerAddressType;
  city?: Maybe<Scalars['String']['output']>;
  country: BankCustomerAddressCountry;
  isActive: Scalars['Boolean']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** The internal address country, specifically, what is stored in our partner's API */
export enum BankCustomerAddressCountry {
  Us = 'US'
}

/** The internal address type, specifically, what is stored in our partner's API */
export enum BankCustomerAddressType {
  Mailing = 'Mailing',
  Residence = 'Residence'
}

export type BankDisclosureDocument = {
  __typename?: 'BankDisclosureDocument';
  bankId: Scalars['ID']['output'];
  documentId: Scalars['ID']['output'];
  documentType: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  programId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type BankDisclosureDocumentFile = {
  __typename?: 'BankDisclosureDocumentFile';
  content: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
};

export type BankDisclosureDocumentResult = {
  __typename?: 'BankDisclosureDocumentResult';
  bankDisclosures: Array<Maybe<BankDisclosureDocument>>;
  bankType: BankType;
};

export enum BankDocumentReason {
  Verification = 'verification'
}

/** Bank Document Requested Alert. */
export type BankDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'BankDocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

export enum BankDocumentType {
  Verification = 'verification'
}

export type BankFee = {
  __typename?: 'BankFee';
  accountName?: Maybe<Scalars['String']['output']>;
  amount: MonetaryAmount;
  category?: Maybe<TransactionCategory>;
  /** @deprecated replaced by last4 */
  digit?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  linkedAccountId?: Maybe<Scalars['ID']['output']>;
  linkedSubAccountId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FeeStatus>;
  submissionKey?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<BankFeeType>;
};

export type BankFeeConnection = {
  __typename?: 'BankFeeConnection';
  bank: BankName;
  eligible: Scalars['Boolean']['output'];
  feeSynopsis?: Maybe<Scalars['String']['output']>;
  institutionName: Scalars['String']['output'];
  latestSubmission?: Maybe<Submission>;
  linkedAccountId: Scalars['ID']['output'];
  logoUrl: Scalars['URL']['output'];
  mailInEligibility: Scalars['Boolean']['output'];
  status: ConnectionStatus;
  submissions?: Maybe<Array<Submission>>;
  totalNegotiableFees: MonetaryAmount;
};

export type BankFeeFilter = {
  connectionStatus?: InputMaybe<Array<BankConnectionStatus>>;
  status?: InputMaybe<Array<FeeStatus>>;
  submissionKey?: InputMaybe<Scalars['String']['input']>;
};

export enum BankFeeNegotiationExternalStatus {
  ActionrequiredConnectionError = 'ACTIONREQUIRED_CONNECTION_ERROR',
  ActionrequiredReportRefund = 'ACTIONREQUIRED_REPORT_REFUND',
  ActionrequiredScheduleCall = 'ACTIONREQUIRED_SCHEDULE_CALL',
  CallScheduled = 'CALL_SCHEDULED',
  ResolvedNoRefund = 'RESOLVED_NO_REFUND',
  ResolvedRefund = 'RESOLVED_REFUND',
  Submitted = 'SUBMITTED',
  SubmittedSent = 'SUBMITTED_SENT'
}

export enum BankFeeNegotiationInternalStatus {
  AutofetchCompleted = 'AUTOFETCH_COMPLETED',
  AutoConnectionError = 'AUTO_CONNECTION_ERROR',
  AutoError = 'AUTO_ERROR',
  AutoInProgress = 'AUTO_IN_PROGRESS',
  CallScheduled = 'CALL_SCHEDULED',
  MailInError = 'MAIL_IN_ERROR',
  MailInEscalated = 'MAIL_IN_ESCALATED',
  MailInPending = 'MAIL_IN_PENDING',
  MailInScheduleCall = 'MAIL_IN_SCHEDULE_CALL',
  MailInSent = 'MAIL_IN_SENT',
  Pending = 'PENDING',
  ResolvedNoRefund = 'RESOLVED_NO_REFUND',
  ResolvedRefund = 'RESOLVED_REFUND'
}

export enum BankFeeNegotiationStatus {
  AutoConnectionError = 'AUTO_CONNECTION_ERROR',
  AutoError = 'AUTO_ERROR',
  AutoInProgress = 'AUTO_IN_PROGRESS',
  CallScheduled = 'CALL_SCHEDULED',
  MailInError = 'MAIL_IN_ERROR',
  MailInEscalated = 'MAIL_IN_ESCALATED',
  MailInPending = 'MAIL_IN_PENDING',
  MailInScheduleCall = 'MAIL_IN_SCHEDULE_CALL',
  MailInSent = 'MAIL_IN_SENT',
  ResolvedNoRefund = 'RESOLVED_NO_REFUND',
  ResolvedRefund = 'RESOLVED_REFUND',
  Submitted = 'SUBMITTED'
}

export type BankFeeSummary = {
  __typename?: 'BankFeeSummary';
  coffeeCount: Scalars['Int']['output'];
  eligible: Scalars['Boolean']['output'];
  feesFound: FeeStatusSummary;
  linkedAccounts: Array<BankFeeConnection>;
  totalNegotiableFees: MonetaryAmount;
  totalNegotiatedFees: MonetaryAmount;
  totalReimbursedFees: MonetaryAmount;
};

export enum BankFeeType {
  AccountMaintenanceFee = 'ACCOUNT_MAINTENANCE_FEE',
  AtmFee = 'ATM_FEE',
  BalanceInquiryFee = 'BALANCE_INQUIRY_FEE',
  CardSetupFee = 'CARD_SETUP_FEE',
  CashAdvance = 'CASH_ADVANCE',
  CheckFee = 'CHECK_FEE',
  ClosedAccountProcessingFee = 'CLOSED_ACCOUNT_PROCESSING_FEE',
  CreditCardInterestCharge = 'CREDIT_CARD_INTEREST_CHARGE',
  DormantFee = 'DORMANT_FEE',
  EarlyClosureFee = 'EARLY_CLOSURE_FEE',
  ExcessFee = 'EXCESS_FEE',
  ExternalTransferFee = 'EXTERNAL_TRANSFER_FEE',
  ForeignTransactionFee = 'FOREIGN_TRANSACTION_FEE',
  LateFee = 'LATE_FEE',
  MinimumBalanceFee = 'MINIMUM_BALANCE_FEE',
  MonthlyServiceFee = 'MONTHLY_SERVICE_FEE',
  NsfFee = 'NSF_FEE',
  OverdraftFee = 'OVERDRAFT_FEE',
  PaperStatementFee = 'PAPER_STATEMENT_FEE',
  StopPaymentFee = 'STOP_PAYMENT_FEE',
  WireTransferFee = 'WIRE_TRANSFER_FEE'
}

export type BankInterestRate = {
  __typename?: 'BankInterestRate';
  /** Pre-formatted to two places (i.e. "5.00"). Not present if the product has no associated interest rate. */
  currentApy?: Maybe<Scalars['String']['output']>;
  liveDate?: Maybe<Scalars['String']['output']>;
  productName: BankingProduct;
};

export type BankInterestRates = {
  __typename?: 'BankInterestRates';
  bankInterestRates?: Maybe<Array<BankInterestRate>>;
};

export type BankInterestRatesResult = BankInterestRates | BankServiceFailure;

export type BankMetadata = {
  __typename?: 'BankMetadata';
  /** Deprecated */
  totals?: Maybe<BankMetadataTotals>;
};

export type BankMetadataTotals = {
  __typename?: 'BankMetadataTotals';
  oak: Scalars['Int']['output'];
  royalOak: Scalars['Int']['output'];
};

export enum BankName {
  Chase = 'CHASE',
  NotApplicable = 'NOT_APPLICABLE',
  TestBank = 'TEST_BANK',
  WellsFargo = 'WELLS_FARGO'
}

export enum BankProgramAccountType {
  CheckingTransfers = 'CHECKING_TRANSFERS',
  InvestTransfers = 'INVEST_TRANSFERS',
  IsaFee = 'ISA_FEE',
  Plan = 'PLAN',
  SubscriptionAcornsTransfers = 'SUBSCRIPTION_ACORNS_TRANSFERS'
}

/** A Bank Record */
export type BankResult = {
  __typename?: 'BankResult';
  bankName: Scalars['String']['output'];
  city: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  routingNumber: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

/** An individual edge within the paginated list of BankResult */
export type BankResultEdge = {
  __typename?: 'BankResultEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The BankResult record in the edge */
  node: BankResult;
};

/** Relay style pagination information for BankResult */
export type BankResultPagination = {
  __typename?: 'BankResultPagination';
  edges: Array<BankResultEdge>;
  pageInfo: PageInfo;
};

export type BankServiceFailure = {
  __typename?: 'BankServiceFailure';
  reason?: Maybe<Scalars['String']['output']>;
  retryable?: Maybe<Scalars['Boolean']['output']>;
};

export type BankTransaction = {
  __typename?: 'BankTransaction';
  /** The amount of funds the transaction represents. */
  amount: CurrencyAmount;
  /** The exact date and time the funds associated with the transaction became available. */
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The card that created the transaction. Will be null if this transaction is
   * not tied to a card
   */
  bankCard?: Maybe<BankCard>;
  /** The exact date and time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Represents a client-specified description of the transaction.
   * If transaction was received from a NACHA file (typeCode is UNKWTH, UNKDEP, UNKRSV),
   * this property contains the description verbatim from the NACHA file. By law, this
   * description must be displayed to the end user. If transaction was received
   * from an ISO-8583 interface (i.e. debit card transaction), this property contains
   * description verbatim from DataElement 43 (Card Acceptor Name/Location) of
   * ISO-8583 interface plus details of any fees or surchages that may have been
   * incurred. By law, this description must be displayed to the end user
   * Otherwise, the transaction was received from a call to CorePro API or it was
   * line item in the Bulk Transfer File. This property contains the description
   * verbatim passed by the client code
   */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nachaCode: Scalars['String']['output'];
  nachaInfo?: Maybe<BankTransactionNachaInfo>;
  /** The exact date and time the transaction was settled. */
  settledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the transaction */
  status: BankTransactionStatus;
  /**
   * Shorter version of description. Depending on type, may contain full description.
   * Ex. Purchase transactions contain merchant name without address.
   */
  summary: Scalars['String']['output'];
  /** The program-wide unique identifier generated for each transfer */
  tag?: Maybe<Scalars['String']['output']>;
  type: BankTransactionType;
  typeCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The exact date and time the transaction was voided. */
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BankTransactionConnection = {
  __typename?: 'BankTransactionConnection';
  edges: Array<Maybe<BankTransactionEdge>>;
  pageInfo: PageInfo;
};

export type BankTransactionEdge = {
  __typename?: 'BankTransactionEdge';
  cursor: Scalars['ID']['output'];
  node?: Maybe<BankTransaction>;
};

export type BankTransactionNachaInfo = {
  __typename?: 'BankTransactionNachaInfo';
  companyDiscretionaryData?: Maybe<Scalars['String']['output']>;
  companyEntryDescription?: Maybe<Scalars['String']['output']>;
  companyIdentification?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  isEarlyDeposit?: Maybe<Scalars['Boolean']['output']>;
  nachaSettledDate?: Maybe<Scalars['DateTime']['output']>;
  standardEntryClassCode?: Maybe<Scalars['String']['output']>;
};

export enum BankTransactionStatus {
  /** Transaction has been created but not yet put into a NACHA file */
  Initiated = 'initiated',
  /** Transaction has been created and put into a NACHA file */
  Pending = 'pending',
  /** Transaction has been posted to the account */
  Settled = 'settled',
  /** Transaction has been voided */
  Voided = 'voided'
}

export enum BankTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export enum BankType {
  Lsb = 'LSB',
  Nbkc = 'NBKC'
}

export type BankingKyc = {
  __typename?: 'BankingKyc';
  addressVerification?: Maybe<AddressVerification>;
  identityVerification?: Maybe<IdentityVerification>;
  kycStatus?: Maybe<KycStatus>;
  /**
   * Details of Banking KYC results surfaced for clients that have been cleared to reuse Banking KYC user info for specific scenarios, with specific criteria.
   *
   * Usage of this field is only appliable for approved clients.
   * Please confirm with the banking team before using.
   */
  verificationDetails?: Maybe<VerificationDetails>;
};

export type BankingKycAddressVerification = AddressVerification & {
  __typename?: 'BankingKycAddressVerification';
  verificationStatus: VerificationStatus;
};

export type BankingKycIdentityVerification = IdentityVerification & {
  __typename?: 'BankingKycIdentityVerification';
  /**
   * If the user can re-attempt identity verification
   *
   * They may have reached the max configured allowed attempts, or need manual review due to suspected fraud or risk
   */
  canRetry?: Maybe<Scalars['Boolean']['output']>;
  verificationStatus: VerificationStatus;
};

export enum BankingProduct {
  EmergencySavings = 'emergencySavings',
  MightyOakChecking = 'mightyOakChecking',
  MightyOakEmergencyFund = 'mightyOakEmergencyFund',
  OakChecking = 'oakChecking',
  OakEmergencyFund = 'oakEmergencyFund'
}

export type BannersErrors = {
  __typename?: 'BannersErrors';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type BannersResponse = BannersErrors | HelpcenterBannerContent | SiteWideBannerContent;

/** Acorns base Portfolio interface */
export type BasePortfolio = {
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation;
  cashOwed: MonetaryAmount;
  currentAllocationPercentage: Scalars['Float']['output'];
  currentBalance: MonetaryAmount;
  currentBalanceWithPending: MonetaryAmount;
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel?: Maybe<PortfolioCustomizationLevel>;
  /** Description of the portfolio */
  description: Scalars['String']['output'];
  /** ID of the Portfolio */
  id: Scalars['ID']['output'];
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']['output'];
  pendingBalance: MonetaryAmount;
  /** Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount). */
  portfolioSecurities?: Maybe<Array<PortfolioSecurity>>;
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations?: Maybe<Array<PortfolioSecurityAllocation>>;
  yearToDateReturn?: Maybe<MarketReturn>;
};

/** Returned result for a batchAddTierSubscriptions mutation */
export type BatchAddTierSubscriptions = {
  __typename?: 'BatchAddTierSubscriptions';
  addedIds: Array<Scalars['ID']['output']>;
  unaddedIds: Array<Scalars['ID']['output']>;
};

export type BatchAddTierSubscriptionsInput = {
  allowInactiveTier?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>;
  migrationId?: InputMaybe<Scalars['ID']['input']>;
  tierId: Scalars['ID']['input'];
  tierPriceId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type BatchAddTierSubscriptionsResult = BatchAddTierSubscriptions | InvalidTier | InvalidTierPrice;

/** Input to get estimated completion dates for transfers */
export type BatchEstimatedTransferDatesInternalInput = {
  /** Pending transfers to get an estimated completion date for */
  internalTransferInput: Array<EstimatedTransferDatesInput>;
  /** The user ID associated with the transfers */
  userId: Scalars['ID']['input'];
};

/** The estimated completion dates for a batch of transfers */
export type BatchEstimatedTransferDatesInternalPayload = {
  __typename?: 'BatchEstimatedTransferDatesInternalPayload';
  /** The estimated UTC DateTime the transfers will be completed */
  estimatedTransferCompletedAt: Array<Scalars['DateTime']['output']>;
};

/** A person who doesn't have an Acorns account, but may someday inherit one or funds from one. */
export type Beneficiary = TimestampsInterface & {
  __typename?: 'Beneficiary';
  /** List of addresses associated with beneficiary */
  addresses?: Maybe<Array<Maybe<Address>>>;
  /** Age of beneficiary */
  age: Scalars['Int']['output'];
  /** URL for the Beneficiary's avatar image */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Internal ID for user who this beneficiary belongs to */
  custodianId: Scalars['ID']['output'];
  /** Beneficiary's nickname for their custodian */
  custodianNickname?: Maybe<Scalars['String']['output']>;
  /**
   * Beneficiary's date of birth:
   * @deprecated Use beneficiary.age or beneficiary.eligible for contribution tooltip instead
   */
  dateOfBirth: Scalars['String']['output'];
  /** Timestamp when the Beneficiary was deactivated */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Beneficiary's birthday is within the next month */
  eligibleForContributionTooltip: Scalars['Boolean']['output'];
  /** Beneficiary's email ID */
  email?: Maybe<Scalars['Email']['output']>;
  /** First name of beneficiary */
  firstName: Scalars['String']['output'];
  /** Internal ID for beneficiary */
  id: Scalars['ID']['output'];
  /** Beneficiary's investment account */
  investmentAccount?: Maybe<InvestmentAccount>;
  /** Last name of beneficiary */
  lastName: Scalars['String']['output'];
  /** List of phone numbers associated with the beneficiary */
  phoneNumbers?: Maybe<Array<Maybe<Phone>>>;
  ssnDocumentRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True if the beneficiary has an ssn false if not */
  ssnPresent: Scalars['Boolean']['output'];
  ssnVerifiedState?: Maybe<Scalars['String']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** A person with the supplied date of birth is too old to open a UTMA/UGMA account */
export type BeneficiaryExceedsAgeLimitException = {
  __typename?: 'BeneficiaryExceedsAgeLimitException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Changeable attributes for beneficiaries */
export type BeneficiaryInfoInput = {
  /** Date of Birth */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Beneficiary Email */
  email?: InputMaybe<Scalars['Email']['input']>;
  /** Beneficiary First Name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Beneficiary Last Name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Mailing Address */
  mailingAddress?: InputMaybe<AddressInput>;
  /** Beneficiary Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Beneficiary SSN */
  ssn?: InputMaybe<Scalars['String']['input']>;
};

/** Changeable attributes for beneficiaries */
export type BeneficiaryInput = {
  /** Date of Birth */
  dateOfBirth: Scalars['String']['input'];
  /** Beneficiary First Name */
  firstName: Scalars['String']['input'];
  /** Beneficiary Last Name */
  lastName: Scalars['String']['input'];
};

/** Beneficiary does not exist */
export type BeneficiaryNotFoundException = {
  __typename?: 'BeneficiaryNotFoundException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type BeneficiarySsn = {
  __typename?: 'BeneficiarySSN';
  /** Beneficiary SSN */
  ssn?: Maybe<Scalars['String']['output']>;
};

export enum BeneficiarySsnVerifiedState {
  /** Pending IRS TIN match verification */
  IrsReviewPending = 'IRS_REVIEW_PENDING',
  /** Pending manual verification by InvestOps */
  ManualReviewPending = 'MANUAL_REVIEW_PENDING',
  /** Beneficiary SSN failed IRS or manual review */
  Unverified = 'UNVERIFIED',
  /** Beneficiary SSN passed IRS or manual review */
  Verified = 'VERIFIED'
}

export enum BenefitProductStatus {
  ComingSoon = 'COMING_SOON',
  Disabled = 'DISABLED',
  DisablingSoon = 'DISABLING_SOON',
  Enabled = 'ENABLED',
  TemporarilyUnavailable = 'TEMPORARILY_UNAVAILABLE',
  UnderMaintenance = 'UNDER_MAINTENANCE'
}

export type BenefitProductTile = {
  __typename?: 'BenefitProductTile';
  product: BenefitsTrackerProducts;
  status: BenefitProductStatus;
};

export enum BenefitPromotedThrough {
  MainFeedCard = 'MAIN_FEED_CARD',
  TourTip = 'TOUR_TIP',
  Wtdn = 'WTDN'
}

export type BenefitStatus = {
  __typename?: 'BenefitStatus';
  benefitProductKey: Scalars['String']['output'];
  claimStatus: ClaimStatus;
  claimedOn?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<Maybe<ClaimStatusDetails>>>;
  expiresOn?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use claim_status instead */
  status: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['String']['output']>;
};

export enum BenefitStatusDetail {
  IneligibleAge = 'INELIGIBLE_AGE',
  IneligibleLocation = 'INELIGIBLE_LOCATION'
}

export type BenefitTileGroup = {
  __typename?: 'BenefitTileGroup';
  group: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<BenefitProductTile>>>;
};

export type BenefitsMessage = {
  __typename?: 'BenefitsMessage';
  message: Scalars['String']['output'];
};

export type BenefitsStatusResponse = {
  __typename?: 'BenefitsStatusResponse';
  benefitsStatus: Array<BenefitStatus>;
  userId: Scalars['String']['output'];
};

export enum BenefitsTrackerProducts {
  BenefitsFeeNegotiation = 'BENEFITS_FEE_NEGOTIATION',
  BenefitsGohenryStandard = 'BENEFITS_GOHENRY_STANDARD',
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsTaxfilingStandard = 'BENEFITS_TAXFILING_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD'
}

export type BgpReport = {
  __typename?: 'BgpReport';
  historical?: Maybe<BgpReportColumn>;
  lastWeek?: Maybe<BgpReportColumn>;
  thisWeek?: Maybe<BgpReportColumn>;
};

export type BgpReportAggregate = {
  __typename?: 'BgpReportAggregate';
  bgpReportUuid?: Maybe<Scalars['ID']['output']>;
  periodAggregateCount?: Maybe<Scalars['String']['output']>;
  rowKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type BgpReportColumn = {
  __typename?: 'BgpReportColumn';
  aggregates?: Maybe<Array<Maybe<BgpReportAggregate>>>;
  endDate?: Maybe<Scalars['Date']['output']>;
  generationFinishedAt?: Maybe<Scalars['Date']['output']>;
  generationStartedAt?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type BgpReportDetailsResult = BgpReport | ReportDoesNotExistError;

export type BgpReportFilterInput = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  endAt?: InputMaybe<Scalars['Date']['input']>;
  generationFinishedAt?: InputMaybe<Scalars['Date']['input']>;
  generationStartedAt?: InputMaybe<Scalars['Date']['input']>;
  maxPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type BgpReportPublishInput = {
  bgpReportUuid?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
};

export type BigCurrencyAmount = {
  __typename?: 'BigCurrencyAmount';
  currency: Currency;
  value: Scalars['BigDecimal']['output'];
};

/** Attributes related to the billing cycle */
export type BillingCycle = TimestampsInterface & {
  __typename?: 'BillingCycle';
  active: Scalars['Boolean']['output'];
  adhoc: Scalars['Boolean']['output'];
  amount?: Maybe<Scalars['Float']['output']>;
  amountCollected?: Maybe<Scalars['Float']['output']>;
  amountOwed?: Maybe<Scalars['Float']['output']>;
  callbackUrl?: Maybe<Scalars['String']['output']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  credits: Array<Maybe<Credit>>;
  endDate: Scalars['String']['output'];
  executionAudits: Array<Maybe<ExecutionAudit>>;
  extension: Scalars['String']['output'];
  fees: Array<Maybe<Fee>>;
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['String']['output'];
  liquidations: Array<Maybe<Liquidation>>;
  nonce?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  state: BillingCycleState;
  tierSubscription?: Maybe<TierSubscription>;
  tierSubscriptionId?: Maybe<Scalars['String']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};


/** Attributes related to the billing cycle */
export type BillingCycleCreditsArgs = {
  discount_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


/** Attributes related to the billing cycle */
export type BillingCycleFeesArgs = {
  execution_methods?: InputMaybe<Array<InputMaybe<FeeExecutionMethod>>>;
};

/** Requested billing cycle is ineligible for a refund */
export type BillingCycleRefundIneligibleError = {
  __typename?: 'BillingCycleRefundIneligibleError';
  /** The billing cycle ID provided that is ineligible for a refund */
  billingCycleId: Scalars['ID']['output'];
};

export enum BillingCycleState {
  Assessed = 'ASSESSED',
  Executed = 'EXECUTED',
  ExecutionFailed = 'EXECUTION_FAILED',
  Failed = 'FAILED',
  Paid = 'PAID',
  Partial = 'PARTIAL',
  PendingRefund = 'PENDING_REFUND',
  Refunded = 'REFUNDED',
  RefundFailed = 'REFUND_FAILED',
  RetryPending = 'RETRY_PENDING',
  Unpaid = 'UNPAID'
}

/** An individual edge within the paginated list of BillingCycleType */
export type BillingCycleTypeEdge = {
  __typename?: 'BillingCycleTypeEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The BillingCycleType record in the edge */
  node: BillingCycle;
};

/** Relay style pagination information for BillingCycleType */
export type BillingCycleTypePagination = {
  __typename?: 'BillingCycleTypePagination';
  edges: Array<BillingCycleTypeEdge>;
  pageInfo: PageInfo;
};

export enum BillingFrequency {
  Monthly = 'MONTHLY',
  Never = 'NEVER'
}

/** Internal representation of a billing cycle */
export type BillingInvoice = {
  __typename?: 'BillingInvoice';
  amount?: Maybe<Scalars['Float']['output']>;
  amountCollected?: Maybe<Scalars['Float']['output']>;
  amountOwed?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  executionMethod?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceItems: Array<Maybe<InvoiceItem>>;
  startDate: Scalars['DateTime']['output'];
  state: BillingCycleState;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  vendorIntegrated: Scalars['Boolean']['output'];
};

/** the billing profile for a user */
export type BillingProfile = {
  __typename?: 'BillingProfile';
  mightyOakCardWaiver?: Maybe<MightyOakCardWaiver>;
  provisionalWaiver?: Maybe<ProvisionalWaiver>;
  userId: Scalars['ID']['output'];
  userVerifiedAt?: Maybe<Scalars['String']['output']>;
  waivers?: Maybe<Array<Waiver>>;
};

/** Billing Profile not found */
export type BillingProfileNotFoundException = {
  __typename?: 'BillingProfileNotFoundException';
  /** message */
  message: Scalars['String']['output'];
};

export type BillingVendorError = {
  __typename?: 'BillingVendorError';
  message: Scalars['String']['output'];
};

export type BlockDeviceInput = {
  deviceId: Scalars['ID']['input'];
};

export type BlockDeviceResult = Device | DeviceNotFoundException;

export type BlockedEmailDomainException = {
  __typename?: 'BlockedEmailDomainException';
  message?: Maybe<Scalars['String']['output']>;
};

export enum BrazeEvent {
  AdvocateReferralLinkClick = 'AdvocateReferralLinkClick',
  FriendInvestCore = 'FriendInvestCore',
  FriendRegistrationStart = 'FriendRegistrationStart',
  FriendUserVerified = 'FriendUserVerified'
}

export enum BreadcrumbTypeEnum {
  /** acat_transfer */
  AcatTransfer = 'ACAT_TRANSFER',
  /** access_unlocked */
  AccessUnlocked = 'ACCESS_UNLOCKED',
  /** account_closure_failed */
  AccountClosureFailed = 'ACCOUNT_CLOSURE_FAILED',
  /** account_liquidation */
  AccountLiquidation = 'ACCOUNT_LIQUIDATION',
  /** application_reopened */
  ApplicationReopened = 'APPLICATION_REOPENED',
  /** application_withdrawn */
  ApplicationWithdrawn = 'APPLICATION_WITHDRAWN',
  /** automated_account_closure */
  AutomatedAccountClosure = 'AUTOMATED_ACCOUNT_CLOSURE',
  /** automatic_roundups_disabled */
  AutomaticRoundupsDisabled = 'AUTOMATIC_ROUNDUPS_DISABLED',
  /** automatic_roundups_enabled */
  AutomaticRoundupsEnabled = 'AUTOMATIC_ROUNDUPS_ENABLED',
  /** chargedback_withdrawal */
  ChargedbackWithdrawal = 'CHARGEDBACK_WITHDRAWAL',
  /** core_account_reopened */
  CoreAccountReopened = 'CORE_ACCOUNT_REOPENED',
  /** create_refund */
  CreateRefund = 'CREATE_REFUND',
  /** custom_allocation_updated */
  CustomAllocationUpdated = 'CUSTOM_ALLOCATION_UPDATED',
  /** early_account_reopened */
  EarlyAccountReopened = 'EARLY_ACCOUNT_REOPENED',
  /** flagged_as_suspicious */
  FlaggedAsSuspicious = 'FLAGGED_AS_SUSPICIOUS',
  /** funding_source_account_number_updated */
  FundingSourceAccountNumberUpdated = 'FUNDING_SOURCE_ACCOUNT_NUMBER_UPDATED',
  /** funding_source_changes_reset */
  FundingSourceChangesReset = 'FUNDING_SOURCE_CHANGES_RESET',
  /** funding_source_change_approved */
  FundingSourceChangeApproved = 'FUNDING_SOURCE_CHANGE_APPROVED',
  /** funding_source_change_rejected */
  FundingSourceChangeRejected = 'FUNDING_SOURCE_CHANGE_REJECTED',
  /** funding_source_deposit_request_suspend */
  FundingSourceDepositRequestSuspend = 'FUNDING_SOURCE_DEPOSIT_REQUEST_SUSPEND',
  /** funding_source_deposit_request_unsuspend */
  FundingSourceDepositRequestUnsuspend = 'FUNDING_SOURCE_DEPOSIT_REQUEST_UNSUSPEND',
  /** funding_source_enabled */
  FundingSourceEnabled = 'FUNDING_SOURCE_ENABLED',
  /** funding_source_linked */
  FundingSourceLinked = 'FUNDING_SOURCE_LINKED',
  /** funding_source_primary_set */
  FundingSourcePrimarySet = 'FUNDING_SOURCE_PRIMARY_SET',
  /** funding_source_rdv_verified */
  FundingSourceRdvVerified = 'FUNDING_SOURCE_RDV_VERIFIED',
  /** funding_source_subaccount_unlinked */
  FundingSourceSubaccountUnlinked = 'FUNDING_SOURCE_SUBACCOUNT_UNLINKED',
  /** funding_source_trigger_rdv */
  FundingSourceTriggerRdv = 'FUNDING_SOURCE_TRIGGER_RDV',
  /** funding_source_unlinked */
  FundingSourceUnlinked = 'FUNDING_SOURCE_UNLINKED',
  /** investment_approved */
  InvestmentApproved = 'INVESTMENT_APPROVED',
  /** investment_canceled */
  InvestmentCanceled = 'INVESTMENT_CANCELED',
  /** investment_chargedback */
  InvestmentChargedback = 'INVESTMENT_CHARGEDBACK',
  /** investment_cxled */
  InvestmentCxled = 'INVESTMENT_CXLED',
  /** investment_posted_in */
  InvestmentPostedIn = 'INVESTMENT_POSTED_IN',
  /** investment_posted_out */
  InvestmentPostedOut = 'INVESTMENT_POSTED_OUT',
  /** investment_refunded_and_cxled */
  InvestmentRefundedAndCxled = 'INVESTMENT_REFUNDED_AND_CXLED',
  /** investment_returned */
  InvestmentReturned = 'INVESTMENT_RETURNED',
  /** investment_reversed */
  InvestmentReversed = 'INVESTMENT_REVERSED',
  /** investment_revoked */
  InvestmentRevoked = 'INVESTMENT_REVOKED',
  /** investment_settled */
  InvestmentSettled = 'INVESTMENT_SETTLED',
  /** investment_shares_settled */
  InvestmentSharesSettled = 'INVESTMENT_SHARES_SETTLED',
  /** investment_status_updated */
  InvestmentStatusUpdated = 'INVESTMENT_STATUS_UPDATED',
  /** investment_transfer_initiated */
  InvestmentTransferInitiated = 'INVESTMENT_TRANSFER_INITIATED',
  /** investment_voided */
  InvestmentVoided = 'INVESTMENT_VOIDED',
  /** ira_account_reopened */
  IraAccountReopened = 'IRA_ACCOUNT_REOPENED',
  /** liquidation_sweep */
  LiquidationSweep = 'LIQUIDATION_SWEEP',
  /** monitored_institution_subaccount_unlinked */
  MonitoredInstitutionSubaccountUnlinked = 'MONITORED_INSTITUTION_SUBACCOUNT_UNLINKED',
  /** monitored_institution_unlinked */
  MonitoredInstitutionUnlinked = 'MONITORED_INSTITUTION_UNLINKED',
  /** name_changed */
  NameChanged = 'NAME_CHANGED',
  /** national_change_of_address_updated */
  NationalChangeOfAddressUpdated = 'NATIONAL_CHANGE_OF_ADDRESS_UPDATED',
  /** order_buy_created */
  OrderBuyCreated = 'ORDER_BUY_CREATED',
  /** order_sell_created */
  OrderSellCreated = 'ORDER_SELL_CREATED',
  /** partial_split_withdrawal_with_force_rebalance */
  PartialSplitWithdrawalWithForceRebalance = 'PARTIAL_SPLIT_WITHDRAWAL_WITH_FORCE_REBALANCE',
  /** paypal_account_unlinked */
  PaypalAccountUnlinked = 'PAYPAL_ACCOUNT_UNLINKED',
  /** paypal_investment_refunded */
  PaypalInvestmentRefunded = 'PAYPAL_INVESTMENT_REFUNDED',
  /** preapproval_documents_uploaded */
  PreapprovalDocumentsUploaded = 'PREAPPROVAL_DOCUMENTS_UPLOADED',
  /** provisional_documents_rejected */
  ProvisionalDocumentsRejected = 'PROVISIONAL_DOCUMENTS_REJECTED',
  /** provisional_removed */
  ProvisionalRemoved = 'PROVISIONAL_REMOVED',
  /** provisional_waiver_removed */
  ProvisionalWaiverRemoved = 'PROVISIONAL_WAIVER_REMOVED',
  /** provisional_waiver_set */
  ProvisionalWaiverSet = 'PROVISIONAL_WAIVER_SET',
  /** recurring_investment_failed */
  RecurringInvestmentFailed = 'RECURRING_INVESTMENT_FAILED',
  /** recurring_investment_skipped */
  RecurringInvestmentSkipped = 'RECURRING_INVESTMENT_SKIPPED',
  /** refund_billing_cycle */
  RefundBillingCycle = 'REFUND_BILLING_CYCLE',
  /** registered_in_profit_stars */
  RegisteredInProfitStars = 'REGISTERED_IN_PROFIT_STARS',
  /** requested_documents_updated */
  RequestedDocumentsUpdated = 'REQUESTED_DOCUMENTS_UPDATED',
  /** reroute_withdrawal */
  RerouteWithdrawal = 'REROUTE_WITHDRAWAL',
  /** reverse_negative_account_balance */
  ReverseNegativeAccountBalance = 'REVERSE_NEGATIVE_ACCOUNT_BALANCE',
  /** reward_canceled */
  RewardCanceled = 'REWARD_CANCELED',
  /** security_question_changed */
  SecurityQuestionChanged = 'SECURITY_QUESTION_CHANGED',
  /** self_directed_account_reopened */
  SelfDirectedAccountReopened = 'SELF_DIRECTED_ACCOUNT_REOPENED',
  /** spend_ach_manual_link_rejected */
  SpendAchManualLinkRejected = 'SPEND_ACH_MANUAL_LINK_REJECTED',
  /** split_withdrawal */
  SplitWithdrawal = 'SPLIT_WITHDRAWAL',
  /** student_fee_waiver_expired */
  StudentFeeWaiverExpired = 'STUDENT_FEE_WAIVER_EXPIRED',
  /** subscription_changed_to_gold */
  SubscriptionChangedToGold = 'SUBSCRIPTION_CHANGED_TO_GOLD',
  /** suitability_backfilled */
  SuitabilityBackfilled = 'SUITABILITY_BACKFILLED',
  /** trigger_debit_split_failed */
  TriggerDebitSplitFailed = 'TRIGGER_DEBIT_SPLIT_FAILED',
  /** unflagged_as_suspicious */
  UnflaggedAsSuspicious = 'UNFLAGGED_AS_SUSPICIOUS',
  /** user_preapproved */
  UserPreapproved = 'USER_PREAPPROVED',
  /** user_reopened */
  UserReopened = 'USER_REOPENED',
  /** user_suspended */
  UserSuspended = 'USER_SUSPENDED',
  /** user_unfrozen */
  UserUnfrozen = 'USER_UNFROZEN',
  /** user_unsuspended */
  UserUnsuspended = 'USER_UNSUSPENDED',
  /** withdrawal_payment_method_change */
  WithdrawalPaymentMethodChange = 'WITHDRAWAL_PAYMENT_METHOD_CHANGE'
}

export type BucketCsvInput = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type BucketInformation = {
  __typename?: 'BucketInformation';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BucketOptions = {
  __typename?: 'BucketOptions';
  bucketInformation: Array<BucketInformation>;
};

/** Bulk Card delivery status */
export type BulkCardDeliveryStatus = {
  __typename?: 'BulkCardDeliveryStatus';
  /** USPS Tracking Number */
  picNumber: Scalars['String']['output'];
  /** Endicia Reference ID */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Status enum */
  status: PackageStatus;
  /** Date and time of current status */
  timestamp?: Maybe<Scalars['String']['output']>;
};

/** bulk provisional fee waiver */
export type BulkProvisionalWaiver = {
  __typename?: 'BulkProvisionalWaiver';
  csvUrl: Scalars['String']['output'];
  waiverPeriodEndDate: Scalars['String']['output'];
  waiverReason?: Maybe<Scalars['String']['output']>;
};

/** input to the bulkSuspend mutation to orchestrate bulk suspensions */
export type BulkSuspendInput = {
  /** Document Request ID from DUS */
  documentRequestId: Scalars['ID']['input'];
  /** Optional note details */
  noteDetails?: InputMaybe<NoteDetailsInput>;
  /** Suspension reason */
  suspensionReason: SuspensionReason;
};

/** bulkSuspend response */
export type BulkSuspendResult = BulkSuspensionRecord | DocumentRequestMissingFileUrlException | InternalErrorException | InvalidDocumentRequestIdException;

/** A bulk suspension record initiated from the bulk suspension flow via Portal Admin */
export type BulkSuspensionRecord = TimestampsInterface & {
  __typename?: 'BulkSuspensionRecord';
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Document Request ID from DUS */
  documentRequestId: Scalars['ID']['output'];
  /** S3 file path for uploaded CSV */
  fileUrl: Scalars['String']['output'];
  noteBody?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the note processing finished */
  noteEndTime?: Maybe<Scalars['DateTime']['output']>;
  /** Note adding status */
  noteStatus: FileProcessingStatus;
  noteTitle?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the suspension processing finished */
  suspensionEndTime?: Maybe<Scalars['DateTime']['output']>;
  /** Provided suspension reason from Portal */
  suspensionReason: Scalars['String']['output'];
  /** Suspension processing status */
  suspensionStatus: FileProcessingStatus;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Portal Admin user's email */
  userEmail: Scalars['String']['output'];
};

/** Grouping of Products */
export type Bundle = {
  __typename?: 'Bundle';
  /** Image asset path in CDN */
  iconPath: Scalars['String']['output'];
  /** Name of bundle */
  name: Scalars['String']['output'];
  /** Associated products to display for grouping */
  products: Array<PresentableProduct>;
};

/** csv does not exist in s3 */
export type CsvDoesNotExistError = {
  __typename?: 'CSVDoesNotExistError';
  /** the csv url that was passed in */
  csvUrl?: Maybe<Scalars['String']['output']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum CampaignBackgroundType {
  SquirrelsWithAcorns = 'SQUIRRELS_WITH_ACORNS',
  SquirrelsWithAcornsCloud = 'SQUIRRELS_WITH_ACORNS_CLOUD',
  SquirrelsWithAcornsTransparent = 'SQUIRRELS_WITH_ACORNS_TRANSPARENT',
  SquirrelsWithAcornsUber = 'SQUIRRELS_WITH_ACORNS_UBER'
}

export enum CampaignFilterType {
  Advertised = 'ADVERTISED',
  Participated = 'PARTICIPATED'
}

export type CampaignHistoryConnection = {
  __typename?: 'CampaignHistoryConnection';
  edges?: Maybe<Array<CampaignHistoryEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export type CampaignHistoryEdge = {
  __typename?: 'CampaignHistoryEdge';
  cursor: Scalars['String']['output'];
  eligibilityMet?: Maybe<Scalars['Boolean']['output']>;
  hurdleMet?: Maybe<Scalars['Boolean']['output']>;
  node: ReferralCampaignV2;
  numCompletedReferrals?: Maybe<Scalars['Int']['output']>;
  numPendingReferrals?: Maybe<Scalars['Int']['output']>;
};

export type CampaignHistoryFilter = {
  /** filters specific Campaign */
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether campaigns where created after the date. */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Whether or not hurdle has been met */
  hurdleMet?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether campaigns where published after the date. Defaults to 6 month back */
  publishedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Published Campaign status (eg. COMPLETE, LIVE, PENDING, SCHEDULED) */
  publishedStatus?: InputMaybe<PublishedCampaignStatus>;
  /** Campaign reward filter type */
  rewardType?: InputMaybe<CampaignRewardFilterType>;
  /** Campaign filter type */
  type: CampaignFilterType;
};

export enum CampaignIconType {
  SquirrelAvatar_1 = 'SQUIRREL_AVATAR_1',
  SquirrelAvatar_2 = 'SQUIRREL_AVATAR_2',
  SquirrelAvatar_3 = 'SQUIRREL_AVATAR_3',
  SquirrelAvatarUber = 'SQUIRREL_AVATAR_UBER'
}

export enum CampaignQualificationActionType {
  InitialInvestment = 'INITIAL_INVESTMENT'
}

export enum CampaignRewardFilterType {
  Burst = 'BURST',
  Evergreen = 'EVERGREEN'
}

export enum CampaignStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type CampaignV2 = {
  __typename?: 'CampaignV2';
  campaignId?: Maybe<Scalars['ID']['output']>;
};

export type CancelBankAccountClosureRequest = {
  __typename?: 'CancelBankAccountClosureRequest';
  accountId?: Maybe<Scalars['ID']['output']>;
  accountType?: Maybe<BankAccountType>;
};

export type CancelBankAccountClosureRequestError = {
  __typename?: 'CancelBankAccountClosureRequestError';
  failureMessage: Scalars['String']['output'];
};

export type CancelBankAccountClosureRequestInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountType?: InputMaybe<BankAccountType>;
  userId: Scalars['ID']['input'];
};

export type CancelBankAccountClosureRequestResult = CancelBankAccountClosureRequestError | CancelBankAccountClosureRequestSuccess;

export type CancelBankAccountClosureRequestSuccess = {
  __typename?: 'CancelBankAccountClosureRequestSuccess';
  cancelBankAccountClosureRequests?: Maybe<Array<Maybe<CancelBankAccountClosureRequest>>>;
};

/** The result of the cancelCheckPayment mutation */
export type CancelCheckPaymentResult = AuthorizationError | CheckPayment | ResourceNotFoundError | UnableToCancelCheckError;

/** Input to cancel funding source */
export type CancelFundingSourceInput = {
  /** Funding source id to cancel */
  fundingSourceId: Scalars['Int']['input'];
};

/** Response of liquidating fractional shares */
export type CancelFundingSourceResponse = CantCancelFundingSourceException | DeletedFundingSourceException | FundingSource | FundingSourceNotFoundException;

/** Cancel investment account request mutation response */
export type CancelInvestmentAccountClosureRequestResult = AccountClosedException | AccountNotFoundException | ClosureRequestDoesNotExistException | InvestmentAccount;

/** Input to cancel a pending investment */
export type CancelInvestmentInput = {
  /** DEPRECATED: The ID of the investment account */
  investmentAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the pending investment associated with the investment account id */
  investmentId: Scalars['ID']['input'];
};

/** ID of canceled investment */
export type CancelInvestmentPayload = {
  __typename?: 'CancelInvestmentPayload';
  id: Scalars['ID']['output'];
};

/** Cancel investment mutation response */
export type CancelInvestmentResult = CancelInvestmentPayload | InvestmentNotFoundException | InvestmentUncancellableException;

export type CancelMoneyAssignmentInput = {
  transactionId: Scalars['ID']['input'];
};

export type CancelMoneyAssignmentResult = MoneyAssignmentAlreadyTransferredError | MoneyAssignmentNotFoundError | MoneyRulesCancelMoneyAssignmentSuccess;

export type CancelRecurringTransferResult = RecurringTransfer | VersionMismatchException;

export type CancelRequestedDocumentInput = {
  documentRequestId: Scalars['ID']['input'];
  reviewerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Statement run cannot be canceled. */
export type CancelStatementRunNotAllowedException = {
  __typename?: 'CancelStatementRunNotAllowedException';
  message: Scalars['String']['output'];
};

/** Result of statement run cancellation */
export type CancelStatementRunResponse = CancelStatementRunNotAllowedException | StatementRun | StatementRunNotFoundException;

export type CancelTransactionData = {
  __typename?: 'CancelTransactionData';
  transactionId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type CancelTransactionInput = {
  transactionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Funding source cant be canceled. */
export type CantCancelFundingSourceException = {
  __typename?: 'CantCancelFundingSourceException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Card delivery status */
export type CardDeliveryStatus = {
  __typename?: 'CardDeliveryStatus';
  /** When the card tracking record was created */
  createdAt: Scalars['String']['output'];
  /** Current Tracking Status Description */
  description?: Maybe<Scalars['String']['output']>;
  /** USPS Tracking Number */
  picNumber?: Maybe<Scalars['String']['output']>;
  /** Reference ID */
  referenceId: Scalars['String']['output'];
  /** Status enum */
  status: PackageStatus;
  /** When the card tracking record was updated */
  updatedAt: Scalars['String']['output'];
};

export enum CarouselType {
  Banner = 'BANNER',
  Standard = 'STANDARD'
}

export type CaseCategoryContent = {
  __typename?: 'CaseCategoryContent';
  caseCategory: Scalars['String']['output'];
};

export type CaseCategoryError = {
  __typename?: 'CaseCategoryError';
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CaseInput = {
  case_category?: InputMaybe<Scalars['String']['input']>;
  group_ids: Array<Scalars['String']['input']>;
  last_comment: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ChallengeAnswerInput = {
  challengeAnswer: Scalars['String']['input'];
  challengeId: Scalars['ID']['input'];
};

export enum ChallengeDeliveryType {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS'
}

export type ChallengePointsEarned = {
  __typename?: 'ChallengePointsEarned';
  challengeID: Scalars['ID']['output'];
  /** legal copy about how points are earned */
  details: Scalars['String']['output'];
  /** how many points earned out of how many possible */
  earningProgress: DiscreteMilestoneProgress;
  /** summarized information about how points are earned */
  summary?: Maybe<Scalars['String']['output']>;
};

export enum ChallengePushState {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ChallengeRateExceededException = {
  __typename?: 'ChallengeRateExceededException';
  errorCode: Scalars['String']['output'];
};

export enum ChallengeTriggers {
  Authenticate = 'AUTHENTICATE',
  InitEmail = 'INIT_EMAIL',
  InitEmailForAuthenticate = 'INIT_EMAIL_FOR_AUTHENTICATE',
  InitPushForVerification = 'INIT_PUSH_FOR_VERIFICATION',
  InitSms = 'INIT_SMS',
  ReinitChallenge = 'REINIT_CHALLENGE',
  StepUpAuthentication = 'STEP_UP_AUTHENTICATION',
  SuspendedChallenge = 'SUSPENDED_CHALLENGE',
  SuspendedInitEmailForAuthenticate = 'SUSPENDED_INIT_EMAIL_FOR_AUTHENTICATE'
}

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  securityAnswer?: InputMaybe<SecurityAnswer>;
};

export type ChangePasswordResult = ChangePasswordSuccess | IncorrectOldPasswordException | IncorrectSecurityAnswerException | InvalidPasswordException;

export type ChangePasswordSuccess = {
  __typename?: 'ChangePasswordSuccess';
  userId: Scalars['ID']['output'];
};

export type ChangeSecuritySymbolInput = {
  newSymbol: Scalars['TickerSymbol']['input'];
  priorSymbol: Scalars['TickerSymbol']['input'];
};

export type ChangeSecuritySymbolResult = Fund | InvalidSecurityForSymbolChangeError | InvalidSymbolForSymbolChangeError | Stock;

export type CheckPayment = {
  __typename?: 'CheckPayment';
  amount: CurrencyAmount;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  checkNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  estimatedArrivalAt: Scalars['DateTime']['output'];
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  failureReason?: Maybe<CheckPaymentFailureReason>;
  fromAccountId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  recipientAddress: CheckPaymentAddress;
  recipientName: Scalars['String']['output'];
  status: CheckPaymentStatus;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type CheckPaymentAddress = {
  __typename?: 'CheckPaymentAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type CheckPaymentAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export type CheckPaymentConnection = {
  __typename?: 'CheckPaymentConnection';
  edges: Array<CheckPaymentEdge>;
  pageInfo: PageInfo;
};

export type CheckPaymentEdge = {
  __typename?: 'CheckPaymentEdge';
  cursor: Scalars['ID']['output'];
  node: CheckPayment;
};

export enum CheckPaymentFailureReason {
  InsufficientFunds = 'insufficientFunds'
}

export type CheckPaymentRecipient = {
  __typename?: 'CheckPaymentRecipient';
  businessName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type CheckPaymentRecipientAddressType = {
  __typename?: 'CheckPaymentRecipientAddressType';
  recipient: CheckPaymentRecipient;
  recipientAddress: CheckPaymentAddress;
};

export type CheckPaymentRecipientInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export enum CheckPaymentStatus {
  Canceled = 'canceled',
  Failed = 'failed',
  Pending = 'pending',
  Shipped = 'shipped'
}

export enum ClaimStatus {
  Claimed = 'CLAIMED',
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON',
  Ineligible = 'INELIGIBLE',
  InProgress = 'IN_PROGRESS',
  Unclaimed = 'UNCLAIMED',
  UpgradeRequired = 'UPGRADE_REQUIRED'
}

export type ClaimStatusDetails = {
  __typename?: 'ClaimStatusDetails';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<BenefitStatusDetail>;
};

/** Response from clearing stuck orders */
export type ClearStuckOrdersResponse = {
  __typename?: 'ClearStuckOrdersResponse';
  status: Scalars['String']['output'];
};

export type ClearSupportSiteCache = {
  __typename?: 'ClearSupportSiteCache';
  eventIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CloseBankAccountInput = {
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type CloseBankAccountPayload = {
  __typename?: 'CloseBankAccountPayload';
  closedBankAccount?: Maybe<ClosedBankAccount>;
};

/** Investment account closure request */
export type CloseInvestmentAccountInput = {
  /** List of reasons for account closure */
  accountClosureReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Account closure reason comments */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the investment account to be closed */
  investmentAccountId: Scalars['ID']['input'];
};

/** Investment Account Closure Response */
export type CloseInvestmentAccountResult = AccountNotFoundException | InvestmentAccount | InvestmentAccountAlreadyClosed | InvestmentAccountClosureInProgress | NonBasicAccountOpenException;

/** Object representing an user from closeUserAccount mutation */
export type CloseUserAccountResponse = {
  __typename?: 'CloseUserAccountResponse';
  /** AASM state of the closure request */
  aasmState: Scalars['String']['output'];
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** User UUID who requested the closure */
  requestedByUserUuid: Scalars['ID']['output'];
  /** Update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** User uuid */
  userUuid: Scalars['ID']['output'];
};

export type ClosedBankAccount = {
  __typename?: 'ClosedBankAccount';
  closingBalanceAmount: Scalars['Float']['output'];
  interestPaidAmount: Scalars['Float']['output'];
  isClosedToExternalAccount: Scalars['Boolean']['output'];
  totalClosingAmount: Scalars['Float']['output'];
  transactionId?: Maybe<Scalars['ID']['output']>;
};

/** No account closure request exists for the given investment account */
export type ClosureRequestDoesNotExistException = {
  __typename?: 'ClosureRequestDoesNotExistException';
  /** message */
  errorMessage?: Maybe<Scalars['String']['output']>;
};

/** The state of a generic group that a User belongs to. */
export type CohortReason = {
  __typename?: 'CohortReason';
  /** Human-readable identifier of the Cohort */
  name: Scalars['String']['output'];
  /** Metadata indicating why the status of a Cohort is what it is for a User */
  reasons: Array<Scalars['String']['output']>;
  /** State of the Cohort in-relation to a User */
  status: CohortStatus;
  /** Timestamp when a CohortReason was last updated for a User */
  updatedAt: Scalars['DateTime']['output'];
  /** Foreign key referencing the User a Cohort object relates to */
  userId: Scalars['ID']['output'];
};

export enum CohortStatus {
  /** User was added into the cohort */
  APartOf = 'A_PART_OF',
  /** User has never been a part of the cohort */
  NeverAPartOf = 'NEVER_A_PART_OF',
  /** User was removed from the cohort */
  WasAPartOf = 'WAS_A_PART_OF'
}

export enum CollectionMethod {
  Automatic = 'automatic',
  Manual = 'manual'
}

export type ConfigureSettingsInput = {
  employerHidden?: InputMaybe<Scalars['Boolean']['input']>;
  employerName: Scalars['String']['input'];
  splitPercent: Scalars['String']['input'];
  splitType: DistributionType;
};

export type ConfigureSplitDepositDirectDepositIntentPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositIntentPayload';
  intent: SplitDepositDirectDepositIntentSetting;
};

export type ConfigureSplitDepositDirectDepositIntentSettingInput = {
  allocations: Array<SplitDepositAllocationInput>;
  estimatedPaycheckAmount: CurrencyAmountInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
  isHidden: Scalars['Boolean']['input'];
  isUsingRecommendedAllocations: Scalars['Boolean']['input'];
};

export type ConfigureSplitDepositDirectDepositSettingInput = {
  allocations: Array<SplitDepositAllocationInput>;
  directDepositIntentSettingId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  isHidden: Scalars['Boolean']['input'];
  isUsingRecommendedAllocations: Scalars['Boolean']['input'];
};

export type ConfigureSplitDepositDirectDepositSettingPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositSettingPayload';
  setting: SplitDepositDirectDepositSetting;
};

export type ConnectCategoryObject = CaseCategoryContent | CaseCategoryError;

export enum ConnectionStatus {
  Authorized = 'AUTHORIZED',
  TfaRequired = 'TFA_REQUIRED',
  Unauthorized = 'UNAUTHORIZED'
}

export type ConnectionSummary = {
  __typename?: 'ConnectionSummary';
  connections?: Maybe<Array<BankConnection>>;
  totalEligibleFeeCount?: Maybe<Scalars['Int']['output']>;
  totalEligibleFees?: Maybe<MonetaryAmount>;
  /** @deprecated replaced by totalEligibleFees */
  totalEligibleFeesForUser?: Maybe<MonetaryAmount>;
  userEligibility?: Maybe<Scalars['Boolean']['output']>;
};

export type ConsumeUserTokenResult = InvalidUserTokenException | UserToken;

export type ContactCategory = {
  __typename?: 'ContactCategory';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  subcategories?: Maybe<Array<ContactSubcategory>>;
  value: Scalars['String']['output'];
};

export type ContactFaq = {
  __typename?: 'ContactFaq';
  answer: Scalars['String']['output'];
  href: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type ContactFormAlert = {
  __typename?: 'ContactFormAlert';
  message?: Maybe<Scalars['String']['output']>;
};

export type ContactSubcategory = {
  __typename?: 'ContactSubcategory';
  chatEnabled: Scalars['Boolean']['output'];
  emailEnabled: Scalars['Boolean']['output'];
  faqs: Array<ContactFaq>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  message?: Maybe<SubcategoryMessage>;
  phoneEnabled: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type ContributionAbility = {
  __typename?: 'ContributionAbility';
  /**  flag indicating if the user can contribute to this tax year */
  canContribute?: Maybe<Scalars['Boolean']['output']>;
  /**  maximum legally allowed amount for contributions */
  planLimit?: Maybe<Scalars['Int']['output']>;
  /**  available contribution amount */
  remaining?: Maybe<Scalars['Float']['output']>;
  /**  tax year of aggregated contributions */
  taxYear: Scalars['Int']['output'];
  /**  total current contributions in tax year */
  yearToDate?: Maybe<Scalars['Float']['output']>;
};

export type ContributionAbilityByYear = {
  __typename?: 'ContributionAbilityByYear';
  contributionAbilities?: Maybe<Array<ContributionAbility>>;
};

/** Attributes for creating an AcceptanceDocument */
export type CreateAcceptanceDocumentInput = {
  /** Type of the AcceptanceDocument */
  documentType: Scalars['String']['input'];
  /** Whether user must scroll to bottom before accepting */
  mustScrollToBottom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the AcceptanceDocument */
  name: Scalars['ID']['input'];
  /** Whether this document should be required */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the summary */
  summaryName?: InputMaybe<Scalars['String']['input']>;
  /** URL to the summary */
  summaryUrl?: InputMaybe<Scalars['URL']['input']>;
  /** URL to the document */
  url: Scalars['URL']['input'];
  /** Version number of the document */
  version: Scalars['String']['input'];
};

/** Result of acceptance document creation */
export type CreateAcceptanceDocumentResponse = AcceptanceDocument | InvalidAcceptanceDocumentException;

/** Attributes for creating a filter on an acceptance document version */
export type CreateAcceptanceDocumentVersionFilterInput = {
  /** UUID of the AcceptanceDocumentVersion */
  acceptanceDocumentVersionId: Scalars['ID']['input'];
  /** Name of the filter */
  name: Scalars['String']['input'];
};

/** Result of acceptance document version filter creation */
export type CreateAcceptanceDocumentVersionFilterResponse = AcceptanceDocumentVersionFilter | AcceptanceDocumentVersionNotFoundException | InvalidAcceptanceDocumentVersionFilterException;

/** Attributes for creating a new acceptance document version */
export type CreateAcceptanceDocumentVersionInput = {
  /** UUID of the AcceptanceDocument */
  acceptanceDocumentId: Scalars['ID']['input'];
  /** Whether user must scroll to bottom before accepting */
  mustScrollToBottom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this document should be required */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the summary */
  summaryName?: InputMaybe<Scalars['String']['input']>;
  /** URL to the summary */
  summaryUrl?: InputMaybe<Scalars['URL']['input']>;
  /** URL to the document */
  url: Scalars['URL']['input'];
  /** Version number of the document */
  version: Scalars['String']['input'];
};

/** Result of acceptance document version creation */
export type CreateAcceptanceDocumentVersionResponse = AcceptanceDocumentNotFoundException | AcceptanceDocumentVersion | InvalidAcceptanceDocumentVersionException;

export type CreateAuthProfileInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type CreateAuthProfileResult = AuthProfile | AuthProfileAlreadyExistsException;

export type CreateBankAccountInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  bankType?: InputMaybe<BankType>;
  isDocumentsAccepted: Scalars['Boolean']['input'];
  shouldEnableAccountEligibility?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  type: BankAccountType;
  userId: Scalars['ID']['input'];
};

export type CreateBankAccountPayload = {
  __typename?: 'CreateBankAccountPayload';
  bankAccountId: Scalars['ID']['output'];
};

/** Routing number must be unique. */
export type CreateBankDuplicateRoutingNumberError = {
  __typename?: 'CreateBankDuplicateRoutingNumberError';
  /** Inputed routing number */
  routingNumber: Scalars['String']['output'];
};

/** Parameters to create a new Bank */
export type CreateBankInput = {
  /** Name of the bank */
  bankName: Scalars['String']['input'];
  /** City */
  city: Scalars['String']['input'];
  /** Routing number (unique) */
  routingNumber: Scalars['String']['input'];
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Result of bank creation */
export type CreateBankResult = BankResult | CreateBankDuplicateRoutingNumberError;

export type CreateBankTransferData = {
  __typename?: 'CreateBankTransferData';
  id: Scalars['ID']['output'];
};

export type CreateBankTransferFromAccountToProgramInput = {
  amount: PositiveCurrencyAmountInput;
  bankProgramAccountType: BankProgramAccountType;
  description?: InputMaybe<Scalars['String']['input']>;
  fromAccountId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateBankTransferFromAccountToProgramNonRetryableError = {
  __typename?: 'CreateBankTransferFromAccountToProgramNonRetryableError';
  failureMessage: Scalars['String']['output'];
};

export type CreateBankTransferFromAccountToProgramResult = CreateBankTransferFromAccountToProgramNonRetryableError | CreateBankTransferFromAccountToProgramSuccess;

export type CreateBankTransferFromAccountToProgramSuccess = {
  __typename?: 'CreateBankTransferFromAccountToProgramSuccess';
  amount: CurrencyAmount;
  bankType: BankType;
};

export type CreateBankTransferFromProgramToAccountInput = {
  amount: PositiveCurrencyAmountInput;
  bankProgramAccountType: BankProgramAccountType;
  description?: InputMaybe<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  toAccountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateBankTransferFromProgramToAccountNonRetryableError = {
  __typename?: 'CreateBankTransferFromProgramToAccountNonRetryableError';
  failureMessage?: Maybe<Scalars['String']['output']>;
};

export type CreateBankTransferFromProgramToAccountResult = CreateBankTransferFromProgramToAccountNonRetryableError | CreateBankTransferFromProgramToAccountRetryableError | CreateBankTransferFromProgramToAccountSuccess;

export type CreateBankTransferFromProgramToAccountRetryableError = {
  __typename?: 'CreateBankTransferFromProgramToAccountRetryableError';
  failureMessage?: Maybe<Scalars['String']['output']>;
};

export type CreateBankTransferFromProgramToAccountSuccess = {
  __typename?: 'CreateBankTransferFromProgramToAccountSuccess';
  amount: CurrencyAmount;
  bankType: BankType;
};

export type CreateBankTransferInput = {
  amount: PositiveCurrencyAmountInput;
  from: Scalars['ID']['input'];
  nonce?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Response to a beneficiary creation attempt */
export type CreateBeneficiaryResult = Beneficiary | BeneficiaryExceedsAgeLimitException | InternalErrorException | InvalidDateOfBirthException | InvalidFirstNameException | InvalidLastNameException;

/** bulk provisional waivers attributes */
export type CreateBulkProvisionalWaiversInput = {
  /** the last day for which the waiver will apply */
  waiverPeriodEndDate: Scalars['String']['input'];
  /** a description of why the waiver was created */
  waiverReason: Scalars['String']['input'];
};

/** result from attempting to create bulk provisional waivers for a csv or users */
export type CreateBulkProvisionalWaiversResult = BulkProvisionalWaiver | CsvDoesNotExistError | InvalidDateException | InvalidWaiverReasonLengthError | WaiverCreationException | WaiverEndDateInPastError;

export type CreateCustomSupportTicketInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  ticketFormId?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateDocumentUpload = {
  __typename?: 'CreateDocumentUpload';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  requestedDocumentId: Scalars['ID']['output'];
  uploadUrl: Scalars['URL']['output'];
};

export type CreateDocumentUploadInput = {
  contentType: Scalars['String']['input'];
  documentType: DocumentType;
  filename?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** error response for CreateFeeCollection mutation */
export type CreateFeeCollectionError = {
  __typename?: 'CreateFeeCollectionError';
  message?: Maybe<Scalars['String']['output']>;
};

/** result from attempting to create a fee collection for a user */
export type CreateFeeCollectionResult = BillingCycle | CreateFeeCollectionError;

/** Input for creating a IRA distribution (withdrawal for Later) */
export type CreateIraDistributionInput = {
  /** IRA distribution (withdrawal) amount with values amount in cents and currency of the amount */
  amount: MoneyInput;
  /** distribution codes for the IRA distribution (withdrawal) */
  distributionCodes: Array<IraDistributionCode>;
  /** For the benefit of */
  fbo?: InputMaybe<Scalars['String']['input']>;
  /** federal tax withholding percentage */
  federalTaxWitholdingPercent: Scalars['String']['input'];
  /** ID of the desired funding source to send funds to */
  fundingSourceId?: InputMaybe<Scalars['ID']['input']>;
  /** Investment account ID of later account to create IRA distribution in */
  investmentAccountId: Scalars['ID']['input'];
  /** Payment method for manual withdrawals created by ops */
  paymentMethod?: InputMaybe<PaymentMethod>;
  /** Reason for IRA distribution */
  reason?: InputMaybe<IraWithdrawalReason>;
  /** state tax withholding percentage */
  stateTaxWitholdingPercent: Scalars['String']['input'];
  /** Tax year the IRA distribution was create/contributed towards */
  taxYear: Scalars['Int']['input'];
  /** Type of IRA distribution (withdrawal) */
  withdrawalType: IraWithdrawalType;
};

/** Response from creating a IRA Distribution */
export type CreateIraDistributionResult = IraDistribution | InvalidFundingSourceError | InvalidIraDistributionAmountError | InvestmentAccountClosedError | InvestmentAccountNotFoundException | NonRetirementAccountError;

export type CreateImplicitTokenForUserInput = {
  oauthAppClientId?: InputMaybe<Scalars['String']['input']>;
  oauthAppId: Scalars['String']['input'];
};

export type CreateImplicitTokenForUserResult = ImplicitToken | InvalidOauthAppClientIdException | OauthAppNotFoundException;

/** Input for creating investing strategy recommendations */
export type CreateInvestingStrategyRecommendationInput = {
  /** Type of account to get recommendation for */
  accountType: SuitabilityAccountType;
  /** Factors affecting outcome of recommendation */
  factors: Array<InvestingStrategyFactors>;
};

export type CreateInvestingStrategyRecommendationResult = BadRequestError | RecommendedInvestingStrategy;

/** Input for Creating an Investment for a User */
export type CreateInvestmentInput = {
  /** Amount to be invested into User's account */
  amount: Scalars['String']['input'];
  /** The desired funding source to pull funds from. Primary funding source will be used as default */
  fundingSourceId?: InputMaybe<Scalars['ID']['input']>;
  /** Funding transfer for investment has already been created externally */
  fundingTransferCreated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Account for the investment being made */
  investmentAccountId: Scalars['ID']['input'];
  /** Note for the investment */
  investmentNote?: InputMaybe<Scalars['String']['input']>;
  /** Investment Type */
  investmentType?: InputMaybe<InvestmentType>;
  /** A nonce to avoid duplicate investments being created */
  nonce: Scalars['ID']['input'];
  /** Payment method */
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  /** Status to initialize the investment with */
  status?: InputMaybe<InvestmentCreationStatus>;
  /** The year in which the contribution occurred */
  taxYear?: InputMaybe<Scalars['Int']['input']>;
  /** Title for the investment */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Transaction ID */
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  /** Type either fee or credit */
  type: Scalars['String']['input'];
  /** Unique Identifier for a User */
  userId: Scalars['ID']['input'];
};

/** Create Investment for User Response */
export type CreateInvestmentResult = AccountAlreadyClosedException | InternalErrorException | InvalidFundingSourceException | Investment | InvestmentCreationFailedException | TaxYearNotEnteredForIraException | UserNotFoundException | UserNotVerifiedException | UserSuspendedException;

export type CreateJobAlertResult = JobAlert;

/** waiver attributes */
export type CreateMightyOakCardWaiverInput = {
  /** number of months which the waiver will apply */
  monthsToWaive: Scalars['Int']['input'];
};

/** result from attempting to create a Mighty Oak Card waiver for a user */
export type CreateMightyOakCardWaiverResult = BillingProfileNotFoundException | InvalidNumberOfMonthsException | InvalidUserIdException | MightyOakCardWaiver | WaiverCreationException;

export type CreateOauthAppInput = {
  accessTokenAudience: Array<InputMaybe<Scalars['String']['input']>>;
  accessTokenExpiry?: InputMaybe<Scalars['Int']['input']>;
  active: Scalars['Boolean']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  externalApp: Scalars['Boolean']['input'];
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pageType: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiry?: InputMaybe<Scalars['Int']['input']>;
  scopeIdentifiers: Array<Scalars['String']['input']>;
  type: OauthAppType;
};

export type CreateOauthAppResult = OauthApp;

export type CreateOfferInput = {
  availableTo: OfferAvailability;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  offerType: OfferType;
  price: OfferPriceInput;
};

export type CreateOfferResult = Offer;

/** Parameters to create a new Portfolio */
export type CreatePortfolioInput = {
  /** Active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Color 1 */
  color1: Scalars['String']['input'];
  /** Color 2 */
  color2: Scalars['String']['input'];
  /** Description of the portfolio */
  description: Scalars['String']['input'];
  /** Funding Ratios */
  fundingRatiosAttributes?: InputMaybe<Array<FundingRatiosInput>>;
  /** Growth rate average */
  growthRateAverage: Scalars['Float']['input'];
  /** Growth rate highest */
  growthRateHighest: Scalars['Float']['input'];
  /** Growth rate lowest */
  growthRateLowest: Scalars['Float']['input'];
  /** Name of the portfolio */
  name: Scalars['String']['input'];
  /** Portfolio type */
  portfolioType: PortfolioTypeEnum;
  /** Position */
  position: Scalars['Int']['input'];
};

/** Parameters to create a new Portfolio Tag */
export type CreatePortfolioTagInput = {
  /** Description */
  description: Scalars['String']['input'];
  /** Order Number */
  orderNumber: Scalars['Int']['input'];
  /** Type */
  tagType: Scalars['String']['input'];
  /** Value */
  tagValue: Scalars['String']['input'];
};

export type CreatePromoCodeInput = {
  businessLine: PromoCodeBusinessLine;
  channel: Scalars['String']['input'];
  condensedTitle: Scalars['String']['input'];
  description: Scalars['String']['input'];
  internalMemo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  publishEnd?: InputMaybe<Scalars['DateTime']['input']>;
  publishStart: Scalars['DateTime']['input'];
  qualificationAction: PromoCodeQualificationAction;
  qualificationAmount: Scalars['Int']['input'];
  rewards: Array<Scalars['ID']['input']>;
  status: PromoCodeStatus;
  termsUrl?: InputMaybe<Scalars['URL']['input']>;
  title: Scalars['String']['input'];
};

export type CreatePromoCodeResult = DuplicatePromoCodeError | PromoCode | PromoCodeFieldLengthError;

export type CreatePromoCodeRewardInput = {
  amount: Scalars['Float']['input'];
  type: PromoCodeRewardType;
};

export type CreatePromoCodeRewardResult = DuplicatePromoCodeRewardError | PromoCodeReward;

/** waiver attributes */
export type CreatePromotionalWaiverInput = {
  /** coupon code for promotional waiver */
  couponPromotion?: InputMaybe<Scalars['String']['input']>;
  /** number of months which the waiver will apply */
  monthsToWaive: Scalars['Int']['input'];
  /** type of promotional waiver to apply */
  promotion?: InputMaybe<WaiverPromotion>;
};

/** result from attempting to create a promotional waiver for a user */
export type CreatePromotionalWaiverResult = BillingProfileNotFoundException | InvalidNumberOfMonthsException | InvalidUserIdException | PromotionalWaiver | WaiverCreationException;

/** Input for creating a prospect user */
export type CreateProspectUserInput = {
  /** Email address of the prospect user */
  email: Scalars['String']['input'];
  /** Prospect Type */
  type: ProspectType;
};

/** Create Prospect User Response */
export type CreateProspectUserResult = GrowProspect | LaterWaitlistProspect | OutsideContributionProspect | User_V2;

/** waiver attributes */
export type CreateProvisionalWaiverInput = {
  /** the last day for which the waiver will apply */
  waiverPeriodEndDate: Scalars['String']['input'];
  /** a description of why the waiver was created */
  waiverReason: Scalars['String']['input'];
};

/** result from attempting to create a provisional waiver for a user */
export type CreateProvisionalWaiverResult = InvalidDateException | InvalidUserIdException | ProvisionalWaiver | WaiverCreationException;

export type CreateReferralCampaignInput = {
  actionFeedDesc?: InputMaybe<Scalars['String']['input']>;
  background?: InputMaybe<CampaignBackgroundType>;
  condensedTitle?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  eligibilityEnd?: InputMaybe<Scalars['DateTime']['input']>;
  hidden: Scalars['Boolean']['input'];
  icon?: InputMaybe<CampaignIconType>;
  internalMemo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  publishEnd?: InputMaybe<Scalars['DateTime']['input']>;
  publishStart: Scalars['DateTime']['input'];
  qualificationAction: CampaignQualificationActionType;
  qualificationAmount: Scalars['Int']['input'];
  rewards: Array<Scalars['ID']['input']>;
  status: CampaignStatus;
  title: Scalars['String']['input'];
};

export type CreateReferralCampaignResult = ReferralCampaignV2;

export type CreateReferralCampaignRewardInput = {
  amount: Scalars['Float']['input'];
  hurdle: Scalars['Int']['input'];
  repeated: Scalars['Boolean']['input'];
  targets: Array<ReferralCampaignRewardTarget>;
  type: ReferralCampaignRewardType;
};

export type CreateReferralCampaignRewardResult = ReferralCampaignReward;

export type CreateReferralPayoutInput = {
  advocateId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
  friendId?: InputMaybe<Scalars['ID']['input']>;
  rewardId: Scalars['ID']['input'];
};

export type CreateReferralPayoutResult = ReferralPayout | ReferralPayoutExistsError;

export type CreateReferralRelationshipResult = InvalidReferralRelationship | ReferralRelationship;

export type CreateRefundError = {
  __typename?: 'CreateRefundError';
  message: Scalars['String']['output'];
};

export type CreateRefundResult = BillingInvoice | CreateRefundError | VendorIntegrationError | VendorRefundInvoiceError;

export type CreateSavingsAccountInternalInput = {
  bankType?: InputMaybe<BankType>;
  currentGoal?: InputMaybe<BankAccountGoalInput>;
  isReopen?: InputMaybe<Scalars['Boolean']['input']>;
  type: SavingsAccountType;
  userId: Scalars['ID']['input'];
};

export type CreateSavingsAccountPayload = {
  __typename?: 'CreateSavingsAccountPayload';
  bankAccountId: Scalars['ID']['output'];
};

export type CreateSavingsAccountResult = CreateSavingsAccountPayload | CreateSavingsAccountVerificationError;

export type CreateSavingsAccountVerificationError = {
  __typename?: 'CreateSavingsAccountVerificationError';
  notEligibleReasons: Array<SavingsAccountEligibilityRequirement>;
};

export type CreateScopeException = {
  __typename?: 'CreateScopeException';
  message: Scalars['String']['output'];
};

export type CreateScopeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateScopeResult = CreateScopeException | Scope;

export type CreateSubscriptionMigrationInput = {
  description: Scalars['String']['input'];
  effectiveAt: Scalars['DateTime']['input'];
  fromTierId: Scalars['ID']['input'];
  toTierId: Scalars['ID']['input'];
};

export type CreateSubscriptionMigrationResult = SubscriptionMigration;

export type CreateSupportTicketInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSuspendedUserSupportTicketInput = {
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  message: Array<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Create presigned url result */
export type CreateTinVerificationUploadPresignedUrlResult = TinVerificationUploadPresignedUrl;

export type CreateUserInput = {
  acceptanceDocumentVersionUuids: Array<InputMaybe<Scalars['String']['input']>>;
  authorizationAccessToken?: InputMaybe<Scalars['String']['input']>;
  authorizationExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  authorizationProvider?: InputMaybe<Scalars['String']['input']>;
  authorizationRefreshToken?: InputMaybe<Scalars['String']['input']>;
  authorizationUid?: InputMaybe<Scalars['String']['input']>;
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  clientCredentialsToken?: InputMaybe<Scalars['String']['input']>;
  codeGroup?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  sourceAttributes?: InputMaybe<Scalars['JSON']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  udid: Scalars['String']['input'];
  usResident?: InputMaybe<Scalars['Boolean']['input']>;
  withBasicAccount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateVendorInvoiceInput = {
  chargeCustomerNotes?: InputMaybe<Scalars['String']['input']>;
  collectionMethod?: InputMaybe<CollectionMethod>;
  creditCustomerNotes?: InputMaybe<Scalars['String']['input']>;
  currency: Currency;
  netTerms?: InputMaybe<Scalars['Int']['input']>;
  netTermsType?: InputMaybe<NetTermsType>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  vatReverseChargeNotes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVendorInvoiceResult = BillingVendorError | InvoiceCollection;

export type CreateVendorLineItemInput = {
  accountingCode?: InputMaybe<Scalars['String']['input']>;
  avalaraServiceType?: InputMaybe<Scalars['Int']['input']>;
  avalaraTransactionType?: InputMaybe<Scalars['Int']['input']>;
  creditReasonCode?: InputMaybe<CreditReasonCode>;
  currency: Currency;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Origin>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  revenueScheduleType?: InputMaybe<RevenueScheduleType>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  taxInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  type: Type;
  unitAmount: Scalars['Float']['input'];
};

export type CreateVendorLineItemResult = BillingVendorError | InvoiceLineItem;

export enum CredentialStatus {
  Invalid = 'INVALID',
  Pending = 'PENDING',
  Valid = 'VALID'
}

export type Credentials = {
  __typename?: 'Credentials';
  email: Scalars['EmailAddress']['output'];
  userId: Scalars['ID']['output'];
};

/** Possible credentials types */
export enum CredentialsType {
  /** Apple OIDC credentials */
  Apple = 'APPLE',
  /** Native email and password credentials */
  User = 'USER'
}

/** Credit information */
export type Credit = TimestampsInterface & {
  __typename?: 'Credit';
  amount: Scalars['Float']['output'];
  assessedAt?: Maybe<Scalars['String']['output']>;
  billingCycle: BillingCycle;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  discountId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  state: Scalars['String']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export enum CreditInvestmentStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Chargeback = 'CHARGEBACK',
  Confirmed = 'CONFIRMED',
  Declined = 'DECLINED',
  Failed = 'FAILED',
  Locked = 'LOCKED',
  Pending = 'PENDING',
  PendingDuplicate = 'PENDING_DUPLICATE',
  PendingSettle = 'PENDING_SETTLE',
  PostedIn = 'POSTED_IN',
  PostedOut = 'POSTED_OUT',
  Refunded = 'REFUNDED',
  Revoked = 'REVOKED',
  Settled = 'SETTLED',
  SharesSettled = 'SHARES_SETTLED',
  Suspended = 'SUSPENDED',
  Transferred = 'TRANSFERRED',
  Voided = 'VOIDED',
  Waiting = 'WAITING'
}

export enum CreditReasonCode {
  General = 'general',
  Promotional = 'promotional',
  Service = 'service'
}

export type Cta = {
  __typename?: 'Cta';
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  title?: Maybe<Scalars['String']['output']>;
  type: CtaType;
};

export enum CtaType {
  Action = 'action',
  Disclaimer = 'disclaimer',
  GrowArticle = 'grow_article',
  Link = 'link',
  ProtectLink = 'protect_link',
  Video = 'video'
}

export enum Currency {
  Usd = 'USD'
}

export type CurrencyAmount = {
  __typename?: 'CurrencyAmount';
  currency: Currency;
  value: Scalars['Float']['output'];
};

export type CurrencyAmountInput = {
  currency: Currency;
  value: Scalars['Float']['input'];
};

export type CurrencyMilestoneProgress = {
  __typename?: 'CurrencyMilestoneProgress';
  /** the type of currency */
  currency: Currency;
  /** the current value */
  currentAmount: Scalars['Float']['output'];
  /** the value needed for completion */
  targetAmount: Scalars['Float']['output'];
};

export type CustomFieldInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption';
  default?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  raw_name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Customer Account Closure Record */
export type CustomerAccountClosure = {
  __typename?: 'CustomerAccountClosure';
  closedAt?: Maybe<Scalars['Date']['output']>;
  closureState: CustomerAccountClosureState;
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Scalars['String']['output'];
  /** User UUID */
  userId: Scalars['ID']['output'];
  workflowId: Scalars['String']['output'];
};

export enum CustomerAccountClosureState {
  Fulfilled = 'FULFILLED',
  Initiated = 'INITIATED'
}

/** Fetch customer actions */
export type CustomerActions = {
  __typename?: 'CustomerActions';
  createdAt: Scalars['DateTime']['output'];
  customerChanges?: Maybe<Array<CustomerChanges>>;
  deviceId?: Maybe<Scalars['String']['output']>;
  /** Unique Identifier for a Customer Actinos */
  id: Scalars['ID']['output'];
  ip: Scalars['String']['output'];
  parameters?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  requestMethod: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Unique Identifier for a User */
  userId?: Maybe<Scalars['ID']['output']>;
  /** Reference user uuid */
  userUuid: Scalars['ID']['output'];
  /** Customer Action uuid */
  uuid: Scalars['ID']['output'];
};

/** An individual edge within the paginated list of CustomerActionsType */
export type CustomerActionsTypeEdge = {
  __typename?: 'CustomerActionsTypeEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The CustomerActionsType record in the edge */
  node: CustomerActions;
};

/** Relay style pagination information for CustomerActionsType */
export type CustomerActionsTypePagination = {
  __typename?: 'CustomerActionsTypePagination';
  edges: Array<CustomerActionsTypeEdge>;
  pageInfo: PageInfo;
};

/** Customer Changes Types Enum */
export enum CustomerChangeType {
  CreditInvestment = 'CREDIT_INVESTMENT',
  FundingSource = 'FUNDING_SOURCE',
  InvestmentAccountPortfolio = 'INVESTMENT_ACCOUNT_PORTFOLIO',
  Transaction = 'TRANSACTION',
  Upload = 'UPLOAD',
  User = 'USER',
  UserPortfolio = 'USER_PORTFOLIO',
  UserProfile = 'USER_PROFILE'
}

/** Fetch customer changes */
export type CustomerChanges = {
  __typename?: 'CustomerChanges';
  createdAt: Scalars['DateTime']['output'];
  customerActionId: Scalars['ID']['output'];
  event: Scalars['String']['output'];
  /** Unique identifier for a Customer Changes */
  id: Scalars['ID']['output'];
  objectChanges: Scalars['String']['output'];
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Customer Changes By User By Type Response including list counter */
export type CustomerChangesByUser = {
  __typename?: 'CustomerChangesByUser';
  counter?: Maybe<Scalars['Int']['output']>;
  customerChanges?: Maybe<Array<CustomerChanges>>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
};

/** Input for Creating an Investment for a User */
export type CustomerChangesByUserByTypeInput = {
  /** Object Types */
  objectTypes: Array<CustomerChangeType>;
  /** Page request */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Limit customer changes to search */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Unique Identifier for a User */
  userUuid: Scalars['ID']['input'];
};

/** An individual edge within the paginated list of CustomerChangesType */
export type CustomerChangesTypeEdge = {
  __typename?: 'CustomerChangesTypeEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The CustomerChangesType record in the edge */
  node: CustomerChanges;
};

/** Relay style pagination information for CustomerChangesType */
export type CustomerChangesTypePagination = {
  __typename?: 'CustomerChangesTypePagination';
  edges: Array<CustomerChangesTypeEdge>;
  pageInfo: PageInfo;
};

/** Customer account closure does not exist */
export type CustomerClosureDoesNotExistException = {
  __typename?: 'CustomerClosureDoesNotExistException';
  /** DateTime that the account closure was requested */
  requestedAt: Scalars['String']['output'];
  /** User uuid */
  userId: Scalars['ID']['output'];
};

export type CustomerEarnOnboardingMilestone = {
  __typename?: 'CustomerEarnOnboardingMilestone';
  badgeText: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completionDescription: Scalars['String']['output'];
  completionTitle: Scalars['String']['output'];
  description: Scalars['String']['output'];
  header: Scalars['String']['output'];
  key: Scalars['String']['output'];
  logoUrl: Scalars['URL']['output'];
  primaryCta: EarnOnboardingMilestoneCta;
  reward: MonetaryAmount;
  secondaryCta?: Maybe<EarnOnboardingMilestoneCta>;
  steps: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CustomerEarnOnboardingProgram = CustomerEarnOnboardingProgramControl | CustomerEarnOnboardingProgramFeature;

export type CustomerEarnOnboardingProgramControl = {
  __typename?: 'CustomerEarnOnboardingProgramControl';
  experimentName: Scalars['String']['output'];
  variantName: Scalars['String']['output'];
};

export type CustomerEarnOnboardingProgramFeature = {
  __typename?: 'CustomerEarnOnboardingProgramFeature';
  activePeriodDays: Scalars['Int']['output'];
  closeAt: Scalars['DateTime']['output'];
  closurePeriodDays: Scalars['Int']['output'];
  completionDescription: Scalars['String']['output'];
  completionLogoUrl: Scalars['URL']['output'];
  completionTitle: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endAt: Scalars['DateTime']['output'];
  experiment?: Maybe<Scalars['String']['output']>;
  header: Scalars['String']['output'];
  milestones: Array<CustomerEarnOnboardingMilestone>;
  primaryCta: Scalars['String']['output'];
  startAt: Scalars['DateTime']['output'];
  status: CustomerEarnOnboardingStatus;
  subTitle: Scalars['String']['output'];
  termsLabel: Scalars['String']['output'];
  title: Scalars['String']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};

export enum CustomerEarnOnboardingStatus {
  BeforeOpen = 'BEFORE_OPEN',
  Closed = 'CLOSED',
  Closing = 'CLOSING',
  Open = 'OPEN'
}

export type CustomerMoneyRulesResult = CustomerMoneyRulesResultSuccess | MoneyRulesRulesetNotFoundException;

export type CustomerMoneyRulesResultSuccess = {
  __typename?: 'CustomerMoneyRulesResultSuccess';
  resultingRuleset: MoneyRulesRuleset;
};

export type DfaDecision = RiskDecision & {
  __typename?: 'DFADecision';
  createdAt: Scalars['DateTime']['output'];
  evaluatedUserRiskProfile?: Maybe<UserRiskProfile>;
  /** when the fund is available. Null if no hold is needed */
  holdUntil?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  input: Scalars['String']['output'];
  /** the version of DFA */
  ruleVersion: Scalars['String']['output'];
  traceId: Scalars['String']['output'];
};

export type DfaDecisions = {
  __typename?: 'DFADecisions';
  decisions: Array<DfaDecision>;
};

export enum DayOfWeek {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

/** Response to a beneficiary ssn update */
export type DeactivateBeneficiaryResult = Beneficiary | BeneficiaryNotFoundException | InternalErrorException;

export type DeactivateOauthAppClientResult = OauthAppClient | OauthAppClientNotFoundException;

export type DeactivateOauthAppResult = OauthApp | OauthAppNotFoundException;

export type DeactivateSecurityFailed = {
  __typename?: 'DeactivateSecurityFailed';
  description: Scalars['String']['output'];
};

export type DeactivateSecurityInput = {
  symbol: Scalars['TickerSymbol']['input'];
};

export type DeactivateSecurityResult = DeactivateSecurityFailed | Fund | Stock;

export type DeactivateTierSubscriptionInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  subscriptionDeactivationReason: TierSubscriptionDeactivationReason;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeactivateTierSubscriptionResult = TierSubscription | TierSubscriptionAlreadyDeactivated;

export enum DealType {
  PartnerLink = 'PARTNER_LINK',
  SimplySpend = 'SIMPLY_SPEND',
  TapAndGet = 'TAP_AND_GET',
  UniquePricePoint = 'UNIQUE_PRICE_POINT',
  VerifiedReferral = 'VERIFIED_REFERRAL'
}

export type DecisionsByTraceIdResult = DfaDecisions | RiskServiceInternalError;

/** ID of the deleted Acceptance Document Version Filter */
export type DeleteAcceptanceDocumentVersionFilterIdOnly = {
  __typename?: 'DeleteAcceptanceDocumentVersionFilterIdOnly';
  /** ID of the deleted Acceptance Document Version Filter */
  id: Scalars['ID']['output'];
};

/** Parameters to delete an Acceptance Document Version Filter */
export type DeleteAcceptanceDocumentVersionFilterInput = {
  /** ID of the filter to delete */
  id: Scalars['ID']['input'];
};

/** Result of acceptance document version filter deletion */
export type DeleteAcceptanceDocumentVersionFilterResponse = AcceptanceDocumentVersionFilterNotFoundException | DeleteAcceptanceDocumentVersionFilterIdOnly | InvalidAcceptanceDocumentVersionFilterException;

export type DeleteBankCardOrderError = {
  __typename?: 'DeleteBankCardOrderError';
  failureMessage: Scalars['String']['output'];
};

export type DeleteBankCardOrderInput = {
  userId: Scalars['ID']['input'];
};

export type DeleteBankCardOrderResult = DeleteBankCardOrderError | DeleteBankCardOrderSuccess;

export type DeleteBankCardOrderSuccess = {
  __typename?: 'DeleteBankCardOrderSuccess';
  userId: Scalars['ID']['output'];
};

/** Result of attempting to delete a user's mighty oak card waiver */
export type DeleteMightyOakCardWaiverResult = BillingProfileNotFoundException | InvalidUserIdException | MightyOakCardWaiver | WaiverDeletionException | WaiverNotFoundException;

export type DeleteOauthAppResult = DeleteOauthAppSuccess | OauthAppNotFoundException;

export type DeleteOauthAppSuccess = {
  __typename?: 'DeleteOauthAppSuccess';
  oauthAppId: Scalars['ID']['output'];
};

/** Parameters needed to delete a Pinwheel webhook */
export type DeletePinwheelWebhookInput = {
  /** Webhook ID */
  webhookId: Scalars['ID']['input'];
};

/** Return value after a Pinwheel webhook is deleted */
export type DeletePinwheelWebhookPayload = {
  __typename?: 'DeletePinwheelWebhookPayload';
  /** Whether or not the webhook was successfully deleted */
  success: Scalars['Boolean']['output'];
};

/** deletePortfolio input */
export type DeletePortfolioInput = {
  /** ID of the Portfolio to be removed */
  portfolioId: Scalars['ID']['input'];
};

/** deletePortfolioTag input */
export type DeletePortfolioTagInput = {
  /** ID of the Portfolio Tag to be removed */
  id: Scalars['ID']['input'];
};

/** waiver type */
export type DeletePromotionalWaiverInput = {
  /** coupon code for promotional waiver */
  couponPromotion?: InputMaybe<Scalars['String']['input']>;
  /** type of promotional waiver to delete */
  promotion?: InputMaybe<WaiverPromotion>;
};

/** Result from attempting to delete a promotional waiver for a user */
export type DeletePromotionalWaiverResult = BillingProfileNotFoundException | InvalidUserIdException | PromotionalWaiver | WaiverDeletionException | WaiverNotFoundException;

/** result of attempting to delete a user's provisional waiver */
export type DeleteProvisionalWaiverResult = ProvisionalWaiver | WaiverCreationException | WaiverNotFoundException;

export type DeleteScopeSuccess = {
  __typename?: 'DeleteScopeSuccess';
  message: Scalars['String']['output'];
};

/** Response for deleting a trusted contact for a user */
export type DeleteTrustedContactResult = InternalErrorException | TrustedContact | TrustedContactNotFoundException;

/** Response from deleting an upload */
export type DeleteUploadResponse = {
  __typename?: 'DeleteUploadResponse';
  uploadId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

/** Funding source was deleted. */
export type DeletedFundingSourceException = {
  __typename?: 'DeletedFundingSourceException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type DepositModelDataEntity = {
  __typename?: 'DepositModelDataEntity';
  acornsCheckingFields?: Maybe<Scalars['String']['output']>;
  adminAction?: Maybe<AdminActionDataEntity>;
  adminLink?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  depositModelVersion?: Maybe<Scalars['String']['output']>;
  depositType: DepositTypeOptions;
  flaggedForOpsReview?: Maybe<Scalars['Boolean']['output']>;
  giactFields?: Maybe<Scalars['String']['output']>;
  latestRecurringFields?: Maybe<Scalars['String']['output']>;
  mocUser?: Maybe<Scalars['Boolean']['output']>;
  modelRanAt?: Maybe<Scalars['String']['output']>;
  mrdcFields?: Maybe<Scalars['String']['output']>;
  outsortFields?: Maybe<Scalars['String']['output']>;
  probabilityScore?: Maybe<Scalars['Float']['output']>;
  reasonForOutsort?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  returnFields?: Maybe<Scalars['String']['output']>;
  reviewStartedAt?: Maybe<Scalars['Date']['output']>;
  reviewer?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Float']['output']>;
  sigmaScore?: Maybe<Scalars['Float']['output']>;
  snapshotDate?: Maybe<Scalars['String']['output']>;
  spendCardLabelCreatedAt?: Maybe<Scalars['Date']['output']>;
  transaction?: Maybe<TransactionEntity>;
  transactionUuid?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type DepositModelNotFoundError = {
  __typename?: 'DepositModelNotFoundError';
  depositModelUuid: Scalars['String']['output'];
};

export enum DepositTypeOptions {
  Ach = 'ACH',
  Mrdc = 'MRDC'
}

export type DeregisterAuthenticatorInput = {
  id: Scalars['ID']['input'];
};

export type DeregisterAuthenticatorResult = AuthenticatorNotFoundException | EmailAuthenticator | PhoneAuthenticator;

export type DesignLibraryIcon = {
  __typename?: 'DesignLibraryIcon';
  /** icon type corresponding to a Design Library icon */
  icon: IconType;
};

export type Destination = {
  __typename?: 'Destination';
  /** deep link to milestone action destination */
  deepLink: Scalars['URL']['output'];
  /** key that maps to client-defined destination label */
  labelKey: Scalars['StringKey']['output'];
};

export type Device = {
  __typename?: 'Device';
  appVersion?: Maybe<Scalars['String']['output']>;
  blockTrigger?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceAdid?: Maybe<Scalars['String']['output']>;
  firstLoginAt?: Maybe<Scalars['DateTime']['output']>;
  hasActiveSession?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isBlocked: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type DeviceBlockedException = {
  __typename?: 'DeviceBlockedException';
  message?: Maybe<Scalars['String']['output']>;
};

export type DeviceNotFoundException = {
  __typename?: 'DeviceNotFoundException';
  message?: Maybe<Scalars['String']['output']>;
};

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type DigitalWalletDevice = {
  __typename?: 'DigitalWalletDevice';
  deviceId: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  deviceNumber: Scalars['String']['output'];
  deviceType: DigitalWalletDeviceType;
};

export enum DigitalWalletDeviceType {
  Card = 'Card',
  FashionAccessory = 'FashionAccessory',
  HomeAppliance = 'HomeAppliance',
  KeyFob = 'KeyFob',
  MediaOrGamingDevice = 'MediaOrGamingDevice',
  MobileDevice = 'MobileDevice',
  MobileDeviceAccessory = 'MobileDeviceAccessory',
  MobilePhone = 'MobilePhone',
  PcOrLaptop = 'PCOrLaptop',
  Tablet = 'Tablet',
  UnknownOther = 'UnknownOther',
  Vehicle = 'Vehicle',
  Watch = 'Watch'
}

export type DigitalWalletToken = {
  __typename?: 'DigitalWalletToken';
  device: DigitalWalletDevice;
  isDeviceProvisioned: Scalars['Boolean']['output'];
  tokenStatus: Scalars['String']['output'];
};

/** Describes a user direct deposit info */
export type DirectDepositInfo = {
  __typename?: 'DirectDepositInfo';
  /** Direct Deposit Status */
  status: DirectDepositStatus;
};

/** Query attributes for Direct Deposit Info */
export type DirectDepositInfoInput = {
  /** User ID */
  userId: Scalars['ID']['input'];
};

/** Direct Deposit Info */
export type DirectDepositInfoPayload = {
  __typename?: 'DirectDepositInfoPayload';
  /** Direct Deposit Info */
  info?: Maybe<DirectDepositInfo>;
};

/** Query attributes for Direct Deposit PDF */
export type DirectDepositPdfInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID']['input'];
  /** Employer Name */
  employerName: Scalars['String']['input'];
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  /** User ID */
  userId: Scalars['ID']['input'];
};

/** Direct Deposit PDF */
export type DirectDepositPdfPayload = {
  __typename?: 'DirectDepositPdfPayload';
  /** Base64 Encoded PDF */
  printablePdf: Scalars['String']['output'];
};

export enum DirectDepositStatus {
  /** Downloaded pdf to personal device or got a success status back from Pinwheel */
  Attempted = 'Attempted',
  /** SplitDepositSettings Query returns a paycheck has landed */
  Completed = 'Completed',
  /** Has not set up DD */
  NoInteraction = 'NoInteraction',
  /** Has viewed the pdf or entered the pinwheel flow */
  Viewed = 'Viewed'
}

export type DiscreteMilestoneProgress = {
  __typename?: 'DiscreteMilestoneProgress';
  /** the current value */
  currentInt: Scalars['Int']['output'];
  /** the value needed for completion */
  targetInt: Scalars['Int']['output'];
};

export type DismissMessageInput = {
  messageId: Scalars['ID']['input'];
};

export type DismissMessagesInput = {
  messageIds: Array<Scalars['ID']['input']>;
};

export type DismissMessagesResult = DismissMessagesSuccess | UpdateMessagesFailure;

export type DismissMessagesSuccess = {
  __typename?: 'DismissMessagesSuccess';
  dismissedCount: Scalars['Int']['output'];
};

export type DistributionAmounts = {
  __typename?: 'DistributionAmounts';
  investment: Scalars['String']['output'];
  retirement: Scalars['String']['output'];
  savings: Scalars['String']['output'];
};

export enum DistributionType {
  Balanced = 'BALANCED',
  LongTerm = 'LONG_TERM',
  LongWeighted = 'LONG_WEIGHTED',
  MediumTerm = 'MEDIUM_TERM',
  MediumWeighted = 'MEDIUM_WEIGHTED'
}

export type Dividend = {
  __typename?: 'Dividend';
  /** Dividend amount per share */
  amountPerShare?: Maybe<Scalars['BigDecimal']['output']>;
  /** The Dividend Execution Date (Ex Date) - This date will typically be one business day prior to the Record Date. */
  executionDate?: Maybe<Scalars['Date']['output']>;
  /** Dividend payout frequency */
  frequency: DividendFrequency;
  /** Dividend Payment Date - This is the date that the stock dividend will be paid. */
  payableDate?: Maybe<Scalars['Date']['output']>;
  /** Dividend Record Date - To receive a "cash" dividend you must own the stock on the Record Date. */
  recordDate?: Maybe<Scalars['Date']['output']>;
  symbol: Scalars['TickerSymbol']['output'];
};

export enum DividendFrequency {
  Annually = 'ANNUALLY',
  Irregularly = 'IRREGULARLY',
  Monthly = 'MONTHLY',
  OtherRegular = 'OTHER_REGULAR',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Unspecified = 'UNSPECIFIED'
}

export type DividendsBySymbolInput = {
  /** Filter to select dividends with executionDate before or on the executionEndDate */
  executionEndDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter to select dividends with executionDate on or after the executionStartDate */
  executionStartDate?: InputMaybe<Scalars['Date']['input']>;
  symbol: Scalars['TickerSymbol']['input'];
};

export type Document = {
  __typename?: 'Document';
  uploadedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

export type DocumentInput = {
  uploadedAt: Scalars['DateTime']['input'];
  url: Scalars['URL']['input'];
};

export enum DocumentQueryType {
  Address = 'address',
  All = 'all',
  BeneficiarySsn = 'beneficiarySsn',
  BulkSuspendCsv = 'bulkSuspendCsv',
  BulkVerifyCsv = 'bulkVerifyCsv',
  CurrentBankStatement = 'currentBankStatement',
  EarlyQuarantinePromotion = 'earlyQuarantinePromotion',
  FutureBankStatement = 'futureBankStatement',
  Id = 'id',
  MilitaryId = 'militaryId',
  Miscellaneous = 'miscellaneous',
  PaypalFundingSource = 'paypalFundingSource',
  SpendAddress = 'spendAddress',
  SpendFundingSource = 'spendFundingSource',
  SpendId = 'spendId',
  Ssn = 'ssn',
  TraditionalFundingSource = 'traditionalFundingSource',
  W9 = 'w9'
}

export type DocumentRequest = {
  __typename?: 'DocumentRequest';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documentType: DocumentType;
  documents?: Maybe<Array<Document>>;
  externalId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  parentRequest?: Maybe<DocumentRequest>;
  parentRequestId?: Maybe<Scalars['ID']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedNote?: Maybe<Scalars['String']['output']>;
  rejectedReason?: Maybe<RejectedReason>;
  /** Idempotency key for ensuring that duplicate requests are not made or to store additional data */
  requestKey?: Maybe<Scalars['String']['output']>;
  requestedFileCount?: Maybe<Scalars['Int']['output']>;
  requesterId?: Maybe<Scalars['ID']['output']>;
  reviewerId?: Maybe<Scalars['String']['output']>;
  status: DocumentStatus;
  userId: Scalars['ID']['output'];
};

export type DocumentRequestEdge = {
  __typename?: 'DocumentRequestEdge';
  node?: Maybe<DocumentRequest>;
};

export type DocumentRequestInput = {
  documentRequestId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Document Request does not have an uploaded file */
export type DocumentRequestMissingFileUrlException = {
  __typename?: 'DocumentRequestMissingFileUrlException';
  /** provided document request ID */
  documentRequestId: Scalars['ID']['output'];
};

export type DocumentRequestsConnection = {
  __typename?: 'DocumentRequestsConnection';
  edges?: Maybe<Array<DocumentRequestEdge>>;
  pageInfo: DocumentRequestsPageInfo;
};

export type DocumentRequestsInput = {
  pageInput?: InputMaybe<DocumentRequestsPageInput>;
  status?: InputMaybe<DocumentStatus>;
  type: DocumentQueryType;
  /** Deprecated: use `status` field */
  uploaded?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type DocumentRequestsPageInfo = {
  __typename?: 'DocumentRequestsPageInfo';
  cursor?: Maybe<Scalars['String']['output']>;
  hasNext: Scalars['Boolean']['output'];
};

export type DocumentRequestsPageInput = {
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum DocumentStatus {
  Accepted = 'accepted',
  Canceled = 'canceled',
  Rejected = 'rejected',
  Requested = 'requested',
  Uploaded = 'uploaded'
}

/** Documents to be reviewed */
export type DocumentToBeReviewed = {
  __typename?: 'DocumentToBeReviewed';
  allowedToApproveSpendAddress?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  mailingAddress?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  user?: Maybe<LegacyUser>;
  userAddress?: Maybe<Scalars['String']['output']>;
};

export enum DocumentType {
  Address = 'address',
  BeneficiarySsn = 'beneficiarySsn',
  BulkSuspendCsv = 'bulkSuspendCsv',
  BulkVerifyCsv = 'bulkVerifyCsv',
  CurrentBankStatement = 'currentBankStatement',
  EarlyQuarantinePromotion = 'earlyQuarantinePromotion',
  FutureBankStatement = 'futureBankStatement',
  Id = 'id',
  MilitaryId = 'militaryId',
  Miscellaneous = 'miscellaneous',
  PaypalFundingSource = 'paypalFundingSource',
  SpendAddress = 'spendAddress',
  SpendFundingSource = 'spendFundingSource',
  SpendId = 'spendId',
  Ssn = 'ssn',
  TraditionalFundingSource = 'traditionalFundingSource',
  W9 = 'w9'
}

export enum DocumentTypeEnum {
  /** address document (bill, etc.) */
  Address = 'address',
  /** A current bank statment */
  CurrentBankStatement = 'currentBankStatement',
  /** A future bank statement */
  FutureBankStatement = 'futureBankStatement',
  /** Driver's license, Passport, etc. */
  Id = 'id',
  /** Miscellaneous document */
  Miscellaneous = 'miscellaneous',
  /** Social security number */
  Ssn = 'ssn',
  /** W9 document */
  W9 = 'w9'
}

export type DocumentUploadSession = {
  __typename?: 'DocumentUploadSession';
  /** Token used as identifier for document upload session */
  token: Scalars['String']['output'];
};

export type DocumentVerification = {
  __typename?: 'DocumentVerification';
  /** Result of verifying uploaded documents */
  decision: DocumentVerificationDecision;
  /** Error descriptors based on reason codes triggered */
  outstandingIssues?: Maybe<Array<Scalars['String']['output']>>;
  /** Flag indicating if the customer’s identity was marked as verified during document review */
  verificationCriteriaMet: Scalars['Boolean']['output'];
};

export enum DocumentVerificationDecision {
  /** Documents were verified and accepted */
  Accepted = 'ACCEPTED',
  /** Documents were declined due to various reason codes */
  Rejected = 'REJECTED',
  /** The information submitted was incomplete or missing */
  ResubmissionRequired = 'RESUBMISSION_REQUIRED',
  /** Manual review is necessary */
  ReviewRequired = 'REVIEW_REQUIRED'
}

/** Response including list counter & documents to be reviewed */
export type DocumentsToBeReviewedResponse = {
  __typename?: 'DocumentsToBeReviewedResponse';
  counter?: Maybe<Scalars['Int']['output']>;
  documents?: Maybe<Array<DocumentToBeReviewed>>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
};

export type DuplicateActionError = {
  __typename?: 'DuplicateActionError';
  requestId: Scalars['ID']['output'];
};

export type DuplicateBillingInfoError = {
  __typename?: 'DuplicateBillingInfoError';
  message: Scalars['String']['output'];
};

export type DuplicatePromoCodeError = {
  __typename?: 'DuplicatePromoCodeError';
  name: Scalars['String']['output'];
};

export type DuplicatePromoCodeRewardError = {
  __typename?: 'DuplicatePromoCodeRewardError';
  amount: Scalars['Float']['output'];
  type: PromoCodeRewardType;
};

/** DEPRECATED - Use Security type instead */
export type Etf = {
  __typename?: 'ETF';
  /** Indicates the amount of every dollar that will go towards buying a share of the ETF */
  amount?: Maybe<Scalars['Int']['output']>;
  /** ETF high price over trailing 12 month period */
  annualHigh?: Maybe<Scalars['Float']['output']>;
  /** ETF low price over trailing 12 month period */
  annualLow?: Maybe<Scalars['Float']['output']>;
  /** Indicates the current per/share price */
  currentPrice?: Maybe<Scalars['Float']['output']>;
  /** The Acorns-designated display name of the ETF */
  displayName: Scalars['String']['output'];
  /** Indicates the individual stocks that make up the ETF */
  holdings?: Maybe<Array<Holding>>;
  /** Indicates the investment category for the ETF */
  investmentCategories: InvestmentCategory;
  /** Indicates the last market day's close per/share price */
  lastClosePrice?: Maybe<Scalars['Float']['output']>;
  /** The Acorns-designated name of the ETF */
  name: Scalars['String']['output'];
  /** Indicates the total worth of the ETF as a whole */
  netAssets?: Maybe<Scalars['String']['output']>;
  /** Indicates the day's open per/share price */
  openPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * Indicates the number of shares the user owns
   * @deprecated Use Portfolio.portfolioSecurities instead.
   */
  ownedShares?: Maybe<Scalars['Float']['output']>;
  /** Indicates the percent of every dollar that will go towards buying a share of the ETF */
  percent?: Maybe<Scalars['Float']['output']>;
  /** Get price values of the ETF over a time range */
  performance: EtfPerformance;
  /** Indicates the position of the ETF */
  position?: Maybe<Scalars['Int']['output']>;
  /** Indicates the per/share price range over the current week */
  priceRangeOverWeek?: Maybe<Scalars['String']['output']>;
  /** Indicates whether or not the ETF can be removed from a managed Portfolio by direction of an account holder. */
  removable?: Maybe<Scalars['Boolean']['output']>;
  /** The market exchange symbol of the ETF */
  symbol: Scalars['String']['output'];
  /** Indicates the total number of shares in the market */
  volume?: Maybe<Scalars['Int']['output']>;
  /** Indicates the year-to-date return of the ETF */
  ytdReturn?: Maybe<Scalars['Float']['output']>;
  /** Indicates the year-to-date return percentage of the ETF */
  ytdReturnPercentage?: Maybe<Scalars['Float']['output']>;
};


/** DEPRECATED - Use Security type instead */
export type EtfPerformanceArgs = {
  points?: InputMaybe<Scalars['Int']['input']>;
  timescale: EtfTimescale;
  timespan: Scalars['Int']['input'];
};

/** Amount and Percentage of ETF Gain */
export type EtfGain = {
  __typename?: 'ETFGain';
  amount: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
};

/** Gain and Prices of ETF */
export type EtfPerformance = {
  __typename?: 'ETFPerformance';
  gain?: Maybe<EtfGain>;
  prices?: Maybe<Array<EtfPrice>>;
};

/** Price of ETF */
export type EtfPrice = {
  __typename?: 'ETFPrice';
  amount: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export enum EtfTimescale {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

/** DEPRECATED - Use InvestmentAccountTransferability instead */
export type EarlyAccountTransferInfo = {
  __typename?: 'EarlyAccountTransferInfo';
  /** The beneficiary investment account's state of residence */
  stateCode: Scalars['String']['output'];
  /** The beneficiary investment account's age of transfer */
  terminationAge: Scalars['Int']['output'];
  /** The beneficiary investment account's date of transfer */
  terminationDate: Scalars['Date']['output'];
};

export type EarnCtaRecord = {
  __typename?: 'EarnCTARecord';
  ctaDates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  devicePlatform?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type EarnMissingCreditRequest = {
  __typename?: 'EarnMissingCreditRequest';
  createdAt: Scalars['DateTime']['output'];
  extensionMerchantName?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['ID']['output'];
  method: EarnPurchaseMethod;
  orderNumber: Scalars['String']['output'];
  proofOfPurchaseUrl: Scalars['URL']['output'];
  purchaseDate: Scalars['Date']['output'];
  subTotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  userId: Scalars['ID']['output'];
};

export type EarnMissingCreditRequestPurchaseDateError = {
  __typename?: 'EarnMissingCreditRequestPurchaseDateError';
  maxDays: Scalars['Int']['output'];
  minDays: Scalars['Int']['output'];
};

export type EarnOffer = {
  __typename?: 'EarnOffer';
  /** The list of applicable categories for affiliates */
  affiliateCategoryList?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether affiliateCategoryList is inclusionary or exclusionary */
  affiliateCategoryType?: Maybe<Scalars['String']['output']>;
  /** For use with colorBackgroundLogoImageUrl */
  backgroundColorHex: Scalars['String']['output'];
  /** Non-logo background image */
  backgroundImageUrl: Scalars['URL']['output'];
  /** Offer's Badge Category */
  badgeCategory?: Maybe<BadgeCategory>;
  /** Long description of what is needed to qualify for offer */
  campaignDescription: Scalars['String']['output'];
  /** ID associated with the Campaign */
  campaignId: Scalars['ID']['output'];
  campaignOfferId: Scalars['ID']['output'];
  /** Transparent logo used with backgroundColorHex overlaid on background */
  colorBackgroundLogoImageUrl: Scalars['URL']['output'];
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  colorImageUrl: Scalars['URL']['output'];
  ctaDetails: EarnOfferCtaDetails;
  /** Offer's Deal Type */
  dealType?: Maybe<DealType>;
  /** Desktop Background/featured image url */
  desktopBackgroundImageUrl?: Maybe<Scalars['URL']['output']>;
  /** Offer Details Information */
  details: Array<Scalars['String']['output']>;
  /** List of device platforms the campaign offer is eligible for */
  devicePlatforms: Array<Scalars['String']['output']>;
  /** The main campaign text used image overlay text */
  displayBody?: Maybe<Scalars['String']['output']>;
  /** The ending date of a campaign */
  displayEndDate?: Maybe<Scalars['String']['output']>;
  /** The main campaign name used on tiles and on details */
  displayName: Scalars['String']['output'];
  /** The starting date of a campaign */
  displayStartDate?: Maybe<Scalars['String']['output']>;
  /** Summary of qualification, e.g. "For new customers only" */
  displaySubtitle?: Maybe<Scalars['String']['output']>;
  /** Display Title for the amount invested, e.g. "Earn 2%" or "Earn $10" */
  displayTitle: Scalars['String']['output'];
  /** Offer Exclusion Information */
  exclusions: Array<Scalars['String']['output']>;
  /** Denotes the favorite order rank by most recently added */
  favoriteRank: Scalars['Int']['output'];
  /** Used for the banner on the categories page */
  featuredCategoryOffer: Scalars['Boolean']['output'];
  /** Used for the banner on the categories page */
  featuredCategoryOfferRank: Scalars['Int']['output'];
  /** The amount for the reward */
  incentiveAmount?: Maybe<Scalars['Float']['output']>;
  /** The reward amount rate */
  incentiveRate?: Maybe<EarnOfferIncentiveRate>;
  /** Amount invested, e.g. "2%" or "$10" */
  incentiveSummary: Scalars['String']['output'];
  /** The reward amount structure */
  incentiveType?: Maybe<EarnOfferIncentiveType>;
  /** Denotes a favorite offer for the current user */
  isFavorite: Scalars['Boolean']['output'];
  /** Offer's Keyphrase Categories Names */
  keyphraseCategoryNames?: Maybe<Array<Scalars['String']['output']>>;
  /** External merchantId associated with owner */
  merchantId?: Maybe<Scalars['String']['output']>;
  /** Description of the brand */
  ownerDescription: Scalars['String']['output'];
  /** ID associated with the Owner */
  ownerId: Scalars['ID']['output'];
  /** The name of the Owner */
  ownerName: Scalars['String']['output'];
  /** Used for the banner on web */
  promoted: Scalars['Boolean']['output'];
  /** Used for the banner on web */
  promotionRank: Scalars['Int']['output'];
  /** Identifying slug on the owner level */
  slug: Scalars['String']['output'];
  termsAndConditionsUrl: Scalars['String']['output'];
  /** The ending time for a campaign */
  visibilityEndTime?: Maybe<Scalars['String']['output']>;
  /** The starting time for a campaign */
  visibilityStartTime?: Maybe<Scalars['String']['output']>;
  /** Manages how we launch offers on mobile */
  webviewEnabled: Scalars['Boolean']['output'];
};

export type EarnOfferCtaDetails = {
  __typename?: 'EarnOfferCtaDetails';
  android?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  chromeExt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  internallyRouted: Scalars['Boolean']['output'];
  ios?: Maybe<Scalars['String']['output']>;
  notificationTitle: Scalars['String']['output'];
  notificationUrl: Scalars['URL']['output'];
  repeatTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userMetadata?: Maybe<Scalars['String']['output']>;
  web?: Maybe<Scalars['String']['output']>;
};

export enum EarnOfferIncentiveRate {
  Dynamic = 'DYNAMIC',
  Flat = 'FLAT'
}

export enum EarnOfferIncentiveTemplate {
  V1 = 'V1'
}

export enum EarnOfferIncentiveType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type EarnOfferQueryPage = {
  __typename?: 'EarnOfferQueryPage';
  earnOffers: Array<EarnOffer>;
  pageInfo: EarnPageInfo;
};

export type EarnOnboardingMilestoneCta = {
  __typename?: 'EarnOnboardingMilestoneCta';
  destination: EarnOnboardingMilestoneCtaType;
  title: Scalars['String']['output'];
};

export enum EarnOnboardingMilestoneCtaType {
  DownloadExtension = 'DOWNLOAD_EXTENSION',
  LinkCard = 'LINK_CARD',
  SimplySpendOffers = 'SIMPLY_SPEND_OFFERS',
  TapAndGetOffers = 'TAP_AND_GET_OFFERS'
}

export type EarnPageInfo = {
  __typename?: 'EarnPageInfo';
  /** This value is passed back as the 'cursor' parameter to continue pagination.  An empty string indicates there are no more pages to fetch. */
  endCursor: Scalars['String']['output'];
};

export enum EarnPurchaseMethod {
  Android = 'ANDROID',
  ChromeExtension = 'CHROME_EXTENSION',
  EarnRewardEmail = 'EARN_REWARD_EMAIL',
  InStore = 'IN_STORE',
  Iphone = 'IPHONE',
  SafariExtension = 'SAFARI_EXTENSION',
  WebApp = 'WEB_APP'
}

export type EarnReward = {
  __typename?: 'EarnReward';
  amount: MonetaryAmount;
  colorBackgroundLogoImageUrl: Scalars['URL']['output'];
  displayName: Scalars['String']['output'];
  expectedFulfilledAt?: Maybe<Scalars['Date']['output']>;
  fulfilledAt?: Maybe<Scalars['Date']['output']>;
  fulfillmentType: EarnRewardFulfillmentType;
  id: Scalars['ID']['output'];
  incentiveAmount?: Maybe<Scalars['Float']['output']>;
  investmentId?: Maybe<Scalars['ID']['output']>;
  linked?: Maybe<Array<EarnReward>>;
  /** The purchase or event date associated with the reward */
  originationDate: Scalars['Date']['output'];
  status?: Maybe<EarnRewardStatus>;
  type: EarnRewardType;
};

export enum EarnRewardFulfillmentType {
  Standard = 'STANDARD',
  Travel = 'TRAVEL'
}

export enum EarnRewardInvestType {
  EarnReward = 'EARN_REWARD',
  EarnRewardMatch = 'EARN_REWARD_MATCH',
  EarnRoundUpMatch = 'EARN_ROUND_UP_MATCH',
  EmployeeContribution = 'EMPLOYEE_CONTRIBUTION',
  Referral = 'REFERRAL'
}

export enum EarnRewardStatus {
  Fulfilled = 'FULFILLED',
  Pending = 'PENDING'
}

export enum EarnRewardType {
  EmployeeBenefit = 'EMPLOYEE_BENEFIT',
  Referral = 'REFERRAL',
  Reward = 'REWARD',
  RewardMatch = 'REWARD_MATCH',
  RoundupMatch = 'ROUNDUP_MATCH'
}

export type Ecbsv = {
  __typename?: 'Ecbsv';
  /** Flag indicating whether eCBSV can be used or not for verification */
  consent: Scalars['Boolean']['output'];
  /** UTC timestamp when customer provided eCBSV response */
  providedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EducationTip = {
  __typename?: 'EducationTip';
  /** key that maps to client-defined education tip details */
  detailsKey: Scalars['StringKey']['output'];
  /** key that maps to client-defined education tip summary */
  summaryKey: Scalars['StringKey']['output'];
};

export type Eligibility = {
  __typename?: 'Eligibility';
  eligible: Scalars['Boolean']['output'];
};

export type EmailAddressValidation = {
  __typename?: 'EmailAddressValidation';
  /** Wether or not credentials are associated with the address or not. */
  credentialsExist: Scalars['Boolean']['output'];
  /** Soft check indicating wether or not a DNS MX record exists for the address domain (does not validate that an email can actually be delivered to the email server).  */
  deliverable: Scalars['Boolean']['output'];
  /** The email that is being validated */
  email: Scalars['EmailAddress']['output'];
  /** Indicates if the email credential is enabled for use. */
  nativeCredentialsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the email is associated with an OIDC provider. */
  oidcAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates wether the address may have common spelling mistakes. */
  possibleTypo: Scalars['Boolean']['output'];
  /** Suggestion for corrected address if there was a typo detected. */
  suggestion?: Maybe<Scalars['EmailAddress']['output']>;
};

export type EmailAuthChallenge = AuthChallenge & {
  __typename?: 'EmailAuthChallenge';
  alternateAuthenticators: Array<AuthenticatorInfo>;
  challengeTrigger: ChallengeTriggers;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  maskedEmail: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmailAuthenticator = Authenticator & {
  __typename?: 'EmailAuthenticator';
  createdAt: Scalars['DateTime']['output'];
  deviceId: Scalars['ID']['output'];
  email: Scalars['EmailAddress']['output'];
  id: Scalars['ID']['output'];
  lastAuthenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  type: AuthType;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmailTakenException = {
  __typename?: 'EmailTakenException';
  message?: Maybe<Scalars['String']['output']>;
};

export enum Employees {
  /** User has full or part time employees under their company */
  FullOrPart = 'fullOrPart',
  /** User has no employees under their company */
  None = 'none'
}

export enum EmploymentStatus {
  /** User is a full time employee or contractor */
  FullTime = 'fullTime',
  /** User is a part time employee or contractor */
  PartTime = 'partTime',
  /** User is retired and does not work */
  Retired = 'retired',
  /** User owns their own business or is self employed */
  SelfEmployed = 'selfEmployed',
  /** User is enrolled full time in school */
  Student = 'student',
  /** User currently is not employed */
  Unemployed = 'unemployed'
}

export enum EnabledPinwheelEvent {
  AccountAdded = 'accountAdded',
  AccountDisconnected = 'accountDisconnected',
  All = 'all',
  DirectDepositAllocationsAdded = 'directDepositAllocationsAdded',
  DirectDepositAllocationsUpdated = 'directDepositAllocationsUpdated',
  DirectDepositPaymentAdded = 'directDepositPaymentAdded',
  DirectDepositSwitchAdded = 'directDepositSwitchAdded',
  EmploymentAdded = 'employmentAdded',
  IdentityAdded = 'identityAdded',
  IncomeAdded = 'incomeAdded',
  PaystubsAdded = 'paystubsAdded',
  PaystubsFullySynced = 'paystubsFullySynced',
  PaystubsNinetyDaysSynced = 'paystubsNinetyDaysSynced',
  PaystubsSevenDaysSynced = 'paystubsSevenDaysSynced',
  PaystubsThirtyDaysSynced = 'paystubsThirtyDaysSynced',
  ShiftsAdded = 'shiftsAdded',
  ShiftsFullySynced = 'shiftsFullySynced',
  ShiftsNinetyDaySynced = 'shiftsNinetyDaySynced',
  ShiftsSevenDaysSynced = 'shiftsSevenDaysSynced',
  ShiftsThirtyDaysSynced = 'shiftsThirtyDaysSynced'
}

export type EstimatedCheckPaymentDates = {
  __typename?: 'EstimatedCheckPaymentDates';
  estimatedArrivalAt: Scalars['DateTime']['output'];
  estimatedShippingAt: Scalars['DateTime']['output'];
  estimatedTransferAtText: Scalars['String']['output'];
};

export type EstimatedTransferDatesInput = {
  amount?: InputMaybe<CurrencyAmountInput>;
  fromAccountType: TransferableAccountTypeEnum;
  toAccountType: TransferableAccountTypeEnum;
  transferCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input to get estimated completion dates for a transfer */
export type EstimatedTransferDatesInternalInput = {
  /** Amount of the transfer which will be created. */
  amount?: InputMaybe<CurrencyAmountInput>;
  /** The account type to move money from */
  fromAccountType: TransferableAccountTypeEnum;
  /** The account type to move money into */
  toAccountType: TransferableAccountTypeEnum;
  /** The UTC DateTime the transfer was initiated. If omitted, the current date will be used */
  transferCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The user ID associated with the transfer */
  userId: Scalars['ID']['input'];
};

/** Estimated completion dates for transfers */
export type EstimatedTransferDatesInternalPayload = {
  __typename?: 'EstimatedTransferDatesInternalPayload';
  /** The estimated UTC DateTime the transfer will be completed */
  estimatedTransferCompletedAt: Scalars['DateTime']['output'];
};

/** Input to get delayed funds availability decision */
export type EvaluateDfaDecisionInput = {
  /** the account type in which the evaluation will happen */
  accountType?: InputMaybe<RiskAccountType>;
  /** the deposit amount */
  depositAmount: Scalars['BigDecimal']['input'];
  /**
   * a reference id that allows upstream systems to trace back to
   * the original transaction on helix.
   */
  masterId?: InputMaybe<Scalars['String']['input']>;
  /** the version of the DFA rule set. */
  ruleVersion?: InputMaybe<RuleVersion>;
  /** the bank name in which a transfer is coming from */
  sourceBankName?: InputMaybe<Scalars['String']['input']>;
  /**
   * the routing number associated to the bank in
   * which a transfer is coming from
   */
  sourceBankRoutingNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * a reference id that allows upstream systems to trace back to
   * the decision that was made.
   */
  traceId: Scalars['String']['input'];
  /**
   * the transaction creation timestamp, used to calculate the
   * holdUntil timestamp if a hold is needed
   */
  transactionCreatedAt: Scalars['DateTime']['input'];
  /** the user uuid */
  userUuid: Scalars['UUID']['input'];
};

export type EvaluateDfaDecisionResult = DfaDecision | RiskServiceInternalError;

/** You don't have permission to liquidate this amount. Please clear the balance as much as possible before liquidation. */
export type ExcessFundsException = {
  __typename?: 'ExcessFundsException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type ExchangeAcornsEarlyTokenResult = AcornsEarlyUserDetails | InvalidAcornsEarlyTokenException;

export type ExecuteMoneyInError = {
  __typename?: 'ExecuteMoneyInError';
  message: Scalars['String']['output'];
};

export type ExecuteMoneyInInput = {
  moneyInEvent: MoneyInEventInput;
};

export type ExecuteMoneyInResult = ExecuteMoneyInError | ExecuteMoneyInSuccess;

export type ExecuteMoneyInSuccess = {
  __typename?: 'ExecuteMoneyInSuccess';
  workflowId: Scalars['ID']['output'];
};

/** Execution Audit */
export type ExecutionAudit = TimestampsInterface & {
  __typename?: 'ExecutionAudit';
  billingCycleId: Scalars['ID']['output'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  decisionName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  result?: Maybe<Scalars['String']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type ExistingEmailVerifiedException = {
  __typename?: 'ExistingEmailVerifiedException';
  message?: Maybe<Scalars['String']['output']>;
};

/** The content that supports and drives the user experience */
export type ExperienceContent = {
  __typename?: 'ExperienceContent';
  /** Campaign ID for the referrer's active campaign */
  campaignId?: Maybe<Scalars['ID']['output']>;
  pillAmount?: Maybe<Scalars['String']['output']>;
  /** JSON Content for rendering the referrer experience */
  rawContent?: Maybe<Scalars['String']['output']>;
  /** Referrer's link to refer new friends */
  shareableLink?: Maybe<Scalars['String']['output']>;
};

export type ExpirePromotionalWaiverInput = {
  promotion: WaiverPromotion_V2;
};

export type ExpirePromotionalWaiverResult = InvalidUserIdException | PromotionalWaiver_V2 | WaiverDeletionException;

export enum ExternalUserSource {
  UserExternalSourceGoHenry = 'USER_EXTERNAL_SOURCE_GO_HENRY',
  UserExternalSourceInvalid = 'USER_EXTERNAL_SOURCE_INVALID'
}

export type ExtoleCampaignHistoryConnection = {
  __typename?: 'ExtoleCampaignHistoryConnection';
  edges?: Maybe<Array<ExtoleCampaignHistoryEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export type ExtoleCampaignHistoryEdge = {
  __typename?: 'ExtoleCampaignHistoryEdge';
  cursor: Scalars['String']['output'];
  hurdleMet?: Maybe<Scalars['Boolean']['output']>;
  node: ExtoleReferralCampaign;
};

export type ExtoleReferralCampaign = {
  __typename?: 'ExtoleReferralCampaign';
  advocateRewardAmount: Scalars['Float']['output'];
  eligibilityEnd: Scalars['DateTime']['output'];
  friendRewardAmount: Scalars['Float']['output'];
  hurdle: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  publishEnd: Scalars['DateTime']['output'];
  publishStart: Scalars['DateTime']['output'];
  status: PublishedCampaignStatus;
  title: Scalars['String']['output'];
};

export type ExtoleReferralHistory = {
  __typename?: 'ExtoleReferralHistory';
  extoleFriendHistory?: Maybe<FriendHistoryConnection>;
  userId?: Maybe<Scalars['ID']['output']>;
};


export type ExtoleReferralHistoryExtoleFriendHistoryArgs = {
  extoleCampaignId?: InputMaybe<Scalars['ID']['input']>;
  filter: ReferralPaginatedFilter;
};

export type FailVendorInvoiceResult = BillingVendorError | Invoice;

export type FavoritePartnerOfferGroup = {
  __typename?: 'FavoritePartnerOfferGroup';
  /** list of offers in the favorite group */
  offers: Array<PartnerOfferGroupItem>;
};

/** Used to customize favorite offer group contents */
export type FavoritePartnerOfferInput = {
  ids: Array<Scalars['String']['input']>;
};

export type FeaturedMilestones = {
  __typename?: 'FeaturedMilestones';
  /** list of featured milestones to show on widget */
  milestones: Array<Milestone>;
};

export type FeaturedMilestonesV2 = AccountSetupMilestones | FeaturedMilestones;

/** Fee information */
export type Fee = TimestampsInterface & {
  __typename?: 'Fee';
  accountId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  amountCollected: Scalars['Float']['output'];
  assessedAt?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  billingCycle: BillingCycle;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  discountedAmount?: Maybe<Scalars['Float']['output']>;
  feeCategoryId: Scalars['String']['output'];
  feeExecutions: Array<Maybe<FeeExecution>>;
  feeType: FeeType;
  id: Scalars['ID']['output'];
  state: Scalars['String']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Fee execution information */
export type FeeExecution = TimestampsInterface & {
  __typename?: 'FeeExecution';
  accountType?: Maybe<Scalars['String']['output']>;
  amountCollected: Scalars['Float']['output'];
  amountRequested: Scalars['Float']['output'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  executionMethod: Scalars['String']['output'];
  externalId?: Maybe<Scalars['ID']['output']>;
  fundingAccountId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export enum FeeExecutionMethod {
  /** Executed fee by direct ACH */
  Direct = 'DIRECT',
  /** Executed fee by selling shares */
  LiquidateSecurities = 'LIQUIDATE_SECURITIES',
  /** Pre-emptively failed execution due to a known failure reason */
  PreemptiveFailure = 'PREEMPTIVE_FAILURE',
  /** Skipped fee execution */
  Skip = 'SKIP',
  /** Executed by direct ACH from Spend funding source */
  SpendDirect = 'SPEND_DIRECT',
  /** Waived fee execution */
  Waive = 'WAIVE'
}

export type FeeNegotiation = {
  __typename?: 'FeeNegotiation';
  connection?: Maybe<BankConnection>;
  created?: Maybe<Scalars['DateTime']['output']>;
  displayStatus?: Maybe<Scalars['String']['output']>;
  feeSynopsis?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalStatus?: Maybe<BankFeeNegotiationInternalStatus>;
  negotiatedAmount?: Maybe<MonetaryAmount>;
  refundAmount?: Maybe<MonetaryAmount>;
  status?: Maybe<BankFeeNegotiationExternalStatus>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type FeeNegotiationSummary = {
  __typename?: 'FeeNegotiationSummary';
  negotiations?: Maybe<Array<FeeNegotiation>>;
  totalRefundedFees?: Maybe<MonetaryAmount>;
};

export enum FeeStatus {
  Negotiable = 'NEGOTIABLE',
  Negotiated = 'NEGOTIATED',
  Processing = 'PROCESSING',
  Unnegotiable = 'UNNEGOTIABLE'
}

export enum FeeStatusFilter {
  Negotiable = 'NEGOTIABLE',
  Negotiated = 'NEGOTIATED',
  Processing = 'PROCESSING',
  Unnegotiable = 'UNNEGOTIABLE'
}

export type FeeStatusSummary = {
  __typename?: 'FeeStatusSummary';
  negotiable: Scalars['Int']['output'];
  negotiated: Scalars['Int']['output'];
  processing: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unnegotiable: Scalars['Int']['output'];
};

export enum FeeType {
  /** ADVISORY fee */
  Advisory = 'ADVISORY',
  /** SUBSCRIPTION fee */
  Subscription = 'SUBSCRIPTION'
}

export type File = {
  __typename?: 'File';
  documentRequestId: Scalars['ID']['output'];
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type FileOrException = File | FileSizeError | UploadFailedError;

export enum FileProcessingStatus {
  Done = 'DONE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  NoNotes = 'NO_NOTES'
}

export type FileSizeError = {
  __typename?: 'FileSizeError';
  message: Scalars['String']['output'];
};

export enum FilingType {
  /** User files taxes with their spouse */
  Joint = 'joint',
  /** User files taxes living with spouse part of the year */
  SeparatePartYear = 'separatePartYear',
  /** User files taxes living apart from spouse all year */
  SeparateWholeYear = 'separateWholeYear'
}

export enum FinancialEducation {
  /** User has little to no experience with financial education */
  Beginner = 'BEGINNER',
  /** User has a lot of experience with financial education */
  Expert = 'EXPERT',
  /** User has some experience with financial education */
  Moderate = 'MODERATE'
}

/** Miscellaneous attributes about a Financial Institution */
export type FinancialInstitution = TimestampsInterface & {
  __typename?: 'FinancialInstitution';
  /** Is this Financial Institution blacklisted within Acorns */
  blacklisted: Scalars['Boolean']['output'];
  /** Inorganic ordering for Financial Institutions */
  boost: Scalars['Int']['output'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Is this Financial Institution removed from Plaid's list */
  deleted: Scalars['Boolean']['output'];
  /** Is this Financial Institution a Direct Bank type */
  directBank: Scalars['Boolean']['output'];
  /** Plaid Financial Institution ID */
  externalId: Scalars['String']['output'];
  /** Does this Financial Institution have multi-factor authentication? */
  hasMfa: Scalars['Boolean']['output'];
  /** Internal Acorns UUID representing Financial Institution */
  id: Scalars['ID']['output'];
  /** The link provider type of the financial institution */
  linkProviderType?: Maybe<LinkProviderType>;
  /** Location of logo for a Financial Institution */
  logoUrl: Scalars['String']['output'];
  /** Name of Financial Institution */
  name: Scalars['String']['output'];
  /** URL for signing in with Direct Bank Integration */
  oauthUrl?: Maybe<Scalars['String']['output']>;
  /** Plaid products this Financial Institution supports */
  products: Array<Scalars['String']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** URL of the Financial Institution */
  url?: Maybe<Scalars['String']['output']>;
};

/** Result from flagging a user as suspicious. */
export type FlagUserAsSuspiciousResponse = LegacyUser | UserAlreadyFlaggedAsSuspicious | UserNotFoundException;

/** input to the flagUserByUserId mutation */
export type FlagUserByUserIdInput = {
  /** Flag type */
  flagType: UserFlagType;
  /** Email identifier for system calls (it will be ignored if any auth header is passed) */
  flaggedBy?: InputMaybe<Scalars['Email']['input']>;
  /** User UUID to be flagged */
  userId: Scalars['ID']['input'];
};

/** flagUserByUserId response */
export type FlagUserByUserIdResult = InternalErrorException | MissingAdminIdentifierException | UserAlreadyFlaggedException | UserFlag;

export type FooterContent = {
  __typename?: 'FooterContent';
  acornsLogoAsset: Scalars['String']['output'];
  disclosures: Scalars['String']['output'];
  linkColumn1Header: Scalars['String']['output'];
  linkColumn2Header: Scalars['String']['output'];
  linkColumn3Header: Scalars['String']['output'];
  mainCTAText: Scalars['String']['output'];
  mainCTAUrl: Scalars['String']['output'];
  mainHeadline: Scalars['String']['output'];
};

/** Response to a beneficiary update */
export type ForceUpdateBeneficiaryInfoResult = BeneficiaryNotFoundException | InternalBeneficiary | InternalErrorException | InvalidSsnException | SecretSquirrelException | SsnAlreadyInUseException | SsnMatchesCustodianException;

export enum FormType {
  Form1099 = 'form1099',
  Form1099Bdiv = 'form1099BDIV',
  Form1099Misc = 'form1099MISC',
  Form1099R = 'form1099R',
  Form1099R1 = 'form1099R1',
  Form1099R2 = 'form1099R2',
  Form1099R4 = 'form1099R4',
  Form1099R7 = 'form1099R7',
  Form1099R8 = 'form1099R8',
  Form1099Re = 'form1099RE',
  Form1099Rj = 'form1099RJ',
  Form1099Rq = 'form1099RQ',
  Form1099Rt = 'form1099RT',
  Form5498 = 'form5498',
  Other = 'other'
}

export type FormattedMonetaryAmount = {
  __typename?: 'FormattedMonetaryAmount';
  currency: Currency;
  value: Scalars['String']['output'];
};

export type FoundMoneyCampaignOfferV2 = {
  __typename?: 'FoundMoneyCampaignOfferV2';
  id: Scalars['ID']['output'];
  incentiveSummary: Scalars['String']['output'];
};

export type FoundMoneyCampaignV2 = {
  __typename?: 'FoundMoneyCampaignV2';
  backgroundColorHex: Scalars['String']['output'];
  backgroundImageUrl: Scalars['URL']['output'];
  cohortSlug: Scalars['String']['output'];
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']['output']>;
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  colorImageUrl: Scalars['URL']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  imageUrl: Scalars['URL']['output'];
  offers: Array<FoundMoneyCampaignOfferV2>;
  ownerId: Scalars['ID']['output'];
};

export type FoundMoneyReward = {
  __typename?: 'FoundMoneyReward';
  /** @deprecated Field is deprecated, use colorBackgroundLogoImageUrl instead */
  campaignOwnerImageUrl?: Maybe<Scalars['URL']['output']>;
  campaignOwnerName?: Maybe<Scalars['String']['output']>;
  categoryIcon?: Maybe<Scalars['String']['output']>;
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']['output']>;
  daysFulfilledWithin?: Maybe<Scalars['Int']['output']>;
  dollarValue?: Maybe<MonetaryAmount>;
  fulfillmentDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFoundMoneyPlus?: Maybe<Scalars['Boolean']['output']>;
  originationDate?: Maybe<Scalars['String']['output']>;
  originationType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type FoundMoneySummary = {
  __typename?: 'FoundMoneySummary';
  totalFulfilledRewardsDollarValue?: Maybe<MonetaryAmount>;
  totalMatchedDollarValue?: Maybe<MonetaryAmount>;
  totalPendingRewardsDollarValue?: Maybe<MonetaryAmount>;
  totalRewardsDollarValue?: Maybe<MonetaryAmount>;
};

/** A user who was referred by an existing Acorns User */
export type Friend = {
  __typename?: 'Friend';
  /** The first name of the referred user's advocate */
  advocateFirstName?: Maybe<Scalars['String']['output']>;
  /** The last name of the referred user's advocate */
  advocateLastName?: Maybe<Scalars['String']['output']>;
  /** The baseline advocate incentive they will earn if friend converts */
  advocateMinimumIncentive?: Maybe<Scalars['String']['output']>;
  /**
   * If the Friend object resolved via the Advocate query, advocateUserId
   * corresponds to the argument passed in at the root level.
   * If Friend object resolved via the Friend query, advocateUserId is the
   * first advocate that is returned by Extole.
   */
  advocateUserId?: Maybe<Scalars['ID']['output']>;
  /** A list of all campaigns that the friend is participating in */
  campaigns?: Maybe<Array<ReferralCampaign>>;
  email: Scalars['String']['output'];
  friendExperienceContent?: Maybe<FriendExperienceContent>;
  name?: Maybe<Scalars['String']['output']>;
  /** Status based on activity of friend */
  status?: Maybe<FriendStatus>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** The content that supports user experience */
export type FriendExperienceContent = {
  __typename?: 'FriendExperienceContent';
  /** The first name of the referred user's advocate */
  advocateFirstName?: Maybe<Scalars['String']['output']>;
  /** The last name of the referred user's advocate */
  advocateLastName?: Maybe<Scalars['String']['output']>;
  /** The baseline advocate incentive they will earn if friend converts */
  advocateMinimumIncentive?: Maybe<Scalars['String']['output']>;
};

/** A summary of information around a referred user */
export type FriendHistory = {
  __typename?: 'FriendHistory';
  /** User ID of the Advocate user */
  advocateUserId?: Maybe<Scalars['ID']['output']>;
  /** Campaign identifier that the referred user signed up under */
  campaignId: Scalars['ID']['output'];
  /** When the friend account was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The first name of the advocate's friend */
  friendFirstName?: Maybe<Scalars['String']['output']>;
  /** The last name of the advocate's friend */
  friendLastName?: Maybe<Scalars['String']['output']>;
  /** High level status indicating referred user reward status */
  status?: Maybe<FriendStatusV2>;
  /** User ID of the referred user */
  userId: Scalars['ID']['output'];
};

export type FriendHistoryConnection = {
  __typename?: 'FriendHistoryConnection';
  edges?: Maybe<Array<FriendHistoryEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export type FriendHistoryEdge = {
  __typename?: 'FriendHistoryEdge';
  cursor: Scalars['String']['output'];
  node: FriendHistory;
};

/** Status of friend */
export enum FriendStatus {
  /** Friend has finished required steps to qualify for reward */
  Complete = 'COMPLETE',
  /** Friend did not complete required steps in allotted time frame */
  Expired = 'EXPIRED',
  /** Reward has been given to Friend/Advocate */
  Fulfilled = 'FULFILLED',
  /** Friend has registered */
  Pending = 'PENDING',
  /** Advocate sent invite but user has not completed any steps */
  Sent = 'SENT'
}

/** Status of friend */
export enum FriendStatusV2 {
  /** Friend has finished required steps to qualify for reward */
  Complete = 'COMPLETE',
  /** Friend has invested */
  ConfirmingEligibility = 'CONFIRMING_ELIGIBILITY',
  /** Friend is ineligible for reward */
  Ineligible = 'INELIGIBLE',
  /** Friend has signed up or created first investment  */
  InProgress = 'IN_PROGRESS'
}

export type FriendSummary = {
  __typename?: 'FriendSummary';
  /** Campaign identifier that the referred user signed up under */
  campaignId: Scalars['ID']['output'];
  /** First name of the referred user */
  name?: Maybe<Scalars['String']['output']>;
  /** High level status indicating referred user reward status */
  status?: Maybe<FriendStatus>;
  userId: Scalars['ID']['output'];
};

export type FriendV2Output = {
  __typename?: 'FriendV2Output';
  advocate?: Maybe<AdvocateV2>;
  campaign?: Maybe<CampaignV2>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type Fund = Security & {
  __typename?: 'Fund';
  active: Scalars['Boolean']['output'];
  currentPrice: BigCurrencyAmount;
  currentlySupported: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  earliestPriceDate: Scalars['Date']['output'];
  headlines: Array<SecurityHeadline>;
  id: Scalars['ID']['output'];
  lastClosePrice: BigCurrencyAmount;
  lastUpdatedAt: Scalars['DateTime']['output'];
  longName: Scalars['String']['output'];
  marketCap: Scalars['BigDecimal']['output'];
  name: Scalars['String']['output'];
  numberOfHoldings: Scalars['Int']['output'];
  openPrice: BigCurrencyAmount;
  profile: SecurityProfile;
  /** @deprecated Use `Security.headlines` instead. */
  securityHeadlines: Array<SecurityHeadline>;
  /** @deprecated Use `Security.profile` instead. */
  securityProfile: SecurityProfile;
  shortName: Scalars['String']['output'];
  symbol: Scalars['TickerSymbol']['output'];
  topHoldings: Array<TopHolding>;
  type: SecurityType;
  uuid: Scalars['ID']['output'];
  volume: Scalars['BigDecimal']['output'];
  week52High: BigCurrencyAmount;
  week52Low: BigCurrencyAmount;
};

/** User Yearly Performance Interval Calculation */
export type FundAccountValue = {
  __typename?: 'FundAccountValue';
  /** Current fund market price  */
  marketPrice?: Maybe<MonetaryAmount>;
  /** Current market value for the owned amount of shares */
  marketValue?: Maybe<MonetaryAmount>;
  percentageOfAssetValueForFund?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  realizedGainForFund?: Maybe<MonetaryAmount>;
  shares?: Maybe<Scalars['Float']['output']>;
  unrealizedGainForFund?: Maybe<MonetaryAmount>;
};

/** Parameters to create a new Portfolio */
export type FundingRatiosInput = {
  /** Fund ID */
  fundId: Scalars['ID']['input'];
  /** Ratio */
  ratio: Scalars['Float']['input'];
};

/** A Funding Source for the acorns user */
export type FundingSource = TimestampsInterface & {
  __typename?: 'FundingSource';
  accountName: Scalars['String']['output'];
  alert?: Maybe<Scalars['JSON']['output']>;
  atRisk?: Maybe<Scalars['Boolean']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  bankAdminDisplayName?: Maybe<Scalars['String']['output']>;
  /** Funding source bank routing number */
  bankRoutingNumber?: Maybe<Scalars['String']['output']>;
  canCancel: Scalars['Boolean']['output'];
  canChange: Scalars['Boolean']['output'];
  canRetriggerRdv: Scalars['Boolean']['output'];
  canTriggerRdv: Scalars['Boolean']['output'];
  /** Indicates whether the user is allowed to verify RDV */
  canVerifyRdv?: Maybe<Scalars['Boolean']['output']>;
  changeRequiresApproval: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  /** Url from funding source supporting documents */
  documentUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  /** the identifier used by the external system of record (e.g. ProfitStars) to track the owner of this FundingSource */
  externalUserId?: Maybe<Scalars['ID']['output']>;
  frozen: Scalars['Boolean']['output'];
  /** The type of the funding source. */
  fundType: FundingSourceType;
  hashedBankAccountNumber?: Maybe<Scalars['String']['output']>;
  /** The bank icon of the funding source */
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  institutionId?: Maybe<Scalars['String']['output']>;
  institutionName: Scalars['String']['output'];
  insufficientFunds?: Maybe<Scalars['Boolean']['output']>;
  investmentsPausedByUser?: Maybe<Scalars['Boolean']['output']>;
  /** Last four digits from social security number */
  last4?: Maybe<Scalars['String']['output']>;
  linked: Scalars['Boolean']['output'];
  linkedSubaccountId?: Maybe<Scalars['ID']['output']>;
  /** The logo url from Linked Accounts Service */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Funding source bank name */
  name: Scalars['String']['output'];
  /** Identifies whether the user has indicated that they prefer to withdraw funds to this account. */
  preferredWithdrawalAccount: Scalars['Boolean']['output'];
  rawAccountNumber?: Maybe<Scalars['String']['output']>;
  rdv?: Maybe<RandomDepositVerification>;
  rdvSettledAt?: Maybe<Scalars['DateTime']['output']>;
  rdvTriggeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The role of the funding source. */
  role?: Maybe<FundingSourceRoleEnum>;
  /** Status of funding source */
  status: FundingSourceStatus;
  totalCredits?: Maybe<MonetaryAmount>;
  totalDebits?: Maybe<MonetaryAmount>;
  transfersApproved: Scalars['Boolean']['output'];
  /** Deprecated - use fundType instead. */
  type: Scalars['String']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  user: User_V2;
  /** funding source uuid */
  uuid: Scalars['ID']['output'];
  verificationStatus: Scalars['Int']['output'];
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export enum FundingSourceChangeAction {
  /** Approve funding source change request */
  Approve = 'APPROVE',
  /** Reject funding source change request */
  Reject = 'REJECT'
}

/** A Funding Source Change Request made by the acorns user */
export type FundingSourceChangeRequest = TimestampsInterface & {
  __typename?: 'FundingSourceChangeRequest';
  accountName: Scalars['String']['output'];
  alert?: Maybe<Scalars['JSON']['output']>;
  atRisk?: Maybe<Scalars['Boolean']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  bankAdminDisplayName?: Maybe<Scalars['String']['output']>;
  /** Funding source bank routing number */
  bankRoutingNumber?: Maybe<Scalars['String']['output']>;
  canCancel: Scalars['Boolean']['output'];
  canChange: Scalars['Boolean']['output'];
  canRetriggerRdv: Scalars['Boolean']['output'];
  canTriggerRdv: Scalars['Boolean']['output'];
  /** Indicates whether the user is allowed to verify RDV */
  canVerifyRdv?: Maybe<Scalars['Boolean']['output']>;
  changeRequiresApproval: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  /** Url from funding source supporting documents */
  documentUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  /** the identifier used by the external system of record (e.g. ProfitStars) to track the owner of this FundingSource */
  externalUserId?: Maybe<Scalars['ID']['output']>;
  frozen: Scalars['Boolean']['output'];
  /** The type of the funding source. */
  fundType: FundingSourceType;
  hashedBankAccountNumber?: Maybe<Scalars['String']['output']>;
  /** The bank icon of the funding source */
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  institutionId?: Maybe<Scalars['String']['output']>;
  institutionName: Scalars['String']['output'];
  insufficientFunds?: Maybe<Scalars['Boolean']['output']>;
  investmentsPausedByUser?: Maybe<Scalars['Boolean']['output']>;
  /** Last four digits from social security number */
  last4?: Maybe<Scalars['String']['output']>;
  linked: Scalars['Boolean']['output'];
  linkedSubaccountId?: Maybe<Scalars['ID']['output']>;
  /** The logo url from Linked Accounts Service */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Funding source bank name */
  name: Scalars['String']['output'];
  /** Identifies whether the user has indicated that they prefer to withdraw funds to this account. */
  preferredWithdrawalAccount: Scalars['Boolean']['output'];
  /** previous funding source change request */
  previousFundingSource?: Maybe<FundingSource>;
  rawAccountNumber?: Maybe<Scalars['String']['output']>;
  rdv?: Maybe<RandomDepositVerification>;
  rdvSettledAt?: Maybe<Scalars['DateTime']['output']>;
  rdvTriggeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The role of the funding source. */
  role?: Maybe<FundingSourceRoleEnum>;
  /** Status of funding source */
  status: FundingSourceStatus;
  totalCredits?: Maybe<MonetaryAmount>;
  totalDebits?: Maybe<MonetaryAmount>;
  transfersApproved: Scalars['Boolean']['output'];
  /** Deprecated - use fundType instead. */
  type: Scalars['String']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  user: User_V2;
  /** funding source change request user name */
  userName?: Maybe<Scalars['String']['output']>;
  /** funding source uuid */
  uuid: Scalars['ID']['output'];
  verificationStatus: Scalars['Int']['output'];
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** Response including list counter & the funding source change request items */
export type FundingSourceChangeRequestResponse = {
  __typename?: 'FundingSourceChangeRequestResponse';
  counter?: Maybe<Scalars['Int']['output']>;
  requests?: Maybe<Array<FundingSourceChangeRequest>>;
};

export enum FundingSourceChangeStatus {
  /** Funding source spend pending ready for approval */
  Checking = 'CHECKING',
  /** Funding source pending for action */
  Pending = 'PENDING',
  /** Funding source rejected */
  Rejected = 'REJECTED'
}

/** Funding Source was not found. */
export type FundingSourceNotFoundException = {
  __typename?: 'FundingSourceNotFoundException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export enum FundingSourceRoleEnum {
  /** The subaccount is the primary funding source of the user */
  PrimaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  SecondaryFunding = 'secondaryFunding'
}

export enum FundingSourceStatus {
  /** funding source cancelled. No user action is required */
  Cancel = 'cancel',
  /** Documents have been requested to verify the funding source. */
  DocsRequired = 'docsRequired',
  /** funding source has error while trying to approve */
  Error = 'error',
  /** RDV verification attempts exhausted. */
  Frozen = 'frozen',
  /** funding source well be reviewed and linked by an Acorns Securities associate */
  NotYetApproved = 'notYetApproved',
  /** Funding Source is waiting on RDV triggers. */
  Pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  RdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  RdvsSettled = 'rdvsSettled',
  /** Funding Source is verified. No user action is required. */
  Success = 'success',
  /** Awaiting admin approval. No user action is required. */
  Unapproved = 'unapproved'
}

export enum FundingSourceStatusEnum {
  /** Documents have been requested to verify the funding source. */
  DocsRequired = 'docsRequired',
  /** RDV verification attempts exhausted. */
  Frozen = 'frozen',
  /** Funding Source is waiting on RDV triggers. */
  Pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  RdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  RdvsSettled = 'rdvsSettled',
  /** Funding Source is verified. No user action is required. */
  Success = 'success',
  /** Awaiting admin approval. No user action is required. */
  Unapproved = 'unapproved'
}

export enum FundingSourceType {
  Ach = 'ach',
  Check = 'check',
  Dc = 'dc',
  Internal = 'internal',
  Paypal = 'paypal',
  Spend = 'spend',
  Wire = 'wire'
}

export enum FundsAvailability {
  /** User wants easy access to cash in an emergency */
  Emergency = 'emergency',
  /** User is planning to save and not withdraw until retirement */
  Retirement = 'retirement'
}

export type GenerateDocumentUploadSessionInput = {
  /** Acorns subaccount for identity processing that is requesting to generate a document upload session */
  product: IdentitySubaccount;
};

export type GenerateDocumentUploadSessionResult = DocumentUploadSession;

export type GenerateReferralCodeResult = Invitation;

/** generateTinFile mutation success response */
export type GenerateTinFileResponse = {
  __typename?: 'GenerateTinFileResponse';
  /** Admin email used in the generation */
  adminEmail: Scalars['String']['output'];
  /** Admin user id used in the generation */
  adminUuid?: Maybe<Scalars['ID']['output']>;
  /** Tin file type used in the generation */
  type?: Maybe<TinFileType>;
};

/** Result from generating document uploader token and sending email */
export type GenerateUserSuspendedUploadTokenResult = InvalidUserEmailError | UserNotFoundException | UserNotSuspendedError | UserSuspendedUploadTokenUrl;

export type GetUsersBankFromAccountTypePayload = {
  __typename?: 'GetUsersBankFromAccountTypePayload';
  bankType: BankType;
};

/** Object representing a grow prospect */
export type GrowProspect = Prospect & {
  __typename?: 'GrowProspect';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type HelpFormContent = {
  __typename?: 'HelpFormContent';
  body?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum HelpFormType {
  Contact = 'CONTACT',
  EarnMissingCredit = 'EARN_MISSING_CREDIT',
  SpendDispute = 'SPEND_DISPUTE'
}

export type HelpcenterBannerContent = {
  __typename?: 'HelpcenterBannerContent';
  bannerText: Scalars['String']['output'];
  bannerType: HelpcenterBannerType;
  currentVersion: Scalars['String']['output'];
  publishedVersion?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
};

export type HelpcenterBannerErrors = {
  __typename?: 'HelpcenterBannerErrors';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum HelpcenterBannerType {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type HelpcenterContentInput = {
  bannerText?: InputMaybe<Scalars['String']['input']>;
  bannerType?: InputMaybe<HelpcenterBannerType>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HideMessageByExternalIdInput = {
  externalMessageId: Scalars['ID']['input'];
};

export type HideMessageInput = {
  messageId: Scalars['ID']['input'];
};

/** The Individual Security on the ETF */
export type Holding = {
  __typename?: 'Holding';
  /** Indicates the amount of every dollar that will go towards buying a share of the stock */
  amount: Scalars['Float']['output'];
  /** The name of the stock */
  name: Scalars['String']['output'];
  /** Indicates the percent of every dollar that will go towards buying a share of the stock */
  percent: Scalars['Float']['output'];
  /** The Symbol of the stock */
  symbol: Scalars['String']['output'];
};

/** Holding transfer information; ex: beneficiaryTransfer, external transfer, and external transfer reversed */
export type HoldingsTransfer = {
  __typename?: 'HoldingsTransfer';
  /** Holding transfer approved date */
  approvedAt?: Maybe<Scalars['Date']['output']>;
  /** Holding custodian account number */
  custodianAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Holding custodian name */
  custodianName?: Maybe<Scalars['String']['output']>;
  /** Transfer fee */
  fees?: Maybe<Array<InvestmentFees>>;
  /** Source Investment Id from holding transfer */
  sourceInvestmentId?: Maybe<Scalars['String']['output']>;
  /** Holding Transfer Status */
  status?: Maybe<Scalars['String']['output']>;
  /** Holdings transfer type */
  transferType: HoldingsTransferType;
  /** Holding transfered date */
  transferredAt?: Maybe<Scalars['Date']['output']>;
};

/** Defines the different types of holdings transfers. */
export enum HoldingsTransferType {
  BeneficiaryTransfer = 'BENEFICIARY_TRANSFER',
  ExternalTransfer = 'EXTERNAL_TRANSFER',
  ExternalTransferReversed = 'EXTERNAL_TRANSFER_REVERSED'
}

export type HotlistBankCardByCardIdInput = {
  id: Scalars['ID']['input'];
  reason: BankCardHotlistReason;
  userId: Scalars['ID']['input'];
};

export type HotlistBankCardByCardIdPayload = {
  __typename?: 'HotlistBankCardByCardIdPayload';
  id?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<BankCardHotlistReason>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** An IRA Distribution or a withdraw investment for Later account */
export type IraDistribution = {
  __typename?: 'IRADistribution';
  /** created at date and time of IRA Distribution */
  createdAt: Scalars['DateTime']['output'];
  /** IRA Distribution federal tax with holding percentage */
  federalTaxWithholdingPct?: Maybe<Scalars['String']['output']>;
  /** Stubbed Field: Federal withholdings for Later account */
  federalWithholdings?: Maybe<MonetaryAmount>;
  /** ID of the IRA Distribution */
  id: Scalars['ID']['output'];
  /** Investment ID of the IRA Distribution from the investment table */
  investmentId: Scalars['ID']['output'];
  /** IRA Distribution reason */
  reason?: Maybe<Scalars['String']['output']>;
  /** IRA Distribution federal tax with holding percentage */
  stateTaxWithholdingPct?: Maybe<Scalars['String']['output']>;
  /** Stubbed Field: State withholdings for Later account */
  stateWithholdings?: Maybe<MonetaryAmount>;
  /** IRA Total tax amount */
  totalTaxAmount?: Maybe<MonetaryAmount>;
  /** update at date and time of IRA Distribution */
  updatedAt: Scalars['DateTime']['output'];
};

/** Distribution code for Later account withdraw investment/distribution */
export enum IraDistributionCode {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  Eight = 'EIGHT',
  F = 'F',
  Five = 'FIVE',
  Four = 'FOUR',
  G = 'G',
  H = 'H',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  Nine = 'NINE',
  One = 'ONE',
  P = 'P',
  Q = 'Q',
  R = 'R',
  S = 'S',
  Seven = 'SEVEN',
  Six = 'SIX',
  T = 'T',
  Three = 'THREE',
  Two = 'TWO',
  U = 'U',
  W = 'W'
}

/** Reason for customer making IRA Distribution */
export enum IraWithdrawalReason {
  Death = 'DEATH',
  DirectTransfer = 'DIRECT_TRANSFER',
  EarlyWithdrawal = 'EARLY_WITHDRAWAL',
  Levy = 'LEVY',
  OverContribution = 'OVER_CONTRIBUTION',
  Retirement = 'RETIREMENT',
  Rollover = 'ROLLOVER'
}

/** Type of IRA Distribution */
export enum IraWithdrawalType {
  EarlyDistribution = 'EARLY_DISTRIBUTION',
  IneligibleContribution = 'INELIGIBLE_CONTRIBUTION',
  IrsLevy = 'IRS_LEVY',
  NormalDistribution = 'NORMAL_DISTRIBUTION'
}

export enum IconType {
  IconAddGoal = 'ICON_ADD_GOAL',
  IconAlert = 'ICON_ALERT',
  IconAlertGrey = 'ICON_ALERT_GREY',
  IconAlertPause = 'ICON_ALERT_PAUSE',
  IconAlertPending = 'ICON_ALERT_PENDING',
  IconAlertRed = 'ICON_ALERT_RED',
  IconAlertYellow = 'ICON_ALERT_YELLOW',
  IconArrow = 'ICON_ARROW',
  IconArticle = 'ICON_ARTICLE',
  IconArticle12 = 'ICON_ARTICLE12',
  IconAudio = 'ICON_AUDIO',
  IconBabyKids = 'ICON_BABY_KIDS',
  IconCard = 'ICON_CARD',
  IconCategoryBaby = 'ICON_CATEGORY_BABY',
  IconCategoryBeauty = 'ICON_CATEGORY_BEAUTY',
  IconCategoryCar = 'ICON_CATEGORY_CAR',
  IconCategoryClothing = 'ICON_CATEGORY_CLOTHING',
  IconCategoryCollege = 'ICON_CATEGORY_COLLEGE',
  IconCategoryEntertainment = 'ICON_CATEGORY_ENTERTAINMENT',
  IconCategoryFlowers = 'ICON_CATEGORY_FLOWERS',
  IconCategoryFood = 'ICON_CATEGORY_FOOD',
  IconCategoryFootball = 'ICON_CATEGORY_FOOTBALL',
  IconCategoryHealth = 'ICON_CATEGORY_HEALTH',
  IconCategoryHome = 'ICON_CATEGORY_HOME',
  IconCategoryPet = 'ICON_CATEGORY_PET',
  IconCategoryPhone = 'ICON_CATEGORY_PHONE',
  IconCategoryShoe = 'ICON_CATEGORY_SHOE',
  IconCheckHub = 'ICON_CHECK_HUB',
  IconCheckIn = 'ICON_CHECK_IN',
  IconCircleCheck = 'ICON_CIRCLE_CHECK',
  IconCircleClock = 'ICON_CIRCLE_CLOCK',
  IconCircleInfo = 'ICON_CIRCLE_INFO',
  IconCirclePause = 'ICON_CIRCLE_PAUSE',
  IconCircleX = 'ICON_CIRCLE_X',
  IconClose = 'ICON_CLOSE',
  IconClothing = 'ICON_CLOTHING',
  IconDepositCheck = 'ICON_DEPOSIT_CHECK',
  IconDirectDeposit = 'ICON_DIRECT_DEPOSIT',
  IconDisclosureRight = 'ICON_DISCLOSURE_RIGHT',
  IconDropPin = 'ICON_DROP_PIN',
  IconEarnJobs = 'ICON_EARN_JOBS',
  IconElectronics = 'ICON_ELECTRONICS',
  IconEntertainment = 'ICON_ENTERTAINMENT',
  IconExpand = 'ICON_EXPAND',
  IconFastQuote = 'ICON_FAST_QUOTE',
  IconFavorites = 'ICON_FAVORITES',
  IconFinancialWellness = 'ICON_FINANCIAL_WELLNESS',
  IconFlowersGifts = 'ICON_FLOWERS_GIFTS',
  IconFoodGourmet = 'ICON_FOOD_GOURMET',
  IconGradCap = 'ICON_GRAD_CAP',
  IconHealthBeauty = 'ICON_HEALTH_BEAUTY',
  IconHealthWellness = 'ICON_HEALTH_WELLNESS',
  IconHistory = 'ICON_HISTORY',
  IconHomeDecor = 'ICON_HOME_DECOR',
  IconInstant = 'ICON_INSTANT',
  IconInterstitialAchievements = 'ICON_INTERSTITIAL_ACHIEVEMENTS',
  IconInterstitialAdd = 'ICON_INTERSTITIAL_ADD',
  IconInterstitialApy = 'ICON_INTERSTITIAL_APY',
  IconInterstitialAutoRefill = 'ICON_INTERSTITIAL_AUTO_REFILL',
  IconInterstitialBank = 'ICON_INTERSTITIAL_BANK',
  IconInterstitialCalculator = 'ICON_INTERSTITIAL_CALCULATOR',
  IconInterstitialCalendar = 'ICON_INTERSTITIAL_CALENDAR',
  IconInterstitialCheck = 'ICON_INTERSTITIAL_CHECK',
  IconInterstitialCheckActive = 'ICON_INTERSTITIAL_CHECK_ACTIVE',
  IconInterstitialConfident = 'ICON_INTERSTITIAL_CONFIDENT',
  IconInterstitialCreditCard = 'ICON_INTERSTITIAL_CREDIT_CARD',
  IconInterstitialDeposit = 'ICON_INTERSTITIAL_DEPOSIT',
  IconInterstitialDocuments = 'ICON_INTERSTITIAL_DOCUMENTS',
  IconInterstitialDollar = 'ICON_INTERSTITIAL_DOLLAR',
  IconInterstitialDollarSign = 'ICON_INTERSTITIAL_DOLLAR_SIGN',
  IconInterstitialEarnJobs = 'ICON_INTERSTITIAL_EARN_JOBS',
  IconInterstitialEntries = 'ICON_INTERSTITIAL_ENTRIES',
  IconInterstitialFastQuote = 'ICON_INTERSTITIAL_FAST_QUOTE',
  IconInterstitialFeelingGood = 'ICON_INTERSTITIAL_FEELING_GOOD',
  IconInterstitialGettingStarted1 = 'ICON_INTERSTITIAL_GETTING_STARTED1',
  IconInterstitialGettingStarted2 = 'ICON_INTERSTITIAL_GETTING_STARTED2',
  IconInterstitialHealthAdd = 'ICON_INTERSTITIAL_HEALTH_ADD',
  IconInterstitialLearn = 'ICON_INTERSTITIAL_LEARN',
  IconInterstitialMatch = 'ICON_INTERSTITIAL_MATCH',
  IconInterstitialNextDay = 'ICON_INTERSTITIAL_NEXT_DAY',
  IconInterstitialNumber = 'ICON_INTERSTITIAL_NUMBER',
  IconInterstitialOffers = 'ICON_INTERSTITIAL_OFFERS',
  IconInterstitialPie = 'ICON_INTERSTITIAL_PIE',
  IconInterstitialPin = 'ICON_INTERSTITIAL_PIN',
  IconInterstitialProfile = 'ICON_INTERSTITIAL_PROFILE',
  IconInterstitialRecurring = 'ICON_INTERSTITIAL_RECURRING',
  IconInterstitialRenters = 'ICON_INTERSTITIAL_RENTERS',
  IconInterstitialRoundUp = 'ICON_INTERSTITIAL_ROUND_UP',
  IconInterstitialRoundUps = 'ICON_INTERSTITIAL_ROUND_UPS',
  IconInterstitialRoundUpBill = 'ICON_INTERSTITIAL_ROUND_UP_BILL',
  IconInterstitialSave = 'ICON_INTERSTITIAL_SAVE',
  IconInterstitialSendCheck = 'ICON_INTERSTITIAL_SEND_CHECK',
  IconInterstitialShipping = 'ICON_INTERSTITIAL_SHIPPING',
  IconInterstitialSideHustles = 'ICON_INTERSTITIAL_SIDE_HUSTLES',
  IconInterstitialSimplySpend = 'ICON_INTERSTITIAL_SIMPLY_SPEND',
  IconInterstitialSmartDeposit = 'ICON_INTERSTITIAL_SMART_DEPOSIT',
  IconInterstitialSmartDepositActive = 'ICON_INTERSTITIAL_SMART_DEPOSIT_ACTIVE',
  IconInterstitialTimer = 'ICON_INTERSTITIAL_TIMER',
  IconInterstitialTree = 'ICON_INTERSTITIAL_TREE',
  IconInterstitialTwoFactorAuth = 'ICON_INTERSTITIAL_TWO_FACTOR_AUTH',
  IconInterstitialWallet = 'ICON_INTERSTITIAL_WALLET',
  IconInvest = 'ICON_INVEST',
  IconLearningCenter = 'ICON_LEARNING_CENTER',
  IconLightningBolt = 'ICON_LIGHTNING_BOLT',
  IconLive = 'ICON_LIVE',
  IconLocalOffers = 'ICON_LOCAL_OFFERS',
  IconLocation = 'ICON_LOCATION',
  IconLock = 'ICON_LOCK',
  IconLockSolid = 'ICON_LOCK_SOLID',
  IconMiniArrowLrgDown = 'ICON_MINI_ARROW_LRG_DOWN',
  IconMiniArrowLrgUp = 'ICON_MINI_ARROW_LRG_UP',
  IconMiniArrowSmDown = 'ICON_MINI_ARROW_SM_DOWN',
  IconMiniArrowSmUp = 'ICON_MINI_ARROW_SM_UP',
  IconMiniArticle = 'ICON_MINI_ARTICLE',
  IconMiniAudio = 'ICON_MINI_AUDIO',
  IconMiniCheckmark = 'ICON_MINI_CHECKMARK',
  IconMiniIndicatorTriangle = 'ICON_MINI_INDICATOR_TRIANGLE',
  IconMiniLightningBolt = 'ICON_MINI_LIGHTNING_BOLT',
  IconMiniLock = 'ICON_MINI_LOCK',
  IconMiniNew = 'ICON_MINI_NEW',
  IconMiniPlay = 'ICON_MINI_PLAY',
  IconMiniSelectionCheck = 'ICON_MINI_SELECTION_CHECK',
  IconMinus = 'ICON_MINUS',
  IconNew = 'ICON_NEW',
  IconOneTime = 'ICON_ONE_TIME',
  IconPets = 'ICON_PETS',
  IconPlane = 'ICON_PLANE',
  IconPlayMini = 'ICON_PLAY_MINI',
  IconPlayVideo = 'ICON_PLAY_VIDEO',
  IconPlus = 'ICON_PLUS',
  IconProductBanking = 'ICON_PRODUCT_BANKING',
  IconProductBenefits = 'ICON_PRODUCT_BENEFITS',
  IconProductColorAchievements = 'ICON_PRODUCT_COLOR_ACHIEVEMENTS',
  IconProductColorEarly = 'ICON_PRODUCT_COLOR_EARLY',
  IconProductColorEarn = 'ICON_PRODUCT_COLOR_EARN',
  IconProductColorEmergencyFund = 'ICON_PRODUCT_COLOR_EMERGENCY_FUND',
  IconProductColorGrow = 'ICON_PRODUCT_COLOR_GROW',
  IconProductColorInvest = 'ICON_PRODUCT_COLOR_INVEST',
  IconProductColorInvite = 'ICON_PRODUCT_COLOR_INVITE',
  IconProductColorLater = 'ICON_PRODUCT_COLOR_LATER',
  IconProductColorLocalFoundMoney = 'ICON_PRODUCT_COLOR_LOCAL_FOUND_MONEY',
  IconProductColorProtect = 'ICON_PRODUCT_COLOR_PROTECT',
  IconProductColorSave = 'ICON_PRODUCT_COLOR_SAVE',
  IconProductColorSpend = 'ICON_PRODUCT_COLOR_SPEND',
  IconProductEarly = 'ICON_PRODUCT_EARLY',
  IconProductEarn = 'ICON_PRODUCT_EARN',
  IconProductEmergency = 'ICON_PRODUCT_EMERGENCY',
  IconProductGoHenry = 'ICON_PRODUCT_GO_HENRY',
  IconProductGrow = 'ICON_PRODUCT_GROW',
  IconProductInvest = 'ICON_PRODUCT_INVEST',
  IconProductInvestHub = 'ICON_PRODUCT_INVEST_HUB',
  IconProductInvestProduct = 'ICON_PRODUCT_INVEST_PRODUCT',
  IconProductLater = 'ICON_PRODUCT_LATER',
  IconProductProtect = 'ICON_PRODUCT_PROTECT',
  IconProductSave = 'ICON_PRODUCT_SAVE',
  IconProductSpend = 'ICON_PRODUCT_SPEND',
  IconProtected = 'ICON_PROTECTED',
  IconReversal = 'ICON_REVERSAL',
  IconRoundUps = 'ICON_ROUND_UPS',
  IconScooter = 'ICON_SCOOTER',
  IconSearch = 'ICON_SEARCH',
  IconSendCheck = 'ICON_SEND_CHECK',
  IconSendMoneyInstant = 'ICON_SEND_MONEY_INSTANT',
  IconShare = 'ICON_SHARE',
  IconShoesAccessories = 'ICON_SHOES_ACCESSORIES',
  IconSideHustles = 'ICON_SIDE_HUSTLES',
  IconSimplySpend = 'ICON_SIMPLY_SPEND',
  IconSportsOutdoors = 'ICON_SPORTS_OUTDOORS',
  IconTimer = 'ICON_TIMER',
  IconTransactionAcorns = 'ICON_TRANSACTION_ACORNS',
  IconTransactionAtm = 'ICON_TRANSACTION_ATM',
  IconTransactionBankFee = 'ICON_TRANSACTION_BANK_FEE',
  IconTransactionCheck = 'ICON_TRANSACTION_CHECK',
  IconTransactionCheckDeposit = 'ICON_TRANSACTION_CHECK_DEPOSIT',
  IconTransactionDirectDeposit = 'ICON_TRANSACTION_DIRECT_DEPOSIT',
  IconTransactionDistribution = 'ICON_TRANSACTION_DISTRIBUTION',
  IconTransactionDividend = 'ICON_TRANSACTION_DIVIDEND',
  IconTransactionEarnReward = 'ICON_TRANSACTION_EARN_REWARD',
  IconTransactionEarnRewardsMatch = 'ICON_TRANSACTION_EARN_REWARDS_MATCH',
  IconTransactionGift = 'ICON_TRANSACTION_GIFT',
  IconTransactionGoHenry = 'ICON_TRANSACTION_GO_HENRY',
  IconTransactionHamburger = 'ICON_TRANSACTION_HAMBURGER',
  IconTransactionId = 'ICON_TRANSACTION_ID',
  IconTransactionInstantRoundUp = 'ICON_TRANSACTION_INSTANT_ROUND_UP',
  IconTransactionOneTime = 'ICON_TRANSACTION_ONE_TIME',
  IconTransactionOriginalTransaction = 'ICON_TRANSACTION_ORIGINAL_TRANSACTION',
  IconTransactionRebalance = 'ICON_TRANSACTION_REBALANCE',
  IconTransactionRecurringDeposit = 'ICON_TRANSACTION_RECURRING_DEPOSIT',
  IconTransactionRefund = 'ICON_TRANSACTION_REFUND',
  IconTransactionRoundUp = 'ICON_TRANSACTION_ROUND_UP',
  IconTransactionSpendCard = 'ICON_TRANSACTION_SPEND_CARD',
  IconTransactionStatus = 'ICON_TRANSACTION_STATUS',
  IconTransactionTransferIn = 'ICON_TRANSACTION_TRANSFER_IN',
  IconTransactionTransferInOut = 'ICON_TRANSACTION_TRANSFER_IN_OUT',
  IconTransactionTransferOut = 'ICON_TRANSACTION_TRANSFER_OUT',
  IconTransactionType = 'ICON_TRANSACTION_TYPE',
  IconTransfer = 'ICON_TRANSFER',
  IconTravelTransportation = 'ICON_TRAVEL_TRANSPORTATION',
  IconTrustedPartners = 'ICON_TRUSTED_PARTNERS',
  IconUtilityAccessibility = 'ICON_UTILITY_ACCESSIBILITY',
  IconUtilityAccountDetails = 'ICON_UTILITY_ACCOUNT_DETAILS',
  IconUtilityAchievement = 'ICON_UTILITY_ACHIEVEMENT',
  IconUtilityAcorn = 'ICON_UTILITY_ACORN',
  IconUtilityAdd = 'ICON_UTILITY_ADD',
  IconUtilityAi = 'ICON_UTILITY_AI',
  IconUtilityAlert = 'ICON_UTILITY_ALERT',
  IconUtilityApy = 'ICON_UTILITY_APY',
  IconUtilityArrowLeft = 'ICON_UTILITY_ARROW_LEFT',
  IconUtilityArrowRight = 'ICON_UTILITY_ARROW_RIGHT',
  IconUtilityArExperience = 'ICON_UTILITY_AR_EXPERIENCE',
  IconUtilityBackupCodes = 'ICON_UTILITY_BACKUP_CODES',
  IconUtilityBag = 'ICON_UTILITY_BAG',
  IconUtilityBank = 'ICON_UTILITY_BANK',
  IconUtilityBankAdd = 'ICON_UTILITY_BANK_ADD',
  IconUtilityBankFees = 'ICON_UTILITY_BANK_FEES',
  IconUtilityBell = 'ICON_UTILITY_BELL',
  IconUtilityBellFilled = 'ICON_UTILITY_BELL_FILLED',
  IconUtilityBeneficiaries = 'ICON_UTILITY_BENEFICIARIES',
  IconUtilityBinoculars = 'ICON_UTILITY_BINOCULARS',
  IconUtilityBirthday = 'ICON_UTILITY_BIRTHDAY',
  IconUtilityBonds = 'ICON_UTILITY_BONDS',
  IconUtilityBook = 'ICON_UTILITY_BOOK',
  IconUtilityBookmark = 'ICON_UTILITY_BOOKMARK',
  IconUtilityBookmarkFilled = 'ICON_UTILITY_BOOKMARK_FILLED',
  IconUtilityBox = 'ICON_UTILITY_BOX',
  IconUtilityBudgeting = 'ICON_UTILITY_BUDGETING',
  IconUtilityCalendar = 'ICON_UTILITY_CALENDAR',
  IconUtilityCamera = 'ICON_UTILITY_CAMERA',
  IconUtilityCancel = 'ICON_UTILITY_CANCEL',
  IconUtilityCar = 'ICON_UTILITY_CAR',
  IconUtilityCashOwed = 'ICON_UTILITY_CASH_OWED',
  IconUtilityCellTower = 'ICON_UTILITY_CELL_TOWER',
  IconUtilityChatBubble = 'ICON_UTILITY_CHAT_BUBBLE',
  IconUtilityCheckmark = 'ICON_UTILITY_CHECKMARK',
  IconUtilityClose = 'ICON_UTILITY_CLOSE',
  IconUtilityCoin = 'ICON_UTILITY_COIN',
  IconUtilityCollapseMenu = 'ICON_UTILITY_COLLAPSE_MENU',
  IconUtilityCompanyBuilding = 'ICON_UTILITY_COMPANY_BUILDING',
  IconUtilityController = 'ICON_UTILITY_CONTROLLER',
  IconUtilityCopy = 'ICON_UTILITY_COPY',
  IconUtilityCrane = 'ICON_UTILITY_CRANE',
  IconUtilityCredit = 'ICON_UTILITY_CREDIT',
  IconUtilityCrypto = 'ICON_UTILITY_CRYPTO',
  IconUtilityCurrentLocation = 'ICON_UTILITY_CURRENT_LOCATION',
  IconUtilityCustomize = 'ICON_UTILITY_CUSTOMIZE',
  IconUtilityCustomStocks = 'ICON_UTILITY_CUSTOM_STOCKS',
  IconUtilityCyberSecurity = 'ICON_UTILITY_CYBER_SECURITY',
  IconUtilityDelete = 'ICON_UTILITY_DELETE',
  IconUtilityDocuments = 'ICON_UTILITY_DOCUMENTS',
  IconUtilityDocumentDownload = 'ICON_UTILITY_DOCUMENT_DOWNLOAD',
  IconUtilityDocumentUpload = 'ICON_UTILITY_DOCUMENT_UPLOAD',
  IconUtilityDots = 'ICON_UTILITY_DOTS',
  IconUtilityDown = 'ICON_UTILITY_DOWN',
  IconUtilityDownFilled = 'ICON_UTILITY_DOWN_FILLED',
  IconUtilityEarnJobs = 'ICON_UTILITY_EARN_JOBS',
  IconUtilityEdit = 'ICON_UTILITY_EDIT',
  IconUtilityEntries = 'ICON_UTILITY_ENTRIES',
  IconUtilityEth = 'ICON_UTILITY_ETH',
  IconUtilityExpand = 'ICON_UTILITY_EXPAND',
  IconUtilityExpandMenu = 'ICON_UTILITY_EXPAND_MENU',
  IconUtilityFace = 'ICON_UTILITY_FACE',
  IconUtilityFaceId = 'ICON_UTILITY_FACE_ID',
  IconUtilityFastQuote = 'ICON_UTILITY_FAST_QUOTE',
  IconUtilityFilter = 'ICON_UTILITY_FILTER',
  IconUtilityFlame = 'ICON_UTILITY_FLAME',
  IconUtilityFlashOff = 'ICON_UTILITY_FLASH_OFF',
  IconUtilityFlashOn = 'ICON_UTILITY_FLASH_ON',
  IconUtilityFlexible = 'ICON_UTILITY_FLEXIBLE',
  IconUtilityGift = 'ICON_UTILITY_GIFT',
  IconUtilityGoal = 'ICON_UTILITY_GOAL',
  IconUtilityGovernment = 'ICON_UTILITY_GOVERNMENT',
  IconUtilityGradCap = 'ICON_UTILITY_GRAD_CAP',
  IconUtilityHamburgerMenu = 'ICON_UTILITY_HAMBURGER_MENU',
  IconUtilityHealth = 'ICON_UTILITY_HEALTH',
  IconUtilityHeart = 'ICON_UTILITY_HEART',
  IconUtilityHeartAdd = 'ICON_UTILITY_HEART_ADD',
  IconUtilityHeartFilled = 'ICON_UTILITY_HEART_FILLED',
  IconUtilityHelp = 'ICON_UTILITY_HELP',
  IconUtilityHide = 'ICON_UTILITY_HIDE',
  IconUtilityHistory = 'ICON_UTILITY_HISTORY',
  IconUtilityHome = 'ICON_UTILITY_HOME',
  IconUtilityInfo = 'ICON_UTILITY_INFO',
  IconUtilityInvestorProfile = 'ICON_UTILITY_INVESTOR_PROFILE',
  IconUtilityInvite = 'ICON_UTILITY_INVITE',
  IconUtilityJobAlerts = 'ICON_UTILITY_JOB_ALERTS',
  IconUtilityKeypad = 'ICON_UTILITY_KEYPAD',
  IconUtilityLaptop = 'ICON_UTILITY_LAPTOP',
  IconUtilityLargeCheckmark = 'ICON_UTILITY_LARGE_CHECKMARK',
  IconUtilityLargePlus = 'ICON_UTILITY_LARGE_PLUS',
  IconUtilityLeaf = 'ICON_UTILITY_LEAF',
  IconUtilityLibrary = 'ICON_UTILITY_LIBRARY',
  IconUtilityLightbulb = 'ICON_UTILITY_LIGHTBULB',
  IconUtilityLocalOffers = 'ICON_UTILITY_LOCAL_OFFERS',
  IconUtilityLoginActivity = 'ICON_UTILITY_LOGIN_ACTIVITY',
  IconUtilityLogOut = 'ICON_UTILITY_LOG_OUT',
  IconUtilityMail = 'ICON_UTILITY_MAIL',
  IconUtilityManualLinking = 'ICON_UTILITY_MANUAL_LINKING',
  IconUtilityMapPin = 'ICON_UTILITY_MAP_PIN',
  IconUtilityMatch = 'ICON_UTILITY_MATCH',
  IconUtilityMedia = 'ICON_UTILITY_MEDIA',
  IconUtilityMenu = 'ICON_UTILITY_MENU',
  IconUtilityMobilePhone = 'ICON_UTILITY_MOBILE_PHONE',
  IconUtilityMorning = 'ICON_UTILITY_MORNING',
  IconUtilityNew = 'ICON_UTILITY_NEW',
  IconUtilityNight = 'ICON_UTILITY_NIGHT',
  IconUtilityNotifications = 'ICON_UTILITY_NOTIFICATIONS',
  IconUtilityOneTime = 'ICON_UTILITY_ONE_TIME',
  IconUtilityPassword = 'ICON_UTILITY_PASSWORD',
  IconUtilityPause = 'ICON_UTILITY_PAUSE',
  IconUtilityPet = 'ICON_UTILITY_PET',
  IconUtilityPhone = 'ICON_UTILITY_PHONE',
  IconUtilityPin = 'ICON_UTILITY_PIN',
  IconUtilityPlane = 'ICON_UTILITY_PLANE',
  IconUtilityPlug = 'ICON_UTILITY_PLUG',
  IconUtilityPointer = 'ICON_UTILITY_POINTER',
  IconUtilityPortfolioType = 'ICON_UTILITY_PORTFOLIO_TYPE',
  IconUtilityPotential = 'ICON_UTILITY_POTENTIAL',
  IconUtilityPreferences = 'ICON_UTILITY_PREFERENCES',
  IconUtilityProfile = 'ICON_UTILITY_PROFILE',
  IconUtilityQr = 'ICON_UTILITY_QR',
  IconUtilityQuestionnaire = 'ICON_UTILITY_QUESTIONNAIRE',
  IconUtilityQuestionMark = 'ICON_UTILITY_QUESTION_MARK',
  IconUtilityQuickWithdraw = 'ICON_UTILITY_QUICK_WITHDRAW',
  IconUtilityReload = 'ICON_UTILITY_RELOAD',
  IconUtilityRenters = 'ICON_UTILITY_RENTERS',
  IconUtilityRisk = 'ICON_UTILITY_RISK',
  IconUtilityRocket = 'ICON_UTILITY_ROCKET',
  IconUtilityRoundUpsRealTime = 'ICON_UTILITY_ROUND_UPS_REAL_TIME',
  IconUtilitySafari = 'ICON_UTILITY_SAFARI',
  IconUtilityScales = 'ICON_UTILITY_SCALES',
  IconUtilityScience = 'ICON_UTILITY_SCIENCE',
  IconUtilityScooter = 'ICON_UTILITY_SCOOTER',
  IconUtilitySearch = 'ICON_UTILITY_SEARCH',
  IconUtilitySettings = 'ICON_UTILITY_SETTINGS',
  IconUtilityShareAndroid = 'ICON_UTILITY_SHARE_ANDROID',
  IconUtilityShareIos = 'ICON_UTILITY_SHARE_IOS',
  IconUtilityShareLink = 'ICON_UTILITY_SHARE_LINK',
  IconUtilityShieldCheck = 'ICON_UTILITY_SHIELD_CHECK',
  IconUtilityShipping = 'ICON_UTILITY_SHIPPING',
  IconUtilityShow = 'ICON_UTILITY_SHOW',
  IconUtilitySilverware = 'ICON_UTILITY_SILVERWARE',
  IconUtilitySingleCoin = 'ICON_UTILITY_SINGLE_COIN',
  IconUtilitySmartDepositShine = 'ICON_UTILITY_SMART_DEPOSIT_SHINE',
  IconUtilitySort = 'ICON_UTILITY_SORT',
  IconUtilitySpace = 'ICON_UTILITY_SPACE',
  IconUtilitySpendCardDispute = 'ICON_UTILITY_SPEND_CARD_DISPUTE',
  IconUtilitySpendCardLocked = 'ICON_UTILITY_SPEND_CARD_LOCKED',
  IconUtilitySprayBottle = 'ICON_UTILITY_SPRAY_BOTTLE',
  IconUtilitySprout = 'ICON_UTILITY_SPROUT',
  IconUtilityStackedCoins = 'ICON_UTILITY_STACKED_COINS',
  IconUtilityStar = 'ICON_UTILITY_STAR',
  IconUtilityStocks = 'ICON_UTILITY_STOCKS',
  IconUtilitySubscription = 'ICON_UTILITY_SUBSCRIPTION',
  IconUtilitySun = 'ICON_UTILITY_SUN',
  IconUtilityTax = 'ICON_UTILITY_TAX',
  IconUtilityTextMessage = 'ICON_UTILITY_TEXT_MESSAGE',
  IconUtilityThematicInvestments = 'ICON_UTILITY_THEMATIC_INVESTMENTS',
  IconUtilityTimer = 'ICON_UTILITY_TIMER',
  IconUtilityTouchId = 'ICON_UTILITY_TOUCH_ID',
  IconUtilityTrash = 'ICON_UTILITY_TRASH',
  IconUtilityTree = 'ICON_UTILITY_TREE',
  IconUtilityTwoFactorAuth = 'ICON_UTILITY_TWO_FACTOR_AUTH',
  IconUtilityUp = 'ICON_UTILITY_UP',
  IconUtilityUpFilled = 'ICON_UTILITY_UP_FILLED',
  IconUtilityWand = 'ICON_UTILITY_WAND',
  IconUtilityWithdraw = 'ICON_UTILITY_WITHDRAW',
  IconVideo = 'ICON_VIDEO',
  IconVideo12 = 'ICON_VIDEO12',
  IconVideoControls_10SForward = 'ICON_VIDEO_CONTROLS_10S_FORWARD',
  IconVideoControls_10SRewind = 'ICON_VIDEO_CONTROLS_10S_REWIND',
  IconVideoControlsMuted = 'ICON_VIDEO_CONTROLS_MUTED',
  IconVideoControlsPause = 'ICON_VIDEO_CONTROLS_PAUSE',
  IconVideoControlsPlay = 'ICON_VIDEO_CONTROLS_PLAY',
  IconVideoControlsReplay = 'ICON_VIDEO_CONTROLS_REPLAY',
  IconVideoControlsSoundOn = 'ICON_VIDEO_CONTROLS_SOUND_ON',
  IconViews = 'ICON_VIEWS',
  IconWithdraw = 'ICON_WITHDRAW'
}

export type IdNote = {
  /** An ID key */
  key: Scalars['String']['input'];
  /** An ID Note */
  note: Scalars['String']['input'];
};

/** Identity Document Requested Alert. */
export type IdentityDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'IdentityDocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

export enum IdentitySubaccount {
  Bank = 'BANK',
  Invest = 'INVEST'
}

export type IdentityVerification = {
  canRetry?: Maybe<Scalars['Boolean']['output']>;
  verificationStatus: VerificationStatus;
};

/** Success response for Identity verification */
export type IdentityVerificationEnqueued = {
  __typename?: 'IdentityVerificationEnqueued';
  /** Message about Identity verification */
  message: Scalars['String']['output'];
  /** User uuid */
  userId: Scalars['String']['output'];
};

/** A response from Idology or Veratad checking a user identity */
export type IdentityVerificationResponse = {
  __typename?: 'IdentityVerificationResponse';
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Internal ID for Response */
  id: Scalars['ID']['output'];
  input?: Maybe<Scalars['String']['output']>;
  issues?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  provider: IdentityVerificationResponseProvider;
  result?: Maybe<IdentityVerificationResponseResult>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Internal ID for user */
  userId: Scalars['ID']['output'];
};

export enum IdentityVerificationResponseProvider {
  /** The response from Idology */
  Idology = 'idology',
  /** The response from Socure */
  Socure = 'socure',
  /** The response from Veratad */
  Veratad = 'veratad'
}

export enum IdentityVerificationResponseResult {
  /** There was an error checking the identity of the user */
  Error = 'error',
  /** The user did not pass the threshold for confirming their identity */
  Fail = 'fail',
  /** The user passed verification */
  Pass = 'pass',
  /** The user should be reviewed manually to confirm verification */
  Review = 'review'
}

/** Idology information */
export type IdologyResponse = {
  /** Document type to request */
  idNotes: Array<IdNote>;
  /** ID document uploader link */
  scanLink: Scalars['String']['input'];
  /** transcation number */
  transactionNumber: Scalars['String']['input'];
};

/** Result of processing the idology response */
export type IdologyResult = {
  __typename?: 'IdologyResult';
  addressDocumentUploadId?: Maybe<Scalars['String']['output']>;
  identityDocumentUploadUrl?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** Idology information */
export type IdologyUpload = {
  /** address */
  address: Scalars['String']['input'];
  /** city */
  city: Scalars['String']['input'];
  /** email */
  email: Scalars['String']['input'];
  /** first name */
  firstName: Scalars['String']['input'];
  /** last name */
  lastName: Scalars['String']['input'];
  /** raw response from Idology */
  rawResponse: Scalars['String']['input'];
  /** state */
  state: Scalars['String']['input'];
  /** telephone */
  telephone: Scalars['String']['input'];
  /** transcation number */
  transactionNumber: Scalars['String']['input'];
  /** zip */
  zip: Scalars['String']['input'];
};

/** Result of processing the idology response */
export type IdologyUploadResponse = {
  __typename?: 'IdologyUploadResponse';
  userId: Scalars['ID']['output'];
};

export type Image = {
  __typename?: 'Image';
  url: Scalars['String']['output'];
};

export type ImplicitToken = {
  __typename?: 'ImplicitToken';
  token: Scalars['String']['output'];
};

/**
 * An abstract representation of some reward a subscriber will be afforded
 * upon subscription to some Offer.
 */
export type Incentive = {
  /**
   * Arbitrary human-readable identifier that can be used by clients
   * to localize related copy.
   */
  copyKey?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Description of what the incentive provides the subscriber. */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IncorrectOldPasswordException = {
  __typename?: 'IncorrectOldPasswordException';
  message?: Maybe<Scalars['String']['output']>;
};

export type IncorrectSecurityAnswerException = {
  __typename?: 'IncorrectSecurityAnswerException';
  message?: Maybe<Scalars['String']['output']>;
};

export type IncorrectSsnException = {
  __typename?: 'IncorrectSsnException';
  message?: Maybe<Scalars['String']['output']>;
};

export enum IneligibleReasons {
  RequiredAccountsNotOpen = 'REQUIRED_ACCOUNTS_NOT_OPEN',
  SubscriptionTierIneligible = 'SUBSCRIPTION_TIER_INELIGIBLE'
}

export type InitiateChallengeInput = {
  authenticatorId?: InputMaybe<Scalars['ID']['input']>;
  mfaToken: Scalars['ID']['input'];
  type?: InputMaybe<AuthType>;
  userId: Scalars['ID']['input'];
};

export type InitiateChallengeResult = AuthenticatorNotFoundException | ChallengeRateExceededException | EmailAuthChallenge | InitiatePushChallengeSuccess | InvalidMfaTokenException | PhoneNumberOptedOutException | PushAuthChallenge | SmsAuthChallenge;

export type InitiateEmailChallengeInput = {
  email: Scalars['EmailAddress']['input'];
};

export type InitiateEmailChallengeResult = ChallengeRateExceededException | EmailAuthChallenge | ExistingEmailVerifiedException;

export type InitiateMoneyAssignmentInput = {
  transactionId: Scalars['ID']['input'];
};

export type InitiateMoneyAssignmentResult = InitiateMoneyAssignmentSuccess | MoneyAssignmentAlreadyTransferredError | MoneyAssignmentNotFoundError;

export type InitiateMoneyAssignmentSuccess = {
  __typename?: 'InitiateMoneyAssignmentSuccess';
  moneyAssignment: MoneyManagerMoneyAssignment;
};

export type InitiatePushChallengeResult = ChallengeRateExceededException | InitiatePushChallengeSuccess | NoRegisteredPushAuthenticatorsException;

export type InitiatePushChallengeSuccess = {
  __typename?: 'InitiatePushChallengeSuccess';
  challenges?: Maybe<Array<PushAuthChallenge>>;
};

export type InitiateSmsChallengeInput = {
  phoneNumber: Scalars['PhoneNumber']['input'];
};

export type InitiateSmsChallengeResult = ChallengeRateExceededException | InvalidPhoneNumberException | PhoneNumberOptedOutException | SmsAuthChallenge;

/** Response from Initiate Spend Funnel Closure */
export type InitiateSpendFunnelClosureResponse = {
  __typename?: 'InitiateSpendFunnelClosureResponse';
  userId: Scalars['ID']['output'];
};

export type InitiateVerificationResult = VerificationProfile;

/** Insufficient Funds user alert. */
export type InsufficientFundsUserAlert = UserAlertsItem & {
  __typename?: 'InsufficientFundsUserAlert';
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

export type InternalAllBankAccountsInput = {
  /** Deprecated. Use types instead. types takes precedence over type if both are non-null */
  type?: InputMaybe<BankAccountType>;
  types?: InputMaybe<Array<BankAccountType>>;
  userId: Scalars['ID']['input'];
};

export type InternalAllBankCardsInput = {
  userId: Scalars['ID']['input'];
};

/** A person who doesn't have an Acorns account, but may someday inherit one or funds from one. */
export type InternalBeneficiary = TimestampsInterface & {
  __typename?: 'InternalBeneficiary';
  /** List of addresses associated with beneficiary */
  addresses?: Maybe<Array<Maybe<Address>>>;
  /** Age of beneficiary */
  age: Scalars['Int']['output'];
  /** URL for the Beneficiary's avatar image */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Internal ID for user who this beneficiary belongs to */
  custodianId: Scalars['ID']['output'];
  /** Beneficiary's nickname for their custodian */
  custodianNickname?: Maybe<Scalars['String']['output']>;
  /** Beneficiary's date of birth */
  dateOfBirth: Scalars['String']['output'];
  /** Timestamp when the Beneficiary was deactivated */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Beneficiary's birthday is within the next month */
  eligibleForContributionTooltip: Scalars['Boolean']['output'];
  /** Beneficiary's email ID */
  email?: Maybe<Scalars['Email']['output']>;
  /** First name of beneficiary */
  firstName: Scalars['String']['output'];
  /** Internal ID for beneficiary */
  id: Scalars['ID']['output'];
  /** Beneficiary's investment account */
  investmentAccount?: Maybe<InvestmentAccount>;
  /** Last name of beneficiary */
  lastName: Scalars['String']['output'];
  /** List of phone numbers associated with the beneficiary */
  phoneNumbers?: Maybe<Array<Maybe<Phone>>>;
  /** Date when Documents for Beneficiary SSN were requested */
  ssnDocumentRequestedAt?: Maybe<Scalars['Date']['output']>;
  /** Beneficiary last four of SSN */
  ssnLastFour?: Maybe<Scalars['String']['output']>;
  /** True if the beneficiary has an ssn false if not */
  ssnPresent: Scalars['Boolean']['output'];
  /** Beneficiary secret SSN token */
  ssnToken?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the Beneficiary SSN was verified */
  ssnVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Beneficiary's SSN verification state */
  ssnVerifiedState?: Maybe<BeneficiarySsnVerifiedState>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An internal error has occurred */
export type InternalErrorException = {
  __typename?: 'InternalErrorException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Miscellaneous attributes about a Linked Account */
export type InternalLinkedAccount = TimestampsInterface & {
  __typename?: 'InternalLinkedAccount';
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Error code attached to operation done on account */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Error message attached to operation done on account */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Plaid token to access account */
  externalAccessToken?: Maybe<Scalars['String']['output']>;
  /** Plaid account ID */
  externalId?: Maybe<Scalars['ID']['output']>;
  /** Source of linked account (plaid or spend) */
  externalSource: LinkedAccountExternalSourceEnum;
  financialInstitution?: Maybe<FinancialInstitution>;
  /** ID of the financial institution this linked account is for */
  financialInstitutionId?: Maybe<Scalars['ID']['output']>;
  /** Linked Account ID */
  id: Scalars['ID']['output'];
  identity?: Maybe<PlaidIdentity>;
  /** Name of the associated institution this linked account is for */
  institutionName?: Maybe<Scalars['String']['output']>;
  /** Request to link account operation id */
  linkRequestId?: Maybe<Scalars['String']['output']>;
  /** Plaid link session id */
  linkSessionId?: Maybe<Scalars['String']['output']>;
  /** Is the account linked? */
  linked: Scalars['Boolean']['output'];
  linkedSubaccounts: Array<InternalLinkedSubaccount>;
  /** The logo url for the institution associated with the account */
  logoUrl: Scalars['String']['output'];
  /** This field should only be fetched for initializing a Plaid Link session */
  publicToken?: Maybe<Scalars['String']['output']>;
  /** Status indicating potential user action required */
  status: LinkedAccountStatusEnum;
  /** DateTime of when Transactions were last synced for financial institution */
  transactionsLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Correlated User UUID */
  userId: Scalars['ID']['output'];
};

/** An individual account between an individual user and financial institution */
export type InternalLinkedSubaccount = TimestampsInterface & {
  __typename?: 'InternalLinkedSubaccount';
  /** Full Account Number */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Last 4 Digits of Account Number */
  accountNumberLastFour?: Maybe<Scalars['String']['output']>;
  /** Roles this linked account can be assigned to */
  allowedRoles: Array<LinkedSubaccountRoleEnum>;
  /** Time balance was updated (via Plaid/Spend) */
  balanceAsOfDate?: Maybe<Scalars['DateTime']['output']>;
  /** Balance available (via Plaid/Spend) */
  balanceAvailable?: Maybe<Scalars['Float']['output']>;
  /** Current balance of subaccount (via Plaid/Spend) */
  balanceCurrent?: Maybe<Scalars['Float']['output']>;
  /** Spending limit of balance */
  balanceLimit?: Maybe<Scalars['Float']['output']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Plaid ID for linked subaccount */
  externalId?: Maybe<Scalars['String']['output']>;
  /** External source of subaccount (plaid, spend, paypal, manual) */
  externalSource?: Maybe<Scalars['String']['output']>;
  /** Internal ID for linked subaccount */
  id: Scalars['ID']['output'];
  /** Subaccount Linked? */
  linked: Scalars['Boolean']['output'];
  linkedAccount: InternalLinkedAccount;
  /** Internal ID for the corresponding linked account */
  linkedAccountId: Scalars['ID']['output'];
  /** Name of linked subaccount (Department) */
  name: Scalars['String']['output'];
  /** Official name (verbose) */
  officialName?: Maybe<Scalars['String']['output']>;
  paymentEngines: Array<LinkedSubaccountPaymentEngineEnum>;
  /** The role of the linked subaccount */
  role?: Maybe<LinkedSubaccountRoleEnum>;
  /** Financial institution routing number. */
  routingNumber?: Maybe<Scalars['String']['output']>;
  /** The status of the linked subaccount */
  status?: Maybe<FundingSourceStatusEnum>;
  /** Subtype (ie checking) */
  subaccountSubtype: Scalars['String']['output'];
  /** Type (depository, credit) */
  subaccountType: Scalars['String']['output'];
  /** Transactions count */
  transactionsLastSyncedCount: Scalars['Int']['output'];
  /** RDVs and docs have been verified and approved for this account */
  transfersApproved?: Maybe<Scalars['Boolean']['output']>;
  /** Is the account at risk or does it have insufficient funds? */
  transfersAtRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Subaccount Verified?
   * @deprecated This will be removed in favor of "transfersApproved"
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** Miscellaneous attributes and information about a user */
export type InternalProfile = TimestampsInterface & {
  __typename?: 'InternalProfile';
  /** Annual income */
  annualIncome?: Maybe<Scalars['Int']['output']>;
  /** Combined annual income */
  combinedAnnualIncome?: Maybe<Scalars['Int']['output']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Debt */
  debt?: Maybe<Scalars['Boolean']['output']>;
  /** Employees */
  employees?: Maybe<Employees>;
  /** Employment status */
  employmentStatus?: Maybe<EmploymentStatus>;
  /** Filing type */
  filingType?: Maybe<FilingType>;
  /** Financial education */
  financialEducation?: Maybe<FinancialEducation>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Funds availability */
  fundsAvailability?: Maybe<FundsAvailability>;
  /** High-interest debt */
  highInterestDebt?: Maybe<Scalars['Boolean']['output']>;
  /** Investment goal */
  investmentGoal?: Maybe<InvestmentGoal>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Marital status */
  maritalStatus?: Maybe<MaritalStatus>;
  /** Monthly expenses */
  monthlyExpenses?: Maybe<Scalars['Float']['output']>;
  /** Net worth */
  netWorth?: Maybe<Scalars['Float']['output']>;
  /** has user opted out of targeting */
  optedOutOfTargeting: Scalars['Boolean']['output'];
  /** Retirement plan access */
  retirementPlanAccess?: Maybe<RetirementPlanAccess>;
  /** Self employed income */
  selfEmployedIncome?: Maybe<Scalars['Int']['output']>;
  /** Signature type */
  signatures: Array<Maybe<Signature>>;
  /** Last four of SSN */
  ssnLastFour?: Maybe<Scalars['String']['output']>;
  /** User has paused their transfers */
  transfersPaused?: Maybe<Scalars['Boolean']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Internal ID for user */
  userId: Scalars['ID']['output'];
};

export type InternalShareTransferFailed = {
  __typename?: 'InternalShareTransferFailed';
  description: Scalars['String']['output'];
};

export type InternalShareTransferInput = {
  sharePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  shareQuantity: Scalars['BigDecimal']['input'];
  symbol: Scalars['TickerSymbol']['input'];
};

/** Invalid acceptance document. */
export type InvalidAcceptanceDocumentException = {
  __typename?: 'InvalidAcceptanceDocumentException';
  /** Inputed message */
  message: Scalars['String']['output'];
};

/** Invalid acceptance document version. */
export type InvalidAcceptanceDocumentVersionException = {
  __typename?: 'InvalidAcceptanceDocumentVersionException';
  /** Inputed message */
  message: Scalars['String']['output'];
};

/** Invalid acceptance document version filter. */
export type InvalidAcceptanceDocumentVersionFilterException = {
  __typename?: 'InvalidAcceptanceDocumentVersionFilterException';
  /** Inputed message */
  message: Scalars['String']['output'];
};

export type InvalidAcornsEarlyTokenException = {
  __typename?: 'InvalidAcornsEarlyTokenException';
  message: Scalars['String']['output'];
};

/** Risk Level cannot be changed on Later and Early accounts */
export type InvalidActionOnAccount = {
  __typename?: 'InvalidActionOnAccount';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidAddressError = {
  __typename?: 'InvalidAddressError';
  /** Error details. Not for user display. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['ID']['output'];
};

/** Invalid Address */
export type InvalidAddressException = {
  __typename?: 'InvalidAddressException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidAppleAccountException = {
  __typename?: 'InvalidAppleAccountException';
  message?: Maybe<Scalars['String']['output']>;
  subId?: Maybe<Scalars['String']['output']>;
};

/** Invalid Billing Cycle ID */
export type InvalidBillingCycleIdError = {
  __typename?: 'InvalidBillingCycleIdError';
  /** The invalid billing cycle ID provided */
  billingCycleId: Scalars['ID']['output'];
};

export type InvalidContentTypeException = {
  __typename?: 'InvalidContentTypeException';
  contentType: Scalars['String']['output'];
};

export type InvalidCredentialsException = {
  __typename?: 'InvalidCredentialsException';
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidDateException = {
  __typename?: 'InvalidDateException';
  message: Scalars['String']['output'];
};

/** Date of birth does not meet validity criteria */
export type InvalidDateOfBirthException = {
  __typename?: 'InvalidDateOfBirthException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidDeviceParametersException = {
  __typename?: 'InvalidDeviceParametersException';
  message?: Maybe<Scalars['String']['output']>;
};

/** Invalid Document Request ID provided */
export type InvalidDocumentRequestIdException = {
  __typename?: 'InvalidDocumentRequestIdException';
  /** provided document request ID */
  documentRequestId: Scalars['ID']['output'];
};

/** Invalid email id */
export type InvalidEmailException = {
  __typename?: 'InvalidEmailException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** First Name does not meet validity criteria */
export type InvalidFirstNameException = {
  __typename?: 'InvalidFirstNameException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Provided funding source is not linked for this user */
export type InvalidFundingSourceError = {
  __typename?: 'InvalidFundingSourceError';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Provided funding source is not linked for this user */
export type InvalidFundingSourceException = {
  __typename?: 'InvalidFundingSourceException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** The IRA Distribution amount provided is invalid */
export type InvalidIraDistributionAmountError = {
  __typename?: 'InvalidIRADistributionAmountError';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidIdentityTokenException = {
  __typename?: 'InvalidIdentityTokenException';
  message?: Maybe<Scalars['String']['output']>;
};

/** Last Name does not meet validity criteria */
export type InvalidLastNameException = {
  __typename?: 'InvalidLastNameException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidLaterInput = LaterTypedException & {
  __typename?: 'InvalidLaterInput';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type InvalidMfaTokenException = {
  __typename?: 'InvalidMfaTokenException';
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Invalid number of months given */
export type InvalidNumberOfMonthsException = {
  __typename?: 'InvalidNumberOfMonthsException';
  /** message */
  message: Scalars['String']['output'];
};

export type InvalidOauthAppClientIdException = {
  __typename?: 'InvalidOauthAppClientIdException';
  oauthAppClientId: Scalars['ID']['output'];
};

export type InvalidPasswordException = {
  __typename?: 'InvalidPasswordException';
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidPasswordResetException = {
  __typename?: 'InvalidPasswordResetException';
  errors: Array<PasswordResetErrors>;
};

export type InvalidPasswordResetTokenException = {
  __typename?: 'InvalidPasswordResetTokenException';
  invalidToken: Scalars['String']['output'];
};

/** Invalid Phone Number */
export type InvalidPhoneException = {
  __typename?: 'InvalidPhoneException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidPhoneNumberException = {
  __typename?: 'InvalidPhoneNumberException';
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidPinException = {
  __typename?: 'InvalidPinException';
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidPromoCodeError = {
  __typename?: 'InvalidPromoCodeError';
  name: Scalars['String']['output'];
};

export type InvalidReferralRelationship = {
  __typename?: 'InvalidReferralRelationship';
  message: Scalars['String']['output'];
};

export type InvalidSecurityForSymbolChangeError = {
  __typename?: 'InvalidSecurityForSymbolChangeError';
  error_reason: Scalars['String']['output'];
};

/** Returned when a given singleRuleId does not match with a rule in the ruleset to be updated */
export type InvalidSingleRuleIdError = {
  __typename?: 'InvalidSingleRuleIdError';
  message: Scalars['String']['output'];
};

/** SSN does not meet validity criteria */
export type InvalidSsnException = {
  __typename?: 'InvalidSsnException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Invalid state transition */
export type InvalidStateTransition = {
  __typename?: 'InvalidStateTransition';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidSymbolForSymbolChangeError = {
  __typename?: 'InvalidSymbolForSymbolChangeError';
  error_reason: Scalars['String']['output'];
};

export type InvalidTier = {
  __typename?: 'InvalidTier';
  message: Scalars['String']['output'];
  validTiers: Array<Tier>;
};

export type InvalidTierForMigrationError = {
  __typename?: 'InvalidTierForMigrationError';
  message: Scalars['String']['output'];
};

export type InvalidTierPrice = {
  __typename?: 'InvalidTierPrice';
  message: Scalars['String']['output'];
  validTierPrices: Array<TierPrice>;
};

export type InvalidTierPriceCombination = {
  __typename?: 'InvalidTierPriceCombination';
  message: Scalars['String']['output'];
  tier: Tier;
};

/** Returned if there is no available tier based on the provided tierPriceId */
export type InvalidTierPriceId = {
  __typename?: 'InvalidTierPriceId';
  message: Scalars['String']['output'];
};

/** Email is not valid */
export type InvalidUserEmailError = {
  __typename?: 'InvalidUserEmailError';
  /** The provided user email */
  email?: Maybe<Scalars['String']['output']>;
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidUserIdException = {
  __typename?: 'InvalidUserIdException';
  message: Scalars['String']['output'];
};

export type InvalidUserTokenException = {
  __typename?: 'InvalidUserTokenException';
  userTokenId: Scalars['ID']['output'];
};

/** waiver reason is not valid exception */
export type InvalidWaiverReasonLengthError = {
  __typename?: 'InvalidWaiverReasonLengthError';
  /** length of the given waiver reason */
  lengthGiven: Scalars['Int']['output'];
  /** max length a waiver reason is allowed to be */
  maxLength: Scalars['Int']['output'];
};

/** Enum for valid keys in Investing Strategy Factors */
export enum InvestingStrategyFactorKey {
  Age = 'AGE',
  AnnualIncome = 'ANNUAL_INCOME',
  CombinedAnnualIncome = 'COMBINED_ANNUAL_INCOME',
  Employees = 'EMPLOYEES',
  EmploymentStatus = 'EMPLOYMENT_STATUS',
  FilingType = 'FILING_TYPE',
  FinancialEducation = 'FINANCIAL_EDUCATION',
  InvestmentGoal = 'INVESTMENT_GOAL',
  MaritalStatus = 'MARITAL_STATUS',
  NetWorth = 'NET_WORTH',
  NetWorthEstimate = 'NET_WORTH_ESTIMATE',
  SelfEmployedIncome = 'SELF_EMPLOYED_INCOME',
  Theme = 'THEME'
}

/** Factors affecting outcome of recommendation */
export type InvestingStrategyFactors = {
  key: InvestingStrategyFactorKey;
  value: Scalars['JSON']['input'];
};

export type Investment = {
  __typename?: 'Investment';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  allocationsOrderId?: Maybe<Scalars['String']['output']>;
  /** Amount requested to be invested */
  amount: Scalars['Float']['output'];
  /** Amount collected by Acorns to cover owed money. */
  amountCollected?: Maybe<MonetaryAmount>;
  /** Cash Owed from chargeback on this investment. */
  cashOwed?: Maybe<MonetaryAmount>;
  /** The date that the investment was created */
  createdAt: Scalars['Date']['output'];
  /** The Fund a dividend was issued for and amount re-invested via this investment */
  dividendFund?: Maybe<Fund>;
  /** Stubbed Field: Name of partner for found money reward investment */
  earnRewardInvestmentPartner?: Maybe<Scalars['String']['output']>;
  /** Stubbed Field: Url logo for found money reward investment */
  earnRewardInvestmentPartnerLogoUrl?: Maybe<Scalars['URL']['output']>;
  /** Stubbed Field: Type of earn reward investment */
  earnRewardInvestmentType?: Maybe<EarnRewardInvestType>;
  /** Eligible investment actions */
  eligibleInvestmentActions: Array<InvestmentAction>;
  /** Stubbed Field: Estimated date for an investment to be completed */
  estimatedCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  failed?: Maybe<Scalars['Boolean']['output']>;
  /** Investment fee */
  fees?: Maybe<Array<InvestmentFees>>;
  /** The associated funding source of the investment */
  fundingSource?: Maybe<FundingSource>;
  /** General type for the investment */
  generalTypeForInvestment: Scalars['String']['output'];
  holdings?: Maybe<Array<InvestmentHoldings>>;
  /** Holdings Transfer Information */
  holdingsTransfer?: Maybe<HoldingsTransfer>;
  /** Unique identifier of the Investment. */
  id: Scalars['ID']['output'];
  /** Investment account details */
  investmentAccount: InvestmentAccount;
  /** Account for the investment being made */
  investmentAccountId: Scalars['ID']['output'];
  /**
   * Unique Identifier for an Investment
   * @deprecated Use id.
   */
  investmentId: Scalars['ID']['output'];
  /** Status of investment */
  investmentStatus?: Maybe<InvestmentStatusV2>;
  /** Transaction type of the investment */
  investmentTransactionType: InvestmentTransactionType;
  /** Investment Type */
  investmentType: InvestmentType;
  /** An IRA Distribution or a withdraw investment for Later account */
  iraDistribution?: Maybe<IraDistribution>;
  iraWithdrawal?: Maybe<Scalars['String']['output']>;
  manual?: Maybe<Scalars['Boolean']['output']>;
  moneyManagerAllocation?: Maybe<MoneyManagerAllocation>;
  /** Investment Multiplier */
  multiplier?: Maybe<Scalars['Int']['output']>;
  nonce?: Maybe<Scalars['ID']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  rebalance?: Maybe<Scalars['Boolean']['output']>;
  /** The original amount requested for the investment */
  requestedAmount: MonetaryAmount;
  /** Type of the round up */
  roundUpType?: Maybe<InvestmentRoundUpType>;
  /** Shares Amount */
  sharesAmount?: Maybe<Scalars['Float']['output']>;
  skipTransferProcess?: Maybe<Scalars['Boolean']['output']>;
  splitFromId?: Maybe<Scalars['Int']['output']>;
  /** Status to initialize the investment with */
  status: InvestmentStatus;
  statusEvents?: Maybe<Array<InvestmentStatusEvent>>;
  /** Tax year the investment was recorded for */
  taxYear?: Maybe<Scalars['Int']['output']>;
  /** Total amount of shares bought or sold for an investment */
  tradedAmount?: Maybe<MonetaryAmount>;
  /** Transaction ID for money transfer */
  transactionId?: Maybe<Scalars['String']['output']>;
  /** Investment Transaction Status */
  transactionStatus?: Maybe<Scalars['String']['output']>;
  transferFundingSourceId?: Maybe<Scalars['String']['output']>;
  /** Amount that was successfully transferred */
  transferredAmount?: Maybe<Scalars['Float']['output']>;
  /** Transferred by ID */
  transferredById?: Maybe<Scalars['String']['output']>;
  /** Transferred Credits */
  transferredCredits?: Maybe<Array<InvestmentTransferredCredit>>;
  /** Type either fee or credit */
  type: Scalars['String']['output'];
  /** Type for the investment */
  typeForInvestment: Scalars['String']['output'];
  /** Type help for the investment */
  typeHelpForInvestment?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  verifier?: Maybe<User_V2>;
  /** Waiting Amount */
  waitingAmount?: Maybe<Scalars['Float']['output']>;
};

/** Beneficiary investment account */
export type InvestmentAccount = TimestampsInterface & {
  __typename?: 'InvestmentAccount';
  /** Investment accounts that investments are allocated to together. */
  allocationGroup: Array<InvestmentAccount>;
  beneficiary?: Maybe<Beneficiary>;
  /** Internal ID of the beneficiary */
  beneficiaryId?: Maybe<Scalars['ID']['output']>;
  cashBalance: MonetaryAmount;
  cashOwed: MonetaryAmount;
  /** Cash owed for one specific account */
  cashOwedForAccount: MonetaryAmount;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date the account closure was requested */
  closureRequestAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  currentBalance?: Maybe<MonetaryAmount>;
  currentBalanceWithPending: MonetaryAmount;
  /** Deposit hold applied at */
  depositHoldAppliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Deposit hold enabled/disabled */
  depositHoldEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Deposit hold expires at */
  depositHoldExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** External Cache In Progress */
  externalCacheInProgress: Scalars['Boolean']['output'];
  friendlyName: Scalars['String']['output'];
  /** Whether or not the user has made their first investment on this account. */
  hasInvested: Scalars['Boolean']['output'];
  /** Internal UUID of the Investment Account */
  id: Scalars['ID']['output'];
  /** Roundup invested */
  investedRoundups?: Maybe<Scalars['Float']['output']>;
  investmentAccountType: InvestmentAccountType;
  /** Name of the Investment Account */
  name: Scalars['String']['output'];
  /** The net investments in this investment account. */
  netInvestments: MonetaryAmount;
  pendingBalance: MonetaryAmount;
  /** Sum of all user's pending investments, including debits */
  pendingInvestmentsSum?: Maybe<MonetaryAmount>;
  pendingWithdrawals: Array<Withdrawal>;
  performance?: Maybe<Performance>;
  portfolio?: Maybe<Portfolio>;
  portfolios?: Maybe<Array<BasePortfolio>>;
  product: InvestmentProduct;
  /** Recap of the investment account's activity and statistics over the last quarter. */
  quarterlyRecap?: Maybe<InvestmentAccountRecap>;
  /** Whether or not quarterly recap generation is enabled for this investment account. */
  quarterlyRecapsEnabled: Scalars['Boolean']['output'];
  recommendedPortfolio?: Maybe<Portfolio>;
  recurringInvestmentSettings?: Maybe<RecurringInvestmentSettings>;
  /** The current status of the account */
  requirements: AccountRequirements;
  /** The all-time returns in this investment account. */
  returnsAllTime: MonetaryAmount;
  selfDirected?: Maybe<InvestmentAccount>;
  status: InvestmentAccountStatus;
  summary: InvestmentAccountSummary;
  /** The total account value in this investment account. */
  totalAccountValue: MonetaryAmount;
  /** The total amount that is invested in bonds in this investment account. */
  totalBonds: MonetaryAmount;
  /** Sum of total cash owed for all investment accounts in the allocation group. */
  totalCashOwed: Scalars['Float']['output'];
  /** The total amount that is invested in crypto in this investment account. */
  totalCrypto: MonetaryAmount;
  /** The total amount that is invested in equities in this investment account. */
  totalEquities: MonetaryAmount;
  /** Total matched contributions all-time. */
  totalMatched: MonetaryAmount;
  /** Total matched contribution amount by tax year. */
  totalMatchedByYear: MonetaryAmount;
  transferability?: Maybe<InvestmentAccountTransferability>;
  trustedContact?: Maybe<TrustedContact>;
  type: Scalars['String']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Age of the account owner */
  userAge?: Maybe<Scalars['Int']['output']>;
  /** UUID for the user */
  userId: Scalars['ID']['output'];
  /** @deprecated Use id instead. */
  uuid: Scalars['ID']['output'];
  /** Roundup waiting */
  waitingRoundups?: Maybe<Scalars['Float']['output']>;
  /** Withdrawing from this account would incur a tax penalty */
  withdrawalsIncurTaxPenalty?: Maybe<Scalars['Boolean']['output']>;
  yearToDateReturn?: Maybe<MarketReturn>;
};


/** Beneficiary investment account */
export type InvestmentAccountPerformanceArgs = {
  days: Scalars['Int']['input'];
};


/** Beneficiary investment account */
export type InvestmentAccountSummaryArgs = {
  endPeriod?: InputMaybe<Scalars['Date']['input']>;
  startPeriod?: InputMaybe<Scalars['Date']['input']>;
};


/** Beneficiary investment account */
export type InvestmentAccountTotalMatchedByYearArgs = {
  year: Scalars['Int']['input'];
};

export type InvestmentAccountAlreadyClosed = {
  __typename?: 'InvestmentAccountAlreadyClosed';
  /** Date and Time of account closure if account is already closed */
  accountClosedAt: Scalars['DateTime']['output'];
};

/** Fetch investment account calculations performance */
export type InvestmentAccountCalculationResponse = {
  __typename?: 'InvestmentAccountCalculationResponse';
  currentBalance?: Maybe<MonetaryAmount>;
  /** Investment account's fund performance calculations */
  fundAccountValues?: Maybe<Array<FundAccountValue>>;
  totalRealized?: Maybe<MonetaryAmount>;
  totalUnrealized?: Maybe<MonetaryAmount>;
};

export type InvestmentAccountClearCache = {
  __typename?: 'InvestmentAccountClearCache';
  /** Investment Account Clear Cache Eexecution feedback message */
  message: Scalars['String']['output'];
};

/** Investment Account Clear Cache Response */
export type InvestmentAccountClearCacheResult = InvestmentAccountClearCache | InvestmentAccountNotFoundException;

/** The account provided is already closed */
export type InvestmentAccountClosedError = {
  __typename?: 'InvestmentAccountClosedError';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvestmentAccountClosureInProgress = {
  __typename?: 'InvestmentAccountClosureInProgress';
  /** Message displayed to customer when closure is already in progress */
  clientMessage: Scalars['String']['output'];
};

export enum InvestmentAccountClosureReason {
  /** Can't afford at this time */
  CantAffordAtThisTime = 'CANT_AFFORD_AT_THIS_TIME',
  /** Change age of transfer */
  ChangeAgeOfTransfer = 'CHANGE_AGE_OF_TRANSFER',
  /** Going to a competitor */
  GoingToACompetitor = 'GOING_TO_A_COMPETITOR',
  /** Had a bad experience */
  HadABadExperience = 'HAD_A_BAD_EXPERIENCE',
  /** Not seeing the value */
  NotSeeingTheValue = 'NOT_SEEING_THE_VALUE',
  /** No longer use */
  NoLongerUse = 'NO_LONGER_USE',
  /** Other */
  Other = 'OTHER',
  /** Rolling over to another ira */
  RollingOverToAnotherIra = 'ROLLING_OVER_TO_ANOTHER_IRA',
  /** Switching to another savings plan */
  SwitchingToAnotherSavingsPlan = 'SWITCHING_TO_ANOTHER_SAVINGS_PLAN',
  /** Using funds for another purpose */
  UsingFundsForAnotherPurpose = 'USING_FUNDS_FOR_ANOTHER_PURPOSE',
  /** Using funds for the good of the child */
  WithdrawalForChild = 'WITHDRAWAL_FOR_CHILD'
}

/** Investment Account Not Found */
export type InvestmentAccountNotFoundException = {
  __typename?: 'InvestmentAccountNotFoundException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Outside contribution made to an investment account. */
export type InvestmentAccountOutsideContribution = {
  __typename?: 'InvestmentAccountOutsideContribution';
  /** Monetary amount of the contribution. */
  amount: MonetaryAmount;
  /** Name of the contributor */
  contributorName: Scalars['String']['output'];
  /** Note from the contributor. */
  note?: Maybe<Scalars['String']['output']>;
};

/** Aggregation of investment account activity and stats over a period of time. */
export type InvestmentAccountRecap = {
  __typename?: 'InvestmentAccountRecap';
  /** Age of the investment account's beneficiary. */
  beneficiaryAge?: Maybe<Scalars['Int']['output']>;
  /** Nickname of the investment account's custodian. */
  beneficiaryCustodianNickname?: Maybe<Scalars['String']['output']>;
  /** First name of the investment account's beneficiary. */
  beneficiaryFirstName?: Maybe<Scalars['String']['output']>;
  /** Last name of the investment account's beneficiary. */
  beneficiaryLastName?: Maybe<Scalars['String']['output']>;
  /** Contributions to the investment account made by non-owners. */
  contributionsByOthers?: Maybe<Array<InvestmentAccountOutsideContribution>>;
  /** Creation date of the investment account recap. */
  createdAt: Scalars['Date']['output'];
  /** Start date of the investment account recap. */
  endsAt: Scalars['Date']['output'];
  /** Unique identifier of the investment account recap. */
  id: Scalars['ID']['output'];
  /** Investment account for which the recap was generated for. */
  investmentAccount: InvestmentAccount;
  /** Unique identifier of the investment account for which the investment account recap was generated for. */
  investmentAccountId: Scalars['ID']['output'];
  /** Latest value of the investment account over the timeframe of the recap. */
  latestAccountValue?: Maybe<MonetaryAmount>;
  /** Market value of the investment account over the timeframe. */
  performance?: Maybe<Performance>;
  /** Whether or not the recap has public access enabled. */
  public: Scalars['Boolean']['output'];
  /** Web URL that the recap is publicly available at. */
  publicUrl?: Maybe<Scalars['URL']['output']>;
  /** Start date of the investment account recap. */
  startsAt: Scalars['Date']['output'];
  /** Total amount contributed to the investment account over the timeframe. */
  totalContributions?: Maybe<MonetaryAmount>;
  /** Total amount contributed to the investment account by non-owners over the timeframe. Only applies to UGMA and UTMA type investment accounts. */
  totalContributionsByOthers?: Maybe<MonetaryAmount>;
  /** Date of last update made to the investment account recap. */
  updatedAt: Scalars['Date']['output'];
  /** Record of whether or not the recap has been viewed by the investment account owner. */
  viewed: Scalars['Boolean']['output'];
};

export enum InvestmentAccountReopenCheck {
  /** Account locked check */
  AccountLockedCheck = 'ACCOUNT_LOCKED_CHECK',
  /** Account suspended check */
  AccountSuspendedCheck = 'ACCOUNT_SUSPENDED_CHECK',
  /** Backup withholding check */
  BackupWithholdingCheck = 'BACKUP_WITHHOLDING_CHECK',
  /** Investment collections check */
  InvestmentCollectionsCheck = 'INVESTMENT_COLLECTIONS_CHECK',
  /** Spend collections check */
  SpendCollectionsCheck = 'SPEND_COLLECTIONS_CHECK',
  /** Underage check */
  UnderageCheck = 'UNDERAGE_CHECK'
}

/** An investment account reopen request */
export type InvestmentAccountReopenRequest = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequest';
  /** A list of actions performed on this account reopen request */
  adminActions: Array<InvestmentAccountReopenRequestAction>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the reopen request */
  id: Scalars['Int']['output'];
  /** The investment account for which this reopen request was made */
  investmentAccount: InvestmentAccount;
  /** The UUID of the investment account for which this request was made */
  investmentAccountId: Scalars['ID']['output'];
  /** A list of update notes for this investment account reopen request */
  notes: Array<InvestmentAccountReopenRequestNote>;
  /** A list of reopen checks for this investment account reopen request */
  reopenChecks: Array<UserInvestmentAccountReopenCheck>;
  /** The ID of the user that created this investment account reopen request */
  reopenedByUserId: Scalars['Int']['output'];
  /** The state of the investment account reopen request */
  state: InvestmentAccountReopenRequestState;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The owner of the investment account associated with the reopen_request */
  user: LegacyUser;
  /** The ID of the user to whom the investment account the request was made for belongs */
  userId: Scalars['Int']['output'];
};

/** An admin action performed on an investment account reopen request */
export type InvestmentAccountReopenRequestAction = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestAction';
  /** The admin user that performed this action */
  adminUser: LegacyUser;
  /** ID of the admin user that performed this action */
  adminUuid: Scalars['ID']['output'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** The starting state of the reopen request */
  fromState: Scalars['String']['output'];
  /** The UUID of the reopen request admin action */
  id: Scalars['ID']['output'];
  /** The investment account for the corresponding reopen request */
  investmentAccount: InvestmentAccount;
  /** A note associated with this action */
  note?: Maybe<InvestmentAccountReopenRequestNote>;
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest;
  /** The end state of the reopen request */
  toState: Scalars['String']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An individual edge within the paginated list of InvestmentAccountReopenRequest */
export type InvestmentAccountReopenRequestEdge = {
  __typename?: 'InvestmentAccountReopenRequestEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The InvestmentAccountReopenRequest record in the edge */
  node: InvestmentAccountReopenRequest;
};

/** A note sent to the user regarding an investment account reopen request */
export type InvestmentAccountReopenRequestNote = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestNote';
  /** The action associated with this note */
  adminAction: InvestmentAccountReopenRequestAction;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** A boolean indicating if an email has been sent for this note */
  emailSent: Scalars['Boolean']['output'];
  /** The UUID of the reopen request note */
  id: Scalars['ID']['output'];
  /** The note text */
  note: Scalars['String']['output'];
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Relay style pagination information for InvestmentAccountReopenRequest */
export type InvestmentAccountReopenRequestPagination = {
  __typename?: 'InvestmentAccountReopenRequestPagination';
  edges: Array<InvestmentAccountReopenRequestEdge>;
  pageInfo: PageInfo;
};

export enum InvestmentAccountReopenRequestState {
  /** Indicates that the request has been approved */
  Approved = 'APPROVED',
  /** Indicates that the request must be reviewed by invest ops */
  PendingReview = 'PENDING_REVIEW',
  /** Indicates that the request is pending user action */
  PendingUserAction = 'PENDING_USER_ACTION',
  /** Indicates that the request has been rejected */
  Rejected = 'REJECTED',
  /** Indicates that the request has been made but not yet processed */
  Requested = 'REQUESTED'
}

/** Input to filter investment account reopen requests by for the InvestmentAccountReopenRequests query */
export type InvestmentAccountReopenRequestsInput = {
  /** Filter by requests created on or after the given UTC start date */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by requests created on or before the given UTC end date */
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUID of the investment account for which to fetch requests */
  investmentAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of investment product to filter requests by */
  investmentProduct?: InputMaybe<InvestmentProduct>;
  /** The state by which to filter reopen requests */
  reopenRequestState?: InputMaybe<InvestmentAccountReopenRequestState>;
  /** Filter by requests updated on or after the given UTC start date */
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by requests updated on or before the given UTC end date */
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUID of the user for whom to fetch requests */
  userUuid?: InputMaybe<Scalars['ID']['input']>;
};

export enum InvestmentAccountStatus {
  /** Investment account is closed */
  Closed = 'CLOSED',
  /** Investment account has reached transfer age */
  LockedForTransfer = 'LOCKED_FOR_TRANSFER',
  /** Investment account is open */
  Open = 'OPEN',
  /** Account has started account closure process */
  PendingClosure = 'PENDING_CLOSURE',
  /** Account has been created but is not fully activated/open */
  PendingOpen = 'PENDING_OPEN',
  /** Account has started account reopen process */
  PendingReopen = 'PENDING_REOPEN'
}

/** Investment account summary data */
export type InvestmentAccountSummary = {
  __typename?: 'InvestmentAccountSummary';
  /** The date of the user's first investment into this account */
  firstInvestmentDate?: Maybe<Scalars['DateTime']['output']>;
  /** The date of the user's most recent one-time investment into this account */
  mostRecentOneTimeInvestmentDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The total credits credited to this account.
   * @deprecated Use referral_rewards and found_money_rewards instead
   */
  totalCredits: Scalars['Float']['output'];
  /** The total amount deposited by the user into this account. Does not include rewards */
  totalDeposits: Scalars['Float']['output'];
  /** The total amount contributed by the user on the current year for this account */
  totalDepositsCurrentYear: Scalars['Float']['output'];
  /** The total amount contributed by the user on the current year within the specified timeframe for this account */
  totalDepositsCurrentYearWithinTimeFrame: Scalars['Float']['output'];
  /** The total amount contributed by the user on the previous year for this account */
  totalDepositsPreviousYear: Scalars['Float']['output'];
  /** The total dividends invested in this account. */
  totalDividends: Scalars['Float']['output'];
  /** The total found money rewards allocated to this account */
  totalFoundMoneyRewards: Scalars['Float']['output'];
  /** The total amount invested into this account. Includes rewards */
  totalInvested: Scalars['Float']['output'];
  /**
   * The total amount contributed by the user on the current year for this account
   * @deprecated Use total_deposits_current_year
   */
  totalInvestedCurrentYear: Scalars['Float']['output'];
  /** The total amount invested into this account. Includes rewards but excludes investments created from Acorns Transfer such as from checking or emergency fund */
  totalInvestedExcludingAcornsBanking: Scalars['Float']['output'];
  /**
   * The total amount contributed by the user on the previous year for this account
   * @deprecated Use total_deposits_previous_year
   */
  totalInvestedPreviousYear: Scalars['Float']['output'];
  /** The total amount matched rewarded */
  totalMatchRewards: Scalars['Float']['output'];
  /** The total one time investments made in this account. */
  totalOneTime: Scalars['Float']['output'];
  /** The total outside contributions to this account. */
  totalOutsideContributions: Scalars['Float']['output'];
  /** The total plan investments invested with this account. */
  totalPlan: Scalars['Float']['output'];
  /** The recurring investment total invested in this account. */
  totalRecurring: Scalars['Float']['output'];
  /** The total referral rewards to this account. */
  totalReferralRewards: Scalars['Float']['output'];
  /** The total round ups contributed to this account. */
  totalRoundUps: Scalars['Float']['output'];
  /** The total real time round ups contributed to this account. */
  totalRtru: Scalars['Float']['output'];
  /** The total amount withdrawn for this account */
  totalWithdrawn: Scalars['Float']['output'];
  /** The total amount withdrawn for this account. Excludes withdrawn to Acorns accounts such as from checking or emergency fund */
  totalWithdrawnExcludingAcornsBanking: Scalars['Float']['output'];
};

/** Transfer information for the given investment account */
export type InvestmentAccountTransferability = {
  __typename?: 'InvestmentAccountTransferability';
  /** The beneficiary investment account's age of transfer */
  transferAge: Scalars['Int']['output'];
  /** The beneficiary investment account's date of transfer */
  transferDate: Scalars['Date']['output'];
  /** The beneficiary investment account's age of transfer reached */
  transferReached: Scalars['Boolean']['output'];
  /** The beneficiary investment account's state of residence */
  transferStateCode: UsStateCodes;
};

export enum InvestmentAccountType {
  /** Basic investment account */
  BasicInvestment = 'BASIC_INVESTMENT',
  /** Roth IRA investment account */
  RothIra = 'ROTH_IRA',
  /** Simplified Employee Pension investment account */
  SimplifiedEmployeePension = 'SIMPLIFIED_EMPLOYEE_PENSION',
  /** Traditional IRA investment account */
  TraditionalIra = 'TRADITIONAL_IRA',
  /** Uniform Gift to Minors Act Custodial Investment Account */
  Ugma = 'UGMA',
  /** Uniform Transfer to Minors Act Custodial Investment Account */
  Utma = 'UTMA',
  /** @deprecated Use BASIC_INVESTMENT. */
  AcornsInvestingAccount = 'acornsInvestingAccount',
  /** @deprecated Use ROTH_IRA */
  RothIra = 'rothIRA',
  /** @deprecated Use SIMPLIFIED_EMPLOYEE_PENSION */
  SimplifiedEmployeePension = 'simplifiedEmployeePension',
  /** @deprecated Use TRADITIONAL_IRA. */
  TraditionalIra = 'traditionalIRA'
}

export enum InvestmentAccountTypes {
  RothIra = 'RothIRA',
  SimplifiedEmployeePension = 'SimplifiedEmployeePension',
  TraditionalIra = 'TraditionalIRA'
}

/** Filter for InvestmentAccountsByUserId query */
export type InvestmentAccountsByUserIdFilter = {
  /** Optionally filter by account status */
  accountStatus?: InputMaybe<InvestmentAccountStatus>;
  /** Investment Account Product Name */
  product?: InputMaybe<InvestmentProduct>;
};

export enum InvestmentAction {
  /** Approve the investment */
  Approve = 'APPROVE',
  /** Cancel the investment */
  Cancel = 'CANCEL',
  /** Post out the investment */
  PostOut = 'POST_OUT',
  /** Process a refund */
  Refund = 'REFUND',
  /** Reroute the investment */
  Reroute = 'REROUTE',
  /** Revoke the investment */
  Revoke = 'REVOKE',
  /** Void the investment */
  Void = 'VOID'
}

/** Additional pagination information */
export type InvestmentAggregation = {
  __typename?: 'InvestmentAggregation';
  totalPendingAmount?: Maybe<MonetaryAmount>;
};

export type InvestmentCategory = {
  __typename?: 'InvestmentCategory';
  bond: Scalars['Float']['output'];
  crypto: Scalars['Float']['output'];
  equity: Scalars['Float']['output'];
  realEstate: Scalars['Float']['output'];
};

/** The process of creating an investment for a user failed */
export type InvestmentCreationFailedException = {
  __typename?: 'InvestmentCreationFailedException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export enum InvestmentCreationStatus {
  /** Investment approved */
  Approved = 'APPROVED',
  /** Investment pending authorization */
  Pending = 'PENDING',
  /** Investment pending settlement */
  PendingSettle = 'PENDING_SETTLE',
  /** Investment settled */
  Settled = 'SETTLED'
}

/** An individual edge within the paginated list of Investment */
export type InvestmentEdge = {
  __typename?: 'InvestmentEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The Investment record in the edge */
  node: Investment;
};

/** Investment Fees Type */
export type InvestmentFees = {
  __typename?: 'InvestmentFees';
  /** Fee amount accrue */
  amount?: Maybe<Scalars['String']['output']>;
  /** Fee amount fixed */
  amountFixed?: Maybe<Scalars['String']['output']>;
  /** Fee amount transfer */
  amountTransfer?: Maybe<Scalars['String']['output']>;
  /** Fee created date */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Fee Id */
  id?: Maybe<Scalars['String']['output']>;
  /** Fee total amount */
  totalAmount?: Maybe<Scalars['String']['output']>;
};

export enum InvestmentFrequency {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export enum InvestmentGoal {
  /** User is looking for a balanced portfolio */
  Balanced = 'BALANCED',
  /** User is looking for conservative growth in their investments */
  Conservative = 'CONSERVATIVE',
  /** User is looking for exponential growth in their investments */
  ExponentialGrowth = 'EXPONENTIAL_GROWTH',
  /** User is looking for moderate growth in their investments */
  ModerateGrowth = 'MODERATE_GROWTH',
  /** User is looking to reduce risk in their investments */
  ReducedRisk = 'REDUCED_RISK'
}

/** The Individual Security on the ETF */
export type InvestmentHoldings = {
  __typename?: 'InvestmentHoldings';
  /** Indicates the amount of every dollar that will go towards buying a share of the stock */
  amount: Scalars['Float']['output'];
  /** The number of shares */
  shares: Scalars['Float']['output'];
  /** Status of the investment holding */
  status?: Maybe<Scalars['String']['output']>;
  /** The Symbol of the stock */
  symbol: Scalars['String']['output'];
};

/** When investment id and investment account id do not match */
export type InvestmentNotFoundException = {
  __typename?: 'InvestmentNotFoundException';
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Relay style pagination information for Investment */
export type InvestmentPagination = {
  __typename?: 'InvestmentPagination';
  aggregation?: Maybe<InvestmentAggregation>;
  edges: Array<InvestmentEdge>;
  pageInfo: PageInfo;
};

export enum InvestmentProduct {
  /** Early investment product */
  Early = 'EARLY',
  /** Invest investment product */
  Invest = 'INVEST',
  /** Later investment product */
  Later = 'LATER'
}

export enum InvestmentRoundUpType {
  Automatic = 'AUTOMATIC',
  RealTime = 'REAL_TIME'
}

/** All investment statuses */
export enum InvestmentStatus {
  /** Investment approved */
  Approved = 'APPROVED',
  /** Investment canceled */
  Canceled = 'CANCELED',
  /** Investment chargeback */
  Chargeback = 'CHARGEBACK',
  /** Investment confirmed */
  Confirmed = 'CONFIRMED',
  /** Investment declined */
  Declined = 'DECLINED',
  /** Investment failed */
  Failed = 'FAILED',
  /** Investment locked */
  Locked = 'LOCKED',
  /** Investment pending authorization */
  Pending = 'PENDING',
  /** Investment pending duplicate */
  PendingDuplicate = 'PENDING_DUPLICATE',
  /** Investment pending settlement */
  PendingSettle = 'PENDING_SETTLE',
  /** Investment posted in */
  PostedIn = 'POSTED_IN',
  /** Investment posted out */
  PostedOut = 'POSTED_OUT',
  /** Investment refunded */
  Refunded = 'REFUNDED',
  /** Investment returned */
  Returned = 'RETURNED',
  /** Investment reversed */
  Reversed = 'REVERSED',
  /** Investment revoked */
  Revoked = 'REVOKED',
  /** Investment settled */
  Settled = 'SETTLED',
  /** Investment shares settled */
  SharesSettled = 'SHARES_SETTLED',
  /** Investment suspended */
  Suspended = 'SUSPENDED',
  /** Investment transferred */
  Transferred = 'TRANSFERRED',
  /** Investment voided */
  Voided = 'VOIDED',
  /** Investment waiting */
  Waiting = 'WAITING'
}

/** Investment Status Event Type */
export type InvestmentStatusEvent = {
  __typename?: 'InvestmentStatusEvent';
  /** Investment Status Created Date */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Investment Status From */
  from?: Maybe<Scalars['String']['output']>;
  /** Investment Status Id */
  id?: Maybe<Scalars['ID']['output']>;
  /** Investment ID */
  investmentId?: Maybe<Scalars['ID']['output']>;
  /** Investment Status Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Transitioner ID */
  transitionerId?: Maybe<Scalars['ID']['output']>;
  /** Investment Status Updated Date */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Investment statuses that are used by frontend clients and external queries */
export enum InvestmentStatusV2 {
  /** Investment not translated */
  NotTranslated = 'NOT_TRANSLATED',
  /** Investment pending authorization */
  Pending = 'PENDING',
  /** Investment refunded */
  Refunded = 'REFUNDED',
  /** Investment returned */
  Returned = 'RETURNED',
  /** Investment reversed */
  Reversed = 'REVERSED',
  /** Investment revoked */
  Revoked = 'REVOKED',
  /** Investment settled */
  Settled = 'SETTLED',
  /** Investment transferred */
  Transferring = 'TRANSFERRING'
}

export enum InvestmentTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

/** Investment Transferred Credit Type */
export type InvestmentTransferredCredit = {
  __typename?: 'InvestmentTransferredCredit';
  /** Total amount of refunded investment */
  amount?: Maybe<MonetaryAmount>;
  /** Investment Status Id */
  id?: Maybe<Scalars['ID']['output']>;
};

/** All investment types */
export enum InvestmentType {
  AutomatedRebalance = 'AUTOMATED_REBALANCE',
  /** Recurring investment automatically created by the system */
  AutoInvestment = 'AUTO_INVESTMENT',
  CashOwedCollection = 'CASH_OWED_COLLECTION',
  CashReinvestment = 'CASH_REINVESTMENT',
  Collection = 'COLLECTION',
  /** Credit Investment */
  Credit = 'CREDIT',
  Dividend = 'DIVIDEND',
  /** Fee Investment */
  Fee = 'FEE',
  GiftCard = 'GIFT_CARD',
  HoldingsTransfer = 'HOLDINGS_TRANSFER',
  InstantRoundUp = 'INSTANT_ROUND_UP',
  IraRollover = 'IRA_ROLLOVER',
  IraTransfer = 'IRA_TRANSFER',
  /** Lump Sum Investment */
  LumpSum = 'LUMP_SUM',
  /** Matching investment made by the firm. */
  Match = 'MATCH',
  /** Removal of matching investment amount made by the firm. */
  MatchRemoval = 'MATCH_REMOVAL',
  /** Outside Contribution Investment */
  OutsideContribution = 'OUTSIDE_CONTRIBUTION',
  /** Plan investment to either a user's core account or to one of their Early accounts */
  Plan = 'PLAN',
  Refund = 'REFUND',
  Reversal = 'REVERSAL',
  /** Reward Investment, currently used by Referrals */
  Reward = 'REWARD',
  RoundUp = 'ROUND_UP',
  SecurityLiquidation = 'SECURITY_LIQUIDATION',
  Withdrawal = 'WITHDRAWAL'
}

/** Investment cannot be cancelled */
export type InvestmentUncancellableException = {
  __typename?: 'InvestmentUncancellableException';
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Investments Paused user alert. */
export type InvestmentsPausedUserAlert = UserAlertsItem & {
  __typename?: 'InvestmentsPausedUserAlert';
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

export type Invitation = {
  __typename?: 'Invitation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ReferralCode']['output'];
};

/** Type wrapper for the Invoice object from the billing vendor */
export type Invoice = {
  __typename?: 'Invoice';
  account?: Maybe<VendorCustomerAccount>;
  id?: Maybe<Scalars['String']['output']>;
  lineItems?: Maybe<Array<Maybe<InvoiceLineItem>>>;
  lineItemsAmountSum?: Maybe<Scalars['Float']['output']>;
  /**
   * Default type for state is 'all'.
   * Possible types are 'open', 'pending', 'processing', 'past_due', 'paid', 'closed', 'failed', 'voided'
   */
  state?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type InvoiceCollection = {
  __typename?: 'InvoiceCollection';
  chargeInvoice?: Maybe<Invoice>;
  creditInvoices?: Maybe<Array<Maybe<Invoice>>>;
  object?: Maybe<Scalars['String']['output']>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  feeCategory: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  addOnCode?: Maybe<Scalars['String']['output']>;
  addOnId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  /** Possible types are 'invoiced' and 'pending' */
  state?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type IsSpendUserWhitelistedInput = {
  userId: Scalars['ID']['input'];
  whitelistType: SpendUserWhitelistType;
};

export type IsSpendUserWhitelistedPayload = {
  __typename?: 'IsSpendUserWhitelistedPayload';
  isWhitelisted: Scalars['Boolean']['output'];
};

export type IssueBankCardInput = {
  bankCardTier?: InputMaybe<BankCardTier>;
  material?: InputMaybe<BankCardMaterial>;
  overrideQualifierCode?: InputMaybe<Scalars['String']['input']>;
  paymentProcessor?: InputMaybe<BankCardPaymentProcessor>;
  physicalCardOrder?: InputMaybe<Scalars['Boolean']['input']>;
  shippingSpeed?: InputMaybe<BankCardShippingSpeed>;
  tag?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type IssueBankCardPayload = {
  __typename?: 'IssueBankCardPayload';
  bankCard?: Maybe<BankCard>;
};

export type IssuePhysicalBankCardInput = {
  cardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Job alert display info */
export type JobAlert = {
  __typename?: 'JobAlert';
  id: Scalars['ID']['output'];
  /** desired job description */
  keyPhrase: Scalars['String']['output'];
  /** desired job location */
  location: Scalars['String']['output'];
};

/** Specifies the alert criteria */
export type JobAlertCriteriaInput = {
  filters: Array<JobSearchFilterInput>;
  location: JobLocationInput;
};

export type JobLocation = {
  __typename?: 'JobLocation';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type JobLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  /** flexible text field to input location as a single string (e.g. "New York, NY 10010" */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type JobOffer = {
  __typename?: 'JobOffer';
  /** Company logo or generic default */
  companyLogo: Image;
  /** Hiring company */
  companyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Relevant job industry */
  industryName?: Maybe<Scalars['String']['output']>;
  /** Job role */
  jobName: Scalars['String']['output'];
  /** Job location */
  location: OfferLocation;
  /** Salary details */
  salary?: Maybe<JobOfferSalary>;
  /** List of tags to display */
  tags: Array<Scalars['String']['output']>;
  /** Redirect URL for job posting */
  url: Scalars['URL']['output'];
};

export type JobOfferSalary = {
  __typename?: 'JobOfferSalary';
  interval: SalaryInterval;
  maxValue: Scalars['Float']['output'];
  minValue: Scalars['Float']['output'];
};

/** Specifies the search criteria */
export type JobSearchCriteria = {
  __typename?: 'JobSearchCriteria';
  filters: Array<JobSearchFilter>;
  location: JobLocation;
  /** Specifies the search radius in miles */
  searchRadius?: Maybe<Scalars['Int']['output']>;
};

/** Specifies the search criteria */
export type JobSearchCriteriaInput = {
  filters: Array<JobSearchFilterInput>;
  location: JobLocationInput;
  searchRadius?: InputMaybe<Scalars['Int']['input']>;
};

export type JobSearchFilter = {
  __typename?: 'JobSearchFilter';
  key: JobSearchFilterKey;
  value: Scalars['String']['output'];
};

/** Specifies which values to filter jobs by */
export type JobSearchFilterInput = {
  key: JobSearchFilterKey;
  value: Scalars['String']['input'];
};

export enum JobSearchFilterKey {
  Company = 'COMPANY',
  KeyPhrase = 'KEY_PHRASE'
}

/** Display wrapper for featured job searches */
export type JobSearchOffer = {
  __typename?: 'JobSearchOffer';
  /** Background/featured image */
  backgroundImage: Image;
  /** Display body for the offer */
  body?: Maybe<Scalars['String']['output']>;
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image;
  id: Scalars['ID']['output'];
  /** Company/partner logo */
  logo?: Maybe<Image>;
  /** List of filters used when searching for jobs */
  searchFilters: Array<JobSearchFilter>;
  /** Display subtitle for the offer */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Display title for the offer */
  title: Scalars['String']['output'];
};

export type JobSearchPage = {
  __typename?: 'JobSearchPage';
  recentSearches: Array<JobSearchCriteria>;
};

export enum KycStatus {
  Accepted = 'accepted',
  ActionRequired = 'actionRequired',
  Failure = 'failure',
  Pending = 'pending'
}

export type LaterAccountAlreadyVerified = LaterTypedException & {
  __typename?: 'LaterAccountAlreadyVerified';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type LaterAccountIneligibleForVerification = LaterTypedException & {
  __typename?: 'LaterAccountIneligibleForVerification';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type LaterAccountInfo = {
  __typename?: 'LaterAccountInfo';
  investmentAccountId: Scalars['ID']['output'];
  plan: InvestmentAccountTypes;
  status: LaterAccountStatus;
  userId: Scalars['ID']['output'];
};

export type LaterAccountInfoOrError = LaterAccountAlreadyVerified | LaterAccountIneligibleForVerification | LaterAccountInfo | LaterAccountNotFound;

export type LaterAccountNotFound = LaterTypedException & {
  __typename?: 'LaterAccountNotFound';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export enum LaterAccountStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  FailedToCreate = 'FAILED_TO_CREATE',
  Hidden = 'HIDDEN',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export type LaterContributionAbilityResult = ContributionAbilityByYear;

export type LaterContributionLimitMet = {
  __typename?: 'LaterContributionLimitMet';
  year: Scalars['Int']['output'];
};

export type LaterFullContributionSuccess = {
  __typename?: 'LaterFullContributionSuccess';
  year: Scalars['Int']['output'];
};

export type LaterPartialContributionSuccess = {
  __typename?: 'LaterPartialContributionSuccess';
  acceptedAmount: CurrencyAmount;
  year: Scalars['Int']['output'];
};

export type LaterProgramAccountContributionInput = {
  amount: CurrencyAmountInput;
  fundingSourceId?: InputMaybe<Scalars['ID']['input']>;
  fundingTransferCreated?: InputMaybe<Scalars['Boolean']['input']>;
  nonce: Scalars['ID']['input'];
  programAccountType: ProgramAccountType;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type LaterProgramAccountContributionResult = LaterContributionLimitMet | LaterFullContributionSuccess | LaterPartialContributionSuccess;

export type LaterTypedException = {
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

/** Object representing an outside contribution prospect */
export type LaterWaitlistProspect = Prospect & {
  __typename?: 'LaterWaitlistProspect';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/**  Reason for withdrawing from a later account */
export enum LaterWithdrawalReason {
  DirectTransfer = 'direct_transfer',
  EarlyWithdrawal = 'early_withdrawal',
  OverContribution = 'over_contribution',
  Retirement = 'retirement',
  Rollover = 'rollover'
}

/**
 *  Reason for withdrawing from a later account
 *  Deprecated - this can be derived from the LaterWithdrawalReason below
 */
export enum LaterWithdrawalType {
  EarlyDistribution = 'EarlyDistribution',
  IneligibleContribution = 'IneligibleContribution',
  NormalDistribution = 'NormalDistribution'
}

/**  Response type for laterWithdrawalV2 mutation */
export type LaterWithdrawalV2Response = {
  __typename?: 'LaterWithdrawalV2Response';
  acornsInvestmentId: Scalars['String']['output'];
};

export type LegacyAlertDismissalSuccess = {
  __typename?: 'LegacyAlertDismissalSuccess';
  id: Scalars['ID']['output'];
};

export enum LegacyDocument {
  /** Address documents required */
  Address = 'address',
  /** Current Bank Statement document required */
  Currentbankstatement = 'currentbankstatement',
  /** Future Bank Statement document required */
  Futurebankstatement = 'futurebankstatement',
  /** ID documents required */
  Id = 'id',
  /** Miscellaneous document required */
  Miscellaneous = 'miscellaneous',
  /** SSN documents required */
  Ssn = 'ssn',
  /** w9 documents required */
  W9 = 'w9'
}

/** Fetch a legacy document request */
export type LegacyDocumentRequests = {
  __typename?: 'LegacyDocumentRequests';
  /** The type of document the request is for. */
  type: LegacyDocument;
};

/** Legacy Identity Verification Response */
export type LegacyIdentityVerificationResponse = {
  __typename?: 'LegacyIdentityVerificationResponse';
  /** The date that the Identity Verification Response was created */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Identity Verification Response Id */
  id?: Maybe<Scalars['ID']['output']>;
  input?: Maybe<Scalars['String']['output']>;
  issues?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  /** The date that the Identity Verification Response was updated */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** User Id */
  userId?: Maybe<Scalars['ID']['output']>;
  /** User uuid */
  userUuid?: Maybe<Scalars['ID']['output']>;
};

/** Fetch a legacy user */
export type LegacyUser = {
  __typename?: 'LegacyUser';
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dob?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  employedAffiliatedWithBrokerDealer?: Maybe<Scalars['Boolean']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  expeditedApproval?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fundingSourceChanges?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  internalSecurityQuestionId?: Maybe<Scalars['Int']['output']>;
  isFlaggedAsSuspicious?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locked: Scalars['Boolean']['output'];
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  /** @deprecated phone number has moved to auth service. use the authProfile query instead. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pinCreated?: Maybe<Scalars['Boolean']['output']>;
  preapprovedAt?: Maybe<Scalars['DateTime']['output']>;
  registrationComplete?: Maybe<Scalars['Boolean']['output']>;
  registrationCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  securityQuestionAnswer?: Maybe<Scalars['String']['output']>;
  shareholderOrDirector?: Maybe<Scalars['Boolean']['output']>;
  sourceAttributes?: Maybe<UserSourceAttributes>;
  sourceId?: Maybe<Scalars['String']['output']>;
  subjectToBackupWithholding?: Maybe<Scalars['Boolean']['output']>;
  suspended: Scalars['Boolean']['output'];
  suspendedReason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usCitizen?: Maybe<Scalars['Boolean']['output']>;
  usResident?: Maybe<Scalars['Boolean']['output']>;
  userNotes?: Maybe<Array<UserNote>>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedById?: Maybe<Scalars['ID']['output']>;
};

/** Subset of information about user referral */
export type LegacyUserReferral = {
  __typename?: 'LegacyUserReferral';
  /** Full name from user passed by query input */
  fullName: Scalars['String']['output'];
  /** User referral code */
  referralCode: Scalars['String']['output'];
  /** List of all referrals from user */
  referrals?: Maybe<Array<LegacyUserReferree>>;
  /** The type of document the request is for. */
  type: LegacyDocument;
};

/** Subset of information about user referree */
export type LegacyUserReferree = {
  __typename?: 'LegacyUserReferree';
  /** Date of referred user created at  */
  adviserAgreementDate: Scalars['DateTime']['output'];
  /** Date of referred investment created at */
  investmentInitiatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Admin full name */
  manuallyCreatedBy?: Maybe<Scalars['String']['output']>;
  /** Referred email */
  referreeEmail: Scalars['String']['output'];
  /** Referred full name */
  referreeName: Scalars['String']['output'];
  /** Referred reward amount */
  referrerRewardAmount?: Maybe<MonetaryAmount>;
  /** Referred investment reward created at */
  referrerRewardCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Referred reward status */
  referrerRewardStatus?: Maybe<RewardStatus>;
  /** Status of referred account */
  statusOfAccount: Scalars['String']['output'];
  /** Status of the investment that the referred user has invested into their account */
  statusOfInvestment?: Maybe<CreditInvestmentStatus>;
  /** Referred user uuid */
  userUuid: Scalars['ID']['output'];
};

/** Link Attempts info for a specific user */
export type LinkAttempts = {
  __typename?: 'LinkAttempts';
  /** Remaining account link attempts */
  attemptsRemaining: Scalars['Int']['output'];
  /** User exceeded Creation Limit */
  exceededCreationLimit: Scalars['Boolean']['output'];
};

export type LinkOidcCredentialsInput = {
  idToken: Scalars['String']['input'];
  nonce: Scalars['String']['input'];
  oidcProvider: OidcProvider;
  udid: Scalars['String']['input'];
};

export type LinkOidcCredentialsResult = InvalidAppleAccountException | InvalidIdentityTokenException | LinkOidcCredentialsSuccess | OidcCredentialsAlreadyLinkedException | OidcCredentialsTakenException;

export type LinkOidcCredentialsSuccess = {
  __typename?: 'LinkOidcCredentialsSuccess';
  email: Scalars['EmailAddress']['output'];
  oidcProvider: OidcProvider;
  userId: Scalars['ID']['output'];
};

export enum LinkProviderType {
  /** Direct bank provider type. */
  DirectBank = 'DIRECT_BANK',
  /** Plaid provider type */
  Plaid = 'PLAID',
  /** Spend provider type. */
  Spend = 'SPEND'
}

/** Miscellaneous attributes about a Linked Account */
export type LinkedAccount = TimestampsInterface & {
  __typename?: 'LinkedAccount';
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Error code attached to operation done on account */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Plaid account ID */
  externalId?: Maybe<Scalars['ID']['output']>;
  /** Source of linked account (plaid or spend) */
  externalSource: LinkedAccountExternalSourceEnum;
  financialInstitution?: Maybe<FinancialInstitution>;
  /** ID of the financial institution this linked account is for */
  financialInstitutionId?: Maybe<Scalars['ID']['output']>;
  /** Linked Account ID */
  id: Scalars['ID']['output'];
  /** Name of the associated institution this linked account is for */
  institutionName?: Maybe<Scalars['String']['output']>;
  /** Is the account linked? */
  linked: Scalars['Boolean']['output'];
  linkedSubaccounts: Array<LinkedSubaccount>;
  /** The logo url for the institution associated with the account */
  logoUrl: Scalars['String']['output'];
  /** This field should only be fetched for initializing a Plaid Link session */
  publicToken?: Maybe<Scalars['String']['output']>;
  /** Status indicating potential user action required */
  status: LinkedAccountStatusEnum;
  /** DateTime of when Transactions were last synced for financial institution */
  transactionsLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Correlated User UUID */
  userId: Scalars['ID']['output'];
};

/** A Linked Account Alert. */
export type LinkedAccountAlert = UserAlertsItem & {
  __typename?: 'LinkedAccountAlert';
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

/** Response from linked account alert query */
export type LinkedAccountAlertsResponse = LinkedAccountAlert | RelinkLinkedAccountAlert;

export enum LinkedAccountExternalSourceEnum {
  /** The link was created directly between the corresponding bank's API and Acorns */
  DirectBank = 'direct_bank',
  /** The user linked by manually entering an account & routing number */
  Manual = 'manual',
  /** PayPal direct connection was used to link this account */
  Paypal = 'paypal',
  /** The link was created through Plaid and represents an external financial institution */
  Plaid = 'plaid',
  /** This account has an internal Acorns spend account associated with it */
  Spend = 'spend'
}

export type LinkedAccountNotFound = {
  __typename?: 'LinkedAccountNotFound';
  message: Scalars['String']['output'];
};

/** Error indicating that the linked account was not found */
export type LinkedAccountNotFoundError = {
  __typename?: 'LinkedAccountNotFoundError';
  /** ID of the linked account that was not found */
  linkedAccountId: Scalars['ID']['output'];
};

export enum LinkedAccountStatusEnum {
  /** The user must take action with their financial institution to fix the issue */
  ExternalAction = 'externalAction',
  /** The user must relink and update their linked account to continue functioning */
  Relink = 'relink',
  /** The linked account is working and requires no action */
  Success = 'success',
  /** The linked account or financial institution is no longer supported and can be unlinked */
  Unsupported = 'unsupported'
}

/** An individual account between an individual user and financial institution */
export type LinkedSubaccount = TimestampsInterface & {
  __typename?: 'LinkedSubaccount';
  /** Last 4 Digits of Account Number */
  accountNumberLastFour?: Maybe<Scalars['String']['output']>;
  /** Roles this linked account can be assigned to */
  allowedRoles: Array<LinkedSubaccountRoleEnum>;
  /** Balance available (via Plaid/Spend) */
  balanceAvailable?: Maybe<Scalars['Float']['output']>;
  /** Current balance of subaccount (via Plaid/Spend) */
  balanceCurrent?: Maybe<Scalars['Float']['output']>;
  /** Spending limit of balance */
  balanceLimit?: Maybe<Scalars['Float']['output']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Plaid ID for linked subaccount */
  externalId?: Maybe<Scalars['String']['output']>;
  /** External source of subaccount (plaid, spend, paypal, manual) */
  externalSource?: Maybe<Scalars['String']['output']>;
  /** Internal ID for linked subaccount */
  id: Scalars['ID']['output'];
  /** Subaccount Linked? */
  linked: Scalars['Boolean']['output'];
  linkedAccount: LinkedAccount;
  /** Internal ID for the corresponding linked account */
  linkedAccountId: Scalars['ID']['output'];
  /** Name of linked subaccount (Department) */
  name: Scalars['String']['output'];
  /** Official name (verbose) */
  officialName?: Maybe<Scalars['String']['output']>;
  paymentEngines: Array<LinkedSubaccountPaymentEngineEnum>;
  /** The role of the linked subaccount */
  role?: Maybe<LinkedSubaccountRoleEnum>;
  /** Financial institution routing number. */
  routingNumber?: Maybe<Scalars['String']['output']>;
  /** The status of the linked subaccount */
  status?: Maybe<FundingSourceStatusEnum>;
  /** Subtype (ie checking) */
  subaccountSubtype: Scalars['String']['output'];
  /** Type (depository, credit) */
  subaccountType: Scalars['String']['output'];
  /** Transactions count */
  transactionsLastSyncedCount: Scalars['Int']['output'];
  /** RDVs and docs have been verified and approved for this account */
  transfersApproved?: Maybe<Scalars['Boolean']['output']>;
  /** Is the account at risk or does it have insufficient funds? */
  transfersAtRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Subaccount Verified?
   * @deprecated This will be removed in favor of "transfersApproved"
   */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export enum LinkedSubaccountPaymentEngineEnum {
  /** The linked subaccount is linked in ProfitStars */
  ProfitStars = 'profitStars'
}

export enum LinkedSubaccountRoleEnum {
  /** The subaccount is the primary funding source of the user */
  PrimaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  SecondaryFunding = 'secondaryFunding'
}

/** Input to liquidate fractional shares */
export type LiquidateAccountInput = {
  /** Note id to update */
  investmentAccountId: Scalars['ID']['input'];
};

/** Response of liquidating fractional shares */
export type LiquidateAccountResponse = ExcessFundsException | InvestmentAccountNotFoundException | LiquidateAccountSuccess | NeedFundingSourceException | PendingInvestmentException | UnknownException;

/** Fractional shares liquidated successfully */
export type LiquidateAccountSuccess = {
  __typename?: 'LiquidateAccountSuccess';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Input to liquidate an investment account */
export type LiquidateInvestmentAccountInput = {
  /** federal tax withholding percentage */
  federalTaxWithholdingPct?: InputMaybe<Scalars['Float']['input']>;
  /** investment account id to update */
  investmentAccountId: Scalars['ID']['input'];
  /** state tax withholding percentage */
  stateTaxWithholdingPct?: InputMaybe<Scalars['Float']['input']>;
};

/** Response of liquidating an investment account */
export type LiquidateInvestmentAccountResponse = AccountDoesNotRequireLiquidationException | Investment | InvestmentAccountNotFoundException | OverThresholdLaterAccountLiquidationAttemptedException | PendingInvestmentsException;

/** Liquidation information */
export type Liquidation = TimestampsInterface & {
  __typename?: 'Liquidation';
  accountId: Scalars['ID']['output'];
  billingCycle: BillingCycle;
  billingCycleId: Scalars['ID']['output'];
  collectedAmount: Scalars['Float']['output'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  feeExecutions: Array<Maybe<FeeExecution>>;
  id: Scalars['ID']['output'];
  investmentId: Scalars['ID']['output'];
  requestedAmount: Scalars['Float']['output'];
  state: Scalars['String']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** List of pinwheel webhooks currently configured */
export type ListPinwheelWebhooksPayload = {
  __typename?: 'ListPinwheelWebhooksPayload';
  /** The list of webhooks */
  webhookList: Array<PinwheelWebhook>;
};

export type LockBankAccountPayload = {
  __typename?: 'LockBankAccountPayload';
  requestId: Scalars['ID']['output'];
};

export type LockBankAccountsInput = {
  userIds: Array<Scalars['ID']['input']>;
};

export type LockBankAccountsResult = LockBankAccountPayload;

export type LockBankCardInput = {
  lockReason: BankCardTemporaryLockReason;
  userId: Scalars['ID']['input'];
};

export type LockBankCardPayload = {
  __typename?: 'LockBankCardPayload';
  bankCard?: Maybe<BankCard>;
};

export type LoginAccess = {
  __typename?: 'LoginAccess';
  loginAllowed: Scalars['Boolean']['output'];
  loginRevokedAt?: Maybe<Scalars['DateTime']['output']>;
  loginRevokedReason?: Maybe<Scalars['String']['output']>;
};

export type LoginRateLimitedException = {
  __typename?: 'LoginRateLimitedException';
  message?: Maybe<Scalars['String']['output']>;
};

export type LogoutDeviceInput = {
  deviceId: Scalars['ID']['input'];
};

export type LogoutDeviceResult = DeviceNotFoundException | LogoutDeviceSuccess | RefreshTokenNotFoundException;

export type LogoutDeviceSuccess = {
  __typename?: 'LogoutDeviceSuccess';
  Device: Device;
};

export type LogoutResult = AuthTokenNotFoundException | LogoutSuccess | RefreshTokenNotFoundException;

export type LogoutSuccess = {
  __typename?: 'LogoutSuccess';
  userId: Scalars['ID']['output'];
};

export enum MailInDocumentType {
  BillNegotiation = 'BILL_NEGOTIATION',
  FeeNegotiation = 'FEE_NEGOTIATION'
}

export type MaintenanceFlagObject = {
  __typename?: 'MaintenanceFlagObject';
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  flagId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  variants?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
};

export type MaintenanceFlagsArgs = {
  flagId: Scalars['String']['input'];
};

/** Make funding source unrecoverable input type. */
export type MakeFundingSourceUnrecoverableInput = {
  /** UUID of the funding source. */
  fundingSourceId: Scalars['ID']['input'];
};

export type MalformedRecurringTransferException = {
  __typename?: 'MalformedRecurringTransferException';
  pathExceptions: Array<RecurringTransferPathException>;
};

export enum ManagePayoutRelationshipAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export enum ManagePayoutRelationshipResult {
  Fail = 'FAIL',
  Success = 'SUCCESS'
}

export enum MaritalStatus {
  /** User is currently in a civil union */
  CivilUnion = 'civil_union',
  /** User is no longer married due to legal separation */
  Divorced = 'divorced',
  /** User is married currently */
  Married = 'married',
  /** User has never been married */
  Single = 'single',
  /** User is no longer married due to death of spouse */
  Widowed = 'widowed'
}

export type MarkAllAsReadResult = MarkAllAsReadSuccess | UpdateMessageFailed;

export type MarkAllAsReadSuccess = {
  __typename?: 'MarkAllAsReadSuccess';
  markedAsReadCount: Scalars['Int']['output'];
};

export type MarketReturn = {
  __typename?: 'MarketReturn';
  marketValue: MonetaryAmount;
  percent: Scalars['Float']['output'];
};

export type Message = {
  body: MessageTextAsset;
  deepLink?: Maybe<Scalars['URL']['output']>;
  externalId: Scalars['ID']['output'];
  icon?: Maybe<MessageVisualAsset>;
  id: Scalars['ID']['output'];
  messageCategory?: Maybe<MessageCategory>;
  messageType: MessageType;
  platforms: Array<Platform>;
  title: MessageTextAsset;
  trackingId?: Maybe<Scalars['ID']['output']>;
};

export enum MessageCategory {
  Account = 'ACCOUNT',
  Banking = 'BANKING',
  BenefitsHub = 'BENEFITS_HUB',
  Braze = 'BRAZE',
  Earn = 'EARN',
  Invest = 'INVEST',
  Later = 'LATER',
  Milestone = 'MILESTONE',
  Onboarding = 'ONBOARDING'
}

/** Specifies a Message Connection */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  edges: Array<MessageEdge>;
  pageInfo: MessagePageInfo;
};

/** Specifies a Message Edge */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor: Scalars['ID']['output'];
  node: Message;
};

/** Specifies Page Information */
export type MessagePageInfo = {
  __typename?: 'MessagePageInfo';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type MessagePageInput = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum MessageStatus {
  Dismissed = 'DISMISSED',
  Read = 'READ'
}

/** A pair of a status and a desired boolean for it. */
export type MessageStatusFilterInput = {
  key: MessageStatus;
  value: Scalars['Boolean']['input'];
};

export type MessageTextAsset = StringKeyAsset;

export enum MessageType {
  Alert = 'ALERT',
  Notification = 'NOTIFICATION'
}

export type MessageVisualAsset = DesignLibraryIcon | Image;

/**  Custom type for representing key-value pairs */
export type MetadataEntry = {
  __typename?: 'MetadataEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MfaMissingAuthAlert = AuthAlert & {
  __typename?: 'MfaMissingAuthAlert';
  type: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type MicrosMoney = {
  __typename?: 'MicrosMoney';
  currency: Currency;
  value: Scalars['Micros']['output'];
};

/** The mighty oak card waiver for a user */
export type MightyOakCardWaiver = {
  __typename?: 'MightyOakCardWaiver';
  mightyOakCardWaiverPeriodEndDate: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type Milestone = {
  __typename?: 'Milestone';
  /** how many account points the user has earned for this milestone so far */
  accountPoints: AccountPoints;
  /**
   * how many challenge points the user has earned for completing this milestone. The specific challenge is indicated by the ID
   * @deprecated This was only relevant for the Path to $1M sweepstakes.
   */
  challengePoints?: Maybe<ChallengePointsEarned>;
  /** key that maps to client-defined milestone description */
  descriptionKey: Scalars['StringKey']['output'];
  /** optional destination label and deep link for milestone action */
  destination?: Maybe<Destination>;
  /**
   * key that maps to client-defined milestone details
   * @deprecated leverage accountPoints.detailsKey
   */
  detailsKey?: Maybe<Scalars['StringKey']['output']>;
  /** milestone education tip content */
  educationTip: EducationTip;
  /** the first time the user completed the milestone */
  firstCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated No longer needed since the logo will be dynamically set based on milestone status. Use 'logo' instead */
  inactiveLogo?: Maybe<Image>;
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']['output'];
  /** the most recent time the user completed the milestone */
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** logo that matches the milestone status */
  logo: Image;
  /** @deprecated Do not use anymore. This field has been replaced by nameKey. */
  name: Scalars['String']['output'];
  /** key that maps to descriptive identifier */
  nameKey: Scalars['StringKey']['output'];
  /** information the user's progress towards completion */
  progress: MilestoneProgress;
  /** milestone rule enum which can be used for grouping and fetch string mappings */
  rule: MilestoneRuleType;
  /** key that maps to simplified descriptive identifier */
  simpleNameKey: Scalars['StringKey']['output'];
  /** the user-specific status */
  status: MilestoneStatus;
  /** the milestone category */
  theme: MilestoneTheme;
  /** how many times the user completed this milestone */
  timesCompleted: Scalars['Int']['output'];
};


export type MilestoneChallengePointsArgs = {
  challengeId: Scalars['ID']['input'];
};

export type MilestoneAccountLevelDefinition = {
  __typename?: 'MilestoneAccountLevelDefinition';
  /** image to display as the background when the level is active */
  activeBackground: Image;
  /** image to display as the foreground when the level is active */
  activeForeground: Image;
  /** level id, e.g. 3 */
  id: Scalars['Int']['output'];
  /** image to display as the background when the level is inactive */
  inactiveBackground: Image;
  /** max points for the level. If min and max are the same value, there is no higher level */
  max: Scalars['Int']['output'];
  /** minimum points needed for the level */
  min: Scalars['Int']['output'];
};

export type MilestoneAchievementActionRule = {
  __typename?: 'MilestoneAchievementActionRule';
  actions: Array<MilestoneAchievementActionType>;
  milestoneID: Scalars['ID']['output'];
};

export enum MilestoneAchievementActionType {
  AnalyticsEvent = 'ANALYTICS_EVENT',
  NativeNotification = 'NATIVE_NOTIFICATION'
}

export type MilestoneByThemeFilterInput = {
  /** No longer in use. Will be ignored if provided. */
  challengeId?: InputMaybe<Scalars['ID']['input']>;
  rule?: InputMaybe<MilestoneRuleType>;
};

export type MilestoneChallenge = {
  __typename?: 'MilestoneChallenge';
  /** Static date label for when the challenge becomes inactive (NOTE: is relative to PST) */
  closingAt: Scalars['String']['output'];
  /** additional information about this challenge */
  details?: Maybe<Scalars['String']['output']>;
  /** Internal UTC timestamp. For display, use 'closingAt'instead */
  endsAt: Scalars['DateTime']['output'];
  /** optional deeplink to challenge FAQ */
  faqDeepLink?: Maybe<Scalars['URL']['output']>;
  /** list of user milestones, grouped and ordered */
  groupedMilestones: Array<MilestoneGroup>;
  id: Scalars['ID']['output'];
  /** optional logo for the challenge */
  logo?: Maybe<Image>;
  /** number of milestones the user has completed for the challenge */
  milestonesCompleted: DiscreteMilestoneProgress;
  /** descriptive identifier */
  name: Scalars['String']['output'];
  /** number of points the user has earned for the challenge. May be null if not applicable to the current challenge */
  pointsEarned?: Maybe<DiscreteMilestoneProgress>;
  /** optional deeplink to official challenge rules */
  rulesDeepLink?: Maybe<Scalars['URL']['output']>;
};

export type MilestoneChallengePointsRule = {
  __typename?: 'MilestoneChallengePointsRule';
  challengeID: Scalars['ID']['output'];
  /** legal copy about how points are earned */
  details: Scalars['String']['output'];
  /** specifies the max points that can be earned if the milestone is completed more than once */
  maxPointsAllowed: Scalars['Int']['output'];
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']['output'];
  /** summarized information about how points are earned */
  summary?: Maybe<Scalars['String']['output']>;
};

export type MilestoneDefinition = {
  __typename?: 'MilestoneDefinition';
  accountPointsRule?: Maybe<AccountPointsRule>;
  /** optional datetime arg required for some milestone rules (e.g. ACTIVE_CUSTOMER) */
  arg1DateTime?: Maybe<Scalars['DateTime']['output']>;
  /** optional integer arg required for some milestone rules (e.g. BALANCED_REACHED) */
  arg1Int?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  challengePointsRule?: Maybe<MilestoneChallengePointsRule>;
  id: Scalars['ID']['output'];
  /** optional logo used for inactive milestone states (e.g. LOCKED, NOT_STARTED) */
  inactiveLogo?: Maybe<Image>;
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']['output'];
  /** default logo */
  logo: Image;
  /** list of MilestoneGroupID for groups to which this milestone belongs */
  milestoneGroups: Array<Scalars['ID']['output']>;
  /** descriptive identifier */
  name: Scalars['String']['output'];
  /** the rule that determines how this milestone changes status */
  rule: MilestoneRule;
  /** the milestone category */
  theme: MilestoneTheme;
};


export type MilestoneDefinitionChallengePointsRuleArgs = {
  challengeId: Scalars['ID']['input'];
};

export type MilestoneEligibility = {
  __typename?: 'MilestoneEligibility';
  eligible: Scalars['Boolean']['output'];
  scope: MilestoneEligibilityScope;
};

export enum MilestoneEligibilityScope {
  AccountSetupComplete = 'ACCOUNT_SETUP_COMPLETE',
  /** @deprecated this value was only used for the AccountSetup feature experiment that is now over */
  AccountSetupExp = 'ACCOUNT_SETUP_EXP'
}

export type MilestoneGroup = MilestoneRuleGroup | MilestoneThemeGroup;

export type MilestoneGroupAchievementActionRule = {
  __typename?: 'MilestoneGroupAchievementActionRule';
  actions: Array<MilestoneAchievementActionType>;
  milestoneGroupID: Scalars['ID']['output'];
};

export type MilestoneGroupDefinition = {
  __typename?: 'MilestoneGroupDefinition';
  id: Scalars['ID']['output'];
  milestoneIDs: Array<Scalars['ID']['output']>;
};

export type MilestoneHub = {
  __typename?: 'MilestoneHub';
  /** list of user milestones, grouped and ordered */
  groupedMilestones: Array<MilestoneGroup>;
  /** static list of min and max values for each account level */
  levelDefinitions: Array<MilestoneAccountLevelDefinition>;
  userAccount: MilestoneHubAccount;
};

export type MilestoneHubAccount = {
  __typename?: 'MilestoneHubAccount';
  /**
   * shows progress of points earned vs points needed to move to the next level.
   * NOTE: the currentInt can exceed the targetInt if the user is at the highest level
   */
  accountPointsProgress: DiscreteMilestoneProgress;
  /** current level achieved */
  currentLevel: Scalars['Int']['output'];
  /** shows progress of milestones completed vs milestones available */
  milestoneProgress: DiscreteMilestoneProgress;
};

export type MilestoneHubDefinition = {
  __typename?: 'MilestoneHubDefinition';
  id: Scalars['ID']['output'];
  milestoneIds: Array<Scalars['ID']['output']>;
};

export type MilestoneProgress = CurrencyMilestoneProgress | DiscreteMilestoneProgress;

/** defines how a milestone is completed */
export type MilestoneRule = {
  __typename?: 'MilestoneRule';
  /** denotes if an argument input needs to be provided for the creation of a MilestoneDefinition */
  argInput: MilestoneRuleArgInput;
  id: Scalars['ID']['output'];
  /** the rule name */
  name: Scalars['String']['output'];
  /** the milestone supported themes */
  themes: Array<MilestoneTheme>;
};

export enum MilestoneRuleArgInput {
  Datetime = 'DATETIME',
  Int = 'INT',
  None = 'NONE'
}

export type MilestoneRuleGroup = {
  __typename?: 'MilestoneRuleGroup';
  contents: Array<MilestoneRuleGroupContent>;
  descriptionKey: Scalars['StringKey']['output'];
  groupCompletion: DiscreteMilestoneProgress;
  logo: Image;
  nameKey: Scalars['StringKey']['output'];
  rule: MilestoneRuleType;
};

export type MilestoneRuleGroupContent = Milestone;

export enum MilestoneRuleType {
  ActiveCustomer = 'ACTIVE_CUSTOMER',
  BalanceReached = 'BALANCE_REACHED',
  CardActivation = 'CARD_ACTIVATION',
  /** @deprecated Use CREATE_ACORNS_ACCOUNT instead */
  CompleteRegistration = 'COMPLETE_REGISTRATION',
  CreateAcornsAccount = 'CREATE_ACORNS_ACCOUNT',
  FirstInvestment = 'FIRST_INVESTMENT',
  FundingSourceLinked = 'FUNDING_SOURCE_LINKED',
  RealtimeRoundup = 'REALTIME_ROUNDUP',
  RecurringInvestmentMonthly = 'RECURRING_INVESTMENT_MONTHLY',
  RewardCreated = 'REWARD_CREATED',
  Roundup = 'ROUNDUP',
  Signup = 'SIGNUP',
  SmartDepositCompleted = 'SMART_DEPOSIT_COMPLETED',
  Verified = 'VERIFIED'
}

export enum MilestoneStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Locked = 'LOCKED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING'
}

export enum MilestoneTheme {
  AccountSetup = 'ACCOUNT_SETUP',
  Acorns = 'ACORNS',
  Early = 'EARLY',
  Earn = 'EARN',
  Invest = 'INVEST',
  Later = 'LATER',
  Spend = 'SPEND'
}

export type MilestoneThemeGroup = {
  __typename?: 'MilestoneThemeGroup';
  contents: Array<MilestoneThemeGroupContent>;
  descriptionKey: Scalars['StringKey']['output'];
  destination?: Maybe<Destination>;
  groupCompletion: DiscreteMilestoneProgress;
  groupPointsProgress?: Maybe<DiscreteMilestoneProgress>;
  isLocked: Scalars['Boolean']['output'];
  logo: Image;
  nameKey: Scalars['StringKey']['output'];
  theme: MilestoneTheme;
};

export type MilestoneThemeGroupContent = Milestone | MilestoneRuleGroup;

/** Miscellaneous document requested. */
export type MiscDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'MiscDocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

/** Returned when the provided distribution units are not all matching */
export type MismatchedDistributionUnitsError = {
  __typename?: 'MismatchedDistributionUnitsError';
  message: Scalars['String']['output'];
};

/** X-Auth-Email header or flaggedBy input is missing. Something isn't setup correclty */
export type MissingAdminIdentifierException = {
  __typename?: 'MissingAdminIdentifierException';
  /** provided user flag type */
  flagType: UserFlagType;
  /** provided user ID to be flagged */
  userId: Scalars['ID']['output'];
};

/** Missing Field return type */
export type MissingFieldError = {
  __typename?: 'MissingFieldError';
  /** exception details */
  message: Scalars['String']['output'];
  /** user uuid */
  userId: Scalars['ID']['output'];
};

/** Missing Identity return type */
export type MissingIdentityInfoError = {
  __typename?: 'MissingIdentityInfoError';
  /** exception details */
  message: Scalars['String']['output'];
  /** user uuid */
  userId: Scalars['ID']['output'];
};

export type MissingRequiredAgreementsException = {
  __typename?: 'MissingRequiredAgreementsException';
  message?: Maybe<Scalars['String']['output']>;
};

/** The given beneficiary does not have an associated SSN. */
export type MissingSsnBeneficiaryAlertItem = UserAlertsItem & {
  __typename?: 'MissingSsnBeneficiaryAlertItem';
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary;
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

/** Returned when an existing customer ruleset is not found, and no override archetype ruleset was provided. */
export type MissingValidRulesetError = {
  __typename?: 'MissingValidRulesetError';
  message: Scalars['String']['output'];
};

export type ModifyMoneyAssignmentInput = {
  /** The target account IDs and amount to assign for each account */
  accountAssignments: Array<AccountMoneyAssignmentInput>;
  /** The incoming transaction ID for money assignment between accounts */
  transactionId: Scalars['ID']['input'];
};

export type ModifyMoneyAssignmentResult = ModifyMoneyAssignmentSuccess | MoneyAssignmentAlreadyTransferredError | MoneyAssignmentNotFoundError;

export type ModifyMoneyAssignmentSuccess = {
  __typename?: 'ModifyMoneyAssignmentSuccess';
  moneyAssignment: MoneyManagerMoneyAssignment;
};

export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  currency: Currency;
  value: Scalars['Float']['output'];
};

/** A monetrary reward that will be provided to a subscriber in some fashion. */
export type MonetaryIncentive = Incentive & {
  __typename?: 'MonetaryIncentive';
  /** Amount of the monetary reward. */
  amount: CurrencyAmount;
  copyKey?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Is the monetary reward recurring. */
  recurring: Scalars['Boolean']['output'];
  /** Total amount of the reward if recurring. */
  totalAmount: CurrencyAmount;
  /**
   * Arbitrary string denoting to fulfillment processes how monetary
   * reward should be provided to a subscriber.
   *
   * Ex. "INVESTMENT"
   */
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MoneyAssignmentAlreadyTransferredError = {
  __typename?: 'MoneyAssignmentAlreadyTransferredError';
  message: Scalars['String']['output'];
};

export type MoneyAssignmentConnection = {
  __typename?: 'MoneyAssignmentConnection';
  edges: Array<MoneyAssignmentEdge>;
  pageInfo: MoneyManagerPageInfo;
};

export type MoneyAssignmentEdge = {
  __typename?: 'MoneyAssignmentEdge';
  cursor: Scalars['String']['output'];
  node: MoneyManagerMoneyAssignment;
};

export type MoneyAssignmentNotFoundError = {
  __typename?: 'MoneyAssignmentNotFoundError';
  message: Scalars['String']['output'];
};

export type MoneyInEventInput = {
  accountId: Scalars['String']['input'];
  customerTag: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  ingestedAt: Scalars['String']['input'];
  transactionAmount: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
  transactionTag: Scalars['String']['input'];
  transactionTypeCode: Scalars['String']['input'];
};

export type MoneyInput = {
  /** amount in cents */
  cents: Scalars['Int']['input'];
  /** The currency of the amount */
  currency: Currency;
};

/** The target account as the result of a MoneyAssignment */
export type MoneyManagerAllocation = {
  __typename?: 'MoneyManagerAllocation';
  amount: MoneyRulesCurrencyAmount;
  beneficiary?: Maybe<Beneficiary>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  destinationAccount: MoneyRulesDestination;
  id: Scalars['ID']['output'];
  moneyAssignment: MoneyManagerMoneyAssignment;
  /**
   *  Deprecated - Use rules instead
   * @deprecated No longer supported
   */
  rule: MoneyRulesRule;
  rules: Array<MoneyRulesRule>;
  status: MoneyManagerAllocationStatus;
  transferId?: Maybe<Scalars['ID']['output']>;
  userId: Scalars['ID']['output'];
};

export enum MoneyManagerAllocationNotEditableReason {
  LaterLimitReached = 'LATER_LIMIT_REACHED',
  NoPercentageRemaining = 'NO_PERCENTAGE_REMAINING'
}

/** Represents the allocation amount details. */
export type MoneyManagerAllocationOption = {
  __typename?: 'MoneyManagerAllocationOption';
  /** The amount of the allocation. */
  amount: MoneyRulesCurrencyAmount;
  /** Deposit amounts normalized to various cadences. */
  normalizedAmounts?: Maybe<MoneyManagerNormalizedAmounts>;
  /** The remainder details of the allocation for other accounts. */
  otherAccountsRemainder: MoneyManagerAllocationRemainder;
  /** The percentage of the allocation. */
  percent: Scalars['Float']['output'];
  /** The remainder details of the allocation. */
  remainder: MoneyManagerAllocationRemainder;
};

/** Input object for allocation amounts query. */
export type MoneyManagerAllocationOptionsInput = {
  /** Pass in an archetype to use as a "starting point" for the algorithm instead of the customer's current ruleset */
  archetype?: InputMaybe<MoneyRulesArchetype>;
  /** Any staged rules to consider when calculating allocation options */
  stagedRules?: InputMaybe<Array<MoneyManagerStagedRulesInput>>;
  /** The target account identifier to get allocation options for */
  targetAccountId: Scalars['ID']['input'];
  /** Set as `true` to base the algorithm on all deposit amounts rather than just the next deposit. */
  useTotalDepositAmount?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents the remainder details for the allocation option */
export type MoneyManagerAllocationRemainder = {
  __typename?: 'MoneyManagerAllocationRemainder';
  /** The amount of the remainder allocation. */
  amount: MoneyRulesCurrencyAmount;
  /** The percentage of the remainder allocation. */
  percent: Scalars['Float']['output'];
};

export enum MoneyManagerAllocationStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type MoneyManagerAutomationTarget = {
  __typename?: 'MoneyManagerAutomationTarget';
  amount: MoneyRulesCurrencyAmount;
  /** Was the goal set by the customer? */
  customSelection: Scalars['Boolean']['output'];
  /** The suggested period of the original target suggestion. */
  suggestedPeriod?: Maybe<MoneyManagerPeriod>;
  type: MoneyManagerAutomationTargetType;
};

export enum MoneyManagerAutomationTargetType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export enum MoneyManagerCancelReason {
  ClosedAccount = 'CLOSED_ACCOUNT',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  SubscriptionStatus = 'SUBSCRIPTION_STATUS',
  ValidationError = 'VALIDATION_ERROR'
}

export type MoneyManagerCascadeObjective = {
  __typename?: 'MoneyManagerCascadeObjective';
  accountType: ProductAccountType;
  /** Is this active for the customer's current state? */
  isLocked: Scalars['Boolean']['output'];
  objectiveType: MoneyManagerCascadeObjectiveType;
  /** Target & contribution data. Null for OVERFLOW objectives (or in a weird case where we're having trouble getting Later data) */
  target?: Maybe<MoneyManagerCascadeTarget>;
};

export enum MoneyManagerCascadeObjectiveType {
  Balance = 'BALANCE',
  Overflow = 'OVERFLOW'
}

export type MoneyManagerCascadeTarget = {
  __typename?: 'MoneyManagerCascadeTarget';
  /** Can the customer change this value? */
  isEditable: Scalars['Boolean']['output'];
  /** Balance in (or contributions YTD to) the destination account */
  progressAmount: MoneyRulesCurrencyAmount;
  /** How close is the customer to the target? 0-100 */
  progressPercentage?: Maybe<Scalars['Int']['output']>;
  /** The automation target or contribution limit for the accountType */
  targetAmount?: Maybe<MoneyRulesCurrencyAmount>;
};

export type MoneyManagerCategoriesInput = {
  amount?: InputMaybe<MoneyRulesCurrencyAmountInput>;
  archetype?: InputMaybe<MoneyRulesArchetype>;
  stagedRules?: InputMaybe<Array<MoneyManagerStagedRulesInput>>;
  /** Base calculations on the customer's monthly deposit amount, instead of their next predicted paycheck. Default: False */
  useMonthlyDepositAmount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MoneyManagerCategoriesResult = MoneyManagerCategoriesSuccess;

export type MoneyManagerCategoriesSuccess = {
  __typename?: 'MoneyManagerCategoriesSuccess';
  categories: Array<MoneyManagerCategory>;
};

export type MoneyManagerCategory = {
  __typename?: 'MoneyManagerCategory';
  allocations: Array<MoneyManagerCategoryAllocation>;
  categoryAmount?: Maybe<MoneyRulesCurrencyAmount>;
  categoryPercent: Scalars['Float']['output'];
  categoryType: MoneyManagerCategoryType;
  isActive: Scalars['Boolean']['output'];
};

export type MoneyManagerCategoryAllocation = {
  __typename?: 'MoneyManagerCategoryAllocation';
  accountId: Scalars['ID']['output'];
  accountType: ProductAccountType;
  amount?: Maybe<MoneyRulesCurrencyAmount>;
  beneficiary?: Maybe<Beneficiary>;
  isEditable: Scalars['Boolean']['output'];
  /** Deposit amounts normalized to various cadences */
  normalizedAmounts?: Maybe<MoneyManagerNormalizedAmounts>;
  notEditableReason?: Maybe<MoneyManagerAllocationNotEditableReason>;
  percent: Scalars['Float']['output'];
  singleRuleId?: Maybe<Scalars['Int']['output']>;
};

export enum MoneyManagerCategoryType {
  Giving = 'GIVING',
  Investing = 'INVESTING',
  Kids = 'KIDS',
  Saving = 'SAVING',
  Spending = 'SPENDING'
}

export type MoneyManagerDeposit = {
  amount: MoneyRulesCurrencyAmount;
  category: MoneyManagerDepositCategory;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

export type MoneyManagerDepositAssignment = MoneyManagerMoneyAssignment & {
  __typename?: 'MoneyManagerDepositAssignment';
  allocations: Array<MoneyManagerAllocation>;
  amount: MoneyRulesCurrencyAmount;
  cancelReason?: Maybe<MoneyManagerCancelReason>;
  createdAt: Scalars['DateTime']['output'];
  deposit: MoneyManagerDeposit;
  id: Scalars['ID']['output'];
  status: MoneyManagerMoneyAssignmentStatus;
  type: MoneyManagerMoneyAssignmentType;
  userId: Scalars['String']['output'];
};

export enum MoneyManagerDepositCategory {
  OneTime = 'ONE_TIME',
  Other = 'OTHER',
  Paycheck = 'PAYCHECK',
  Recurring = 'RECURRING'
}

export enum MoneyManagerDepositState {
  /** The customer has never had the Money Manager process a deposit and is waiting for the first deposit to arrive */
  AwaitingFirstDeposit = 'AWAITING_FIRST_DEPOSIT',
  /** The most recent deposit has arrived and has been split and waiting for the next deposit */
  AwaitingNextDeposit = 'AWAITING_NEXT_DEPOSIT',
  /** The current deposit has arrived and is pending */
  DepositArrived = 'DEPOSIT_ARRIVED'
}

/** Represents the current summary and state of money manager deposits */
export type MoneyManagerDepositSummary = {
  __typename?: 'MoneyManagerDepositSummary';
  /** The amount of the deposit based off the deposit state */
  amount?: Maybe<MoneyRulesCurrencyAmount>;
  /** The type of deposit based off the deposit state */
  depositType?: Maybe<MoneyManagerDepositCategory>;
  /** Most recently created pending MoneyAssignment that has not yet been split */
  pendingMoneyAssignment?: Maybe<MoneyManagerMoneyAssignment>;
  /** The projected deposit amount based on annual income */
  predictedDepositAmount?: Maybe<MoneyRulesCurrencyAmount>;
  /** The state of Money Manager deposits for the customer */
  state?: Maybe<MoneyManagerDepositState>;
};

export type MoneyManagerEligibilityResult = {
  __typename?: 'MoneyManagerEligibilityResult';
  ineligibleReasons?: Maybe<Array<IneligibleReasons>>;
  isEligible: Scalars['Boolean']['output'];
};

export type MoneyManagerError = {
  message: Scalars['String']['output'];
};

export type MoneyManagerGlobalConfig = {
  __typename?: 'MoneyManagerGlobalConfig';
  recurringDepositsConfig: MoneyManagerRecurringDepositsConfig;
};

export type MoneyManagerInputError = MoneyManagerError & {
  __typename?: 'MoneyManagerInputError';
  message: Scalars['String']['output'];
};

export type MoneyManagerMoneyAssignment = {
  allocations: Array<MoneyManagerAllocation>;
  amount: MoneyRulesCurrencyAmount;
  cancelReason?: Maybe<MoneyManagerCancelReason>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The status of the MoneyAssignment as a whole including the Assignment Target Allocations */
  status: MoneyManagerMoneyAssignmentStatus;
  type: MoneyManagerMoneyAssignmentType;
  userId: Scalars['String']['output'];
};

export enum MoneyManagerMoneyAssignmentStatus {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
  Transferring = 'TRANSFERRING'
}

export enum MoneyManagerMoneyAssignmentType {
  Deposit = 'DEPOSIT',
  Rebalance = 'REBALANCE'
}

export type MoneyManagerNormalizedAmounts = {
  __typename?: 'MoneyManagerNormalizedAmounts';
  daily?: Maybe<MoneyRulesCurrencyAmount>;
  monthly?: Maybe<MoneyRulesCurrencyAmount>;
  weekly?: Maybe<MoneyRulesCurrencyAmount>;
  yearly?: Maybe<MoneyRulesCurrencyAmount>;
};

export type MoneyManagerPageInfo = {
  __typename?: 'MoneyManagerPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  /** We don't actually have the ability to determine if there was a previous page. Will return true if a cursor was provided */
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
};

export type MoneyManagerPageInput = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type MoneyManagerPaycheck = MoneyManagerDeposit & {
  __typename?: 'MoneyManagerPaycheck';
  amount: MoneyRulesCurrencyAmount;
  category: MoneyManagerDepositCategory;
  createdAt: Scalars['DateTime']['output'];
  employer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

export type MoneyManagerPeriod = {
  __typename?: 'MoneyManagerPeriod';
  unit: MoneyManagerPeriodUnit;
  value: Scalars['Int']['output'];
};

export type MoneyManagerPeriodInput = {
  unit: MoneyManagerPeriodUnit;
  value: Scalars['Int']['input'];
};

export enum MoneyManagerPeriodUnit {
  Month = 'MONTH',
  Week = 'WEEK'
}

export type MoneyManagerRebalanceAssignment = MoneyManagerMoneyAssignment & {
  __typename?: 'MoneyManagerRebalanceAssignment';
  accountId: Scalars['ID']['output'];
  allocations: Array<MoneyManagerAllocation>;
  amount: MoneyRulesCurrencyAmount;
  cancelReason?: Maybe<MoneyManagerCancelReason>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  sourceAccountType: MoneyManagerRebalanceSouceAccountType;
  status: MoneyManagerMoneyAssignmentStatus;
  type: MoneyManagerMoneyAssignmentType;
  userId: Scalars['String']['output'];
};

export enum MoneyManagerRebalanceSouceAccountType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export enum MoneyManagerRebalanceSuppressionSource {
  ClientHome = 'CLIENT_HOME',
  MoneyManagerLander = 'MONEY_MANAGER_LANDER',
  MoneyManagerRebalanceFlow = 'MONEY_MANAGER_REBALANCE_FLOW'
}

export type MoneyManagerRebalancesResponse = {
  __typename?: 'MoneyManagerRebalancesResponse';
  rebalances: Array<Maybe<MoneyManagerRebalanceAssignment>>;
};

export type MoneyManagerRecurringDeposit = MoneyManagerDeposit & {
  __typename?: 'MoneyManagerRecurringDeposit';
  amount: MoneyRulesCurrencyAmount;
  category: MoneyManagerDepositCategory;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

export type MoneyManagerRecurringDepositsConfig = {
  __typename?: 'MoneyManagerRecurringDepositsConfig';
  allowedFrequencies: Array<MoneyManagerRecurringFrequency>;
  maximumAmount: MoneyRulesCurrencyAmount;
  minimumAmount: MoneyRulesCurrencyAmount;
};

export enum MoneyManagerRecurringFrequency {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type MoneyManagerRulesetNotFoundError = MoneyManagerError & {
  __typename?: 'MoneyManagerRulesetNotFoundError';
  message: Scalars['String']['output'];
};

export type MoneyManagerScheduledDeposit = {
  amount: MoneyRulesCurrencyAmount;
  expectedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MoneyManagerScheduledPaycheck = MoneyManagerScheduledDeposit & {
  __typename?: 'MoneyManagerScheduledPaycheck';
  amount: MoneyRulesCurrencyAmount;
  employer: Scalars['String']['output'];
  expectedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MoneyManagerScheduledRecurringDeposit = MoneyManagerScheduledDeposit & {
  __typename?: 'MoneyManagerScheduledRecurringDeposit';
  amount: MoneyRulesCurrencyAmount;
  expectedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MoneyManagerSettings = {
  __typename?: 'MoneyManagerSettings';
  depositSources: Array<MoneyRulesSourceSetting>;
  processRecurringDeposits: Scalars['Boolean']['output'];
  status: MoneyManagerStatus;
  suppressRebalancesUntil?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
};

export type MoneyManagerSourceSetting = {
  __typename?: 'MoneyManagerSourceSetting';
  depositType: MoneyRulesDepositType;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
};

/** Input type for MoneyManager allocation. */
export type MoneyManagerStagedRulesInput = {
  distribution: MoneyRulesDistributionInput;
  singleRuleId: Scalars['Int']['input'];
};

export enum MoneyManagerState {
  /** The customer has never had the Money Manager turned on */
  NotSetup = 'NOT_SETUP',
  /** The Money Manager is turned off */
  Off = 'OFF',
  /** The Money Manager is turned on */
  On = 'ON'
}

export enum MoneyManagerStatus {
  NotSetup = 'NOT_SETUP',
  Off = 'OFF',
  On = 'ON'
}

/** Represents the current summary and state of the money manager */
export type MoneyManagerSummary = {
  __typename?: 'MoneyManagerSummary';
  depositSummary: MoneyManagerDepositSummary;
  /** The amount received by the Money Manager this month */
  receivedThisPeriodAmount: MoneyRulesCurrencyAmount;
  /** The amount scheduled for the Money Manager for this month */
  scheduledThisPeriodAmount: MoneyRulesCurrencyAmount;
  /**
   * The state of the Money Manager for the customer
   * @deprecated Use status on MoneyManagerSettings instead
   */
  state: MoneyManagerState;
};

export enum MoneyRulesAccountType {
  Checking = 'CHECKING',
  Early = 'EARLY',
  Invest = 'INVEST',
  Later = 'LATER',
  Savings = 'SAVINGS'
}

export enum MoneyRulesArchetype {
  DebtFocused = 'DEBT_FOCUSED',
  Default = 'DEFAULT',
  GivingFocused = 'GIVING_FOCUSED'
}

export type MoneyRulesArchetypesInput = {
  archetypes?: InputMaybe<Array<MoneyRulesArchetype>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MoneyRulesArchetypesResult = MoneyRulesArchetypesSuccess;

export type MoneyRulesArchetypesSuccess = {
  __typename?: 'MoneyRulesArchetypesSuccess';
  rulesets: Array<MoneyRulesRuleset>;
};

export type MoneyRulesCancelMoneyAssignmentSuccess = {
  __typename?: 'MoneyRulesCancelMoneyAssignmentSuccess';
  moneyAssignment: MoneyManagerMoneyAssignment;
};

export type MoneyRulesCondition = {
  __typename?: 'MoneyRulesCondition';
  fallback?: Maybe<MoneyRulesDestination>;
  type: MoneyRulesConditionType;
  unit: MoneyRulesConditionUnit;
  value: Scalars['Float']['output'];
};

export type MoneyRulesConditionInput = {
  fallback?: InputMaybe<MoneyRulesDestinationInput>;
  type: MoneyRulesConditionType;
  unit: MoneyRulesConditionUnit;
  value: Scalars['Float']['input'];
};

export enum MoneyRulesConditionType {
  DebtExists = 'DEBT_EXISTS',
  HighInterestDebtExists = 'HIGH_INTEREST_DEBT_EXISTS',
  SourceAmountAtLeast = 'SOURCE_AMOUNT_AT_LEAST'
}

export enum MoneyRulesConditionUnit {
  Currency = 'CURRENCY'
}

export type MoneyRulesCurrencyAmount = {
  __typename?: 'MoneyRulesCurrencyAmount';
  currency: Currency;
  value: Scalars['Float']['output'];
};

export type MoneyRulesCurrencyAmountInput = {
  currency: Currency;
  value: Scalars['Float']['input'];
};

export enum MoneyRulesDepositType {
  OneTime = 'ONE_TIME',
  Paycheck = 'PAYCHECK',
  Recurring = 'RECURRING'
}

export type MoneyRulesDestination = {
  __typename?: 'MoneyRulesDestination';
  accountId: Scalars['String']['output'];
  accountType: MoneyRulesAccountType;
};

export type MoneyRulesDestinationInput = {
  accountId: Scalars['String']['input'];
  accountType: MoneyRulesAccountType;
};

export type MoneyRulesDistribution = {
  __typename?: 'MoneyRulesDistribution';
  unit: MoneyRulesDistributionUnit;
  value: Scalars['Float']['output'];
};

export type MoneyRulesDistributionInput = {
  unit: MoneyRulesDistributionUnit;
  value: Scalars['Float']['input'];
};

export enum MoneyRulesDistributionUnit {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type MoneyRulesMoneySource = {
  __typename?: 'MoneyRulesMoneySource';
  accountId: Scalars['String']['output'];
  accountType: MoneyRulesAccountType;
  amount: MoneyRulesCurrencyAmount;
};

export type MoneyRulesMoneySourceInput = {
  accountId: Scalars['String']['input'];
  accountType: MoneyRulesAccountType;
  amount: MoneyRulesCurrencyAmountInput;
};

export type MoneyRulesMoneySplit = {
  __typename?: 'MoneyRulesMoneySplit';
  destination: MoneyRulesDestination;
  distribution: MoneyRulesDistribution;
};

export type MoneyRulesRule = {
  __typename?: 'MoneyRulesRule';
  conditions: Array<MoneyRulesCondition>;
  destination: MoneyRulesDestination;
  distribution: MoneyRulesDistribution;
  priority: Scalars['Int']['output'];
  ruleType: MoneyRulesRuleType;
};

export type MoneyRulesRuleInput = {
  conditions: Array<MoneyRulesConditionInput>;
  destination: MoneyRulesDestinationInput;
  distribution: MoneyRulesDistributionInput;
  priority: Scalars['Int']['input'];
  ruleType: MoneyRulesRuleType;
};

export enum MoneyRulesRuleType {
  FlatPct = 'FLAT_PCT',
  FlatPctAdjustedForIncomeShare = 'FLAT_PCT_ADJUSTED_FOR_INCOME_SHARE',
  FlatPctUpToLaterGoal = 'FLAT_PCT_UP_TO_LATER_GOAL',
  FlatPctUpToLaterGoalAdjustedForIncomeShare = 'FLAT_PCT_UP_TO_LATER_GOAL_ADJUSTED_FOR_INCOME_SHARE',
  FlatValue = 'FLAT_VALUE',
  FullRemainder = 'FULL_REMAINDER',
  UpToCheckingGoal = 'UP_TO_CHECKING_GOAL',
  UpToLaterLimit = 'UP_TO_LATER_LIMIT',
  UpToSavingsGoal = 'UP_TO_SAVINGS_GOAL',
  UpToSavingsGoalCappedAdjustedForIncomeShare = 'UP_TO_SAVINGS_GOAL_CAPPED_ADJUSTED_FOR_INCOME_SHARE'
}

export type MoneyRulesRuleset = {
  __typename?: 'MoneyRulesRuleset';
  archetype: MoneyRulesArchetype;
  createdAt: Scalars['DateTime']['output'];
  isCustomized: Scalars['Boolean']['output'];
  minimumAmount: Scalars['Int']['output'];
  rules: Array<MoneyRulesRule>;
};

export type MoneyRulesRulesetInput = {
  archetype: MoneyRulesArchetype;
  minimumAmount: Scalars['Int']['input'];
  rules: Array<MoneyRulesRuleInput>;
};

export type MoneyRulesRulesetNotFoundException = {
  __typename?: 'MoneyRulesRulesetNotFoundException';
  message: Scalars['String']['output'];
};

export type MoneyRulesSettings = {
  __typename?: 'MoneyRulesSettings';
  depositSources: Array<MoneyRulesSourceSetting>;
  /** @deprecated Use status instead */
  moneyManagerEnabled: Scalars['Boolean']['output'];
  processRecurringDeposits: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

export type MoneyRulesSourceSetting = {
  __typename?: 'MoneyRulesSourceSetting';
  depositType: MoneyRulesDepositType;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
};

export type MoneyRulesSplitOverridesInput = {
  acornsIncomePercentage?: InputMaybe<Scalars['Float']['input']>;
  adjustForAcornsIncomeShare?: InputMaybe<Scalars['Boolean']['input']>;
  grossYearlyIncome?: InputMaybe<Scalars['Int']['input']>;
  stateOfResidence?: InputMaybe<StateCode>;
};

export type MoneyRulesSuggestedSplits = {
  __typename?: 'MoneyRulesSuggestedSplits';
  moneySource: MoneyRulesMoneySource;
  rulesetVersion?: Maybe<Scalars['Int']['output']>;
  splits: Array<Maybe<MoneyRulesMoneySplit>>;
};

export type MoneyRulesSuggestionResult = MoneyRulesSuggestedSplits;

export type MoneyRulesUpdateArchetypeResult = MoneyRulesUpdateRulesetSuccess;

export type MoneyRulesUpdateCustomerMoneyRulesResult = MoneyRulesUpdateRulesetSuccess;

export type MoneyRulesUpdateRulesetSuccess = {
  __typename?: 'MoneyRulesUpdateRulesetSuccess';
  resultingRuleset: MoneyRulesRuleset;
};

export type MonthlyTotal = {
  __typename?: 'MonthlyTotal';
  isPredicted: Scalars['Boolean']['output'];
  totalAmount: FormattedMonetaryAmount;
  yearMonth: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptUploadedDocument: DocumentRequest;
  activateOauthApp: ActivateOauthAppResult;
  activateOauthAppClient: ActivateOauthAppClientResult;
  addBankCustomerIdToAccounts: AddBankCustomerIdToAccountsResult;
  addDocumentUrls: DocumentRequest;
  addFavoritePartnerOffers: FavoritePartnerOfferGroup;
  /** Add a note to a user */
  addNote: AddNoteResponse;
  /** Add a note to multiple users */
  addNoteMultipleUsers: AddNoteMultipleUsersResponse;
  /** Adding or removing users from the whitelist will apply to both spend and save account reopens. */
  addOrRemoveUsersFromSpendWhitelist?: Maybe<AddOrRemoveUsersFromSpendWhitelistPayload>;
  /** Add a policy to the set of valid policies for authorization */
  addPolicy: AddPolicyResult;
  /**
   * Mutation to add a new symbol in the trading service database. Called internally when we want to include
   * a new security in our ecosystem.
   */
  addSecurities: AddSecuritiesResult;
  /** Add a trusted contact for a user */
  addTrustedContact: UpdateTrustedContactResult;
  adminActionClose: AdminActionResponse;
  adminActionLock: AdminActionResponse;
  adminActionMrdcReject: AdminActionResponse;
  adminActionPass: AdminActionResponse;
  /** Validate a challenge. */
  answerChallenge: AnswerChallengeResult;
  applyPromoCode: ApplyPromoCodeResult;
  /** Apply a promotion to an existing subscription. May entitle a subscriber to promotional pricing for their subscription and/or additional incentives. */
  applyPromotion: ApplyPromotionResult;
  /** Apply a promotional waiver */
  applyPromotionalWaiver?: Maybe<ApplyPromotionalWaiverResult>;
  /** Apply a provisional (open ended) waiver */
  applyProvisionalWaiver?: Maybe<ApplyProvisionalWaiverResult>;
  /** Approve an investment */
  approveInvestment: Investment;
  archiveBankCard?: Maybe<ArchiveBankCardPayload>;
  archiveBankCardByCardId?: Maybe<ArchiveBankCardByCardIdPayload>;
  archiveCoreproCustomer: ArchiveCoreproCustomerPayload;
  assignAdminApps: AssignAdminAppsResult;
  /** Assign a trusted contact to one or more accounts. NOTE: this mutation is intended to upsert assignment records and will soft delete any existing assignment records for accounts that are not given as input. */
  assignTrustedContact: Array<InvestmentAccount>;
  /** Request an AuthSession for the provided credentials. */
  authenticate: AuthenticateResult;
  authenticateForFeeNegotiation: AuthenticateForFeeNegotiationResult;
  authenticateForFeeNegotiationChallenge: AuthenticateNegotiationStatusResult;
  authenticateForFeeNegotiationChallengeMethod: AuthenticateNegotiationStatusResult;
  bankAdminPurgeDLQ: Scalars['String']['output'];
  /** Batch adds tier-subscription items for users for specified user uuids, tierIds, tierPriceId */
  batchAddTierSubscriptions: BatchAddTierSubscriptionsResult;
  blockDevice: BlockDeviceResult;
  /** Orchestrator for the bulk suspension flow initiated from Portal Admin */
  bulkSuspend: BulkSuspendResult;
  /** Processes bulk verification CSV file uploaded to S3. */
  bulkVerify: Scalars['String']['output'];
  cancelBankAccountClosureRequest: CancelBankAccountClosureRequestResult;
  cancelCheckPayment?: Maybe<CancelCheckPaymentResult>;
  cancelDocumentRequest: DocumentRequest;
  /** Cancel funding source by funding source uuid */
  cancelFundingSource: CancelFundingSourceResponse;
  cancelInvestment: CancelInvestmentResult;
  /** Cancel an existing account closure request */
  cancelInvestmentAccountClosureRequest: CancelInvestmentAccountClosureRequestResult;
  /** Gives the customer the ability to cancel a pending Money Assignment */
  cancelMoneyAssignment?: Maybe<CancelMoneyAssignmentResult>;
  /** Deletes recurring transfer settings for an investment account. */
  cancelRecurringInvestment: InvestmentAccount;
  cancelRecurringTransfer?: Maybe<CancelRecurringTransferResult>;
  /** Cancel a statement run. */
  cancelStatementRun: CancelStatementRunResponse;
  cancelTransaction?: Maybe<CancelTransactionData>;
  /** Changes a users password if password change criteria is met */
  changePassword?: Maybe<Scalars['Void']['output']>;
  changePasswordAuth: ChangePasswordResult;
  /**
   * Mutation to change the name of a symbol in the trading service database. Called as a result of
   * a corporate action to change the name of a symbol listed for a public security.
   */
  changeSecuritySymbol: ChangeSecuritySymbolResult;
  /** Clears failed and/or stuck buy orders, and clears the buy order cache in non-production environments. */
  clearStuckOrders: ClearStuckOrdersResponse;
  clearSupportSiteCache?: Maybe<ClearSupportSiteCache>;
  closeBankAccount?: Maybe<CloseBankAccountPayload>;
  /** Close an InvestmentAccount immediately if possible otherwise initiate the closure process and put the InvestmentAccount in the PENDING_CLOSURE state. */
  closeInvestmentAccount: CloseInvestmentAccountResult;
  /** Close an user account by user UUID */
  closeUserAccount: CloseUserAccountResponse;
  configureSplitDepositDirectDepositIntentSetting: ConfigureSplitDepositDirectDepositIntentPayload;
  configureSplitDepositDirectDepositSetting: ConfigureSplitDepositDirectDepositSettingPayload;
  consumeUserToken: ConsumeUserTokenResult;
  /** Creates a new AcceptanceDocument */
  createAcceptanceDocument: CreateAcceptanceDocumentResponse;
  /** Creates a new version of an acceptance document */
  createAcceptanceDocumentVersion: CreateAcceptanceDocumentVersionResponse;
  /** Creates a new filter on an acceptance document version */
  createAcceptanceDocumentVersionFilter: CreateAcceptanceDocumentVersionFilterResponse;
  createAuthProfile: CreateAuthProfileResult;
  createAuthenticatedSupportTicket?: Maybe<SupportTicket>;
  /** Create a new Bank */
  createBank: CreateBankResult;
  /**
   * Creates a checking account with our bank partner (LSB / NBKC) and returns the account details.
   * If you want to create a savings account from backend, please use createSavingsAccount mutation
   */
  createBankAccount?: Maybe<CreateBankAccountPayload>;
  /** @deprecated Use async processing flow instead. Publish CreateTransfer command to SNS and have bank consume to create a transfer. */
  createBankTransfer?: Maybe<CreateBankTransferData>;
  createBankTransferFromAccountToProgram: CreateBankTransferFromAccountToProgramResult;
  createBankTransferFromProgramToAccount?: Maybe<CreateBankTransferFromProgramToAccountResult>;
  /** Create a beneficiary */
  createBeneficiary: CreateBeneficiaryResult;
  /** Waive users in the given csv stored in s3 */
  createBulkProvisionalWaivers: CreateBulkProvisionalWaiversResult;
  createDocumentUpload: CreateDocumentUpload;
  /** Collect fees from a user by creating a billing cycle */
  createFeeCollection: CreateFeeCollectionResult;
  createImplicitTokenForUser: CreateImplicitTokenForUserResult;
  /** Calculates portfolio recommendation based off of specific factors for specific account type */
  createInvestingStrategyRecommendation: CreateInvestingStrategyRecommendationResult;
  /** Creates an investment for a given user id */
  createInvestment: CreateInvestmentResult;
  /** Creates an IRA distribution (withdrawal investment) for a later account */
  createIraDistribution: CreateIraDistributionResult;
  /** @deprecated Job Alerts are no longer supported */
  createJobAlert?: Maybe<CreateJobAlertResult>;
  /** Waive a single user's fees for a specified number of months */
  createMightyOakCardWaiver: CreateMightyOakCardWaiverResult;
  createOauthApp: CreateOauthAppResult;
  /** (Internal-only) Provision a new offer. */
  createOffer: CreateOfferResult;
  /** Create a new Portfolio */
  createPortfolio: PortfolioMeta;
  /** Create a new Portfolio Tag */
  createPortfolioTag: PortfolioTag;
  createPresignedUrlForAdminCSVBucket: Scalars['String']['output'];
  createPromoCode: CreatePromoCodeResult;
  createPromoCodeReward: CreatePromoCodeRewardResult;
  /** Waive a single user's fees for a specified number of months */
  createPromotionalWaiver: CreatePromotionalWaiverResult;
  /** Create a Prospect User */
  createProspectUser: CreateProspectUserResult;
  /** Waive a single user's fees for a specified period of time */
  createProvisionalWaiver: CreateProvisionalWaiverResult;
  createReferralCampaign: CreateReferralCampaignResult;
  createReferralCampaignReward: CreateReferralCampaignRewardResult;
  createReferralPayout: CreateReferralPayoutResult;
  createReferralRelationship: CreateReferralRelationshipResult;
  /** (Internal-only) Create a refund for a given invoice */
  createRefund?: Maybe<CreateRefundResult>;
  createSavingsAccount: CreateSavingsAccountResult;
  createScope: CreateScopeResult;
  /** (Internal-only) Provision a new subscription migration. */
  createSubscriptionMigration: CreateSubscriptionMigrationResult;
  /** @deprecated Replaced with createSupportTicketOrException mutation. */
  createSupportTicket?: Maybe<SupportTicket>;
  createSupportTicketOrException?: Maybe<SupportTicketResponse>;
  createSupportTicketWithCustomFields?: Maybe<SupportTicketWithCustomFieldsResponse>;
  createSuspendedUserSupportTicket?: Maybe<SupportTicketWithCustomFieldsResponse>;
  /** Create presigned url for tin verification upload bucket with 'beneficiary_tinFile_' prepended to file key */
  createTinVerificationUploadPresignedUrl: CreateTinVerificationUploadPresignedUrlResult;
  createUser?: Maybe<Session>;
  /** Create a billing vendor invoice */
  createVendorInvoice?: Maybe<CreateVendorInvoiceResult>;
  /** Create a new billing vendor line item */
  createVendorLineItem?: Maybe<CreateVendorLineItemResult>;
  /** Deactivates the specified account and returns the newley deactived account. */
  deactivateAccount?: Maybe<Account>;
  /** Deactivate a beneficiary that is no longer used */
  deactivateBeneficiary: DeactivateBeneficiaryResult;
  deactivateOauthApp: DeactivateOauthAppResult;
  deactivateOauthAppClient: DeactivateOauthAppClientResult;
  deactivateSecurity: DeactivateSecurityResult;
  /** Deactivate a user's subscription */
  deactivateTierSubscription: DeactivateTierSubscriptionResult;
  /** Deletes an Acceptance Document Version Filter */
  deleteAcceptanceDocumentVersionFilter: DeleteAcceptanceDocumentVersionFilterResponse;
  deleteBankCardOrder?: Maybe<DeleteBankCardOrderResult>;
  /** Remove a mighty oak card waiver assigned to a user */
  deleteMightyOakCardWaiver: DeleteMightyOakCardWaiverResult;
  deleteOauthApp: DeleteOauthAppResult;
  /** Delete a Pinwheel webhook */
  deletePinwheelWebhook: DeletePinwheelWebhookPayload;
  /** Delete a Portfolio */
  deletePortfolio: PortfolioMeta;
  /** Delete a Portfolio Tag */
  deletePortfolioTag: PortfolioTag;
  /** Delete a user's promotional waiver */
  deletePromotionalWaiver: DeletePromotionalWaiverResult;
  /** Remove a provisional waiver assigned to a user */
  deleteProvisionalWaiver: DeleteProvisionalWaiverResult;
  deleteScope: DeleteScopeSuccess;
  /** Deletes a trusted contact for a user */
  deleteTrustedContact: DeleteTrustedContactResult;
  /** Deletes a user-uploaded file from an account */
  deleteUpload: DeleteUploadResponse;
  /** Deregister and Authenticator. */
  deregisterAuthenticator: DeregisterAuthenticatorResult;
  dismissMessage: UpdateMessageResult;
  dismissMessages: DismissMessagesResult;
  /** Edit a trusted contact for a user */
  editTrustedContact: UpdateTrustedContactResult;
  evaluateDFADecision: EvaluateDfaDecisionResult;
  exchangeAcornsEarlyToken: ExchangeAcornsEarlyTokenResult;
  /** Internal API used for triggering MoneyIn workflows */
  executeMoneyIn?: Maybe<ExecuteMoneyInResult>;
  /** Expire a promotional waiver */
  expirePromotionalWaiver?: Maybe<ExpirePromotionalWaiverResult>;
  /** Mark an open billing vendor invoice as failed */
  failVendorInvoice?: Maybe<FailVendorInvoiceResult>;
  /** Flag user as suspicious */
  flagUserAsSuspicious: FlagUserAsSuspiciousResponse;
  /** Flag the user with the provided flag type */
  flagUserByUserId: FlagUserByUserIdResult;
  forceUpdateAuthPhoneNumber: UpdateAuthPhoneNumberResult;
  /** Force update a beneficiary's basic info */
  forceUpdateBeneficiaryInfo: ForceUpdateBeneficiaryInfoResult;
  /** Creates session input to initialize SDK for document upload and verification */
  generateDocumentUploadSession: GenerateDocumentUploadSessionResult;
  generateReferralCode: GenerateReferralCodeResult;
  /** Generate the tin file */
  generateTinFile: GenerateTinFileResponse;
  /** Generate a doc uploader token for a suspended user and send email */
  generateUserSuspendedUploadToken: GenerateUserSuspendedUploadTokenResult;
  hideMessage: UpdateMessageResult;
  hideMessageByExternalId: UpdateMessageResult;
  hotlistBankCardByCardId?: Maybe<HotlistBankCardByCardIdPayload>;
  /** Initiate challenge following credentials validation. */
  initiateChallenge: InitiateChallengeResult;
  /** Initiate registration of an EmailAuthenticator. */
  initiateEmailChallenge: InitiateEmailChallengeResult;
  initiateLaterProgramAccountContribution?: Maybe<LaterProgramAccountContributionResult>;
  /** Gives the customer the ability to immediately start the allocation of a pending Money Assignment */
  initiateMoneyAssignment?: Maybe<InitiateMoneyAssignmentResult>;
  /** Initiate sending push notifications to registered PushAuthenticator(s). */
  initiatePushChallenge: InitiatePushChallengeResult;
  /** Initiate registration of a PhoneAuthenticator. */
  initiateSMSChallenge: InitiateSmsChallengeResult;
  /** Initiate Spend closure for a user */
  initiateSpendFunnelClosure: InitiateSpendFunnelClosureResponse;
  initiateVerification: InitiateVerificationResult;
  /** Clear the investment account calculations cache */
  investmentAccountClearCache?: Maybe<InvestmentAccountClearCacheResult>;
  /**
   * Issues bank card with bank partner
   * In the Sandbox environment, cards will always be created with a cardNumberMasked value of 1111 and can be verified immediately afterwards
   */
  issueBankCard?: Maybe<IssueBankCardPayload>;
  issuePhysicalBankCard: IssueBankCardPayload;
  /**
   *  Make a withdrawal from a later account
   *  One of either earlyDistributionTaxExceptionReason or reason is required; reason is newer/preferred
   *  withdrawalType is no longer supported, since it can be derived
   */
  laterWithdrawal?: Maybe<Scalars['Void']['output']>;
  /**
   *  Make a withdrawal from a later account and return the investment ID
   *  One of either earlyDistributionTaxExceptionReason or reason is required; reason is newer/preferred
   *  withdrawalType is no longer supported, since it can be derived
   */
  laterWithdrawalV2?: Maybe<LaterWithdrawalV2Response>;
  /** Link OIDC credentials to an existing account */
  linkOidcCredentials: LinkOidcCredentialsResult;
  /** Liquidate the fractional shares of an investment account */
  liquidateAccount: LiquidateAccountResponse;
  /** Liquidate a given investment account */
  liquidateInvestmentAccount: LiquidateInvestmentAccountResponse;
  lockBankAccounts: LockBankAccountsResult;
  lockBankCard?: Maybe<LockBankCardPayload>;
  logout: LogoutResult;
  logoutDevice: LogoutDeviceResult;
  /** Make a funding source unrecoverable */
  makeFundingSourceUnrecoverable: FundingSource;
  managePayoutRelationship: PayoutRelationshipResult;
  markAllAsRead: MarkAllAsReadResult;
  /** Gives the customer the ability update the assignment target amounts for a pending Money Assignment */
  modifyMoneyAssignment: ModifyMoneyAssignmentResult;
  optInPhoneNumber: Scalars['Boolean']['output'];
  orderBankCard?: Maybe<OrderBankCardResult>;
  /** Pin a user note */
  pinNote: PinNoteResponse;
  postBankFeeNegotiation: BenefitsMessage;
  postUserReportedBankFeeRefund: BenefitsMessage;
  /** Pre approve users accounts */
  preApproveAccount: Array<PreApproveAccountResponse>;
  processBankTransferCommand?: Maybe<ProcessBankTransferCommandPayload>;
  processCheckTransferCommand?: Maybe<ProcessCheckTransferCommandPayload>;
  /** Checks the input data and determines if the user needs  id/address/both/neither for documents */
  processIdologyResponse: IdologyResult;
  processSocureResponse: SocureResult;
  processTransferFromProgramAccount?: Maybe<ProcessTransferFromProgramAccountPayload>;
  processTransferToProgramAccount?: Maybe<ProcessTransferToProgramAccountPayload>;
  publishBgpReport: PublishBgpReportResult;
  /** Reactivate a beneficiary that was previously deactivated */
  reactivateBeneficiary: ReactivateBeneficiaryResult;
  readMessage: UpdateMessageResult;
  reallocateClosedAccounts: ReallocateClosedAccountsResult;
  /** Reconcile a statement run. */
  reconcileStatementRun: ReconcileStatementRunResponse;
  /** Record an Action or Event from Friend */
  recordReferralEvent: RecordReferralEventResult;
  /** Record an external payment for manual billing vendor invoices */
  recordVendorExternalTransaction?: Maybe<RecordVendorExternalTransactionResult>;
  refreshAuthToken: RefreshAuthTokenResult;
  /** Refund a billing cycle given a billing cycle ID */
  refundBillingCycle: RefundBillingCycleResult;
  registerCredentials: RegisterCredentialsResult;
  /** Register a PushAuthenticator and SNS device token. */
  registerDeviceTokenAndPushAuthenticator: RegisterDeviceTokenAndPushAuthenticatorResult;
  /** Register an EmailAuthenticator. */
  registerEmailAuthenticator: RegisterEmailAuthenticatorResult;
  /** Register OIDC credentials */
  registerOidcCredentials: RegisterOidcCredentialsResult;
  /** Register a PhoneAuthenticator. */
  registerPhoneAuthenticator: RegisterPhoneAuthenticatorResult;
  /** Register a PhoneAuthenticator without requiring a challenge. This is used for Plaid Layer accounts who already have a phone number registered and confirmed. */
  registerPhoneAuthenticatorWithoutChallenge: RegisterPhoneAuthenticatorWithoutChallengeResult;
  /** Re-initiate registration of an Authenticator. */
  reinitiateChallenge: ReinitiateSmsChallengeResult;
  /** @deprecated This operation is no longer used */
  reissueBankCard?: Maybe<ReissueBankCardPayload>;
  rejectUploadedDocument: DocumentRequest;
  releaseAdminApp: AdminApp;
  /** Release an statement run */
  releaseStatementRun: ReleaseStatementRunResponse;
  /** Relink a funding source */
  relinkFundingSource: FundingSource;
  /** Re-initiate a link between a funding source and ProfitStars. */
  relinkWithProfitStars: FundingSource;
  /** Removes account approval in an array of user accounts */
  removeAccountPreApproval: Array<RemoveAccountPreApprovalResponse>;
  removeFavoritePartnerOffers: FavoritePartnerOfferGroup;
  /** @deprecated Job Alerts are no longer supported */
  removeJobAlert?: Maybe<RemoveJobAlertResult>;
  removePolicy: RemovePolicyResult;
  /** Remove a requested a document from a user */
  removeRequestedDocument: RemoveRequestedDocumentResponse;
  /** Reopens an array of user accounts for verification */
  reopenAccountForVerification: Array<ReopenAccountForVerificationResponse>;
  /** Reopen a closed Acorns user account */
  reopenUserAccount: ReopenUserAccountResult;
  /** Request a document from a user */
  requestDocument: RequestDocumentResponse;
  requestDocumentUpload: DocumentRequest;
  /** Request to be waived from being migrated to a new Subscription. */
  requestSubscriptionMigrationWaiver: RequestSubscriptionMigrationWaiverResult;
  /** Resends files to CPI for a given date. */
  resendFiles: ResendFilesResult;
  resetPassword?: Maybe<Scalars['Void']['output']>;
  /** Resets a password if the password reset token exists (legacy Backend flow) */
  resetPasswordByToken: ResetPasswordByTokenResult;
  /** Resets a password if the password reset token exists (updated flow through web app) */
  resetPasswordWithToken: ResetPasswordWithTokenResult;
  resetRateLimit: ResetRateLimitResult;
  /** Restore user login access */
  restoreLoginAccess: RestoreLoginAccessResult;
  /** Reverse Negative Balance By Account Id */
  reverseInvestmentAccountNegativeBalance: ReverseInvestmentAccountNegativeBalanceResponse;
  /** Approves Checking Address on review documents */
  reviewDocumentsApproveAddress: ReviewDocumentsApproveAddressResponse;
  /** Mark a review document as approved */
  reviewDocumentsMarkReviewed: ReviewDocumentsMarkReviewedResponse;
  revokeAdminApps: RevokeAdminAppsResult;
  revokeLoginAccess: RevokeLoginAccessResult;
  /** Revokes given reset password token */
  revokePasswordResetToken: RevokePasswordResetTokenResult;
  roundUpProfile?: Maybe<RoundUpProfile>;
  /** Runs an account verification */
  runAccountVerification: RunAccountVerificationResponse;
  scheduleRecurringTransfer?: Maybe<ScheduleRecurringTransferResult>;
  sendBrazeEvent: Scalars['String']['output'];
  sendCheckPayment?: Maybe<SendCheckPaymentResult>;
  sendCustomerDueDiligenceAnswersToBankingPartner?: Maybe<SendCustomerDueDiligenceToBankingPartnerResult>;
  /**
   * Send a referral event to Extole. User ID is a required field on the input type,
   * but is not a field level argument as this mutation is only used internally
   */
  sendReferralEvent?: Maybe<Scalars['Boolean']['output']>;
  sessionRefresh?: Maybe<Session>;
  setAuthenticationPIN: SetAuthenticationPinResult;
  setDefaultAuthenticator: SetDefaultAuthenticatorResult;
  /** Enable or disable the deposit hold */
  setDepositHold: SetDepositHoldResponse;
  setFavoritePartnerOffers: FavoritePartnerOfferGroup;
  setManualRoundUps: Array<RoundUp>;
  /** @deprecated Use mutation.updateNegotiationStatus instead */
  setNegotiationStatus: SetNegotiationStatusResult;
  /** Create a new webhook to use for callbacks from Pinwheel jobs */
  setPinwheelWebhook: SetPinwheelWebhookPayload;
  /** Set primary funding source */
  setPrimaryFundingSource: FundingSource;
  setReferralCampaignFlags: SetReferralCampaignFlagsResult;
  setRiskModelInReview: SetRiskModelInReviewResponse;
  splitDeposit: SplitDepositMutation;
  splitDepositSettings: SplitDepositSettingsMutation;
  stub?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use mutation.postUserReportedBankFeeRefund instead */
  submitBankFeeNegotiation: SubmitBankFeeNegotiationResult;
  /** Submit Earn missing credit request */
  submitEarnMissingCreditRequest: SubmitEarnMissingCreditRequestResult;
  /** @deprecated Use mutation.postUserReportedBankFeeRefund instead */
  submitUserReportedBankFeeRefund: SubmitUserReportedBankFeeRefundResult;
  /** Eventually will replace the current 'subscribeUserToTier' mutation */
  subscribeToTier: SubscribeToTierResult;
  /**
   * Attempt to subscribe a user to a specific Tier + TierPrice
   * Reliant on some synchronous calls to service (for statuses)
   */
  subscribeUserToTier: SubscribeUserToTierResult;
  /**
   * Subscribes a user to the cheapest default tier based on their current open accounts
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByOpenAccounts: TierSubscription;
  /**
   * Subscribes a user to the cheapest default tier available with provided productKey
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByProductKey: TierSubscription;
  /** Mark an open billing vendor invoice as successful */
  succeedVendorInvoice?: Maybe<SucceedVendorInvoiceResult>;
  /**
   * Suppresses money manager rebalances until a specified future date. This prevents automatic rebalancing of investments
   * for the given user until the specified date. The date must be in the future.
   */
  suppressMoneyManagerRebalances: SuppressMoneyManagerRebalancesResult;
  /** Suspend all deposits. */
  suspendDeposits: SuspendDepositsResponse;
  /** Suspends an user. */
  suspendUser: UserSuspensionResult;
  /** Suspends a user with the provided suspension reason */
  suspendUserByUserId: SuspendUserByUserIdResult;
  syncBankAddresses?: Maybe<SyncBankAddressesPayload>;
  syncBankCustomer?: Maybe<SyncBankCustomerPayload>;
  syncBankFeeTransactions: SyncBankFeeTransactionsResult;
  syncBankSocialSecurityNumber?: Maybe<SyncBankSocialSecurityNumberPayload>;
  /** Syncs a user's current primary funding source to vendor */
  syncFundingSourceToVendor?: Maybe<SyncFundingSourceToVendorResult>;
  syncSupportAccount?: Maybe<SyncSupportAccountResponse>;
  /**  Returns the tax withholding amounts for state and federal */
  taxWithholdingAmounts?: Maybe<TaxWithholdingAmounts>;
  toggleMaintenanceFlag: ToggleMaintenanceFlagObject;
  /**
   * Move shares between our internal Drivewealth accounts.
   * Mainly between the “Master Trading Account” and the “Master Holding Account”.
   * The Trading Account is used to place our trades where the holding account is
   * where our customer’s shares actually live. These separate accounts are for compliance
   * and regulatory purposes.
   *
   * Determines transfer source and destination accounts based on shareTransferType or manual input
   * of the source and destination accounts.
   */
  transferInternalShares: TransferInternalSharesResult;
  /** Triggers an Random Deposit Verification on the users primary funding source. */
  triggerRdv: TriggerRdvResponse;
  /** Unassign a trusted contact from all of their assigned accounts */
  unassignTrustedContact: Array<Maybe<InvestmentAccount>>;
  unblockDevice: UnblockDeviceResult;
  /** Unflag user as suspicious */
  unflagUserAsSuspicious: UnflagUserAsSuspiciousResponse;
  /** unFlag the user with the provide flag type */
  unflagUserByUserId: UnflagUserByUserIdResult;
  unlinkLinkedAccount?: Maybe<LinkedAccount>;
  /** Unlink OIDC credentials from an existing account */
  unlinkOidcCredentials: UnlinkOidcCredentialsResult;
  /** Unlink Paypal Account */
  unlinkPaypalAccount: FundingSource;
  unlockBankAccounts: UnlockBankAccountsResult;
  unlockBankCard?: Maybe<UnlockBankCardPayload>;
  /** Unlocks a user. */
  unlockUser: UnlockUserResponse;
  /** Unpin a user note */
  unpinNote: UnpinNoteResponse;
  /** Unsubscribes user from notificaiton channel. */
  unsubscribeNotifications: UnsubscribeNotificationsResponse;
  /** Unsubscribes a user to from their current tier */
  unsubscribeUserFromTier: UnsubscribeUserFromTierResult;
  /** Unsuspend all deposits. */
  unsuspendDeposits: UnsuspendDepositsResponse;
  /** Unsuspends a user. */
  unsuspendUser: UserSuspensionResult;
  /** Unsuspends a user */
  unsuspendUserByUserId: UnsuspendUserByUserIdResult;
  /** Update an Acceptance Document */
  updateAcceptanceDocument: UpdateAcceptanceDocumentResponse;
  /** Updates an acceptance document version */
  updateAcceptanceDocumentVersion: UpdateAcceptanceDocumentVersionResponse;
  /** Update an Acceptance Document Version Filter */
  updateAcceptanceDocumentVersionFilter: UpdateAcceptanceDocumentVersionFilterResponse;
  /** Updates Account Portfolio */
  updateAccountPortfolio: UpdateAccountPortfolioResponse;
  /** Update a single address for a user */
  updateAddress?: Maybe<Address>;
  updateAuthEmail: UpdateAuthEmailResult;
  updateAuthPhoneNumber: UpdateAuthPhoneNumberResult;
  updateBankAccount: UpdateBankAccountResult;
  updateBanners?: Maybe<Array<Maybe<BannersResponse>>>;
  /** Update a beneficiary's basic info */
  updateBeneficiaryInfo: UpdateBeneficiaryInfoResult;
  updateBenefitStatus: UpdateBenefitStatusResponse;
  /** Update the invoice date of a billing cycle given a billing cycle ID and date */
  updateBillingCycleInvoiceDate: UpdateBillingCycleInvoiceDateResult;
  updateCheckPaymentRecipientAddress: CheckPayment;
  /** Update the contribution tax year for all later investments */
  updateContribution: UpdateContributionResponse;
  updateCredentials: UpdateCredentialsResult;
  /** Updates a customer account closure record */
  updateCustomerAccountClosure: UpdateCustomerAccountClosureResult;
  updateCustomerMoneyRules?: Maybe<MoneyRulesUpdateCustomerMoneyRulesResult>;
  updateDocumentVerificationResponse: UpdateDocumentVerificationResult;
  /** Approve or reject a funding source change request */
  updateFundingSourceChangeRequest: FundingSource;
  /** @deprecated Replaced with updateBanners mutation. */
  updateHelpcenterBanner?: Maybe<HelpcenterBannerResponse>;
  /** Updates an investment account's reopen request. */
  updateInvestmentAccountReopenRequest: UpdateInvestmentAccountReopenRequestResponse;
  /** Updates a linked subaccount */
  updateLinkedSubaccount?: Maybe<InternalLinkedSubaccount>;
  updateMaintenanceFlag: UpdateMaintenanceFlagObject;
  /** Update money manager allocations */
  updateMoneyManagerAllocations: UpdateMoneyManagerAllocationsResult;
  /** Sets a money manager automation target. */
  updateMoneyManagerAutomationTarget: UpdateMoneyManagerAutomationTargetResult;
  /** Update the money manager settings for a customer */
  updateMoneyManagerSettings: UpdateMoneyManagerSettingsResult;
  updateMoneyRulesArchetype?: Maybe<MoneyRulesUpdateArchetypeResult>;
  /**
   * Update the money rules source settings for a customer
   * @deprecated Use updateMoneyManagerSettings instead
   */
  updateMoneyRulesSourceSettings?: Maybe<UpdateMoneyRulesSourceSettingsResult>;
  updateNegotiationStatus: BenefitsMessage;
  /** Updates the user's next invoice date given a valid date */
  updateNextInvoiceDate: UpdateBillingCycleInvoiceDateResult;
  updateOauthApp: UpdateOauthAppResult;
  /** Update a Pinwheel webhook */
  updatePinwheelWebhook: UpdatePinwheelWebhookPayload;
  /** Updates a Portfolio */
  updatePortfolio: PortfolioMeta;
  /** Update a single profile for a user */
  updateProfile?: Maybe<Profile>;
  updatePromoCode: UpdatePromoCodeResult;
  /** Update the JSON configuration file associated with promoted brands */
  updatePromotedCampaigns?: Maybe<UpdatePromotedCampaignsResult>;
  /** Updates the recurring deposit settings for an investment account. */
  updateRecurringDepositSettings: UpdateRecurringDepositSettingsResult;
  updateReferralCampaign: UpdateReferralCampaignResult;
  updateReferralPayout: UpdateReferralPayoutResult;
  /** Mutation to update referral relationship status */
  updateReferralRelationship: UpdateReferralRelationshipResult;
  /**
   * Update a Referral Reward as Rewarded or Cancelled.
   * Returns UpdateReferralRewardError if given rewardId is not found
   */
  updateReferralRewardStatus: UpdateReferralRewardResponse;
  updateReferralUserProfile?: Maybe<Scalars['ID']['output']>;
  updateRoundUpAccount?: Maybe<RoundUpAccount>;
  updateScope: UpdateScopeResult;
  updateSpendEligibility?: Maybe<UpdateSpendEligibilityPayload>;
  /** Update Tracking Status */
  updateTrackingStatus?: Maybe<CardDeliveryStatus>;
  /** Updates subset of a user's profile */
  updateUserProfile: UpdateUserProfileResponse;
  /** Mutation to update user profile and automation target. */
  updateUserProfileAndAutomationTarget: UpdateUserProfileAndAutomationTargetResult;
  updateVerificationProfile: UpdateVerificationProfileResult;
  /** Upgrade to JWT authentication */
  upgradeAuthentication: UpgradeAuthenticationResult;
  uploadAudienceList: Scalars['String']['output'];
  uploadBankDocument?: Maybe<UploadBankDocumentPayload>;
  /** Uploads signature files for the user to S3 */
  uploadDebitSignatureFile: UploadDebitSignatureFileResponse;
  /** Upload a document from a user */
  uploadDocument: UploadDocumentResponse;
  uploadDocuments: Array<FileOrException>;
  /** Uploads the input data to CorePro/LSB */
  uploadIdologyResponse: IdologyUploadResponse;
  uploadOauthAppImage: UploadOauthAppImageResult;
  /** Upload Socure KYC response data to NBKC */
  uploadSocureResponse: SocureUploadResponse;
  uploadUnsolicitedDocuments: Array<FileOrException>;
  /** @deprecated Creating a transfer will automatically upsert an external account. */
  upsertBankExternalAccount?: Maybe<UpsertBankExternalAccountData>;
  /** Request an MFA token for the provided credentials. */
  validateCredentials: ValidateCredentialsResult;
  vendAuthSession: VendAuthSessionResult;
  /** Verify a beneficiary's SSN given a beneficiary ID */
  verifyBeneficiarySsn: VerifyBeneficiarySsnResult;
  verifyDevice: VerifyDeviceResult;
  verifyIdentityByDocuments: VerifyIdentityByDocumentsResult;
  /**  Verify and create a later account */
  verifyLaterAccountOrError: LaterAccountInfoOrError;
  verifyPasswords: VerifyPasswordsResult;
  /** Verify Rdv for a funding source. */
  verifyRdv: FundingSource;
  voidBankTransactions: VoidBankTransactionsResult;
};


export type MutationAcceptUploadedDocumentArgs = {
  input: AcceptUploadedDocumentInput;
};


export type MutationActivateOauthAppArgs = {
  oauthAppId: Scalars['ID']['input'];
};


export type MutationActivateOauthAppClientArgs = {
  oauthAppClientId: Scalars['ID']['input'];
  oauthAppId: Scalars['ID']['input'];
};


export type MutationAddBankCustomerIdToAccountsArgs = {
  input: AddBankCustomerIdToAccountsInput;
};


export type MutationAddDocumentUrlsArgs = {
  input: AddDocumentUrlsInput;
};


export type MutationAddFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput;
  userId: Scalars['String']['input'];
};


export type MutationAddNoteArgs = {
  input: AddNoteInput;
};


export type MutationAddNoteMultipleUsersArgs = {
  input: AddNoteMultipleUsersInput;
};


export type MutationAddOrRemoveUsersFromSpendWhitelistArgs = {
  input: Array<AddOrRemoveUsersFromSpendWhitelistInput>;
};


export type MutationAddPolicyArgs = {
  input: AddPolicyInput;
};


export type MutationAddSecuritiesArgs = {
  input: AddSecuritiesInput;
};


export type MutationAddTrustedContactArgs = {
  input: TrustedContactInput;
  userId: Scalars['ID']['input'];
};


export type MutationAdminActionCloseArgs = {
  adminActionInput: AdminActionInput;
};


export type MutationAdminActionLockArgs = {
  adminActionInput: AdminActionInput;
  adminNoteInput: AdminActionNoteInput;
};


export type MutationAdminActionMrdcRejectArgs = {
  adminActionInput: AdminActionInput;
};


export type MutationAdminActionPassArgs = {
  adminActionInput: AdminActionInput;
};


export type MutationAnswerChallengeArgs = {
  input: ChallengeAnswerInput;
};


export type MutationApplyPromoCodeArgs = {
  name: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationApplyPromotionArgs = {
  input: ApplyPromotionInput;
};


export type MutationApplyPromotionalWaiverArgs = {
  input: ApplyPromotionalWaiverInput;
  userId: Scalars['ID']['input'];
};


export type MutationApplyProvisionalWaiverArgs = {
  userId: Scalars['ID']['input'];
  waiverPeriodEndDate: Scalars['String']['input'];
  waiverReason: Scalars['String']['input'];
};


export type MutationApproveInvestmentArgs = {
  input: ApproveInvestmentInput;
};


export type MutationArchiveBankCardArgs = {
  input: ArchiveBankCardInput;
};


export type MutationArchiveBankCardByCardIdArgs = {
  input: ArchiveBankCardByCardIdInput;
};


export type MutationArchiveCoreproCustomerArgs = {
  input: ArchiveCoreproCustomerInput;
};


export type MutationAssignAdminAppsArgs = {
  input: AssignAdminAppsInput;
};


export type MutationAssignTrustedContactArgs = {
  investmentAccountIds: Array<Scalars['ID']['input']>;
  trustedContactId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAuthenticateArgs = {
  alternateAuthenticatorId?: InputMaybe<Scalars['ID']['input']>;
  challengeAnswerInput?: InputMaybe<ChallengeAnswerInput>;
  input: AuthenticateInput;
};


export type MutationAuthenticateForFeeNegotiationArgs = {
  input: AuthenticateForFeeNegotiationInput;
};


export type MutationAuthenticateForFeeNegotiationChallengeArgs = {
  input: AuthenticateForFeeNegotiationChallengeInput;
};


export type MutationAuthenticateForFeeNegotiationChallengeMethodArgs = {
  input: AuthenticateForFeeNegotiationChallengeMethodInput;
};


export type MutationBankAdminPurgeDlqArgs = {
  DLQName: Scalars['String']['input'];
};


export type MutationBatchAddTierSubscriptionsArgs = {
  input: BatchAddTierSubscriptionsInput;
};


export type MutationBlockDeviceArgs = {
  input: BlockDeviceInput;
  userId: Scalars['ID']['input'];
};


export type MutationBulkSuspendArgs = {
  input: BulkSuspendInput;
  userEmail: Scalars['Email']['input'];
};


export type MutationBulkVerifyArgs = {
  fileKey: Scalars['String']['input'];
  forceStart?: InputMaybe<Scalars['Boolean']['input']>;
  notifyUser?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCancelBankAccountClosureRequestArgs = {
  input: CancelBankAccountClosureRequestInput;
};


export type MutationCancelCheckPaymentArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCancelDocumentRequestArgs = {
  input: CancelRequestedDocumentInput;
};


export type MutationCancelFundingSourceArgs = {
  input: CancelFundingSourceInput;
};


export type MutationCancelInvestmentArgs = {
  input: CancelInvestmentInput;
};


export type MutationCancelInvestmentAccountClosureRequestArgs = {
  investmentAccountId: Scalars['ID']['input'];
};


export type MutationCancelMoneyAssignmentArgs = {
  input: CancelMoneyAssignmentInput;
  userId: Scalars['ID']['input'];
};


export type MutationCancelRecurringInvestmentArgs = {
  investmentAccountId: Scalars['ID']['input'];
};


export type MutationCancelRecurringTransferArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCancelStatementRunArgs = {
  statementRunId: Scalars['ID']['input'];
};


export type MutationCancelTransactionArgs = {
  input: CancelTransactionInput;
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  securityAnswer?: InputMaybe<SecurityAnswer>;
  userId: Scalars['ID']['input'];
};


export type MutationChangePasswordAuthArgs = {
  input: ChangePasswordInput;
  userId: Scalars['ID']['input'];
};


export type MutationChangeSecuritySymbolArgs = {
  input: ChangeSecuritySymbolInput;
};


export type MutationCloseBankAccountArgs = {
  input: CloseBankAccountInput;
};


export type MutationCloseInvestmentAccountArgs = {
  input: CloseInvestmentAccountInput;
  userId: Scalars['ID']['input'];
};


export type MutationCloseUserAccountArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationConfigureSplitDepositDirectDepositIntentSettingArgs = {
  input: ConfigureSplitDepositDirectDepositIntentSettingInput;
  userId: Scalars['ID']['input'];
};


export type MutationConfigureSplitDepositDirectDepositSettingArgs = {
  input: ConfigureSplitDepositDirectDepositSettingInput;
  userId: Scalars['ID']['input'];
};


export type MutationConsumeUserTokenArgs = {
  userTokenId: Scalars['ID']['input'];
};


export type MutationCreateAcceptanceDocumentArgs = {
  input: CreateAcceptanceDocumentInput;
};


export type MutationCreateAcceptanceDocumentVersionArgs = {
  input: CreateAcceptanceDocumentVersionInput;
};


export type MutationCreateAcceptanceDocumentVersionFilterArgs = {
  input: CreateAcceptanceDocumentVersionFilterInput;
};


export type MutationCreateAuthProfileArgs = {
  input?: InputMaybe<CreateAuthProfileInput>;
  userId: Scalars['ID']['input'];
};


export type MutationCreateAuthenticatedSupportTicketArgs = {
  input: CreateSupportTicketInput;
};


export type MutationCreateBankArgs = {
  input: CreateBankInput;
};


export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput;
};


export type MutationCreateBankTransferArgs = {
  input: CreateBankTransferInput;
};


export type MutationCreateBankTransferFromAccountToProgramArgs = {
  input: CreateBankTransferFromAccountToProgramInput;
};


export type MutationCreateBankTransferFromProgramToAccountArgs = {
  input: CreateBankTransferFromProgramToAccountInput;
};


export type MutationCreateBeneficiaryArgs = {
  custodianId: Scalars['ID']['input'];
  input: BeneficiaryInput;
};


export type MutationCreateBulkProvisionalWaiversArgs = {
  csvUrl: Scalars['String']['input'];
  input: CreateBulkProvisionalWaiversInput;
};


export type MutationCreateDocumentUploadArgs = {
  input: CreateDocumentUploadInput;
};


export type MutationCreateFeeCollectionArgs = {
  amount: Scalars['Float']['input'];
  callbackUrl: Scalars['String']['input'];
  nonce: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateImplicitTokenForUserArgs = {
  input: CreateImplicitTokenForUserInput;
  userId: Scalars['ID']['input'];
};


export type MutationCreateInvestingStrategyRecommendationArgs = {
  input: CreateInvestingStrategyRecommendationInput;
  userId: Scalars['ID']['input'];
};


export type MutationCreateInvestmentArgs = {
  input: CreateInvestmentInput;
};


export type MutationCreateIraDistributionArgs = {
  input: CreateIraDistributionInput;
};


export type MutationCreateJobAlertArgs = {
  alertCriteria: JobAlertCriteriaInput;
  userId: Scalars['String']['input'];
};


export type MutationCreateMightyOakCardWaiverArgs = {
  input: CreateMightyOakCardWaiverInput;
  updateBillingProfileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationCreateOauthAppArgs = {
  input: CreateOauthAppInput;
};


export type MutationCreateOfferArgs = {
  input: CreateOfferInput;
};


export type MutationCreatePortfolioArgs = {
  input: CreatePortfolioInput;
};


export type MutationCreatePortfolioTagArgs = {
  input: CreatePortfolioTagInput;
};


export type MutationCreatePresignedUrlForAdminCsvBucketArgs = {
  bucketCSVInput: BucketCsvInput;
};


export type MutationCreatePromoCodeArgs = {
  input: CreatePromoCodeInput;
};


export type MutationCreatePromoCodeRewardArgs = {
  input: CreatePromoCodeRewardInput;
};


export type MutationCreatePromotionalWaiverArgs = {
  input: CreatePromotionalWaiverInput;
  updateBillingProfileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationCreateProspectUserArgs = {
  input: CreateProspectUserInput;
};


export type MutationCreateProvisionalWaiverArgs = {
  input: CreateProvisionalWaiverInput;
  updateBillingProfileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationCreateReferralCampaignArgs = {
  input: CreateReferralCampaignInput;
};


export type MutationCreateReferralCampaignRewardArgs = {
  input: CreateReferralCampaignRewardInput;
};


export type MutationCreateReferralPayoutArgs = {
  input: CreateReferralPayoutInput;
};


export type MutationCreateReferralRelationshipArgs = {
  referralCode: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateRefundArgs = {
  invoiceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateSavingsAccountArgs = {
  input: CreateSavingsAccountInternalInput;
};


export type MutationCreateScopeArgs = {
  input: CreateScopeInput;
};


export type MutationCreateSubscriptionMigrationArgs = {
  input: CreateSubscriptionMigrationInput;
};


export type MutationCreateSupportTicketArgs = {
  input: CreateSupportTicketInput;
};


export type MutationCreateSupportTicketOrExceptionArgs = {
  input: CreateSupportTicketInput;
};


export type MutationCreateSupportTicketWithCustomFieldsArgs = {
  input: CreateCustomSupportTicketInput;
};


export type MutationCreateSuspendedUserSupportTicketArgs = {
  input: CreateSuspendedUserSupportTicketInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVendorInvoiceArgs = {
  input: CreateVendorInvoiceInput;
  userId: Scalars['ID']['input'];
};


export type MutationCreateVendorLineItemArgs = {
  input: CreateVendorLineItemInput;
  userId: Scalars['ID']['input'];
};


export type MutationDeactivateAccountArgs = {
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeactivateBeneficiaryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeactivateOauthAppArgs = {
  oauthAppId: Scalars['ID']['input'];
};


export type MutationDeactivateOauthAppClientArgs = {
  oauthAppClientId: Scalars['ID']['input'];
  oauthAppId: Scalars['ID']['input'];
};


export type MutationDeactivateSecurityArgs = {
  input: DeactivateSecurityInput;
};


export type MutationDeactivateTierSubscriptionArgs = {
  input: DeactivateTierSubscriptionInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteAcceptanceDocumentVersionFilterArgs = {
  input: DeleteAcceptanceDocumentVersionFilterInput;
};


export type MutationDeleteBankCardOrderArgs = {
  input?: InputMaybe<DeleteBankCardOrderInput>;
};


export type MutationDeleteMightyOakCardWaiverArgs = {
  updateBillingProfileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationDeleteOauthAppArgs = {
  oauthAppId: Scalars['ID']['input'];
};


export type MutationDeletePinwheelWebhookArgs = {
  input: DeletePinwheelWebhookInput;
};


export type MutationDeletePortfolioArgs = {
  input: DeletePortfolioInput;
};


export type MutationDeletePortfolioTagArgs = {
  input: DeletePortfolioTagInput;
};


export type MutationDeletePromotionalWaiverArgs = {
  input: DeletePromotionalWaiverInput;
  updateBillingProfileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationDeleteProvisionalWaiverArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteScopeArgs = {
  identifier: Scalars['String']['input'];
};


export type MutationDeleteTrustedContactArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteUploadArgs = {
  uploadId: Scalars['ID']['input'];
};


export type MutationDeregisterAuthenticatorArgs = {
  input: DeregisterAuthenticatorInput;
  userId: Scalars['ID']['input'];
};


export type MutationDismissMessageArgs = {
  input: DismissMessageInput;
  userId: Scalars['ID']['input'];
};


export type MutationDismissMessagesArgs = {
  input: DismissMessagesInput;
  userId: Scalars['ID']['input'];
};


export type MutationEditTrustedContactArgs = {
  id: Scalars['ID']['input'];
  input: TrustedContactInput;
  userId: Scalars['ID']['input'];
};


export type MutationEvaluateDfaDecisionArgs = {
  input: EvaluateDfaDecisionInput;
};


export type MutationExchangeAcornsEarlyTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationExecuteMoneyInArgs = {
  input: ExecuteMoneyInInput;
};


export type MutationExpirePromotionalWaiverArgs = {
  input: ExpirePromotionalWaiverInput;
  userId: Scalars['ID']['input'];
};


export type MutationFailVendorInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationFlagUserAsSuspiciousArgs = {
  userId: Scalars['String']['input'];
};


export type MutationFlagUserByUserIdArgs = {
  input: FlagUserByUserIdInput;
};


export type MutationForceUpdateAuthPhoneNumberArgs = {
  input: UpdateAuthPhoneNumberInput;
  userId: Scalars['ID']['input'];
};


export type MutationForceUpdateBeneficiaryInfoArgs = {
  id: Scalars['ID']['input'];
  input: BeneficiaryInfoInput;
};


export type MutationGenerateDocumentUploadSessionArgs = {
  input: GenerateDocumentUploadSessionInput;
  userId: Scalars['ID']['input'];
};


export type MutationGenerateReferralCodeArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationGenerateTinFileArgs = {
  type: TinFileType;
};


export type MutationGenerateUserSuspendedUploadTokenArgs = {
  email: Scalars['String']['input'];
};


export type MutationHideMessageArgs = {
  input: HideMessageInput;
  userId: Scalars['ID']['input'];
};


export type MutationHideMessageByExternalIdArgs = {
  input: HideMessageByExternalIdInput;
  userId: Scalars['ID']['input'];
};


export type MutationHotlistBankCardByCardIdArgs = {
  input: HotlistBankCardByCardIdInput;
};


export type MutationInitiateChallengeArgs = {
  input: InitiateChallengeInput;
};


export type MutationInitiateEmailChallengeArgs = {
  input: InitiateEmailChallengeInput;
  userId: Scalars['ID']['input'];
};


export type MutationInitiateLaterProgramAccountContributionArgs = {
  input: LaterProgramAccountContributionInput;
  userId: Scalars['ID']['input'];
};


export type MutationInitiateMoneyAssignmentArgs = {
  input: InitiateMoneyAssignmentInput;
  userId: Scalars['ID']['input'];
};


export type MutationInitiatePushChallengeArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationInitiateSmsChallengeArgs = {
  input: InitiateSmsChallengeInput;
  userId: Scalars['ID']['input'];
};


export type MutationInitiateSpendFunnelClosureArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationInitiateVerificationArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationInvestmentAccountClearCacheArgs = {
  investmentAccountId: Scalars['ID']['input'];
};


export type MutationIssueBankCardArgs = {
  input: IssueBankCardInput;
};


export type MutationIssuePhysicalBankCardArgs = {
  input: IssuePhysicalBankCardInput;
};


export type MutationLaterWithdrawalArgs = {
  amount: Scalars['Float']['input'];
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']['input']>;
  federalTaxes: Scalars['Float']['input'];
  investmentAccountId: Scalars['ID']['input'];
  reason?: InputMaybe<LaterWithdrawalReason>;
  stateTaxes: Scalars['Float']['input'];
  taxYear: Scalars['Int']['input'];
  withdrawalType?: InputMaybe<LaterWithdrawalType>;
};


export type MutationLaterWithdrawalV2Args = {
  amount: Scalars['Float']['input'];
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']['input']>;
  federalTaxes: Scalars['Float']['input'];
  investmentAccountId: Scalars['ID']['input'];
  reason?: InputMaybe<LaterWithdrawalReason>;
  stateTaxes: Scalars['Float']['input'];
  taxYear: Scalars['Int']['input'];
  withdrawalType?: InputMaybe<LaterWithdrawalType>;
};


export type MutationLinkOidcCredentialsArgs = {
  input: LinkOidcCredentialsInput;
  userId: Scalars['ID']['input'];
};


export type MutationLiquidateAccountArgs = {
  input: LiquidateAccountInput;
};


export type MutationLiquidateInvestmentAccountArgs = {
  input: LiquidateInvestmentAccountInput;
};


export type MutationLockBankAccountsArgs = {
  input: LockBankAccountsInput;
};


export type MutationLockBankCardArgs = {
  input: LockBankCardInput;
};


export type MutationLogoutArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationLogoutDeviceArgs = {
  input: LogoutDeviceInput;
  userId: Scalars['ID']['input'];
};


export type MutationMakeFundingSourceUnrecoverableArgs = {
  input: MakeFundingSourceUnrecoverableInput;
};


export type MutationManagePayoutRelationshipArgs = {
  input: ManagePayoutRelationshipInput;
};


export type MutationMarkAllAsReadArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationModifyMoneyAssignmentArgs = {
  input: ModifyMoneyAssignmentInput;
  userId: Scalars['ID']['input'];
};


export type MutationOptInPhoneNumberArgs = {
  phoneNumber: Scalars['PhoneNumber']['input'];
};


export type MutationOrderBankCardArgs = {
  input: OrderBankCardInput;
  userId: Scalars['ID']['input'];
};


export type MutationPinNoteArgs = {
  input: PinNoteInput;
};


export type MutationPostBankFeeNegotiationArgs = {
  linkedAccountId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationPostUserReportedBankFeeRefundArgs = {
  submissionId: Scalars['String']['input'];
  totalRefunds: Scalars['Float']['input'];
  userId: Scalars['String']['input'];
};


export type MutationPreApproveAccountArgs = {
  input: PreApproveAccountInput;
};


export type MutationProcessBankTransferCommandArgs = {
  input: ProcessBankTransferCommandInput;
};


export type MutationProcessCheckTransferCommandArgs = {
  input: ProcessCheckTransferCommandInput;
};


export type MutationProcessIdologyResponseArgs = {
  input: IdologyResponse;
  userId: Scalars['ID']['input'];
};


export type MutationProcessSocureResponseArgs = {
  socureResponse: SocureResponse;
  userId: Scalars['ID']['input'];
};


export type MutationProcessTransferFromProgramAccountArgs = {
  input: ProcessTransferFromProgramAccountInput;
};


export type MutationProcessTransferToProgramAccountArgs = {
  input: ProcessTransferToProgramAccountInput;
};


export type MutationPublishBgpReportArgs = {
  input?: InputMaybe<BgpReportPublishInput>;
};


export type MutationReactivateBeneficiaryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReadMessageArgs = {
  input: ReadMessageInput;
  userId: Scalars['ID']['input'];
};


export type MutationReallocateClosedAccountsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationReconcileStatementRunArgs = {
  statementRunId: Scalars['ID']['input'];
};


export type MutationRecordReferralEventArgs = {
  input: RecordReferralEventInput;
};


export type MutationRecordVendorExternalTransactionArgs = {
  input: RecordVendorExternalTransactionInput;
  invoiceId: Scalars['ID']['input'];
};


export type MutationRefreshAuthTokenArgs = {
  input: RefreshAuthTokenInput;
};


export type MutationRefundBillingCycleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegisterCredentialsArgs = {
  input: RegisterCredentialsInput;
};


export type MutationRegisterDeviceTokenAndPushAuthenticatorArgs = {
  input: RegisterDeviceTokenAndPushAuthenticatorInput;
  userId: Scalars['ID']['input'];
};


export type MutationRegisterEmailAuthenticatorArgs = {
  challengeAnswerInput: ChallengeAnswerInput;
  input: RegisterEmailAuthenticatorInput;
  userId: Scalars['ID']['input'];
};


export type MutationRegisterOidcCredentialsArgs = {
  input: RegisterOidcCredentialsInput;
};


export type MutationRegisterPhoneAuthenticatorArgs = {
  challengeAnswerInput: ChallengeAnswerInput;
  input: RegisterPhoneAuthenticatorInput;
  userId: Scalars['ID']['input'];
};


export type MutationRegisterPhoneAuthenticatorWithoutChallengeArgs = {
  input: RegisterPhoneAuthenticatorInput;
  userId: Scalars['ID']['input'];
};


export type MutationReinitiateChallengeArgs = {
  input: ReinitiateSmsChallengeInput;
};


export type MutationReissueBankCardArgs = {
  input: ReissueBankCardInput;
};


export type MutationRejectUploadedDocumentArgs = {
  input: RejectUploadedDocumentInput;
};


export type MutationReleaseAdminAppArgs = {
  input: ReleaseAdminAppInput;
};


export type MutationReleaseStatementRunArgs = {
  input: ReleaseStatementRunInput;
};


export type MutationRelinkFundingSourceArgs = {
  input: RelinkFundingSourceInput;
};


export type MutationRelinkWithProfitStarsArgs = {
  input: RelinkWithProfitStarsInput;
};


export type MutationRemoveAccountPreApprovalArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput;
  userId: Scalars['String']['input'];
};


export type MutationRemoveJobAlertArgs = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemovePolicyArgs = {
  input: RemovePolicyInput;
};


export type MutationRemoveRequestedDocumentArgs = {
  input: RemoveRequestedDocumentInput;
};


export type MutationReopenAccountForVerificationArgs = {
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationReopenUserAccountArgs = {
  userUuid: Scalars['ID']['input'];
};


export type MutationRequestDocumentArgs = {
  input: RequestDocumentInput;
};


export type MutationRequestDocumentUploadArgs = {
  input: RequestDocumentUploadInput;
};


export type MutationRequestSubscriptionMigrationWaiverArgs = {
  input: RequestSubscriptionMigrationWaiverInput;
  userId: Scalars['ID']['input'];
};


export type MutationResendFilesArgs = {
  date: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetPasswordByTokenArgs = {
  input: ResetPasswordByTokenInput;
};


export type MutationResetPasswordWithTokenArgs = {
  input: ResetPasswordWithTokenInput;
};


export type MutationResetRateLimitArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRestoreLoginAccessArgs = {
  input: RestoreLoginAccessInput;
};


export type MutationReverseInvestmentAccountNegativeBalanceArgs = {
  investmentAccountId: Scalars['ID']['input'];
};


export type MutationReviewDocumentsApproveAddressArgs = {
  uploadId: Scalars['ID']['input'];
};


export type MutationReviewDocumentsMarkReviewedArgs = {
  uploadId: Scalars['ID']['input'];
};


export type MutationRevokeAdminAppsArgs = {
  input: RevokeAdminAppsInput;
};


export type MutationRevokeLoginAccessArgs = {
  input: RevokeLoginAccessInput;
};


export type MutationRevokePasswordResetTokenArgs = {
  input: RevokePasswordResetTokenInput;
};


export type MutationRoundUpProfileArgs = {
  input: RoundUpProfileInput;
  userId: Scalars['ID']['input'];
};


export type MutationRunAccountVerificationArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationScheduleRecurringTransferArgs = {
  input: ScheduleRecurringTransferInput;
  userId: Scalars['ID']['input'];
};


export type MutationSendBrazeEventArgs = {
  input: SendBrazeEventInput;
};


export type MutationSendCheckPaymentArgs = {
  input: SendCheckPaymentInput;
  userId: Scalars['ID']['input'];
};


export type MutationSendCustomerDueDiligenceAnswersToBankingPartnerArgs = {
  input: SendCustomerDueDiligenceAnswersToBankingPartnerInput;
};


export type MutationSendReferralEventArgs = {
  input: ReferralEventInput;
};


export type MutationSessionRefreshArgs = {
  longSession?: InputMaybe<Scalars['Boolean']['input']>;
  pin: Scalars['String']['input'];
};


export type MutationSetAuthenticationPinArgs = {
  input: SetAuthenticationPinInput;
  userId: Scalars['ID']['input'];
};


export type MutationSetDefaultAuthenticatorArgs = {
  input: SetDefaultAuthenticatorInput;
  userId: Scalars['ID']['input'];
};


export type MutationSetDepositHoldArgs = {
  enabled: Scalars['Boolean']['input'];
  investmentAccountId: Scalars['ID']['input'];
};


export type MutationSetFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput;
  userId: Scalars['String']['input'];
};


export type MutationSetManualRoundUpsArgs = {
  roundUpIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationSetNegotiationStatusArgs = {
  input: SetNegotiationStatusInput;
  userId: Scalars['String']['input'];
};


export type MutationSetPinwheelWebhookArgs = {
  input: SetPinwheelWebhookInput;
};


export type MutationSetPrimaryFundingSourceArgs = {
  fundingSourceId: Scalars['ID']['input'];
};


export type MutationSetReferralCampaignFlagsArgs = {
  input: SetReferralCampaignFlagsInput;
};


export type MutationSetRiskModelInReviewArgs = {
  depositModelUuid: Scalars['String']['input'];
  override?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSplitDepositArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSplitDepositSettingsArgs = {
  employerHidden?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationStubArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationSubmitBankFeeNegotiationArgs = {
  input: SubmitBankFeeNegotiationInput;
  userId: Scalars['String']['input'];
};


export type MutationSubmitEarnMissingCreditRequestArgs = {
  input: SubmitEarnMissingCreditRequestInput;
  userId: Scalars['ID']['input'];
};


export type MutationSubmitUserReportedBankFeeRefundArgs = {
  input: SubmitUserReportedBankFeeRefundInput;
  userId: Scalars['String']['input'];
};


export type MutationSubscribeToTierArgs = {
  input: SubscribeToTierInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSubscribeUserToTierArgs = {
  input: SubscribeUserToTierInput;
  userId: Scalars['ID']['input'];
};


export type MutationSubscribeUserToTierByOpenAccountsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationSubscribeUserToTierByProductKeyArgs = {
  input?: InputMaybe<SubscribeUserToTierByProductKeyInput>;
  userId: Scalars['ID']['input'];
};


export type MutationSucceedVendorInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationSuppressMoneyManagerRebalancesArgs = {
  input: SuppressMoneyManagerRebalancesInput;
  userId: Scalars['ID']['input'];
};


export type MutationSuspendDepositsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationSuspendUserArgs = {
  input: SuspendUserInput;
};


export type MutationSuspendUserByUserIdArgs = {
  input: SuspendUserByUserIdInput;
};


export type MutationSyncBankAddressesArgs = {
  input: SyncBankAddressesInput;
};


export type MutationSyncBankCustomerArgs = {
  input: SyncBankCustomerInput;
};


export type MutationSyncBankFeeTransactionsArgs = {
  input: SyncBankFeeTransactionsInput;
  userId: Scalars['String']['input'];
};


export type MutationSyncBankSocialSecurityNumberArgs = {
  input: SyncBankSocialSecurityNumberInput;
};


export type MutationSyncFundingSourceToVendorArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationSyncSupportAccountArgs = {
  input: SyncSupportAccountInput;
};


export type MutationTaxWithholdingAmountsArgs = {
  investmentId: Scalars['ID']['input'];
  totalSharesAmount: CurrencyAmountInput;
};


export type MutationToggleMaintenanceFlagArgs = {
  input: ToggleMaintenanceFlagInput;
};


export type MutationTransferInternalSharesArgs = {
  input: TransferInternalSharesInput;
};


export type MutationTriggerRdvArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUnassignTrustedContactArgs = {
  trustedContactId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUnblockDeviceArgs = {
  input: UnblockDeviceInput;
  userId: Scalars['ID']['input'];
};


export type MutationUnflagUserAsSuspiciousArgs = {
  userId: Scalars['String']['input'];
};


export type MutationUnflagUserByUserIdArgs = {
  input: UnflagUserByUserIdInput;
};


export type MutationUnlinkLinkedAccountArgs = {
  linkedAccountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUnlinkOidcCredentialsArgs = {
  input: UnlinkOidcCredentialsInput;
  userId: Scalars['ID']['input'];
};


export type MutationUnlinkPaypalAccountArgs = {
  input: UnlinkPaypalAccountInput;
};


export type MutationUnlockBankAccountsArgs = {
  input: UnlockBankAccountsInput;
};


export type MutationUnlockBankCardArgs = {
  input: UnlockBankCardInput;
};


export type MutationUnlockUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUnpinNoteArgs = {
  input: UnpinNoteInput;
};


export type MutationUnsubscribeNotificationsArgs = {
  input: UnsubscribeNotificationsInput;
};


export type MutationUnsubscribeUserFromTierArgs = {
  input?: InputMaybe<UnsubscribeUserFromTierInput>;
  userId: Scalars['ID']['input'];
};


export type MutationUnsuspendDepositsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUnsuspendUserArgs = {
  input: UnsuspendUserInput;
};


export type MutationUnsuspendUserByUserIdArgs = {
  input: UnsuspendUserByUserIdInput;
};


export type MutationUpdateAcceptanceDocumentArgs = {
  id: Scalars['ID']['input'];
  input: AcceptanceDocumentInput;
};


export type MutationUpdateAcceptanceDocumentVersionArgs = {
  input: UpdateAcceptanceDocumentVersionInput;
};


export type MutationUpdateAcceptanceDocumentVersionFilterArgs = {
  input: UpdateAcceptanceDocumentVersionFilterInput;
};


export type MutationUpdateAccountPortfolioArgs = {
  input: UpdateAccountPortfolioInput;
};


export type MutationUpdateAddressArgs = {
  addressType: AddressType;
  changedByAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  input: AddressInput;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateAuthEmailArgs = {
  input: UpdateAuthEmailInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateAuthPhoneNumberArgs = {
  input: UpdateAuthPhoneNumberInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateBankAccountArgs = {
  input: UpdateBankAccountInput;
};


export type MutationUpdateBannersArgs = {
  input: UpdateBannersInput;
};


export type MutationUpdateBeneficiaryInfoArgs = {
  id: Scalars['ID']['input'];
  input: BeneficiaryInfoInput;
};


export type MutationUpdateBenefitStatusArgs = {
  input: UpdateBenefitStatusInput;
  userId: Scalars['String']['input'];
};


export type MutationUpdateBillingCycleInvoiceDateArgs = {
  billingDate: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateCheckPaymentRecipientAddressArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCheckPaymentRecipientAddressInputType;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateContributionArgs = {
  investmentUuid: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
};


export type MutationUpdateCredentialsArgs = {
  input: UserCredentialsInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateCustomerAccountClosureArgs = {
  input: UpdateCustomerAccountClosureInput;
};


export type MutationUpdateCustomerMoneyRulesArgs = {
  input: MoneyRulesRulesetInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateDocumentVerificationResponseArgs = {
  input: UpdateDocumentVerificationResponseInput;
};


export type MutationUpdateFundingSourceChangeRequestArgs = {
  input: UpdateFundingSourceChangeInput;
};


export type MutationUpdateHelpcenterBannerArgs = {
  input: HelpcenterContentInput;
};


export type MutationUpdateInvestmentAccountReopenRequestArgs = {
  input: UpdateInvestmentAccountReopenRequestInput;
};


export type MutationUpdateLinkedSubaccountArgs = {
  input: UpdateLinkedSubaccountInput;
  linkedSubaccountId: Scalars['ID']['input'];
};


export type MutationUpdateMaintenanceFlagArgs = {
  input: UpdateMaintenanceFlagInput;
};


export type MutationUpdateMoneyManagerAllocationsArgs = {
  input: UpdateMoneyManagerAllocationsInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateMoneyManagerAutomationTargetArgs = {
  input: UpdateMoneyManagerAutomationTargetInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateMoneyManagerSettingsArgs = {
  input: UpdateMoneyManagerSettingsInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateMoneyRulesArchetypeArgs = {
  input: MoneyRulesRulesetInput;
};


export type MutationUpdateMoneyRulesSourceSettingsArgs = {
  input: UpdateMoneyRulesSourceSettingsInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateNegotiationStatusArgs = {
  negotiationStatusInput: NegotiationStatus;
  userId: Scalars['String']['input'];
};


export type MutationUpdateNextInvoiceDateArgs = {
  billingDate: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateOauthAppArgs = {
  input: UpdateOauthAppInput;
  oauthAppId: Scalars['ID']['input'];
};


export type MutationUpdatePinwheelWebhookArgs = {
  input: UpdatePinwheelWebhookInput;
};


export type MutationUpdatePortfolioArgs = {
  input: UpdatePortfolioInput;
};


export type MutationUpdateProfileArgs = {
  input: ProfileInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdatePromoCodeArgs = {
  input: UpdatePromoCodeInput;
};


export type MutationUpdatePromotedCampaignsArgs = {
  input?: InputMaybe<UpdatePromotedCampaignsInput>;
};


export type MutationUpdateRecurringDepositSettingsArgs = {
  input: RecurringDepositSettingsInput;
};


export type MutationUpdateReferralCampaignArgs = {
  input: UpdateReferralCampaignInput;
};


export type MutationUpdateReferralPayoutArgs = {
  input: UpdateReferralPayoutInput;
};


export type MutationUpdateReferralRelationshipArgs = {
  input: UpdateReferralRelationshipInput;
};


export type MutationUpdateReferralRewardStatusArgs = {
  rewardId: Scalars['ID']['input'];
  rewardStatus: ReferralRewardUpdateStatus;
};


export type MutationUpdateReferralUserProfileArgs = {
  email: Scalars['String']['input'];
  updateInfo: ReferralUserUpdateInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateRoundUpAccountArgs = {
  enabled: Scalars['Boolean']['input'];
  linkedSubaccountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateScopeArgs = {
  identifier: Scalars['String']['input'];
  input: UpdateScopeInput;
};


export type MutationUpdateSpendEligibilityArgs = {
  input: UpdateSpendEligibilityInput;
};


export type MutationUpdateTrackingStatusArgs = {
  input: UpdateTrackingStatusInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpdateUserProfileAndAutomationTargetArgs = {
  input: UpdateUserProfileAndAutomationTargetInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateVerificationProfileArgs = {
  input: VerificationProfileInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpgradeAuthenticationArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUploadAudienceListArgs = {
  input: UploadAudienceListInput;
};


export type MutationUploadBankDocumentArgs = {
  input: UploadBankDocumentInput;
};


export type MutationUploadDebitSignatureFileArgs = {
  coreproCardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUploadDocumentArgs = {
  input: UploadDocumentInput;
};


export type MutationUploadDocumentsArgs = {
  input: UploadDocumentsInput;
};


export type MutationUploadIdologyResponseArgs = {
  input: IdologyUpload;
  userId: Scalars['ID']['input'];
};


export type MutationUploadOauthAppImageArgs = {
  contentType: Scalars['String']['input'];
  oauthAppClientId?: InputMaybe<Scalars['ID']['input']>;
  oauthAppId: Scalars['ID']['input'];
};


export type MutationUploadSocureResponseArgs = {
  input: SocureUpload;
  userId: Scalars['ID']['input'];
};


export type MutationUploadUnsolicitedDocumentsArgs = {
  input: UploadUnsolicitedDocumentsInput;
};


export type MutationUpsertBankExternalAccountArgs = {
  input: UpsertBankExternalAccountInput;
};


export type MutationValidateCredentialsArgs = {
  input: ValidateCredentialsInput;
};


export type MutationVendAuthSessionArgs = {
  input: VendAuthSessionInput;
};


export type MutationVerifyBeneficiarySsnArgs = {
  id: Scalars['ID']['input'];
};


export type MutationVerifyDeviceArgs = {
  challengeAnswerInput?: InputMaybe<ChallengeAnswerInput>;
  input: VerifyDeviceInput;
};


export type MutationVerifyIdentityByDocumentsArgs = {
  input: ValidateDocumentsInput;
  userId: Scalars['ID']['input'];
};


export type MutationVerifyLaterAccountOrErrorArgs = {
  investmentAccountId: Scalars['ID']['input'];
};


export type MutationVerifyPasswordsArgs = {
  input: VerifyPasswordsInput;
  userId: Scalars['ID']['input'];
};


export type MutationVerifyRdvArgs = {
  input: VerifyRdvInput;
};


export type MutationVoidBankTransactionsArgs = {
  input: VoidBankTransactionsInput;
};

export type NativeLoginInput = {
  email: Scalars['EmailAddress']['input'];
  password: Scalars['String']['input'];
};

/** There is no funding source attached to this account.  Please attach one to complete liquidation. */
export type NeedFundingSourceException = {
  __typename?: 'NeedFundingSourceException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export enum NegotiationMethod {
  Automatic = 'AUTOMATIC',
  Letter = 'LETTER'
}

export type NegotiationServiceConnectionFailure = {
  __typename?: 'NegotiationServiceConnectionFailure';
  message: Scalars['String']['output'];
};

export type NegotiationStatus = {
  negotiationMethod: NegotiationType;
  operator: Scalars['String']['input'];
  refundAmount?: InputMaybe<Scalars['Float']['input']>;
  status: BankFeeNegotiationInternalStatus;
  submissionId: Scalars['ID']['input'];
};

export enum NegotiationType {
  AutomatedNegotiation = 'AUTOMATED_NEGOTIATION',
  MailInNegotiation = 'MAIL_IN_NEGOTIATION'
}

export enum NetTermsType {
  Eom = 'eom',
  Net = 'net'
}

/** The next billing date for a user */
export type NextBillingDate = {
  __typename?: 'NextBillingDate';
  next_billing_date?: Maybe<Scalars['String']['output']>;
};

export type NextTransferDateResult = MalformedRecurringTransferException | RecurringTransferDate;

/** There are no billing cycles found that are eligible for this update. */
export type NoEligibleBillingCyclesException = {
  __typename?: 'NoEligibleBillingCyclesException';
  /** message */
  message: Scalars['String']['output'];
};

/** No Funding Source Alert. */
export type NoFundingSourceUserAlert = UserAlertsItem & {
  __typename?: 'NoFundingSourceUserAlert';
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

export type NoRegisteredPushAuthenticatorsException = {
  __typename?: 'NoRegisteredPushAuthenticatorsException';
  userId: Scalars['ID']['output'];
};

/** The user needs to close all other investment accounts before closing this account */
export type NonBasicAccountOpenException = {
  __typename?: 'NonBasicAccountOpenException';
  /** message */
  errorMessage?: Maybe<Scalars['String']['output']>;
};

/** Cannot create an IRA Distribution for a non Individual Retirement investment account */
export type NonRetirementAccountError = {
  __typename?: 'NonRetirementAccountError';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Returned when one or more singleRuleId's are not unique */
export type NonUniqueSingleRuleIdsError = {
  __typename?: 'NonUniqueSingleRuleIdsError';
  message: Scalars['String']['output'];
};

/** Optional note title and body for bulk suspensions */
export type NoteDetailsInput = {
  /** Note body */
  noteBody?: InputMaybe<Scalars['String']['input']>;
  /** Note title */
  noteTitle?: InputMaybe<Scalars['String']['input']>;
};

/** No note was found for the ID provided */
export type NoteNotFoundException = {
  __typename?: 'NoteNotFoundException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
  /** The provided note id */
  noteId: Scalars['ID']['output'];
};

export enum NotificationChannel {
  /** Email notifications */
  Email = 'email'
}

export type NotificationMessage = Message & {
  __typename?: 'NotificationMessage';
  body: MessageTextAsset;
  createdAt: Scalars['DateTime']['output'];
  deepLink?: Maybe<Scalars['URL']['output']>;
  externalId: Scalars['ID']['output'];
  icon?: Maybe<MessageVisualAsset>;
  id: Scalars['ID']['output'];
  isDismissed: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  messageCategory: MessageCategory;
  messageType: MessageType;
  platforms: Array<Platform>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  title: MessageTextAsset;
  trackingId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OauthApp = {
  __typename?: 'OauthApp';
  accessTokenAudience: Array<Maybe<Scalars['String']['output']>>;
  accessTokenExpiry?: Maybe<Scalars['Int']['output']>;
  active: Scalars['Boolean']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  externalApp: Scalars['Boolean']['output'];
  imageUri: Scalars['String']['output'];
  name: Scalars['String']['output'];
  oauthAppId: Scalars['ID']['output'];
  pageType: Scalars['String']['output'];
  redirectUri?: Maybe<Scalars['String']['output']>;
  refreshTokenExpiry?: Maybe<Scalars['Int']['output']>;
  scopes: Array<OauthAppScope>;
  secret?: Maybe<Scalars['String']['output']>;
  type: OauthAppType;
  updatedAt: Scalars['DateTime']['output'];
};

export type OauthAppClient = {
  __typename?: 'OauthAppClient';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  imageUri: Scalars['String']['output'];
  name: Scalars['String']['output'];
  oauthAppClientId: Scalars['ID']['output'];
  oauthAppId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OauthAppClientNotFoundException = {
  __typename?: 'OauthAppClientNotFoundException';
  oauthAppClientId: Scalars['ID']['output'];
};

export type OauthAppImageUpload = {
  __typename?: 'OauthAppImageUpload';
  expiresAt: Scalars['DateTime']['output'];
  uploadUrl: Scalars['URL']['output'];
};

export type OauthAppNotFoundException = {
  __typename?: 'OauthAppNotFoundException';
  oauthAppId: Scalars['ID']['output'];
};

export type OauthAppScope = {
  __typename?: 'OauthAppScope';
  description?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export enum OauthAppType {
  Aggregator = 'AGGREGATOR',
  Partner = 'PARTNER'
}

export type Offer = {
  __typename?: 'Offer';
  /**
   * Meta field enabling clients to delegate to the backend
   * more logic determining when it is valid to present the Offer.
   *
   * Examples: "SUBSCRIPTION_CANCELLATION", "PASSIONS_PRODUCT_EXPLORATION"
   */
  availableIn?: Maybe<Array<Scalars['String']['output']>>;
  /** The cohort of subscribers the Offer is available to (driven by the Offer type). */
  availableTo: OfferAvailability;
  createdAt: Scalars['DateTime']['output'];
  /** Once subscribed to how long is the Offer valid for. */
  expiresAfter?: Maybe<OfferExpiration>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** What the Offer entitles a subscriber access to. */
  offering: Offering;
  /** Amount the subscriber agrees to pay for access to the Offer's offering. */
  price: OfferPrice;
  /** URL to the terms and conditions of the Offer. */
  termsUrl: Scalars['URL']['output'];
  /** Indicates semantics of the Offer (generally whom it is available to and when). */
  type: OfferType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OfferAvailability {
  All = 'ALL',
  Cancelled = 'CANCELLED',
  Existing = 'EXISTING',
  New = 'NEW',
  None = 'NONE'
}

export type OfferExpiration = {
  __typename?: 'OfferExpiration';
  period: OfferExpirationPeriod;
  value: Scalars['Int']['output'];
};

export enum OfferExpirationPeriod {
  Month = 'MONTH'
}

export enum OfferGroupsType {
  Category = 'CATEGORY',
  Ranked = 'RANKED'
}

export type OfferLocation = {
  __typename?: 'OfferLocation';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type OfferLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type OfferPrice = {
  __typename?: 'OfferPrice';
  amount: CurrencyAmount;
  type: OfferPriceType;
};

export type OfferPriceInput = {
  amount: CurrencyAmountInput;
  type: OfferPriceType;
};

export enum OfferPriceType {
  Free = 'FREE',
  Monthly = 'MONTHLY'
}

export enum OfferType {
  Promotional = 'PROMOTIONAL',
  Standard = 'STANDARD'
}

/** An Offering is something that a subscriber subscribes to access to. */
export type Offering = Product | Tier;

export type OidcCredentialsAlreadyLinkedException = {
  __typename?: 'OidcCredentialsAlreadyLinkedException';
  subId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type OidcCredentialsNotFoundException = {
  __typename?: 'OidcCredentialsNotFoundException';
  oidcProvider?: Maybe<OidcProvider>;
  userId: Scalars['ID']['output'];
};

export type OidcCredentialsTakenException = {
  __typename?: 'OidcCredentialsTakenException';
  subId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type OidcLoginInput = {
  idToken: Scalars['String']['input'];
  nonce: Scalars['String']['input'];
};

export enum OidcProvider {
  Apple = 'APPLE'
}

export type OmnibusShareTransferId = {
  __typename?: 'OmnibusShareTransferId';
  value: Scalars['String']['output'];
};

export type OnboardingBenefitsInput = {
  product?: InputMaybe<OnboardingProducts>;
};

export enum OnboardingGroups {
  Family = 'FAMILY',
  Future = 'FUTURE',
  Security = 'SECURITY'
}

export type OnboardingProductStatus = {
  __typename?: 'OnboardingProductStatus';
  claimStatus: ClaimStatus;
  claimedOn?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<Maybe<ClaimStatusDetails>>>;
  expiresOn?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['String']['output']>;
};

export type OnboardingProductTile = {
  __typename?: 'OnboardingProductTile';
  claimDetails: OnboardingProductStatus;
  product: OnboardingProducts;
  status: BenefitProductStatus;
};

export enum OnboardingProducts {
  BenefitsGohenryStandard = 'BENEFITS_GOHENRY_STANDARD',
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsTaxfilingStandard = 'BENEFITS_TAXFILING_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
  Early = 'EARLY',
  Earn = 'EARN',
  EarnChoice = 'EARN_CHOICE',
  EarnPrime = 'EARN_PRIME',
  EmergencyFund = 'EMERGENCY_FUND',
  Invest = 'INVEST',
  Later = 'LATER',
  LaterMatch = 'LATER_MATCH',
  SelfDirectedInvest = 'SELF_DIRECTED_INVEST',
  Spend = 'SPEND'
}

export type OnboardingTileGroup = {
  __typename?: 'OnboardingTileGroup';
  group: OnboardingGroups;
  products?: Maybe<Array<Maybe<OnboardingProductTile>>>;
};

export enum OperationStage {
  AuthCompleted = 'AUTH_COMPLETED',
  AuthFailed = 'AUTH_FAILED',
  AwaitingTfaCode = 'AWAITING_TFA_CODE',
  AwaitingTfaOption = 'AWAITING_TFA_OPTION',
  ProcessingCredentials = 'PROCESSING_CREDENTIALS',
  ProcessingTfaCode = 'PROCESSING_TFA_CODE',
  ProcessingTfaOption = 'PROCESSING_TFA_OPTION'
}

export type OpsCode = {
  __typename?: 'OpsCode';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  type: OpsCodeType;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type OpsCodeFilterInput = {
  type?: InputMaybe<OpsCodeType>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum OpsCodeType {
  Lock = 'LOCK',
  MrdcReject = 'MRDC_REJECT',
  MrdcReview = 'MRDC_REVIEW',
  Pass = 'PASS'
}

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderBankCardInput = {
  bankCardTier?: InputMaybe<BankCardTier>;
  bankType?: InputMaybe<BankType>;
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  isDocumentsAccepted: Scalars['Boolean']['input'];
  isReopen?: InputMaybe<Scalars['Boolean']['input']>;
  paymentProcessor?: InputMaybe<BankCardPaymentProcessor>;
  prefundTransfer?: InputMaybe<BankCardPrefundTransfer>;
  requestVersion?: InputMaybe<RequestVersions>;
};

export type OrderBankCardResult = BankCardOrder;

export enum OrderByTypes {
  /** Sort order by ascending */
  Asc = 'ASC',
  /** Sort order by descending */
  Desc = 'DESC'
}

export enum Origin {
  ExternalGiftCard = 'external_gift_card',
  Prepayment = 'prepayment'
}

/** Object representing an outside contribution prospect */
export type OutsideContributionProspect = Prospect & {
  __typename?: 'OutsideContributionProspect';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Attempted to liquidate Later account with balance over current residual threshold. */
export type OverThresholdLaterAccountLiquidationAttemptedException = {
  __typename?: 'OverThresholdLaterAccountLiquidationAttemptedException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type OverrideInput = {
  originalAutoAdd?: InputMaybe<Scalars['ID']['input']>;
  originalFallback?: InputMaybe<Scalars['ID']['input']>;
  originalQa?: InputMaybe<Scalars['ID']['input']>;
};

export enum PackageStatus {
  /** Available for Pickup */
  AvailableForPickup = 'availableForPickup',
  /** Customer Recall */
  CustomerRecall = 'customerRecall',
  /** Dead Letter */
  DeadLetter = 'deadLetter',
  /** Delivered */
  Delivered = 'delivered',
  /** Delivery Status Not Updated */
  DeliveryStatusNotUpdated = 'deliveryStatusNotUpdated',
  /** Forwarded to New Address */
  ForwardedToNewAddress = 'forwardedToNewAddress',
  /** Logged at USPS */
  LoggedAtUsps = 'loggedAtUSPS',
  /** New Item */
  NewItem = 'newItem',
  /** Found – No Status */
  NoStatus = 'noStatus',
  /** Not Found */
  NotFound = 'notFound',
  /** Notice Left for Recipient */
  NoticeLeftForRecipient = 'noticeLeftForRecipient',
  /** Other */
  Other = 'other',
  /** Out for Delivery */
  OutForDelivery = 'outForDelivery',
  /** Returned to Sender */
  ReturnedToSender = 'returnedToSender',
  /** Scanned in Route */
  ScannedInRoute = 'scannedInRoute',
  /** Undeliverable */
  Undeliverable = 'undeliverable'
}

/** Pagination meta information about the current response */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Indicates records exist after the given cursor */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates records exist before the given cursor */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Number of records returned in the response */
  limit: Scalars['Int']['output'];
};

/** Pagination input to fetch pages of records */
export type PageInput = {
  /** Cursor to fetch records starting after */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** How many records to return */
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerOfferGroup = {
  __typename?: 'PartnerOfferGroup';
  /** display body for the group */
  body?: Maybe<Scalars['String']['output']>;
  carouselType: CarouselType;
  id: Scalars['ID']['output'];
  /** list of offers in the group */
  offers: Array<PartnerOfferGroupItem>;
  /** display title for the group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Used to customize offer group contents */
export type PartnerOfferGroupFilterInput = {
  /** Location is required for job offers */
  location?: InputMaybe<OfferLocationInput>;
};

export type PartnerOfferGroupItem = EarnOffer | JobOffer | JobSearchOffer | PromoOffer;

/** Specifies the offer group type input */
export type PartnerOfferGroupsTypeInput = {
  type: OfferGroupsType;
};

export enum PasswordResetErrors {
  InvalidPasswordLength = 'INVALID_PASSWORD_LENGTH',
  InvalidPasswordMissingLowerCase = 'INVALID_PASSWORD_MISSING_LOWER_CASE',
  InvalidPasswordMissingNumber = 'INVALID_PASSWORD_MISSING_NUMBER',
  InvalidPasswordMissingSpecialCharacter = 'INVALID_PASSWORD_MISSING_SPECIAL_CHARACTER',
  InvalidPasswordMissingUpperCase = 'INVALID_PASSWORD_MISSING_UPPER_CASE',
  InvalidSsn = 'INVALID_SSN',
  NewPasswordMatchesOldPassword = 'NEW_PASSWORD_MATCHES_OLD_PASSWORD',
  PasswordsDoNotMatch = 'PASSWORDS_DO_NOT_MATCH'
}

export type PasswordResetForm = {
  __typename?: 'PasswordResetForm';
  fields: Array<Maybe<PasswordResetFormFields>>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type PasswordResetFormFields = {
  __typename?: 'PasswordResetFormFields';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PastItem = {
  amount?: Maybe<CurrencyAmount>;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PastItemConnection = {
  __typename?: 'PastItemConnection';
  edges: Array<PastItemEdge>;
  pageInfo: PageInfo;
};

export type PastItemEdge = {
  __typename?: 'PastItemEdge';
  cursor: Scalars['ID']['output'];
  node?: Maybe<PastItem>;
};

export enum PastItemStatus {
  Complete = 'complete',
  Pending = 'pending',
  Selling = 'selling',
  Transferring = 'transferring'
}

export type PastLaterSummary = {
  __typename?: 'PastLaterSummary';
  contributions: CurrencyAmount;
  currentYearContributions: CurrencyAmount;
  dividends: CurrencyAmount;
  netReturns: CurrencyAmount;
  priorYearContributions: CurrencyAmount;
  withdrawals: CurrencyAmount;
};

export type PastTargetedTransferItem = {
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
};

export type PastUserTransferItem = {
  estimatedCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
};

/** Supported payment methods for a withdrawal created from Admin */
export enum PaymentMethod {
  Ach = 'ACH',
  Check = 'CHECK',
  Dc = 'DC',
  Hold = 'HOLD',
  Internal = 'INTERNAL',
  Paypal = 'PAYPAL',
  Spend = 'SPEND',
  Wire = 'WIRE'
}

export type PayoutRelationshipResult = {
  __typename?: 'PayoutRelationshipResult';
  action?: Maybe<ManagePayoutRelationshipAction>;
  result?: Maybe<ManagePayoutRelationshipResult>;
};

/** There is a pending investment on this account.  Liquidation not available at this time. */
export type PendingInvestmentException = {
  __typename?: 'PendingInvestmentException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Account has uncancelable pending investment(s). Liquidation not available at this time. */
export type PendingInvestmentsException = {
  __typename?: 'PendingInvestmentsException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Performance values for a given Investment Account */
export type Performance = {
  __typename?: 'Performance';
  /** Investment account values based on previous market day's closing prices */
  accountValues?: Maybe<Array<Maybe<AccountValue>>>;
  /** The dollar change in account value over the reporting period */
  marketChange?: Maybe<Scalars['Float']['output']>;
  /** The percentage change in account value over the reporting period */
  marketChangePercent?: Maybe<Scalars['Float']['output']>;
  /** The percentage change in account value over the reporting period (excluding fees) */
  marketChangePercentWithoutFees?: Maybe<Scalars['Float']['output']>;
  /** The dollar change in account value over the reporting period (excluding fees) */
  marketChangeWithoutFees?: Maybe<Scalars['Float']['output']>;
  /** Investment account value based on previous market day's closing prices */
  previousCloseAmount?: Maybe<Scalars['Float']['output']>;
  /**
   * The total dollar amount invested over the reporting period
   * @deprecated Will not be supported in the future
   */
  totalInvested?: Maybe<Scalars['Float']['output']>;
  /**
   * The total dollar amount invested over the reporting period (including pending investments)
   * @deprecated Will not be supported in the future
   */
  totalInvestedWithPending?: Maybe<Scalars['Float']['output']>;
};

/** User calculations Performance Calculation */
export type PerformanceCalculation = {
  __typename?: 'PerformanceCalculation';
  ninetyDayPerformanceCalculator?: Maybe<PerformanceIntervalCalculation>;
  sinceInceptionPerformanceCalculator?: Maybe<PerformanceIntervalCalculation>;
  thirtyDayPerformanceCalculator?: Maybe<PerformanceIntervalCalculation>;
  ytdPerformanceCalculator?: Maybe<PerformanceIntervalCalculation>;
};

/** User Performance Interval Calculation */
export type PerformanceIntervalCalculation = {
  __typename?: 'PerformanceIntervalCalculation';
  marketChange?: Maybe<MonetaryAmount>;
  marketChangePercent?: Maybe<Scalars['Float']['output']>;
  marketChangePercentWithoutFees?: Maybe<Scalars['Float']['output']>;
  marketChangeWithoutFees?: Maybe<MonetaryAmount>;
  periodTotalBalanceChange?: Maybe<MonetaryAmount>;
  periodTotalContributions?: Maybe<MonetaryAmount>;
  periodTotalDividends?: Maybe<MonetaryAmount>;
  periodTotalFees?: Maybe<MonetaryAmount>;
  periodTotalInvested?: Maybe<MonetaryAmount>;
  periodTotalWithdrawn?: Maybe<MonetaryAmount>;
  previousBalancePlusPeriodInvested?: Maybe<MonetaryAmount>;
};

/** Miscellaneous attributes and information about a user's phone numbers */
export type Phone = TimestampsInterface & {
  __typename?: 'Phone';
  /** Country code */
  countryCode: Scalars['String']['output'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Internal ID for phone */
  id: Scalars['ID']['output'];
  /** Phone Number */
  phoneNumber: Scalars['String']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Internal ID for user */
  userId: Scalars['ID']['output'];
  /** Phone has been verified */
  verified: Scalars['Boolean']['output'];
};

export type PhoneAuthenticator = Authenticator & {
  __typename?: 'PhoneAuthenticator';
  createdAt: Scalars['DateTime']['output'];
  deviceId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastAuthenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['PhoneNumber']['output'];
  type: AuthType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PhoneNumberOptedOutException = {
  __typename?: 'PhoneNumberOptedOutException';
  message?: Maybe<Scalars['String']['output']>;
};

/** Input to pin note by setting pinned_at */
export type PinNoteInput = {
  /** Note id to update */
  noteId: Scalars['ID']['input'];
};

/** Response of pinning a note */
export type PinNoteResponse = NoteNotFoundException | UserNote;

/** A Pinwheel webhook */
export type PinwheelWebhook = {
  __typename?: 'PinwheelWebhook';
  /** When the pinwheel webhook was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The list of events enabled for this webhook */
  enabledEvents: Array<EnabledPinwheelEvent>;
  /** ID of the webhook */
  id: Scalars['ID']['output'];
  /** Status of the webhook */
  status: PinwheelWebhookStatus;
  /** URL endpoint of the webhook */
  url: Scalars['String']['output'];
};

export enum PinwheelWebhookStatus {
  Active = 'active',
  Paused = 'paused'
}

/** Plaid account information */
export type PlaidAccount = {
  __typename?: 'PlaidAccount';
  /** External id of the account */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Balances for the account */
  balances?: Maybe<PlaidBalance>;
  /** Last 4 digits of the account number */
  mask?: Maybe<Scalars['String']['output']>;
  /** Name of the account */
  name?: Maybe<Scalars['String']['output']>;
  /** Official name of the account */
  officialName?: Maybe<Scalars['String']['output']>;
  /** Subtype of the account */
  subtype?: Maybe<Scalars['String']['output']>;
  /** Type of the account */
  type?: Maybe<Scalars['String']['output']>;
};

/** Identity match data for a Plaid account */
export type PlaidAccountIdentityMatch = {
  __typename?: 'PlaidAccountIdentityMatch';
  /** Plaid's unique identifier for the account. */
  accountId: Scalars['String']['output'];
  /** Match score for address. */
  address?: Maybe<PlaidIdentityMatchAddressScore>;
  /** Balance information for the account. */
  balances: PlaidBalance;
  /** Match score for email address. */
  emailAddress?: Maybe<PlaidIdentityMatchScore>;
  /** Match score for legal name. */
  legalName?: Maybe<PlaidIdentityMatchLegalNameScore>;
  /** The last 2-4 alphanumeric characters of an account number. */
  mask?: Maybe<Scalars['String']['output']>;
  /** The name of the account. */
  name: Scalars['String']['output'];
  /** The official name of the account. */
  officialName?: Maybe<Scalars['String']['output']>;
  /** Match score for phone number. */
  phoneNumber?: Maybe<PlaidIdentityMatchScore>;
  /** The subtype of the account (e.g., checking, savings). */
  subtype?: Maybe<Scalars['String']['output']>;
  /** The type of account (e.g., depository, credit). */
  type: Scalars['String']['output'];
};

/** Plaid address information */
export type PlaidAddress = {
  __typename?: 'PlaidAddress';
  /** Accounts for an address */
  accounts?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  /** Primary address */
  primary?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Plaid balance information */
export type PlaidBalance = {
  __typename?: 'PlaidBalance';
  /** amount of funds available to be withdrawn from an account */
  available?: Maybe<Scalars['Float']['output']>;
  /** amount of funds currently in the account */
  current?: Maybe<Scalars['Float']['output']>;
  /** The ISO currency code. */
  isoCurrencyCode?: Maybe<Scalars['String']['output']>;
  /** Timestamp of last balance update. */
  lastUpdatedDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** limit amount of the account. i.e. credit card limit */
  limit?: Maybe<Scalars['Float']['output']>;
  /** The unofficial currency code. */
  unofficialCurrencyCode?: Maybe<Scalars['String']['output']>;
};

/** Plaid email information */
export type PlaidEmail = {
  __typename?: 'PlaidEmail';
  email?: Maybe<Scalars['String']['output']>;
  /** Email addresss */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Whether this is the primary email */
  primary?: Maybe<Scalars['Boolean']['output']>;
  /** Type of email */
  type?: Maybe<Scalars['String']['output']>;
};

/** Plaid identity information */
export type PlaidIdentity = {
  __typename?: 'PlaidIdentity';
  /** Plaid accounts */
  accounts?: Maybe<Array<PlaidAccount>>;
  /** Plaid addresses */
  addresses?: Maybe<Array<PlaidAddress>>;
  /** Plaid emails */
  emails?: Maybe<Array<PlaidEmail>>;
  /** Plaid names */
  names?: Maybe<Array<Scalars['String']['output']>>;
  /** Plaid phone numbers */
  phoneNumbers?: Maybe<Array<PlaidPhoneNumber>>;
};

/** Input for address data for Plaid identity match */
export type PlaidIdentityMatchAddressInput = {
  /** The full city name */
  city: Scalars['String']['input'];
  /** The ISO 3166-1 alpha-2 country code */
  country: Scalars['String']['input'];
  /** The postal code */
  postalCode: Scalars['String']['input'];
  /** The region or state */
  region: Scalars['String']['input'];
  /** The full street address */
  street: Scalars['String']['input'];
};

/** Score for address in Plaid identity match */
export type PlaidIdentityMatchAddressScore = {
  __typename?: 'PlaidIdentityMatchAddressScore';
  /** Whether the postal code matched. */
  isPostalCodeMatch?: Maybe<Scalars['Boolean']['output']>;
  /** Match score for the field. 100 is a perfect score. */
  score?: Maybe<Scalars['Int']['output']>;
};

/** Input for Plaid identity match */
export type PlaidIdentityMatchInput = {
  /** The ID of the linked account. */
  linkedAccountId: Scalars['ID']['input'];
  /** An optional object to filter /identity/match results. */
  options?: InputMaybe<PlaidIdentityMatchOptionsInput>;
  /** The user's PII for matching. */
  user?: InputMaybe<PlaidIdentityMatchUserInput>;
};

/** Score for legal name in Plaid identity match */
export type PlaidIdentityMatchLegalNameScore = {
  __typename?: 'PlaidIdentityMatchLegalNameScore';
  /** Whether a business name was detected. */
  isBusinessNameDetected?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the first or last name matched. */
  isFirstNameOrLastNameMatch?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a nickname matched. */
  isNicknameMatch?: Maybe<Scalars['Boolean']['output']>;
  /** Match score for the field. 100 is a perfect score. */
  score?: Maybe<Scalars['Int']['output']>;
};

/** Input for options for Plaid identity match */
export type PlaidIdentityMatchOptionsInput = {
  /** A list of account_ids to retrieve for the Item. */
  accountIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Response from Plaid identity match */
export type PlaidIdentityMatchResponse = {
  __typename?: 'PlaidIdentityMatchResponse';
  /** The accounts for which Identity match has been requested. */
  accounts: Array<PlaidAccountIdentityMatch>;
  /** Metadata about the Item. */
  item: PlaidItem;
  /** A unique identifier for the request. */
  requestId: Scalars['String']['output'];
};

/** Returns Plaid identity match data or error */
export type PlaidIdentityMatchResult = LinkedAccountNotFoundError | PlaidIdentityMatchResponse;

/** Score for a specific field in Plaid identity match */
export type PlaidIdentityMatchScore = {
  __typename?: 'PlaidIdentityMatchScore';
  /** Match score for the field. 100 is a perfect score. */
  score?: Maybe<Scalars['Int']['output']>;
};

/** Input for user data for Plaid identity match */
export type PlaidIdentityMatchUserInput = {
  /** The user's address. */
  address?: InputMaybe<PlaidIdentityMatchAddressInput>;
  /** The user's email address. */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** The user's full legal name. */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** The user's phone number, in E.164 format. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Metadata about the Plaid Item */
export type PlaidItem = {
  __typename?: 'PlaidItem';
  /** A list of products available for the Item. */
  availableProducts?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of products that have been billed for the Item. */
  billedProducts?: Maybe<Array<Scalars['String']['output']>>;
  /** Error message if any. */
  error?: Maybe<Scalars['String']['output']>;
  /** The Plaid Institution ID. */
  institutionId?: Maybe<Scalars['String']['output']>;
  /** The name of the institution. */
  institutionName?: Maybe<Scalars['String']['output']>;
  /** The Plaid Item ID. */
  itemId: Scalars['String']['output'];
};

/** Plaid phone numbers information */
export type PlaidPhoneNumber = {
  __typename?: 'PlaidPhoneNumber';
  /** Phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Whether this is the primary phone number */
  primary?: Maybe<Scalars['Boolean']['output']>;
  /** Type of phone number */
  type?: Maybe<Scalars['String']['output']>;
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Undefined = 'UNDEFINED',
  Web = 'WEB'
}

export type PoliciesRecordDoesNotExistException = {
  __typename?: 'PoliciesRecordDoesNotExistException';
  policyInput?: Maybe<Scalars['String']['output']>;
};

export type Policy = {
  __typename?: 'Policy';
  name: Scalars['String']['output'];
};

export type PolicyNotAddedException = {
  __typename?: 'PolicyNotAddedException';
  policyInput?: Maybe<Scalars['String']['output']>;
};

/** Acorns Managed Portfolio Object */
export type Portfolio = BasePortfolio & {
  __typename?: 'Portfolio';
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation;
  cashOwed: MonetaryAmount;
  currentAllocationPercentage: Scalars['Float']['output'];
  currentBalance: MonetaryAmount;
  currentBalanceWithPending: MonetaryAmount;
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel?: Maybe<PortfolioCustomizationLevel>;
  /** Description of the portfolio */
  description: Scalars['String']['output'];
  /**
   * Indicates the ETFs that the portfolio is composed of
   * @deprecated Use BasePortfolio.portfolioSecurityAllocations instead
   */
  etfs?: Maybe<Array<Etf>>;
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount).
   * @deprecated Use Portfolio.portfolioSecurities instead.
   */
  holdings?: Maybe<Array<PortfolioHolding>>;
  /** ID of the Portfolio */
  id: Scalars['ID']['output'];
  /** Indicates the minimum ratio that must be allocated to the managed portfolio */
  minimumManagedAllocationPercent: Scalars['Float']['output'];
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']['output'];
  /** Indicates a key based off of the portfolio name */
  nameKey: Scalars['String']['output'];
  pendingBalance: MonetaryAmount;
  /** Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount). */
  portfolioSecurities?: Maybe<Array<PortfolioSecurity>>;
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations?: Maybe<Array<PortfolioSecurityAllocation>>;
  /** Indicates the display priority */
  position?: Maybe<Scalars['Int']['output']>;
  /** Indicates the projection of the portfolio */
  projection?: Maybe<PortfolioProjection>;
  /** Indicates how risky the portfolio is */
  riskLevel: PortfolioRiskLevel;
  /** Indicates if the portfolio is standard or sustainable */
  theme: PortfolioTheme;
  yearToDateReturn?: Maybe<MarketReturn>;
};

/** Portfolio Allocation Object */
export type PortfolioAllocation = {
  __typename?: 'PortfolioAllocation';
  /** Percentage of investment allocated to this portfolio */
  allocationPercent: Scalars['Float']['output'];
  /** ID of the PortfolioAllocation */
  portfolioId: Scalars['ID']['output'];
};

export enum PortfolioCustomizationLevel {
  /** Additional pre-approved Security's may be added to the Portfolio at pre-set allocations. */
  Addon = 'ADDON',
  /** Portfolio holdings and allocation percentages are fully configurable. */
  FullyConfigured = 'FULLY_CONFIGURED',
  /** Portfolio holdings and allocation percentages are pre-set. */
  None = 'NONE'
}

/** Portfolio Holding */
export type PortfolioHolding = {
  __typename?: 'PortfolioHolding';
  /** The dollar amount of shares a user has */
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** The Acorns-assigned name of the ETF */
  name: Scalars['String']['output'];
  /** The actual percentage of a user's portfolio the ETF accounts for */
  percentage: Scalars['Float']['output'];
  /** The quanity of shares a user has */
  shares: Scalars['Float']['output'];
  /** The ETF's trading symbol */
  symbol: Scalars['String']['output'];
};

/** Portfolio input type */
export type PortfolioInput = {
  /** Portfolio Valid Types */
  portfolioType?: InputMaybe<PortfolioTypeEnum>;
};

/** Internal Portfolio Type */
export type PortfolioMeta = BasePortfolio & {
  __typename?: 'PortfolioMeta';
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation;
  active?: Maybe<Scalars['Boolean']['output']>;
  cashOwed: MonetaryAmount;
  color1?: Maybe<Scalars['String']['output']>;
  color2?: Maybe<Scalars['String']['output']>;
  currentAllocationPercentage: Scalars['Float']['output'];
  currentBalance: MonetaryAmount;
  currentBalanceWithPending: MonetaryAmount;
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel?: Maybe<PortfolioCustomizationLevel>;
  /** Description of the portfolio */
  description: Scalars['String']['output'];
  efvMultipliers?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates the ETFs that the portfolio is composed of
   * @deprecated Use BasePortfolio.portfolioSecurityAllocations instead
   */
  etfs?: Maybe<Array<Etf>>;
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount).
   * @deprecated Use Portfolio.portfolioSecurities instead.
   */
  holdings?: Maybe<Array<PortfolioHolding>>;
  /** ID of the Portfolio */
  id: Scalars['ID']['output'];
  /** Indicates the minimum ratio that must be allocated to the managed portfolio */
  minimumManagedAllocationPercent: Scalars['Float']['output'];
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']['output'];
  /** Indicates a key based off of the portfolio name */
  nameKey: Scalars['String']['output'];
  pendingBalance: MonetaryAmount;
  /** Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount). */
  portfolioSecurities?: Maybe<Array<PortfolioSecurity>>;
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations?: Maybe<Array<PortfolioSecurityAllocation>>;
  portfolioTags: Array<PortfolioTag>;
  portfolioType: PortfolioTypeEnum;
  /** Indicates the display priority */
  position?: Maybe<Scalars['Int']['output']>;
  /** Indicates the projection of the portfolio */
  projection?: Maybe<PortfolioProjection>;
  /** Indicates how risky the portfolio is */
  riskLevel: PortfolioRiskLevel;
  /** Indicates if the portfolio is standard or sustainable */
  theme: PortfolioTheme;
  yearToDateReturn?: Maybe<MarketReturn>;
};

/** An individual edge within the paginated list of PortfolioMeta */
export type PortfolioMetaEdge = {
  __typename?: 'PortfolioMetaEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The PortfolioMeta record in the edge */
  node: PortfolioMeta;
};

/** Relay style pagination information for PortfolioMeta */
export type PortfolioMetaPagination = {
  __typename?: 'PortfolioMetaPagination';
  edges: Array<PortfolioMetaEdge>;
  pageInfo: PageInfo;
};

/** Portfolio Not Found */
export type PortfolioNotFoundException = {
  __typename?: 'PortfolioNotFoundException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Portfolio Projection */
export type PortfolioProjection = {
  __typename?: 'PortfolioProjection';
  /** The projected average growth rate */
  averageGrowthRate: Scalars['Float']['output'];
  /** The projected highest growth rate */
  highestGrowthRate: Scalars['Float']['output'];
  /** The projected lowest growth rate */
  lowestGrowthRate: Scalars['Float']['output'];
};

export enum PortfolioRiskLevel {
  Aggressive = 'AGGRESSIVE',
  Conservative = 'CONSERVATIVE',
  Custom = 'CUSTOM',
  Moderate = 'MODERATE',
  ModeratelyAggressive = 'MODERATELY_AGGRESSIVE',
  ModeratelyConservative = 'MODERATELY_CONSERVATIVE'
}

/** Portfolio Security */
export type PortfolioSecurity = {
  __typename?: 'PortfolioSecurity';
  /** The current percentage of the market value over the customer's total balance */
  currentAllocationPercentage: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Current price of the security */
  marketPrice?: Maybe<MonetaryAmount>;
  /** The market value of shares owned by the customer */
  marketValue: MonetaryAmount;
  /** The Acorns-assigned name of the security */
  name: Scalars['String']['output'];
  /** The quantity of shares a user has */
  shares: Scalars['Float']['output'];
  /** The security's trading symbol */
  symbol: Scalars['String']['output'];
  /**
   * DEPRECATED: The target percentage of the market value over the customer's total balance
   * @deprecated Will not be populated with self directed investments release.
   */
  targetAllocationPercentage?: Maybe<Scalars['Float']['output']>;
  /** The customer's returns for today */
  todaysReturn: MarketReturn;
  /** The customer's returns for all time for the security */
  totalReturn: MarketReturn;
};

/** Security allocation */
export type PortfolioSecurityAllocation = {
  __typename?: 'PortfolioSecurityAllocation';
  allocationPercent: Scalars['Float']['output'];
  /** @deprecated Use Security.displayName instead */
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Indicates the investment category for the security */
  investmentCategories: InvestmentCategory;
  /** @deprecated Use Security.shortName instead */
  name: Scalars['String']['output'];
  /** Indicates whether the Security can be removed from an Investment Account's base Portfolio. */
  removableFromBasePortfolio: Scalars['Boolean']['output'];
  symbol: Scalars['String']['output'];
};

/** Portfolio Tag */
export type PortfolioTag = {
  __typename?: 'PortfolioTag';
  portfolios?: Maybe<Array<PortfolioMeta>>;
  type: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

/** An individual edge within the paginated list of PortfolioTagType */
export type PortfolioTagTypeEdge = {
  __typename?: 'PortfolioTagTypeEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The PortfolioTagType record in the edge */
  node: PortfolioTag;
};

/** Relay style pagination information for PortfolioTagType */
export type PortfolioTagTypePagination = {
  __typename?: 'PortfolioTagTypePagination';
  edges: Array<PortfolioTagTypeEdge>;
  pageInfo: PageInfo;
};

export enum PortfolioTheme {
  SelfDirected = 'SELF_DIRECTED',
  Standard = 'STANDARD',
  Sustainable = 'SUSTAINABLE'
}

/** Portfolio type enum by portfolio model */
export enum PortfolioTypeEnum {
  CustomizedType = 'CUSTOMIZED_TYPE',
  ManagedType = 'MANAGED_TYPE',
  SelfDirectedType = 'SELF_DIRECTED_TYPE'
}

/** Failed to update portfolio on investment account */
export type PortfolioUpdateFailedException = {
  __typename?: 'PortfolioUpdateFailedException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type PositiveCurrencyAmountInput = {
  currency: Currency;
  value: Scalars['PositiveFloat']['input'];
};

/** Input to pre approve accounts */
export type PreApproveAccountInput = {
  /** Set as an expedited pre approval */
  expedited: Scalars['Boolean']['input'];
  /** Users to be pre approved */
  userIds: Array<Scalars['ID']['input']>;
};

/** Response of pre approval of accounts */
export type PreApproveAccountResponse = LegacyUser | UnknownException | UserNotFoundException;

/** Presentation-driven entity for an associated Product */
export type PresentableProduct = {
  __typename?: 'PresentableProduct';
  /** Keys to strings to display description of associated product */
  descriptionKeys: Array<Scalars['StringKey']['output']>;
  /** Associated product */
  product: Product;
};

export enum PresentableWithdrawalStatus {
  Canceled = 'canceled',
  Complete = 'complete',
  Failed = 'failed',
  Pending = 'pending',
  Refunded = 'refunded',
  SellingInvestments = 'sellingInvestments',
  Transferring = 'transferring'
}

export type ProcessBankTransferCommandInput = {
  amount: PositiveCurrencyAmountInput;
  description?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
  to: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ProcessBankTransferCommandPayload = {
  __typename?: 'ProcessBankTransferCommandPayload';
  id?: Maybe<Scalars['String']['output']>;
};

export type ProcessCheckTransferCommandInput = {
  amount: PositiveCurrencyAmountInput;
  description: Scalars['String']['input'];
  fromAccountId: Scalars['ID']['input'];
  tag: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ProcessCheckTransferCommandPayload = {
  __typename?: 'ProcessCheckTransferCommandPayload';
  id: Scalars['ID']['output'];
};

export type ProcessTransferFromProgramAccountInput = {
  amount: PositiveCurrencyAmountInput;
  /** Customer Facing ACH Description. Make sure your description is OK'd by compliance. */
  description?: InputMaybe<Scalars['String']['input']>;
  source: TransferSource;
  tag: Scalars['ID']['input'];
  toAccountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ProcessTransferFromProgramAccountPayload = {
  __typename?: 'ProcessTransferFromProgramAccountPayload';
  id: Scalars['ID']['output'];
};

export type ProcessTransferToProgramAccountInput = {
  amount: PositiveCurrencyAmountInput;
  /** Customer Facing ACH Description. Make sure your description is OK'd by compliance. */
  description?: InputMaybe<Scalars['String']['input']>;
  fromAccountId: Scalars['ID']['input'];
  source: TransferSource;
  tag: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ProcessTransferToProgramAccountPayload = {
  __typename?: 'ProcessTransferToProgramAccountPayload';
  id: Scalars['ID']['output'];
};

/** Canonical representation of an Acorns product that can be used and billed for. */
export type Product = {
  __typename?: 'Product';
  /** Indicates whether or not the Product is available to new Users. */
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  descriptionKeys?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  key: ProductKey;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum ProductAccountType {
  Brokerage = 'BROKERAGE',
  Checking = 'CHECKING',
  Custodial = 'CUSTODIAL',
  Retirement = 'RETIREMENT',
  Savings = 'SAVINGS'
}

/** Ref for product name */
export enum ProductKey {
  BenefitsGohenryStandard = 'BENEFITS_GOHENRY_STANDARD',
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsTaxfilingStandard = 'BENEFITS_TAXFILING_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
  Early = 'EARLY',
  EarlyMatch = 'EARLY_MATCH',
  EarlyPublishing = 'EARLY_PUBLISHING',
  EarlySelfDirectedInvest = 'EARLY_SELF_DIRECTED_INVEST',
  Earn = 'EARN',
  EarnChoice = 'EARN_CHOICE',
  EarnPrime = 'EARN_PRIME',
  EmergencyFund = 'EMERGENCY_FUND',
  Invest = 'INVEST',
  Later = 'LATER',
  LaterMatch = 'LATER_MATCH',
  Learn = 'LEARN',
  LearnPremium = 'LEARN_PREMIUM',
  MightyOakCard = 'MIGHTY_OAK_CARD',
  MoneyManager = 'MONEY_MANAGER',
  PremiumEducation = 'PREMIUM_EDUCATION',
  SelfDirectedInvest = 'SELF_DIRECTED_INVEST',
  Spend = 'SPEND',
  StandardBenefitsInsurance = 'STANDARD_BENEFITS_INSURANCE'
}

export enum ProductType {
  Core = 'core',
  Early = 'early',
  Later = 'later',
  Spend = 'spend'
}

/** Miscellaneous attributes and information about a user */
export type Profile = TimestampsInterface & {
  __typename?: 'Profile';
  /** Annual income */
  annualIncome?: Maybe<Scalars['Int']['output']>;
  /** Combined annual income */
  combinedAnnualIncome?: Maybe<Scalars['Int']['output']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Debt */
  debt?: Maybe<Scalars['Boolean']['output']>;
  /** Employees */
  employees?: Maybe<Employees>;
  /** Employment status */
  employmentStatus?: Maybe<EmploymentStatus>;
  /** Filing type */
  filingType?: Maybe<FilingType>;
  /** Financial education */
  financialEducation?: Maybe<FinancialEducation>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Funds availability */
  fundsAvailability?: Maybe<FundsAvailability>;
  /** High-interest debt */
  highInterestDebt?: Maybe<Scalars['Boolean']['output']>;
  /** Investment goal */
  investmentGoal?: Maybe<InvestmentGoal>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Marital status */
  maritalStatus?: Maybe<MaritalStatus>;
  /** Monthly expenses */
  monthlyExpenses?: Maybe<Scalars['Float']['output']>;
  /** Net worth */
  netWorth?: Maybe<Scalars['Float']['output']>;
  /** has user opted out of targeting */
  optedOutOfTargeting: Scalars['Boolean']['output'];
  /** Retirement plan access */
  retirementPlanAccess?: Maybe<RetirementPlanAccess>;
  /** Self employed income */
  selfEmployedIncome?: Maybe<Scalars['Int']['output']>;
  /** Signature type */
  signatures: Array<Maybe<Signature>>;
  /** Last four of SSN */
  ssnLastFour?: Maybe<Scalars['String']['output']>;
  /** User has paused their transfers */
  transfersPaused?: Maybe<Scalars['Boolean']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Internal ID for user */
  userId: Scalars['ID']['output'];
};

/** Changeable attributes for user profiles */
export type ProfileInput = {
  /** Non-self employed income */
  annualIncome?: InputMaybe<Scalars['Int']['input']>;
  /** Total annual income */
  combinedAnnualIncome?: InputMaybe<Scalars['Int']['input']>;
  /** Debt */
  debt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of employees the user has (if self employed) */
  employees?: InputMaybe<Employees>;
  /** Status of user's employment */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  /** How the user files their taxes */
  filingType?: InputMaybe<FilingType>;
  /** User's level of financial education */
  financialEducation?: InputMaybe<FinancialEducation>;
  /** Funds availability */
  fundsAvailability?: InputMaybe<FundsAvailability>;
  /** High-interest debt */
  highInterestDebt?: InputMaybe<Scalars['Boolean']['input']>;
  /** User's investment goal */
  investmentGoal?: InputMaybe<InvestmentGoal>;
  /** Marital status */
  maritalStatus?: InputMaybe<MaritalStatus>;
  /** Monthly expenses */
  monthlyExpenses?: InputMaybe<Scalars['Float']['input']>;
  /** Net worth */
  netWorth?: InputMaybe<Scalars['Float']['input']>;
  /** How the user wants to access their retirement plan */
  retirementPlanAccess?: InputMaybe<RetirementPlanAccess>;
  /** Self employed income */
  selfEmployedIncome?: InputMaybe<Scalars['Int']['input']>;
  /** Pause transfers */
  transfersPaused?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ProgramAccountType {
  Plan = 'PLAN'
}

export type PromoCode = {
  __typename?: 'PromoCode';
  businessLine: PromoCodeBusinessLine;
  channel: Scalars['String']['output'];
  condensedTitle: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalMemo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  publishEnd?: Maybe<Scalars['DateTime']['output']>;
  publishStart: Scalars['DateTime']['output'];
  qualificationAction: PromoCodeQualificationAction;
  qualificationAmount: Scalars['Int']['output'];
  rewards: Array<PromoCodeReward>;
  status: PromoCodeStatus;
  termsUrl?: Maybe<Scalars['URL']['output']>;
  title: Scalars['String']['output'];
};

export enum PromoCodeBusinessLine {
  Affiliate = 'AFFILIATE',
  Brand = 'BRAND',
  Organic = 'ORGANIC',
  PaidMedia = 'PAID_MEDIA'
}

export type PromoCodeCustomer = {
  __typename?: 'PromoCodeCustomer';
  promoCode: PromoCode;
  userId: Scalars['ID']['output'];
};

export type PromoCodeEdge = {
  __typename?: 'PromoCodeEdge';
  cursor: Scalars['String']['output'];
  node: PromoCode;
};

export type PromoCodeFieldLengthError = {
  __typename?: 'PromoCodeFieldLengthError';
  field: Scalars['String']['output'];
  max: Scalars['Int']['output'];
};

export type PromoCodePaginatedFilter = {
  /** Cursor to start pagination results for (exclusive) */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Number of nodes to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoCodePaginatedInfo = {
  __typename?: 'PromoCodePaginatedInfo';
  /** Cursor corresponding to the last node in the list of edges */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the filter */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior to the set defined by the filter */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Cursor corresponding to the first node in the list of edges */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PromoCodeQualificationAction {
  InitialInvestment = 'INITIAL_INVESTMENT',
  InitialRecurringInvestment = 'INITIAL_RECURRING_INVESTMENT',
  InitialRoundup = 'INITIAL_ROUNDUP',
  InitialSubscriptionPayment = 'INITIAL_SUBSCRIPTION_PAYMENT'
}

export type PromoCodeReward = {
  __typename?: 'PromoCodeReward';
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  type: PromoCodeRewardType;
};

export type PromoCodeRewardEdge = {
  __typename?: 'PromoCodeRewardEdge';
  cursor: Scalars['String']['output'];
  node: PromoCodeReward;
};

export enum PromoCodeRewardType {
  Investment = 'INVESTMENT',
  Other = 'OTHER'
}

export type PromoCodeRewardsConnection = {
  __typename?: 'PromoCodeRewardsConnection';
  edges?: Maybe<Array<PromoCodeRewardEdge>>;
  pageInfo: PromoCodePaginatedInfo;
};

export enum PromoCodeStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type PromoCodesConnection = {
  __typename?: 'PromoCodesConnection';
  edges?: Maybe<Array<PromoCodeEdge>>;
  pageInfo: PromoCodePaginatedInfo;
};

/** Display wrapper for featured promo offer */
export type PromoOffer = {
  __typename?: 'PromoOffer';
  /** Background/featured image */
  backgroundImage: Image;
  /** Display body for the offer */
  body?: Maybe<Scalars['String']['output']>;
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image;
  id: Scalars['ID']['output'];
  /** Company/partner logo */
  logo?: Maybe<Image>;
  /** Partner url */
  partnerUrl: Scalars['URL']['output'];
  /** Display subtitle for the offer */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Display title for the offer */
  title: Scalars['String']['output'];
};

export type PromotedBenefit = {
  __typename?: 'PromotedBenefit';
  product: BenefitsTrackerProducts;
  promotedThrough: Array<BenefitPromotedThrough>;
};

export type PromotedCampaigns = {
  __typename?: 'PromotedCampaigns';
  campaignIds: Array<Maybe<Scalars['ID']['output']>>;
};

/** Time-bound pricing and/or additional incentives offered to subscibers of a particular offering (tier or product). */
export type Promotion = {
  __typename?: 'Promotion';
  /** Wether or not the promotion is available for new applications. */
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** How long the promotion lasts once applied to a subscription. */
  duration?: Maybe<PromotionDuration>;
  /** When the promotion is set to expire and become inactive. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Additional incentives the promotion entitles subscribers to. */
  incentives?: Maybe<Array<Incentive>>;
  name: Scalars['String']['output'];
  /** Services that the promotion is for. */
  offering: Offering;
  /** Metadata indicating in what contexts a client should present the promotion. */
  presentInContexts: Array<Scalars['String']['output']>;
  /** Link to legal terms and conditions of the promotion. */
  termsUrl: Scalars['URL']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PromotionConsumedError = {
  __typename?: 'PromotionConsumedError';
  message: Scalars['String']['output'];
};

export type PromotionDuration = {
  __typename?: 'PromotionDuration';
  period: PromotionDurationPeriod;
  periodCount: Scalars['Int']['output'];
};

export enum PromotionDurationPeriod {
  Month = 'MONTH'
}

export type PromotionExpiredError = {
  __typename?: 'PromotionExpiredError';
  expiredAt: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
};

export type PromotionFilterInput = {
  presentInContexts?: InputMaybe<PromotionPresentInContextsFilterInput>;
};

export type PromotionNotFoundError = {
  __typename?: 'PromotionNotFoundError';
  message: Scalars['String']['output'];
};

export type PromotionPresentInContextsFilterInput = {
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** promotional waiver */
export type PromotionalWaiver = {
  __typename?: 'PromotionalWaiver';
  promotion?: Maybe<WaiverPromotion>;
  promotionalWaiverPeriodEndDate: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type PromotionalWaiver_V2 = {
  __typename?: 'PromotionalWaiver_V2';
  promotion: WaiverPromotion_V2;
  promotionalWaiverPeriodEndDate: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type Prospect = {
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum ProspectType {
  Grow = 'GROW',
  LaterWaitlist = 'LATER_WAITLIST',
  OutsideContribution = 'OUTSIDE_CONTRIBUTION'
}

/** provisional fee waiver */
export type ProvisionalWaiver = {
  __typename?: 'ProvisionalWaiver';
  userId: Scalars['ID']['output'];
  waiverPeriodEndDate: Scalars['String']['output'];
  waiverReason?: Maybe<Scalars['String']['output']>;
};

export type ProvisionalWaiver_V2 = {
  __typename?: 'ProvisionalWaiver_V2';
  userId: Scalars['ID']['output'];
  waiverPeriodEndDate: Scalars['String']['output'];
  waiverReason: Scalars['String']['output'];
};

export type PublishBgpReportResult = {
  __typename?: 'PublishBgpReportResult';
  messageId: Scalars['String']['output'];
};

/** Statuses after a campaign is published */
export enum PublishedCampaignStatus {
  Complete = 'COMPLETE',
  Live = 'LIVE',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED'
}

export type PushAuthChallenge = AuthChallenge & {
  __typename?: 'PushAuthChallenge';
  alternateAuthenticators: Array<AuthenticatorInfo>;
  challengeTrigger: ChallengeTriggers;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  pushState: ChallengePushState;
  updatedAt: Scalars['DateTime']['output'];
};

export type PushAuthenticator = Authenticator & {
  __typename?: 'PushAuthenticator';
  createdAt: Scalars['DateTime']['output'];
  deviceId: Scalars['ID']['output'];
  deviceType: DeviceType;
  id: Scalars['ID']['output'];
  lastAuthenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  type: AuthType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PushAuthenticatorAlreadyExistsException = {
  __typename?: 'PushAuthenticatorAlreadyExistsException';
  authenticatorId: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type QualificationSubTypeMismatchError = {
  __typename?: 'QualificationSubTypeMismatchError';
  message: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** GraphQL SDL */
  _service: _Service;
  /** Fetch abilities for a given user ID */
  abilities: Array<Maybe<Ability>>;
  /** Get a single acceptance document by ID */
  acceptanceDocument?: Maybe<AcceptanceDocument>;
  /** Get a single acceptance document version by ID */
  acceptanceDocumentVersion: AcceptanceDocumentVersion;
  /** Get all filters for an acceptance document version */
  acceptanceDocumentVersionFilters: Array<AcceptanceDocumentVersionFilter>;
  /** Get all versions for an acceptance document */
  acceptanceDocumentVersions?: Maybe<Array<AcceptanceDocumentVersion>>;
  /** Get all acceptance documents */
  acceptanceDocuments?: Maybe<AcceptanceDocumentsResult>;
  accountPointsRuleByMilestoneId?: Maybe<AccountPointsRule>;
  accountPointsRules?: Maybe<Array<AccountPointsRule>>;
  /** Fetches a list of investment account strength achievements and their status */
  accountStrength?: Maybe<AccountStrengthResult>;
  /** Return list of user information for users that satisfy the given criteria in the account verification queue */
  accountVerificationQueue?: Maybe<AccountVerificationQueueResponse>;
  /** Fetch a list of accounts for a user */
  accounts: Array<Maybe<Account>>;
  activeEarnOffers: EarnOfferQueryPage;
  /** @deprecated No longer supported */
  activeReferralCampaigns?: Maybe<ActiveReferralCampaignOutput>;
  /** Fetch a list of addresses for a user */
  addresses: Array<Maybe<Address>>;
  adminApp?: Maybe<AdminApp>;
  adminApps?: Maybe<Array<AdminApp>>;
  adminCSVBuckets: BucketOptions;
  advocate?: Maybe<Advocate>;
  /** @deprecated No longer supported */
  advocateFriendsStatuses?: Maybe<AdvocateFriendsStatuses>;
  /** An array of the alerts for a user. */
  alertCards?: Maybe<Array<AlertCard>>;
  /** Fetch all beneficiary alerts for a user */
  alertHubBeneficiaryAlerts?: Maybe<Array<AlertHubBeneficiaryAlert>>;
  /** Get all acceptance documents */
  allAcceptanceDocuments: Array<AcceptanceDocument>;
  allBankAccounts?: Maybe<Array<BankAccount>>;
  allBankCards?: Maybe<Array<Maybe<BankCard>>>;
  allBankCustomerAddresses?: Maybe<Array<Maybe<BankCustomerAddress>>>;
  allBankTransactions?: Maybe<BankTransactionConnection>;
  allCardTrackingStatuses?: Maybe<Array<CardDeliveryStatus>>;
  allCheckPayments?: Maybe<AllCheckPaymentsResult>;
  /** Returns list of categories and nested subcategories for dynamic values in contact form */
  allContactCategories?: Maybe<Array<ContactCategory>>;
  /** Fetches all messages for a user. Leverages Hedwig's DB for notifications/alerts and queries external services for alerts. Make sure a `x-client-platform` header is passed in as a string that is a comma-separated list of valid platforms. Will return messages that support any of the passed platforms */
  allMessages?: Maybe<Array<Message>>;
  allPastSpendItems?: Maybe<PastItemConnection>;
  allPendingBankTransfers?: Maybe<Array<Maybe<BankTransaction>>>;
  /** Fetch all valid policies for authz */
  allPolicies?: Maybe<ValidPolicies>;
  /** Returns all support articles */
  allSupportArticles?: Maybe<Array<Maybe<SupportArticle>>>;
  /** Returns all the current categories within the Help Center */
  allSupportCategories?: Maybe<Array<Maybe<SupportCategory>>>;
  /** Returns all support sections */
  allSupportSections?: Maybe<Array<Maybe<SupportSection>>>;
  /** Returns all support ticket forms */
  allSupportTicketForms?: Maybe<Array<Maybe<SupportTicketForm>>>;
  /** Fetch all trusted contacts for a user by user uuid */
  allTrustedContactsByUserId: Array<Maybe<TrustedContact>>;
  auditLogs: Array<AuditLogModel>;
  authAlerts?: Maybe<Array<AuthAlert>>;
  authProfile?: Maybe<AuthProfile>;
  authenticateForFeeNegotiationStatusByLinkedAccountId?: Maybe<AuthenticateForFeeNegotiationStatus>;
  /** Auto Invest Changes By User Id */
  autoInvestChangesByUserId: AutoInvestChangePagination;
  /** Returns backend job batches for order types */
  backendJobBatchAutomatedOrders?: Maybe<Array<BackendJobBatch>>;
  /** Returns backend job batches for money movement */
  backendJobBatchMoneyMovement?: Maybe<Array<BackendJobBatch>>;
  /** Returns backend job batches for order types */
  backendJobBatchOrders?: Maybe<Array<BackendJobBatch>>;
  /** Returns backend job batches for profit star deposits */
  backendJobBatchProfitStars?: Maybe<Array<BackendJobBatch>>;
  /** Returns all order aggregation stats */
  backendJobBatchSummary?: Maybe<BackendJobBatchSummary>;
  /** Returns the bank account state for a given account type. */
  bankAccountState?: Maybe<BankAccountStateResult>;
  bankAdminSearchDynamoDB: BankAdminSearchDynamoDbResult;
  bankCardOrder?: Maybe<BankCardOrder>;
  /** Returns a temporary encrypted token used by clients to show a card's details */
  bankCardPanDisplay: BankCardPanDisplayResult;
  /** Returns an encrypted token for virtual bank card provisioning */
  bankCardProvisioningDetails: BankCardProvisioningDetailsResult;
  bankCardReissue?: Maybe<BankCardReissue>;
  bankDisclosureDocumentFile?: Maybe<BankDisclosureDocumentFile>;
  bankDisclosureDocuments?: Maybe<Array<Maybe<BankDisclosureDocumentResult>>>;
  bankFeeNegotiationsByUserId: FeeNegotiationSummary;
  /** @deprecated Use query.bankFeesByUserId instead */
  bankFeeSummaryByUserId?: Maybe<BankFeeSummary>;
  bankFeesByUserId?: Maybe<Array<BankFee>>;
  /** Returns interest rates for banking products. Omit filter to return data for all products. Add refreshInterestRateCache: true to fetch latest from Helix and update database (generally only should be done from a daily cron job, not clients). */
  bankInterestRates: BankInterestRatesResult;
  /** @deprecated Incorrect and no longer in use, we are removing this method in the future */
  bankMetadata?: Maybe<BankMetadata>;
  bankTransaction?: Maybe<BankTransaction>;
  bankTransactionByTag?: Maybe<BankTransaction>;
  /**
   * Returns the KYC status and verification details for the user, if it exists.
   * This is used to determine if the user has completed Banking KYC and if any action is required.
   */
  bankingKycDetails?: Maybe<BankingKyc>;
  /** Get all banks or filter by Bank Name or Routing Number */
  banksByNameByRoutingNumber: BankResultPagination;
  /** Returns Acorns banners information data */
  banners?: Maybe<Array<Maybe<BannersResponse>>>;
  batchEstimatedTransferDates?: Maybe<BatchEstimatedTransferDatesInternalPayload>;
  /** Fetch all beneficiaries for a user */
  beneficiaries?: Maybe<Array<InternalBeneficiary>>;
  /** Fetch a beneficiary with a given ID */
  beneficiary?: Maybe<InternalBeneficiary>;
  /** Fetch a beneficiary SSN with a given ID and shared secret */
  beneficiarySSN?: Maybe<BeneficiarySsn>;
  bgpReportDetails: BgpReportDetailsResult;
  bgpReports: Array<BgpReportColumn>;
  /** Fetch billing cycles given an ID */
  billingCycle?: Maybe<BillingCycle>;
  /** Fetch billing cycles given a user ID */
  billingCycles?: Maybe<Array<BillingCycle>>;
  /** Fetches all billing cycles for a given invoice date also accepting a state and pagination input */
  billingCyclesByInvoiceDate: BillingCycleTypePagination;
  /** Fetch the data used in determining how a user is billed */
  billingProfile?: Maybe<BillingProfile>;
  /** Get the Card Delivery Status */
  bulkCardTrackingStatusByReferenceIds?: Maybe<Array<BulkCardDeliveryStatus>>;
  /** Fetch the most recent bulk suspension records */
  bulkSuspensionRecords: Array<BulkSuspensionRecord>;
  calculateMoneySplits?: Maybe<MoneyRulesSuggestionResult>;
  campaignHistory?: Maybe<CampaignHistoryConnection>;
  challenges?: Maybe<Array<AuthChallenge>>;
  /** Investment account closure reasons */
  closureReasonsByInvestmentAccountType: Array<InvestmentAccountClosureReason>;
  cohortReasonsByUserId?: Maybe<Array<CohortReason>>;
  /** Returns completed investments for the provided user and investment account id */
  completedInvestments?: Maybe<InvestmentPagination>;
  connectionsByUserId: ConnectionSummary;
  /** Returns contact form alert message if it has been set in Zesty */
  contactFormAlert?: Maybe<ContactFormAlert>;
  /** Fetch credits belonging to a user */
  creditsByUserId?: Maybe<Array<Credit>>;
  /** Get customer actions by user. */
  customerActionByUserId: CustomerActionsTypePagination;
  /** Get customer changes by user. */
  customerChangesByCustomerAction: CustomerChangesTypePagination;
  /** Get customer changes by user and by type. */
  customerChangesByUserByType: CustomerChangesByUser;
  /**
   * Get a customer's Earn onboarding program and status
   * @deprecated The Earn Onboarding program has been discontinued
   */
  customerEarnOnboardingProgram?: Maybe<CustomerEarnOnboardingProgram>;
  customerMoneyRules?: Maybe<CustomerMoneyRulesResult>;
  /**
   * Lookup 'Decision' by 'traceId'
   * a traceId might be related to multiple decisions, so this
   * could return more than one decision
   */
  decisionsByTraceId: DecisionsByTraceIdResult;
  device?: Maybe<Device>;
  devicesByUserId?: Maybe<Array<Device>>;
  /** Return the user's direct deposit status */
  directDepositInfo: DirectDepositInfoPayload;
  /** Generate Direct Deposit PDF */
  directDepositPdf: DirectDepositPdfPayload;
  /** Request dividend information for the given list of symbols. */
  dividendsBySymbol?: Maybe<Array<Dividend>>;
  documentRequest?: Maybe<DocumentRequest>;
  documentRequests?: Maybe<DocumentRequestsConnection>;
  /** An array of documents to be reviewed */
  documentsToBeReviewed?: Maybe<DocumentsToBeReviewedResponse>;
  earlyAccountTransferInfo?: Maybe<EarlyAccountTransferInfo>;
  /** Get a list of Earn CTA Data */
  earnCTADataByUserId?: Maybe<Array<EarnCtaRecord>>;
  /** Retrieve EarnOffer by campaignOfferId with fall back support by campaignId */
  earnOfferByCampaignOfferId?: Maybe<EarnOffer>;
  /** Get the reward information associated with investment IDs */
  earnRewardsByInvestmentIds?: Maybe<Array<EarnReward>>;
  /** Check for existence of credentials and formatting of input for a given email */
  emailAddressValidation: EmailAddressValidation;
  estimatedCheckPaymentDates?: Maybe<EstimatedCheckPaymentDates>;
  estimatedTransferDates?: Maybe<EstimatedTransferDatesInternalPayload>;
  extoleCampaignHistory?: Maybe<ExtoleCampaignHistoryConnection>;
  extoleReferralHistory?: Maybe<ExtoleReferralHistory>;
  /** Retrieves list of favorite EarnOffers that the user is currently eligible for */
  favoriteEarnOffers: FavoritePartnerOfferGroup;
  featuredMilestones: FeaturedMilestones;
  /** @deprecated This will no longer be used to support the account setup user state, replace with featuredMilestones */
  featuredMilestones_v2?: Maybe<FeaturedMilestonesV2>;
  /** Fetch a fee given the ID */
  fee?: Maybe<Fee>;
  /** Fetch all fees given an argument */
  fees?: Maybe<Array<Fee>>;
  /** Returns acorns footer content */
  footerContent?: Maybe<FooterContent>;
  /**
   * Get a list of Found Money rewards
   * @deprecated This has been replaced by foundMoneyRewardsV2
   */
  foundMoneyRewards?: Maybe<Array<Maybe<FoundMoneyReward>>>;
  /** Get a list of Found Money rewards */
  foundMoneyRewardsV2?: Maybe<Array<EarnReward>>;
  /** Get a summary of all Found Money rewards */
  foundMoneySummary?: Maybe<FoundMoneySummary>;
  /** @deprecated No longer supported */
  friend?: Maybe<Friend>;
  friendV2?: Maybe<FriendV2Output>;
  /** Fetches a funding source by ID (UUID) */
  fundingSource?: Maybe<FundingSource>;
  /** Fetch funding source changes */
  fundingSourceChangeRequest: FundingSourceChangeRequestResponse;
  /** Fetches a list of funding source(s) for a user */
  fundingSources?: Maybe<Array<FundingSource>>;
  getAllScopes: Array<Maybe<Scope>>;
  getBillingHistory?: Maybe<Array<BillingInvoice>>;
  getConnectCategory: ConnectCategoryObject;
  getOauthApp?: Maybe<OauthApp>;
  getPlaidAccountDetails: Account;
  getRelevantMacros?: Maybe<RelevantMacrosResponse>;
  getScope?: Maybe<Scope>;
  /** @deprecated No longer in use */
  getUsersBankFromAccountType?: Maybe<GetUsersBankFromAccountTypePayload>;
  /** Lookup billing vendor invoice by invoice id */
  getVendorInvoice?: Maybe<Invoice>;
  /** Returns help form submission content */
  helpFormContent?: Maybe<HelpFormContent>;
  /**
   * Returns helpcenter banner information data
   * @deprecated Replaced with banners query.
   */
  helpcenterBanner?: Maybe<HelpcenterBannerResponse>;
  /** Returns instant support articles from search term currently in search field */
  instantSearchSupportArticles?: Maybe<Array<Maybe<SearchSupportArticleResult>>>;
  /** Retrieve an Investment by it's unique `id`. */
  investment?: Maybe<Investment>;
  /** Fetches an investment account without user auth */
  investmentAccount?: Maybe<InvestmentAccount>;
  investmentAccountByBeneficiaryId?: Maybe<InvestmentAccount>;
  /** Investment Account performance calculation values */
  investmentAccountCalculations: InvestmentAccountCalculationResponse;
  /** Returns investment account reopen requests */
  investmentAccountReopenRequests: InvestmentAccountReopenRequestPagination;
  /** Fetch user's investment accounts */
  investmentAccountsByUserId: Array<InvestmentAccount>;
  /** Fetches an investment by its nonce */
  investmentByNonce?: Maybe<Investment>;
  /** Returns investments between the provided date range (default is 1 month) for the provided investment account id */
  investmentsByInvestmentAccountId?: Maybe<InvestmentPagination>;
  isPhoneNumberOptedOut: Scalars['Boolean']['output'];
  isSpendUserWhitelisted?: Maybe<IsSpendUserWhitelistedPayload>;
  /** @deprecated Job Alerts are no longer supported */
  jobAlerts?: Maybe<Array<JobAlert>>;
  jobEducationContent?: Maybe<Jobs_Education>;
  jobSearch?: Maybe<Array<Jobs_Offer>>;
  jobSearchPage?: Maybe<JobSearchPage>;
  jobSearchV2?: Maybe<Jobs_OfferConnection>;
  /**
   *  Contribution ability per year; only years in the current "tax window" returned
   * @deprecated Use laterUserContributionAbility
   */
  laterContributionAbility?: Maybe<Array<Maybe<ContributionAbility>>>;
  laterUserContributionAbility?: Maybe<LaterContributionAbilityResult>;
  /** Retrieve documents requested */
  legacyDocumentRequests?: Maybe<Array<LegacyDocumentRequests>>;
  /** Retrieve user and user profile information */
  legacyUser?: Maybe<LegacyUser>;
  /** An array of referrals information from user */
  legacyUserReferralsBy?: Maybe<LegacyUserReferral>;
  /** Fetch the number of link attempts remaining for a given user */
  linkAttempts: LinkAttempts;
  linkedAccountAlerts?: Maybe<Array<LinkedAccountAlertsResponse>>;
  linkedAccounts: Array<InternalLinkedAccount>;
  /** Fetch linked accounts for a given user, excluding legacy funding accounts from Backend */
  linkedAccountsWithoutLegacyFundingSources: Array<InternalLinkedAccount>;
  linkedSubaccount?: Maybe<InternalLinkedSubaccount>;
  linkedSubaccounts: Array<InternalLinkedSubaccount>;
  /** Fetch a liquidation given the ID */
  liquidation?: Maybe<Liquidation>;
  /** Fetch all liquidations given an argument */
  liquidations?: Maybe<Array<Liquidation>>;
  /** Get a list of all active waiver coupons from the vendor */
  listActiveWaivers: Array<WaiverCoupon>;
  listBenefitsByUserId?: Maybe<Array<BenefitTileGroup>>;
  /** Returns all webhooks configured with Pinwheel */
  listPinwheelWebhooks: ListPinwheelWebhooksPayload;
  /** Retrieve all currently active coupon redemptions for a user */
  listUserWaiverCoupons?: Maybe<Array<RedeemedWaiverCoupon>>;
  maintenanceFlags: Array<Maybe<MaintenanceFlagObject>>;
  /** Fetches a message based on a user ID and internal message ID. */
  message?: Maybe<Message>;
  /** Fetches a message based on a user ID and external message ID. */
  messageByExternalId?: Maybe<Message>;
  /** Fetches messages for a user. Supports pagination (offset/count) and filtering. Make sure an x-client-platform header is passed in as a string that is a comma-separated list of valid platforms. Will return messages that support any of the passed platforms */
  messages?: Maybe<MessageConnection>;
  milestone?: Maybe<Milestone>;
  milestoneAccountLevelDefinitions?: Maybe<Array<MilestoneAccountLevelDefinition>>;
  milestoneAchievementActionRule?: Maybe<MilestoneAchievementActionRule>;
  milestoneAchievementActionRules: Array<MilestoneAchievementActionRule>;
  milestoneAchievementActionTypes: Array<MilestoneAchievementActionType>;
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  milestoneChallenge?: Maybe<MilestoneChallenge>;
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  milestoneChallengePointsRuleByMilestoneIdByChallengeId?: Maybe<MilestoneChallengePointsRule>;
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  milestoneChallengePointsRulesByMilestoneId?: Maybe<Array<MilestoneChallengePointsRule>>;
  milestoneDefinition?: Maybe<MilestoneDefinition>;
  milestoneDefinitions?: Maybe<Array<MilestoneDefinition>>;
  milestoneEligibilityByScopes?: Maybe<Array<MilestoneEligibility>>;
  milestoneGroupAchievementActionRule?: Maybe<MilestoneGroupAchievementActionRule>;
  milestoneGroupAchievementActionRules?: Maybe<Array<MilestoneGroupAchievementActionRule>>;
  milestoneGroupDefinition?: Maybe<MilestoneGroupDefinition>;
  milestoneGroupDefinitions?: Maybe<Array<MilestoneGroupDefinition>>;
  milestoneHub?: Maybe<MilestoneHub>;
  milestoneHubDefinition?: Maybe<MilestoneHubDefinition>;
  milestoneHubDefinitions: Array<MilestoneHubDefinition>;
  /** @deprecated This query was only relevant for the initial rollout of milestone hub, replace with milestoneEligibilityByScopes */
  milestoneHubEligible?: Maybe<Eligibility>;
  milestoneRules?: Maybe<Array<MilestoneRule>>;
  milestonesByTheme?: Maybe<MilestoneThemeGroup>;
  moneyAssignment?: Maybe<MoneyManagerMoneyAssignment>;
  /** Get the possible allocation amounts for a given account based off the customers existing rules and any staged rules */
  moneyManagerAllocationOptions: Array<MoneyManagerAllocationOption>;
  /** Retrieves the default money manager automation targets for a user based on their income. */
  moneyManagerAutomationTargetDefaults: Array<MoneyManagerAutomationTarget>;
  moneyManagerAutomationTargets: Array<MoneyManagerAutomationTarget>;
  moneyManagerCascadeObjectives: Array<MoneyManagerCascadeObjective>;
  moneyManagerCategories?: Maybe<MoneyManagerCategoriesResult>;
  moneyManagerDepositHistory: MoneyAssignmentConnection;
  moneyManagerEligibility: MoneyManagerEligibilityResult;
  moneyManagerGlobalConfig: MoneyManagerGlobalConfig;
  moneyManagerPaychecks: Array<MoneyManagerPaycheck>;
  moneyManagerRebalances: MoneyManagerRebalancesResponse;
  moneyManagerScheduledDeposits: Array<MoneyManagerScheduledDeposit>;
  moneyManagerScheduledPaycheckPerEmployer: Array<Maybe<MoneyManagerScheduledPaycheck>>;
  moneyManagerSettings: MoneyManagerSettings;
  moneyManagerSummary?: Maybe<MoneyManagerSummary>;
  moneyRulesArchetypes?: Maybe<MoneyRulesArchetypesResult>;
  /** @deprecated Use moneyManagerSettings instead */
  moneyRulesSettings?: Maybe<MoneyRulesSettings>;
  /** Fetch the next billing date for a user */
  nextBillingDate?: Maybe<NextBillingDate>;
  nextTransferDate?: Maybe<NextTransferDateResult>;
  /** Does Absolutely Nothing */
  nothing?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<Offer>;
  onboardingBenefits?: Maybe<Array<OnboardingTileGroup>>;
  opsCode?: Maybe<Array<Maybe<OpsCode>>>;
  partnerOfferGroup?: Maybe<PartnerOfferGroup>;
  partnerOfferGroupCategories?: Maybe<Array<PartnerOfferGroup>>;
  partnerOfferGroupsByType?: Maybe<Array<PartnerOfferGroup>>;
  passwordResetFormFieldsByToken?: Maybe<PasswordResetForm>;
  pastLaterSummary?: Maybe<PastLaterSummary>;
  payoutRelationships: Array<Maybe<ReferralPayoutRelationship>>;
  /** Returns pending investments for the provided user and investment account id */
  pendingInvestments?: Maybe<InvestmentPagination>;
  pendingMoneyAssignments: Array<MoneyManagerMoneyAssignment>;
  personalizedEarnOffers?: Maybe<Array<EarnOffer>>;
  /** Get personalized offers for a given user */
  personalizedFoundMoney?: Maybe<Array<FoundMoneyCampaignV2>>;
  /** Performs a Plaid identity match. */
  plaidIdentityMatch: PlaidIdentityMatchResult;
  /** Fetch Portfolio by Id (UUID) */
  portfolioById?: Maybe<PortfolioMeta>;
  /** Get portfolio tags */
  portfolioTags: PortfolioTagTypePagination;
  /** Return all portfolios */
  portfolios: PortfolioMetaPagination;
  /** Number of files processed in the last n hours */
  processedRecently: Scalars['Int']['output'];
  /** Lookup a specific Product by it's unique id. */
  product?: Maybe<Product>;
  /** Lookup a specific Product by it's unique key. */
  productByKey?: Maybe<Product>;
  /** List all Products. */
  products?: Maybe<Array<Product>>;
  /** Fetch a single profile for a user */
  profile: InternalProfile;
  promoCodeApplied?: Maybe<PromoCode>;
  promoCodeRewards?: Maybe<PromoCodeRewardsConnection>;
  promoCodes?: Maybe<PromoCodesConnection>;
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  promoMilestoneChallengeId?: Maybe<Scalars['ID']['output']>;
  promotedBenefitsByUserId: Array<PromotedBenefit>;
  promotedCampaigns?: Maybe<PromotedCampaigns>;
  promotedEarnOffers?: Maybe<Array<EarnOffer>>;
  /** Lookup a particular promotion by it's unique id. */
  promotion?: Maybe<Promotion>;
  /** Get a list of promotions to which a user is eligible. */
  promotionsByUserId?: Maybe<Array<Promotion>>;
  /** Check if user is rate limited */
  rateLimits: RateLimitStatus;
  recommendedPortfolio?: Maybe<Suitability_Portfolio>;
  /** Get the Reconciliation File Information */
  reconciliationFileInformation?: Maybe<Array<ReconciliationFileInformationType>>;
  recurringTransfers?: Maybe<Array<Maybe<RecurringTransfer>>>;
  referralCampaignRewards?: Maybe<ReferralRewardsConnection>;
  referralCampaigns?: Maybe<ReferralCampaignConnection>;
  referralHistory?: Maybe<ReferralHistory>;
  referralPayouts?: Maybe<ReferralPayoutConnection>;
  referralRelationships?: Maybe<ReferralRelationshipConnection>;
  registeredAuthenticators?: Maybe<Array<Authenticator>>;
  riskModelData?: Maybe<RiskModelResponse>;
  riskModelToDoList: Array<DepositModelDataEntity>;
  roundUpAccount?: Maybe<RoundUpAccount>;
  roundUpAccounts: Array<RoundUpAccount>;
  roundUpProfile?: Maybe<RoundUpProfile>;
  roundUps: RoundUpTypePagination;
  sampleMailInDocument?: Maybe<SampleMailInDocument>;
  savingsAccountEligibilityByUserId?: Maybe<SavingsAccountEligibility>;
  searchActiveEarnOffers: EarnOfferQueryPage;
  /**
   * Fuzzy search for securities of the provided types (declared in SearchSecuritiesInput.securityTypes) by symbol and
   * company name.
   * Securities are selected as "candidates" and then ordered by SearchSecuritiesInput.orderby.
   * Results are served using a cursor-based pagination dictated by the page-size SearchSecuritiesInput.limit
   * and the cursor SearchSecuritiesInput.after
   */
  searchSecurities?: Maybe<SearchSecuritiesResponse>;
  /** Returns all relevant support articles and all categories given a query */
  searchSupportArticles?: Maybe<SearchSupportResult>;
  /**
   * Search for securities of the provided types (declared in SecuritiesBySectorInput.securityTypes) that are a part of
   * any/all of the provided trading sectors in SecuritiesBySectorInput.sectors.
   * Securities of the requested type that contain 1+ of the provided trading sectors are selected and then ordered by
   * SecuritiesBySectorInput.orderBy.
   * Results are served using a cursor-based pagination dictated by the page-size SecuritiesBySectorInput.limit
   * and the cursor SecuritiesBySectorInput.after.
   */
  securitiesBySector?: Maybe<SecuritiesBySectorResponse>;
  securitiesBySymbols?: Maybe<SecuritiesBySymbolsResponse>;
  securityBySymbol?: Maybe<Security>;
  securityPerformanceBySymbol?: Maybe<SecurityPerformance>;
  /** Provide historical end of day prices for many Securities */
  securityPerformancesBySymbol?: Maybe<Array<SecurityPerformance>>;
  /** Fetches a list of shared funding source(s) for a given funding source */
  sharedFundingSources?: Maybe<Array<FundingSource>>;
  /** Fetch a list of signatures for a user */
  signatures: Array<Maybe<Signature>>;
  /** Get the Signature Names for a File */
  signaturesSentByFilename?: Maybe<Array<SignatureInformationType>>;
  smartDepositMetadata?: Maybe<SmartDepositMetadataResult>;
  spendAccount?: Maybe<SpendAccount>;
  spendAlerts: Array<SpendAlert>;
  splitDepositSettings?: Maybe<SplitDepositSettings>;
  splitDepositSettingsByUserId?: Maybe<Array<SplitDepositSettings>>;
  /** Fetch a statement run by its ID. */
  statementRun: StatementRunResponse;
  /** Return a paginated list of statement runs */
  statementRuns: StatementRunPagination;
  /** Get statements reports archive by investment account */
  statementsByInvestmentAccountId: StatementPagination;
  subscriptionMigration?: Maybe<SubscriptionMigration>;
  subscriptionMigrationWaiver?: Maybe<SubscriptionMigrationWaiver>;
  subscriptionMigrationWaiversByUserId?: Maybe<Array<SubscriptionMigrationWaiver>>;
  suggestedMoneyRules?: Maybe<SuggestedMoneyRulesResult>;
  suitabilityHistory?: Maybe<Suitability_HistoryResult>;
  suitabilityResponses?: Maybe<Array<Suitability_SuitabilityResponse>>;
  suitabilityServiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Returns support article given an id */
  supportArticle?: Maybe<SupportArticle>;
  /** Returns all articles in section given a sectionId */
  supportArticlesBySectionId?: Maybe<Array<Maybe<SupportArticle>>>;
  /** Returns support category given an id */
  supportCategory?: Maybe<SupportCategory>;
  /**
   * See if in-app support chat is currently enabled. This is a fault-tolerant query and thus will return \`false\` rather than fail.
   * @deprecated Replaced with more general supportSchedule query.
   */
  supportChatEnabled: Scalars['Boolean']['output'];
  /** Returns most common faq articles if it has been set in Zesty */
  supportMostCommonFaq?: Maybe<Array<ContactFaq>>;
  /** See if specified support channel is currently enabled. This is a fault-tolerant query and thus will return \`false\` rather than fail. */
  supportSchedule?: Maybe<ScheduleResult>;
  /** Returns support section given an id */
  supportSection?: Maybe<SupportSection>;
  /** Returns all support sections by category id */
  supportSectionsByCategoryId?: Maybe<Array<Maybe<SupportSection>>>;
  /** Returns a support ticket by given case id */
  supportTicket?: Maybe<SupportTicket>;
  /** Return the given support ticket form by id */
  supportTicketForm?: Maybe<SupportTicketForm>;
  supportTicketFormField?: Maybe<SupportTicketFormField>;
  /** Lookup a Tier by it's unique id. */
  tier?: Maybe<Tier>;
  /**
   * Returns a tier group w/ tiers, products, prices, etc. Can not be tied to
   * a specfic user (needs to support anonymous users).
   * id is optional for case of returning default
   */
  tierGroup?: Maybe<TierGroup>;
  /** TierGroup for specific user (includes the Tier they are subscribed to) */
  tierGroupForUser?: Maybe<TierGroup>;
  /**
   * Returns the cheapest tier option for a given user's open accounts
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByOpenAccounts?: Maybe<TierOption>;
  /**
   * Returns the cheapest tier option for a given product key
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByProductKey?: Maybe<TierOption>;
  /**
   * For a given TierPriceId, returns the TierOption associated with that price id.
   * Returns InvalidTierPriceId if the tier price id is not found.
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByTierPriceId?: Maybe<TierOptionByTierPriceIdResult>;
  /** Any arbitrary subscription (current or historical) */
  tierSubscription?: Maybe<TierSubscription>;
  /** A User's TierSubscription by User.uuid. */
  tierSubscriptionByUserId?: Maybe<TierSubscription>;
  /**
   * The current subscription for an arbitrary user
   * @deprecated Use Query.tierSubscriptionByUserId.
   */
  tierSubscriptionForUser?: Maybe<TierSubscriptionForUser>;
  /** All of a Users's TierSubscriptions by User.uuid. */
  tierSubscriptionHistoryByUserId?: Maybe<TierSubscriptionConnection>;
  /** Show all active tiers */
  tiers?: Maybe<Array<Tier>>;
  /** Fetches TIN verification files */
  tinVerificationFiles: TinVerificationFilePagination;
  /** returns Plaid transactions data for user */
  transactions: TransactionPage;
  /** Get the files that haven't been processed on the USPS SFTP server. */
  unprocessedUSPSFiles: Array<Scalars['String']['output']>;
  /** Fetch a single user */
  user?: Maybe<User>;
  /** An array of agreements signed by a user. */
  userAgreements?: Maybe<Array<UserAgreement>>;
  /** An array of the alerts for a user. */
  userAlerts?: Maybe<Array<UserAlertsResponse>>;
  userBenefitsStatus: BenefitsStatusResponse;
  /** An array of user breadcrumbs */
  userBreadcrumbs: UserBreadcrumbTypePagination;
  /** Fetch all credentials types for a given user */
  userCredentials: Array<Maybe<UserCredentials>>;
  /** Fetch a single user's flags */
  userFlags: Array<Maybe<UserFlag>>;
  /** Referral invitation information */
  userInvitation?: Maybe<UserInvitation>;
  /** Fetch a single user's external matches */
  userMatches: Array<Maybe<UserMatch>>;
  /** User information performance calculations data */
  userPerformanceCalculations: UserPerformanceResponse;
  /** Referrer user information */
  userReferredBy?: Maybe<UserReferredBy>;
  /** Return the user switches' state */
  userState: UserStatePayload;
  /** Return all the switches for a user */
  userSwitches: UserSwitchesPayload;
  userTokensByUserId: Array<Maybe<UserToken>>;
  /** Returns user winback score */
  userWinbackScore?: Maybe<UserWinbackScoreRes>;
  users?: Maybe<UsersResponse>;
  /** USPS responses for a user */
  uspsResponses: Array<Scalars['String']['output']>;
  validatePasswordResetToken: ValidatePasswordResetTokenResult;
  verificationProfile?: Maybe<VerificationProfile>;
  /** An array of verification uploads */
  verificationUploads: Array<VerificationUploadsResponse>;
  verifyCheckPaymentRecipientAddress?: Maybe<VerifyCheckPaymentRecipientAddressResult>;
  verifyPromoCode?: Maybe<VerifyPromoCodeResponse>;
  /**  Estimated withholding amounts (only on gains for Roth IRAs) */
  withholdingEstimates?: Maybe<WithholdingEstimates>;
  yearLaterReport: YearLaterReport;
};


export type QueryAbilitiesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAcceptanceDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAcceptanceDocumentVersionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAcceptanceDocumentVersionFiltersArgs = {
  versionId: Scalars['ID']['input'];
};


export type QueryAcceptanceDocumentVersionsArgs = {
  acceptanceDocumentId: Scalars['ID']['input'];
};


export type QueryAcceptanceDocumentsArgs = {
  pageInput?: InputMaybe<PageInput>;
};


export type QueryAccountPointsRuleByMilestoneIdArgs = {
  milestoneID: Scalars['ID']['input'];
};


export type QueryAccountStrengthArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']['input']>;
  userUuid: Scalars['ID']['input'];
};


export type QueryAccountVerificationQueueArgs = {
  requestInput: AccountVerificationQueueInput;
};


export type QueryAccountsArgs = {
  status?: InputMaybe<Array<InputMaybe<AccountStatus>>>;
  userId: Scalars['ID']['input'];
};


export type QueryActiveEarnOffersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAddressesArgs = {
  addressType?: InputMaybe<AddressType>;
  userId: Scalars['ID']['input'];
};


export type QueryAdminAppArgs = {
  input: AdminAppInput;
};


export type QueryAdminAppsArgs = {
  input: AdminAppsInput;
};


export type QueryAdvocateArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdvocateFriendsStatusesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAlertCardsArgs = {
  userUuid: Scalars['ID']['input'];
};


export type QueryAlertHubBeneficiaryAlertsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAllAcceptanceDocumentsArgs = {
  requiredFor?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllBankAccountsArgs = {
  input: InternalAllBankAccountsInput;
};


export type QueryAllBankCardsArgs = {
  filter?: InputMaybe<AllBankCardsFilter>;
  input: InternalAllBankCardsInput;
};


export type QueryAllBankCustomerAddressesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAllBankTransactionsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  beginDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  pagination?: InputMaybe<PageInput>;
  userId: Scalars['ID']['input'];
};


export type QueryAllCardTrackingStatusesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAllCheckPaymentsArgs = {
  pageInput?: InputMaybe<PageInput>;
  userId: Scalars['ID']['input'];
};


export type QueryAllMessagesArgs = {
  categoryFilters?: InputMaybe<Array<MessageCategory>>;
  statusFilters?: InputMaybe<Array<MessageStatusFilterInput>>;
  typeFilters?: InputMaybe<Array<MessageType>>;
  userId: Scalars['ID']['input'];
};


export type QueryAllPastSpendItemsArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AllPastSpendItemsSchemaFilter>;
  pagination?: InputMaybe<PageInput>;
  userId: Scalars['ID']['input'];
};


export type QueryAllPendingBankTransfersArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryAllSupportArticlesArgs = {
  filter?: InputMaybe<AllSupportArticlesFilterInput>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllSupportSectionsArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllTrustedContactsByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAuditLogsArgs = {
  auditLogFilterInput?: InputMaybe<AuditLogFilterInput>;
};


export type QueryAuthAlertsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAuthProfileArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAuthenticateForFeeNegotiationStatusByLinkedAccountIdArgs = {
  linkedAccountId: Scalars['ID']['input'];
};


export type QueryAutoInvestChangesByUserIdArgs = {
  pageInput?: InputMaybe<PageInput>;
  userUuid: Scalars['ID']['input'];
};


export type QueryBackendJobBatchAutomatedOrdersArgs = {
  filter: BackendJobBatchAutomatedOrdersFilterInput;
};


export type QueryBackendJobBatchMoneyMovementArgs = {
  filter: BackendJobBatchMoneyMovementFilterInput;
};


export type QueryBackendJobBatchOrdersArgs = {
  filter: BackendJobBatchOrdersFilterInput;
};


export type QueryBackendJobBatchProfitStarsArgs = {
  filter: BackendJobBatchProfitStarsFilterInput;
};


export type QueryBackendJobBatchSummaryArgs = {
  filter: BackendJobBatchSummaryFilterInput;
};


export type QueryBankAccountStateArgs = {
  accountType?: InputMaybe<BankAccountType>;
  userId: Scalars['ID']['input'];
};


export type QueryBankAdminSearchDynamoDbArgs = {
  input: BankAdminSearchDynamoDbInput;
};


export type QueryBankCardOrderArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryBankCardPanDisplayArgs = {
  endUserRequestIps: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryBankCardProvisioningDetailsArgs = {
  nonce: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryBankCardReissueArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryBankDisclosureDocumentFileArgs = {
  bankType: BankType;
  documentId: Scalars['ID']['input'];
};


export type QueryBankFeeNegotiationsByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryBankFeeSummaryByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryBankFeesByUserIdArgs = {
  filter?: InputMaybe<BankFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<Array<InputMaybe<FeeStatusFilter>>>;
  userId: Scalars['ID']['input'];
};


export type QueryBankInterestRatesArgs = {
  includeHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  productFilter?: InputMaybe<Array<InputMaybe<BankingProduct>>>;
  refreshInterestRateCache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBankTransactionArgs = {
  bankAccountType?: InputMaybe<BankAccountType>;
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryBankTransactionByTagArgs = {
  tag: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryBankingKycDetailsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryBanksByNameByRoutingNumberArgs = {
  bankName?: InputMaybe<Scalars['String']['input']>;
  pageInput?: InputMaybe<PageInput>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBatchEstimatedTransferDatesArgs = {
  input?: InputMaybe<BatchEstimatedTransferDatesInternalInput>;
};


export type QueryBeneficiariesArgs = {
  custodianId: Scalars['ID']['input'];
};


export type QueryBeneficiaryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBeneficiarySsnArgs = {
  id: Scalars['ID']['input'];
  sharedSecret: Scalars['ID']['input'];
};


export type QueryBgpReportDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBgpReportsArgs = {
  input?: InputMaybe<BgpReportFilterInput>;
};


export type QueryBillingCycleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBillingCyclesArgs = {
  state?: InputMaybe<Array<InputMaybe<BillingCycleState>>>;
  userId: Scalars['ID']['input'];
};


export type QueryBillingCyclesByInvoiceDateArgs = {
  invoiceDate: Scalars['Date']['input'];
  pageInput?: InputMaybe<PageInput>;
  state?: InputMaybe<Array<InputMaybe<BillingCycleState>>>;
};


export type QueryBillingProfileArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryBulkCardTrackingStatusByReferenceIdsArgs = {
  referenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCalculateMoneySplitsArgs = {
  moneySource: MoneyRulesMoneySourceInput;
  overrides?: InputMaybe<MoneyRulesSplitOverridesInput>;
  userId: Scalars['ID']['input'];
};


export type QueryCampaignHistoryArgs = {
  filter: CampaignHistoryFilter;
  page: ReferralPaginatedFilter;
  userId: Scalars['ID']['input'];
};


export type QueryChallengesArgs = {
  deliveryType?: InputMaybe<ChallengeDeliveryType>;
  userId: Scalars['ID']['input'];
};


export type QueryClosureReasonsByInvestmentAccountTypeArgs = {
  product?: InputMaybe<InvestmentProduct>;
};


export type QueryCohortReasonsByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCompletedInvestmentsArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']['input']>;
  pageInput?: InputMaybe<PageInput>;
  userId: Scalars['ID']['input'];
};


export type QueryConnectionsByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryCreditsByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCustomerActionByUserIdArgs = {
  pageInput?: InputMaybe<PageInput>;
  userUuid: Scalars['ID']['input'];
};


export type QueryCustomerChangesByCustomerActionArgs = {
  pageInput?: InputMaybe<PageInput>;
  userUuid: Scalars['ID']['input'];
};


export type QueryCustomerChangesByUserByTypeArgs = {
  requestInput: CustomerChangesByUserByTypeInput;
};


export type QueryCustomerEarnOnboardingProgramArgs = {
  userId: Scalars['ID']['input'];
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryCustomerMoneyRulesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryDecisionsByTraceIdArgs = {
  traceId: Scalars['String']['input'];
};


export type QueryDeviceArgs = {
  deviceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryDevicesByUserIdArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryDirectDepositInfoArgs = {
  input: DirectDepositInfoInput;
};


export type QueryDirectDepositPdfArgs = {
  input: DirectDepositPdfInput;
};


export type QueryDividendsBySymbolArgs = {
  input: DividendsBySymbolInput;
};


export type QueryDocumentRequestArgs = {
  input: DocumentRequestInput;
};


export type QueryDocumentRequestsArgs = {
  input: DocumentRequestsInput;
};


export type QueryDocumentsToBeReviewedArgs = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEarlyAccountTransferInfoArgs = {
  investmentAccountId: Scalars['ID']['input'];
};


export type QueryEarnCtaDataByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryEarnOfferByCampaignOfferIdArgs = {
  campaignOfferId: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  incentiveTemplate?: InputMaybe<EarnOfferIncentiveTemplate>;
  origin: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type QueryEarnRewardsByInvestmentIdsArgs = {
  investmentIds: Array<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmailAddressValidationArgs = {
  email: Scalars['EmailAddress']['input'];
};


export type QueryEstimatedTransferDatesArgs = {
  input?: InputMaybe<EstimatedTransferDatesInternalInput>;
};


export type QueryExtoleCampaignHistoryArgs = {
  page: ReferralPaginatedFilter;
  userId: Scalars['ID']['input'];
};


export type QueryExtoleReferralHistoryArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryFavoriteEarnOffersArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryFeaturedMilestonesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryFeaturedMilestones_V2Args = {
  userId: Scalars['ID']['input'];
};


export type QueryFeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeesArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  billingCycleId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFoundMoneyRewardsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFoundMoneyRewardsV2Args = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFoundMoneySummaryArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFriendArgs = {
  advocateReferralCode?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryFriendV2Args = {
  userId: Scalars['ID']['input'];
};


export type QueryFundingSourceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFundingSourceChangeRequestArgs = {
  counter?: InputMaybe<Scalars['Boolean']['input']>;
  fundingSourceStatus?: InputMaybe<FundingSourceChangeStatus>;
  order?: InputMaybe<OrderByTypes>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFundingSourcesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  userUuid: Scalars['ID']['input'];
};


export type QueryGetBillingHistoryArgs = {
  state?: InputMaybe<Array<InputMaybe<BillingCycleState>>>;
  userId: Scalars['ID']['input'];
};


export type QueryGetConnectCategoryArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryGetOauthAppArgs = {
  oauthAppId: Scalars['ID']['input'];
};


export type QueryGetPlaidAccountDetailsArgs = {
  externalId: Scalars['String']['input'];
  linkedSubAccountId: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};


export type QueryGetRelevantMacrosArgs = {
  input: CaseInput;
};


export type QueryGetScopeArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryGetUsersBankFromAccountTypeArgs = {
  type: BankAccountType;
  userId: Scalars['ID']['input'];
};


export type QueryGetVendorInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryHelpFormContentArgs = {
  form: HelpFormType;
};


export type QueryInstantSearchSupportArticlesArgs = {
  isPrivate: Scalars['Boolean']['input'];
  query: Scalars['String']['input'];
};


export type QueryInvestmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvestmentAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvestmentAccountByBeneficiaryIdArgs = {
  beneficiaryId: Scalars['ID']['input'];
};


export type QueryInvestmentAccountCalculationsArgs = {
  investmentAccountId: Scalars['ID']['input'];
};


export type QueryInvestmentAccountReopenRequestsArgs = {
  input: InvestmentAccountReopenRequestsInput;
  pageInput?: InputMaybe<PageInput>;
};


export type QueryInvestmentAccountsByUserIdArgs = {
  filter?: InputMaybe<InvestmentAccountsByUserIdFilter>;
  userId: Scalars['ID']['input'];
};


export type QueryInvestmentByNonceArgs = {
  nonce: Scalars['ID']['input'];
};


export type QueryInvestmentsByInvestmentAccountIdArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  investmentAccountId: Scalars['ID']['input'];
  pageInput?: InputMaybe<PageInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryIsPhoneNumberOptedOutArgs = {
  phoneNumber: Scalars['PhoneNumber']['input'];
};


export type QueryIsSpendUserWhitelistedArgs = {
  input: IsSpendUserWhitelistedInput;
};


export type QueryJobAlertsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryJobSearchArgs = {
  searchCriteria: JobSearchCriteriaInput;
  userId: Scalars['String']['input'];
};


export type QueryJobSearchPageArgs = {
  userId: Scalars['String']['input'];
};


export type QueryJobSearchV2Args = {
  pagination: PageInput;
  saveAsRecentSearch?: InputMaybe<Scalars['Boolean']['input']>;
  searchCriteria: JobSearchCriteriaInput;
  userId: Scalars['String']['input'];
};


export type QueryLaterContributionAbilityArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLaterUserContributionAbilityArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryLegacyDocumentRequestsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryLegacyUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryLegacyUserReferralsByArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryLinkAttemptsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryLinkedAccountAlertsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryLinkedAccountsArgs = {
  externalSources?: InputMaybe<Array<LinkedAccountExternalSourceEnum>>;
  linked?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryLinkedAccountsWithoutLegacyFundingSourcesArgs = {
  externalSources?: InputMaybe<Array<LinkedAccountExternalSourceEnum>>;
  linked?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryLinkedSubaccountArgs = {
  linkedSubaccountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryLinkedSubaccountsArgs = {
  linked?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryLiquidationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLiquidationsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  billingCycleId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryListBenefitsByUserIdArgs = {
  group?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<BenefitsTrackerProducts>;
  userId: Scalars['ID']['input'];
};


export type QueryListUserWaiverCouponsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMaintenanceFlagsArgs = {
  flags: Array<MaintenanceFlagsArgs>;
};


export type QueryMessageArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryMessageByExternalIdArgs = {
  externalId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryMessagesArgs = {
  categoryFilters?: InputMaybe<Array<MessageCategory>>;
  pagination?: InputMaybe<MessagePageInput>;
  statusFilters?: InputMaybe<Array<MessageStatusFilterInput>>;
  typeFilters?: InputMaybe<Array<MessageType>>;
  userId: Scalars['ID']['input'];
};


export type QueryMilestoneArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryMilestoneAchievementActionRuleArgs = {
  milestoneID: Scalars['ID']['input'];
};


export type QueryMilestoneChallengeArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryMilestoneChallengePointsRuleByMilestoneIdByChallengeIdArgs = {
  challengeID: Scalars['ID']['input'];
  milestoneID: Scalars['ID']['input'];
};


export type QueryMilestoneChallengePointsRulesByMilestoneIdArgs = {
  milestoneID: Scalars['ID']['input'];
};


export type QueryMilestoneDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMilestoneEligibilityByScopesArgs = {
  scopes: Array<MilestoneEligibilityScope>;
  userId: Scalars['ID']['input'];
};


export type QueryMilestoneGroupAchievementActionRuleArgs = {
  milestoneGroupID: Scalars['ID']['input'];
};


export type QueryMilestoneGroupDefinitionArgs = {
  groupID: Scalars['ID']['input'];
};


export type QueryMilestoneHubArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMilestoneHubDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMilestoneHubEligibleArgs = {
  registrationCompletedAt: Scalars['DateTime']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryMilestonesByThemeArgs = {
  filter?: InputMaybe<MilestoneByThemeFilterInput>;
  theme: MilestoneTheme;
  userId: Scalars['ID']['input'];
};


export type QueryMoneyAssignmentArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerAllocationOptionsArgs = {
  input: MoneyManagerAllocationOptionsInput;
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerAutomationTargetDefaultsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerAutomationTargetsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerCascadeObjectivesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerCategoriesArgs = {
  input?: InputMaybe<MoneyManagerCategoriesInput>;
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerDepositHistoryArgs = {
  pagination?: InputMaybe<MoneyManagerPageInput>;
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerEligibilityArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerPaychecksArgs = {
  employer?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerRebalancesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerScheduledDepositsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerScheduledPaycheckPerEmployerArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerSettingsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMoneyManagerSummaryArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMoneyRulesArchetypesArgs = {
  input?: InputMaybe<MoneyRulesArchetypesInput>;
};


export type QueryMoneyRulesSettingsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryNextBillingDateArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryNextTransferDateArgs = {
  recurrenceRule: RecurrenceRuleInput;
};


export type QueryOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOnboardingBenefitsArgs = {
  input?: InputMaybe<OnboardingBenefitsInput>;
  userId: Scalars['ID']['input'];
};


export type QueryOpsCodeArgs = {
  filter?: InputMaybe<OpsCodeFilterInput>;
};


export type QueryPartnerOfferGroupArgs = {
  filter?: InputMaybe<PartnerOfferGroupFilterInput>;
  id: Scalars['String']['input'];
};


export type QueryPartnerOfferGroupCategoriesArgs = {
  ids: Array<Scalars['ID']['input']>;
  incentiveTemplate?: InputMaybe<EarnOfferIncentiveTemplate>;
};


export type QueryPartnerOfferGroupsByTypeArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  partnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput;
};


export type QueryPasswordResetFormFieldsByTokenArgs = {
  resetToken: Scalars['String']['input'];
};


export type QueryPastLaterSummaryArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPayoutRelationshipsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  payoutId?: InputMaybe<Scalars['ID']['input']>;
  relationshipId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPendingInvestmentsArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']['input']>;
  pageInput?: InputMaybe<PageInput>;
  userId: Scalars['ID']['input'];
};


export type QueryPendingMoneyAssignmentsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryPersonalizedEarnOffersArgs = {
  platform?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonalizedFoundMoneyArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlaidIdentityMatchArgs = {
  input: PlaidIdentityMatchInput;
};


export type QueryPortfolioByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPortfolioTagsArgs = {
  pageInput?: InputMaybe<PageInput>;
};


export type QueryPortfoliosArgs = {
  filter?: InputMaybe<PortfolioInput>;
  pageInput?: InputMaybe<PageInput>;
};


export type QueryProcessedRecentlyArgs = {
  numberHours?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductByKeyArgs = {
  productKey: ProductKey;
};


export type QueryProfileArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryPromoCodeAppliedArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryPromoCodeRewardsArgs = {
  page: PromoCodePaginatedFilter;
};


export type QueryPromoCodesArgs = {
  page: PromoCodePaginatedFilter;
};


export type QueryPromoMilestoneChallengeIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryPromotedBenefitsByUserIdArgs = {
  product?: InputMaybe<BenefitsTrackerProducts>;
  userId: Scalars['ID']['input'];
};


export type QueryPromotedEarnOffersArgs = {
  platform?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPromotionsByUserIdArgs = {
  filter?: InputMaybe<PromotionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryRateLimitsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryRecommendedPortfolioArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryReconciliationFileInformationArgs = {
  date: Scalars['String']['input'];
};


export type QueryRecurringTransfersArgs = {
  filter?: InputMaybe<RecurringTransfersFilterInput>;
  userId: Scalars['ID']['input'];
};


export type QueryReferralCampaignRewardsArgs = {
  filter: ReferralPaginatedFilter;
};


export type QueryReferralCampaignsArgs = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  filter: ReferralPaginatedFilter;
};


export type QueryReferralHistoryArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryReferralPayoutsArgs = {
  filter: ReferralPayoutsFilter;
  page: ReferralPaginatedFilter;
};


export type QueryReferralRelationshipsArgs = {
  filter: ReferralRelationshipsFilter;
  page: ReferralPaginatedFilter;
};


export type QueryRegisteredAuthenticatorsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryRiskModelDataArgs = {
  filter?: InputMaybe<RiskModelFilterInput>;
};


export type QueryRiskModelToDoListArgs = {
  filter?: InputMaybe<RiskModelToDoListFilterInput>;
};


export type QueryRoundUpAccountArgs = {
  linkedSubaccountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryRoundUpAccountsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryRoundUpProfileArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryRoundUpsArgs = {
  autoInvestable?: InputMaybe<Scalars['Boolean']['input']>;
  instant?: InputMaybe<Scalars['Boolean']['input']>;
  investmentId?: InputMaybe<Scalars['ID']['input']>;
  investmentNonce?: InputMaybe<Scalars['ID']['input']>;
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  pageInput?: InputMaybe<PageInput>;
  state?: InputMaybe<Array<RoundUpState>>;
  targetAccountId?: InputMaybe<Scalars['ID']['input']>;
  transactionDateAfter?: InputMaybe<Scalars['String']['input']>;
  transactionDateBefore?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type QuerySampleMailInDocumentArgs = {
  typeFilter: MailInDocumentType;
};


export type QuerySavingsAccountEligibilityByUserIdArgs = {
  type: SavingsAccountType;
  userId: Scalars['ID']['input'];
};


export type QuerySearchActiveEarnOffersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchSecuritiesArgs = {
  input: SearchSecuritiesInput;
};


export type QuerySearchSupportArticlesArgs = {
  isPrivate: Scalars['Boolean']['input'];
  query: Scalars['String']['input'];
};


export type QuerySecuritiesBySectorArgs = {
  input: SecuritiesBySectorInput;
};


export type QuerySecuritiesBySymbolsArgs = {
  input: SecuritiesBySymbolsInput;
};


export type QuerySecurityBySymbolArgs = {
  input: SecurityBySymbolInput;
};


export type QuerySecurityPerformanceBySymbolArgs = {
  input: SecurityPerformanceBySymbolInput;
};


export type QuerySecurityPerformancesBySymbolArgs = {
  input: SecurityPerformancesBySymbolInput;
};


export type QuerySharedFundingSourcesArgs = {
  limit: Scalars['Int']['input'];
  uuid: Scalars['ID']['input'];
};


export type QuerySignaturesArgs = {
  signatureType?: InputMaybe<SignatureType>;
  userId: Scalars['ID']['input'];
};


export type QuerySignaturesSentByFilenameArgs = {
  filename: Scalars['String']['input'];
};


export type QuerySmartDepositMetadataArgs = {
  smartDepositMetadataInput: SmartDepositMetadataInput;
  userId: Scalars['ID']['input'];
};


export type QuerySpendAccountArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerySpendAlertsArgs = {
  input: SpendAlertsInput;
};


export type QuerySplitDepositSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySplitDepositSettingsByUserIdArgs = {
  filter?: InputMaybe<SplitDepositSettingsFilterInput>;
  normalizeToFrequency?: InputMaybe<SplitDepositNormalizationFrequency>;
  userId: Scalars['ID']['input'];
};


export type QueryStatementRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStatementRunsArgs = {
  pageInput?: InputMaybe<PageInput>;
};


export type QueryStatementsByInvestmentAccountIdArgs = {
  filters?: InputMaybe<StatementsByInvestmentAccountIdFilter>;
  investmentAccountId: Scalars['ID']['input'];
  pageInput?: InputMaybe<PageInput>;
};


export type QuerySubscriptionMigrationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubscriptionMigrationWaiverArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubscriptionMigrationWaiversByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerySuggestedMoneyRulesArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerySuitabilityHistoryArgs = {
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QuerySuitabilityResponsesArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerySuitabilityServiceEnabledArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerySupportArticleArgs = {
  id: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySupportArticlesBySectionIdArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId: Scalars['ID']['input'];
};


export type QuerySupportCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QuerySupportScheduleArgs = {
  input: ScheduleInput;
};


export type QuerySupportSectionArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId: Scalars['ID']['input'];
};


export type QuerySupportSectionsByCategoryIdArgs = {
  categoryId: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySupportTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupportTicketFormArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupportTicketFormFieldArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTierGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTierGroupForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryTierOptionByOpenAccountsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryTierOptionByProductKeyArgs = {
  productKey: ProductKey;
  tierGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTierOptionByTierPriceIdArgs = {
  tierPriceId: Scalars['ID']['input'];
};


export type QueryTierSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTierSubscriptionByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryTierSubscriptionForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryTierSubscriptionHistoryByUserIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryTinVerificationFilesArgs = {
  pageInput?: InputMaybe<PageInput>;
};


export type QueryTransactionsArgs = {
  endDate: Scalars['String']['input'];
  linkedSubaccountId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserAgreementsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserAlertsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserBenefitsStatusArgs = {
  benefitProductKey?: InputMaybe<Scalars['String']['input']>;
  tierKey: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryUserBreadcrumbsArgs = {
  byUser?: InputMaybe<Scalars['ID']['input']>;
  forUser?: InputMaybe<Scalars['ID']['input']>;
  pageInput?: InputMaybe<PageInput>;
  type?: InputMaybe<BreadcrumbTypeEnum>;
};


export type QueryUserCredentialsArgs = {
  credentialsType?: InputMaybe<CredentialsType>;
  userId: Scalars['ID']['input'];
};


export type QueryUserFlagsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserInvitationArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserMatchesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserPerformanceCalculationsArgs = {
  investmentAccountId: Scalars['ID']['input'];
  userUuid: Scalars['ID']['input'];
};


export type QueryUserReferredByArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserStateArgs = {
  input: UserStateInput;
};


export type QueryUserSwitchesArgs = {
  input: UserSwitchesInput;
};


export type QueryUserTokensByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserWinbackScoreArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersArgs = {
  input: UsersInput;
};


export type QueryUspsResponsesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryValidatePasswordResetTokenArgs = {
  resetToken: Scalars['String']['input'];
};


export type QueryVerificationProfileArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryVerificationUploadsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryVerifyCheckPaymentRecipientAddressArgs = {
  input: VerifyCheckPaymentRecipientAddressInputType;
  userId: Scalars['ID']['input'];
};


export type QueryVerifyPromoCodeArgs = {
  name: Scalars['String']['input'];
};


export type QueryWithholdingEstimatesArgs = {
  federalWithholdingPercentage: Scalars['Float']['input'];
  investmentAccountId: Scalars['ID']['input'];
  reason?: InputMaybe<LaterWithdrawalReason>;
  stateWithholdingPercentage: Scalars['Float']['input'];
  withdrawalAmount: CurrencyAmountInput;
};


export type QueryYearLaterReportArgs = {
  year: Scalars['Int']['input'];
};

/** Random Deposit Verification Fields for Funding Source */
export type RandomDepositVerification = {
  __typename?: 'RandomDepositVerification';
  attempts?: Maybe<Scalars['Int']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
  gatewaySettlement?: Maybe<Scalars['String']['output']>;
  gatewayStatus?: Maybe<Scalars['String']['output']>;
  initiated?: Maybe<Scalars['Boolean']['output']>;
  lastStatusAt?: Maybe<Scalars['DateTime']['output']>;
  profitStarsCreditId?: Maybe<Scalars['String']['output']>;
  triggeredAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RateLimitDoesNotExistException = {
  __typename?: 'RateLimitDoesNotExistException';
  userId?: Maybe<Scalars['ID']['output']>;
};

export type RateLimitStatus = {
  __typename?: 'RateLimitStatus';
  /** The remaining duration of the block in milliseconds */
  challengeBlockDurationRemaining?: Maybe<Scalars['Int']['output']>;
  isBlocked: Scalars['Boolean']['output'];
  /** The remaining duration of the block in milliseconds */
  loginBlockDurationRemaining?: Maybe<Scalars['Int']['output']>;
};

/** RDVs are required user alert. */
export type RdvRequiredUserAlert = UserAlertsItem & {
  __typename?: 'RdvRequiredUserAlert';
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

/** Response to reactivating a deactivated beneficiary */
export type ReactivateBeneficiaryResult = BeneficiaryNotFoundException | InternalBeneficiary | InternalErrorException;

export type ReadMessageInput = {
  messageId: Scalars['ID']['input'];
};

export type ReallocateClosedAccountsResult = {
  __typename?: 'ReallocateClosedAccountsResult';
  reallocatedSettings: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type RecaptchaException = {
  __typename?: 'RecaptchaException';
  errorCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Recommended investing strategy */
export type RecommendedInvestingStrategy = {
  __typename?: 'RecommendedInvestingStrategy';
  accountSubtype: SuitabilityAccountSubtype;
  accountType: SuitabilityAccountType;
  /** Timestamp when recommendation was recorded */
  createdAt: Scalars['DateTime']['output'];
  portfolioId?: Maybe<Scalars['ID']['output']>;
};

/** Statement run cannot be reconciled. */
export type ReconcileStatementRunNotAllowedException = {
  __typename?: 'ReconcileStatementRunNotAllowedException';
  message: Scalars['String']['output'];
};

/** Result of statement run reconciliation */
export type ReconcileStatementRunResponse = ReconcileStatementRunNotAllowedException | StatementRun | StatementRunNotFoundException;

/** Reconciliation file information */
export type ReconciliationFileInformationType = {
  __typename?: 'ReconciliationFileInformationType';
  /** Bucket prefix / date */
  bucketPrefix: Scalars['String']['output'];
  /** Number of signatures that CPI processed */
  cpiCount?: Maybe<Scalars['Int']['output']>;
  /** Time the file was created */
  createdAt: Scalars['DateTime']['output'];
  /** File name sent to CPI */
  fileName: Scalars['String']['output'];
  /** Id of record */
  id: Scalars['String']['output'];
  /** Number of signatures sent if the file */
  imageFileCount: Scalars['Int']['output'];
  /** Whether CPI processed or not */
  processedByCpi?: Maybe<Scalars['Boolean']['output']>;
  /** SHA of the files */
  sha1Hash?: Maybe<Scalars['String']['output']>;
  /** Time the file was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type RecordReferralEventInput = {
  /** Time Event got Recorded */
  eventRecordedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Type of referral event */
  eventType: ReferralEventTypeV2;
  /** Friend who triggered the Event */
  friendId: Scalars['ID']['input'];
  /** subType of the Event */
  subType?: InputMaybe<ReferralEventType>;
};

export type RecordReferralEventResult = QualificationSubTypeMismatchError | ReferralEventV2 | ReferralRelationshipMissingError | RelationshipAlreadyQualifiedError;

export type RecordVendorExternalTransactionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  collectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<SubscriptionPaymentMethod>;
};

export type RecordVendorExternalTransactionResult = BillingVendorError | Transaction;

export enum RecurrenceFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type RecurrenceRule = {
  __typename?: 'RecurrenceRule';
  byMonthDay?: Maybe<Array<Scalars['Int']['output']>>;
  byWeekDay?: Maybe<Array<DayOfWeek>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  frequency: RecurrenceFrequency;
  interval: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type RecurrenceRuleInput = {
  byMonthDay?: InputMaybe<Array<Scalars['Int']['input']>>;
  byWeekDay?: InputMaybe<Array<DayOfWeek>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  frequency: RecurrenceFrequency;
  interval: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum RecurringDepositFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

/** Preferences for recurring deposit settings */
export type RecurringDepositSettings = {
  __typename?: 'RecurringDepositSettings';
  /** Amount of money to be recurring deposited */
  amount: MonetaryAmount;
  /** The frequency is the id based on Internal::Types::Enums::RecurringDepositFrequency */
  frequency: Scalars['Int']['output'];
  /** Updater feedback message */
  message: Scalars['String']['output'];
};

/** Recurring investment settings for the specified investment account. */
export type RecurringDepositSettingsInput = {
  /** Recurring investment amount */
  amount: Scalars['String']['input'];
  /** The frequency of the recurring deposits */
  frequency: RecurringDepositFrequency;
  /** The ID of the investment account to be updated */
  investmentAccountId: Scalars['ID']['input'];
};

/** Recurring deposit settings for an account */
export type RecurringInvestmentSettings = TimestampsInterface & {
  __typename?: 'RecurringInvestmentSettings';
  amount?: Maybe<Scalars['Float']['output']>;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  day?: Maybe<Scalars['Int']['output']>;
  frequency?: Maybe<InvestmentFrequency>;
  /** Next scheduled date of a configured recurring investment. */
  nextInvestmentAt?: Maybe<Scalars['Date']['output']>;
  /** Accounts Gateway ID of the account that will be debited for the recurring investment */
  sourceAccountId?: Maybe<Scalars['String']['output']>;
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
};

export type RecurringTransfer = {
  __typename?: 'RecurringTransfer';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  nextTransferDate?: Maybe<Scalars['Date']['output']>;
  recurrenceRule: RecurrenceRule;
  transferEvent: RecurringTransferEvent;
};

export type RecurringTransferAccount = {
  __typename?: 'RecurringTransferAccount';
  id: Scalars['ID']['output'];
  type: RecurringTransferAccountType;
};

export type RecurringTransferAccountIdFilterInput = {
  filter?: InputMaybe<RecurringTransferDirectionFilterInput>;
  targetAccountId: Scalars['ID']['input'];
};

export type RecurringTransferAccountInput = {
  id: Scalars['ID']['input'];
  type: RecurringTransferAccountType;
};

export enum RecurringTransferAccountType {
  Spend = 'SPEND'
}

export type RecurringTransferDate = {
  __typename?: 'RecurringTransferDate';
  nextTransferDate?: Maybe<Scalars['Date']['output']>;
};

export enum RecurringTransferDirection {
  Deposit = 'DEPOSIT',
  Withdrawal = 'WITHDRAWAL'
}

export type RecurringTransferDirectionFilterInput = {
  direction: RecurringTransferDirection;
};

export type RecurringTransferEvent = {
  __typename?: 'RecurringTransferEvent';
  amount: CurrencyAmount;
  direction: RecurringTransferDirection;
  fundingSource: RecurringTransferFundingSource;
  targetAccount: RecurringTransferAccount;
};

export type RecurringTransferEventInput = {
  amount: CurrencyAmountInput;
  direction: RecurringTransferDirection;
  fundingSource: RecurringTransferFundingSourceInput;
  targetAccount: RecurringTransferAccountInput;
};

export type RecurringTransferFundingSource = {
  __typename?: 'RecurringTransferFundingSource';
  id: Scalars['ID']['output'];
  type: RecurringTransferFundingSourceType;
};

export type RecurringTransferFundingSourceInput = {
  id: Scalars['ID']['input'];
  type: RecurringTransferFundingSourceType;
};

export enum RecurringTransferFundingSourceType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type RecurringTransferPathException = {
  __typename?: 'RecurringTransferPathException';
  exception: RecurringTransferPathExceptionCase;
  path: Array<Scalars['String']['output']>;
};

export enum RecurringTransferPathExceptionCase {
  Blank = 'BLANK',
  InvalidValue = 'INVALID_VALUE'
}

export type RecurringTransfersFilterInput = {
  filter?: InputMaybe<RecurringTransferAccountIdFilterInput>;
  targetAccountType: RecurringTransferAccountType;
};

export type RedeemedWaiverCoupon = {
  __typename?: 'RedeemedWaiverCoupon';
  couponId?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountType: Scalars['String']['output'];
  waiverPeriodEndDate: Scalars['String']['output'];
  waiverType: Scalars['String']['output'];
};

/** Object with friend campaign information such as completed events and reward statuses */
export type ReferralCampaign = {
  __typename?: 'ReferralCampaign';
  /** The email of the advocate participating in the campaign */
  advocateEmail: Scalars['String']['output'];
  /**
   * Advocate Reward for completing all necessary steps. The object assumes that the
   * advocateUserId on type ReferralCampaign is the user that will receive the reward, but
   * friends can potentially have multiple advocates. Further investigation may be required.
   */
  advocateRewards?: Maybe<Array<ReferralReward>>;
  /** The id of the advocate participating in the campaign */
  advocateUserId?: Maybe<Scalars['ID']['output']>;
  /** The id of the referral campaign that is also associated with the campaign id in Extole */
  campaignId: Scalars['ID']['output'];
  /** A list of events and their statuses to earn reward */
  events?: Maybe<Array<ReferralEvent>>;
  /** The email of the friend participating in the campaign */
  friendEmail: Scalars['String']['output'];
  /** Friend Reward for completing all necessary steps */
  friendRewards?: Maybe<Array<ReferralReward>>;
  /** The id of the friend participating in the campaign */
  friendUserId?: Maybe<Scalars['ID']['output']>;
  /** The name of the campaign */
  name?: Maybe<Scalars['String']['output']>;
};

export type ReferralCampaignConnection = {
  __typename?: 'ReferralCampaignConnection';
  autoAddCampaignId?: Maybe<Scalars['ID']['output']>;
  edges?: Maybe<Array<ReferralCampaignEdge>>;
  fallbackCampaignId?: Maybe<Scalars['ID']['output']>;
  pageInfo: ReferralPaginatedInfo;
};

export type ReferralCampaignEdge = {
  __typename?: 'ReferralCampaignEdge';
  cursor: Scalars['String']['output'];
  node: ReferralCampaignV2;
};

export type ReferralCampaignReward = {
  __typename?: 'ReferralCampaignReward';
  amount: Scalars['Float']['output'];
  hurdle: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  repeated: Scalars['Boolean']['output'];
  targets: Array<ReferralCampaignRewardTarget>;
  type: ReferralCampaignRewardType;
};

export enum ReferralCampaignRewardTarget {
  Advocate = 'ADVOCATE',
  Friend = 'FRIEND'
}

export enum ReferralCampaignRewardType {
  Investment = 'INVESTMENT',
  Other = 'OTHER'
}

export type ReferralCampaignV2 = {
  __typename?: 'ReferralCampaignV2';
  actionFeedDesc?: Maybe<Scalars['String']['output']>;
  activeInHouseCampaign?: Maybe<Scalars['Boolean']['output']>;
  autoAdd: Scalars['Boolean']['output'];
  background: Scalars['String']['output'];
  condensedTitle?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eligibilityEnd?: Maybe<Scalars['DateTime']['output']>;
  fallback: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  icon: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  internalMemo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publishEnd?: Maybe<Scalars['DateTime']['output']>;
  publishStart: Scalars['DateTime']['output'];
  publishedStatus?: Maybe<PublishedCampaignStatus>;
  qa: Scalars['Boolean']['output'];
  qualificationAction: Scalars['String']['output'];
  qualificationAmount: Scalars['Int']['output'];
  rewards: Array<ReferralCampaignReward>;
  status: CampaignStatus;
  title: Scalars['String']['output'];
};

/** Object containing status of event associated with a Referral */
export type ReferralEvent = {
  __typename?: 'ReferralEvent';
  /** Date event was completed if status is 'COMPLETED' */
  dateCompleted?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Referral event nonce
   * @deprecated No longer supported
   */
  referralEventId?: Maybe<Scalars['String']['output']>;
  /** Type of referral event */
  referralEventType: ReferralEventType;
  /** Status based on activity of friend */
  status: ReferralEventStatus;
};

/** input type specifying the parameters to create an event */
export type ReferralEventInput = {
  eventDetails?: InputMaybe<Scalars['JSON']['input']>;
  eventNonce?: InputMaybe<Scalars['ID']['input']>;
  eventType: ReferralEventType;
  userId: Scalars['String']['input'];
};

/** Status of referral events */
export enum ReferralEventStatus {
  /** Friend has completed event */
  Completed = 'COMPLETED',
  /** Friend has not started or completed event */
  NotStarted = 'NOT_STARTED',
  /** Friend has initiated event but event has not fully processed */
  Pending = 'PENDING'
}

/** Descriptions of User actions needed to earn reward */
export enum ReferralEventType {
  /** User has made a transfer into a Spend Account */
  DepositSpend = 'DEPOSIT_SPEND',
  /** User has opened an Early account */
  EarlyAccountOpened = 'EARLY_ACCOUNT_OPENED',
  /** User has a funding source linked */
  FsLinked = 'FS_LINKED',
  /** User has made initial investment into core account */
  InvestCore = 'INVEST_CORE',
  /** User has made initial investment into early account */
  InvestEarly = 'INVEST_EARLY',
  /** User has made initial investment into later account */
  InvestLater = 'INVEST_LATER',
  /** User has opened a Later account */
  LaterAccountOpened = 'LATER_ACCOUNT_OPENED',
  /** User has signed the referral agreement */
  ReferralAgreementSigned = 'REFERRAL_AGREEMENT_SIGNED',
  /** User has completed registration */
  RegistrationCompleted = 'REGISTRATION_COMPLETED',
  /** User has initialized the registration process */
  SignedUp = 'SIGNED_UP',
  /** User has opened a Spend account */
  SpendAccountOpened = 'SPEND_ACCOUNT_OPENED',
  /** User has paid their subscription */
  SubscriptionPaid = 'SUBSCRIPTION_PAID',
  /** Unknown referral event type */
  Unknown = 'UNKNOWN',
  /** User has been verified */
  UserVerified = 'USER_VERIFIED'
}

/** Descriptions of Friend Events */
export enum ReferralEventTypeV2 {
  /** User has made initial investment */
  FirstHoldingsCreated = 'FIRST_HOLDINGS_CREATED',
  /** User has completed registration */
  UserRegistrationCompleted = 'USER_REGISTRATION_COMPLETED'
}

/** Object containing status of event associated with a Referra In-house platform */
export type ReferralEventV2 = {
  __typename?: 'ReferralEventV2';
  /** Advocate who is associated the Event */
  advocateId: Scalars['ID']['output'];
  /** Campaign associated the Event */
  campaignId: Scalars['ID']['output'];
  /** Time Event got Created */
  created: Scalars['DateTime']['output'];
  /** Is it an Eligible Event */
  eligible: Scalars['Boolean']['output'];
  /** Time Event got Recorded */
  eventRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Type of referral event */
  eventType: ReferralEventTypeV2;
  /** Friend who triggered the Event */
  friendId: Scalars['ID']['output'];
  /** Referral event Id */
  id: Scalars['ID']['output'];
  /** Relationship associated the Event */
  relationshipId: Scalars['ID']['output'];
};

/** Object that holds referral statistics for an Acorns User */
export type ReferralHistory = {
  __typename?: 'ReferralHistory';
  friendHistory?: Maybe<FriendHistoryConnection>;
  friendSummary?: Maybe<Array<FriendSummary>>;
  /** The number of completed referrals for a user */
  numCompletedReferrals?: Maybe<Scalars['Int']['output']>;
  /** The number of status pending referrals for a user */
  numPendingReferrals?: Maybe<Scalars['Int']['output']>;
  /** The total monetary reward amount the user has earned */
  totalReferralRewardsEarned?: Maybe<CurrencyAmount>;
  userId?: Maybe<Scalars['ID']['output']>;
};


/** Object that holds referral statistics for an Acorns User */
export type ReferralHistoryFriendHistoryArgs = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  filter: ReferralPaginatedFilter;
};

export type ReferralPaginatedFilter = {
  /** Cursor to start pagination results for (exclusive) */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Number of nodes to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ReferralPaginatedInfo = {
  __typename?: 'ReferralPaginatedInfo';
  /** Cursor corresponding to the last node in the list of edges */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the filter */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior to the set defined by the filter */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Cursor corresponding to the first node in the list of edges */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReferralPayout = {
  __typename?: 'ReferralPayout';
  advocateId?: Maybe<Scalars['ID']['output']>;
  advocateOfferId?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<ReferralCampaignV2>;
  created?: Maybe<Scalars['DateTime']['output']>;
  friendId?: Maybe<Scalars['ID']['output']>;
  friendOfferId?: Maybe<Scalars['String']['output']>;
  payoutId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<ReferralCampaignReward>;
  status?: Maybe<ReferralPayoutStatus>;
  statusChangeAt?: Maybe<Scalars['DateTime']['output']>;
  statusChangeBy?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type ReferralPayoutConnection = {
  __typename?: 'ReferralPayoutConnection';
  edges?: Maybe<Array<ReferralPayoutEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export type ReferralPayoutEdge = {
  __typename?: 'ReferralPayoutEdge';
  cursor: Scalars['String']['output'];
  node: ReferralPayout;
};

export type ReferralPayoutExistsError = {
  __typename?: 'ReferralPayoutExistsError';
  message: Scalars['String']['output'];
};

export type ReferralPayoutRelationship = {
  __typename?: 'ReferralPayoutRelationship';
  advocateId?: Maybe<Scalars['ID']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  friendId?: Maybe<Scalars['ID']['output']>;
  payoutId: Scalars['ID']['output'];
  payoutRelationshipId?: Maybe<Scalars['ID']['output']>;
  relationshipId: Scalars['ID']['output'];
};

export enum ReferralPayoutStatus {
  /** Only Advocate among multi-targets is rewarded  */
  AdvocateOnlyRewarded = 'ADVOCATE_ONLY_REWARDED',
  /** Payout has met the hurdle in the holdout period */
  Approved = 'APPROVED',
  /** Payout have been Cancelled or Paid outside the Automated system  */
  Cancelled = 'CANCELLED',
  /** Payout has been disqualified due to validation check fails */
  Disqualified = 'DISQUALIFIED',
  /** Payout have expired as the eligibility end date passed for disqualified payout  */
  Expired = 'EXPIRED',
  /** Only Friend among multi-targets is rewarded  */
  FriendOnlyRewarded = 'FRIEND_ONLY_REWARDED',
  /** Payout have been sent for fulfillment  */
  Fulfilled = 'FULFILLED',
  /** Payout started the process for fulfillment  */
  Fulfilling = 'FULFILLING',
  /** Payout has been created, but hurdle not met yet */
  Pending = 'PENDING',
  /** Payout has been rejected manually (not used) */
  Rejected = 'REJECTED',
  /** All target rewarded are invested  */
  Rewarded = 'REWARDED',
  /** All target rewards failed to be invested  */
  RewardFailed = 'REWARD_FAILED'
}

export type ReferralPayoutsFilter = {
  advocateId?: InputMaybe<Scalars['ID']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  displayCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  payoutId?: InputMaybe<Scalars['ID']['input']>;
  statusList?: InputMaybe<Array<ReferralPayoutStatus>>;
};

export type ReferralRelationship = {
  __typename?: 'ReferralRelationship';
  advocateId: Scalars['ID']['output'];
  campaignId: Scalars['ID']['output'];
  friendId: Scalars['ID']['output'];
  status: ReferralRelationshipStatus;
  statusChangeAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReferralRelationshipConnection = {
  __typename?: 'ReferralRelationshipConnection';
  edges?: Maybe<Array<ReferralRelationshipEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export type ReferralRelationshipEdge = {
  __typename?: 'ReferralRelationshipEdge';
  cursor: Scalars['String']['output'];
  node: ReferralRelationship;
};

export type ReferralRelationshipMissingError = {
  __typename?: 'ReferralRelationshipMissingError';
  message: Scalars['String']['output'];
};

/** Status of referral relationship */
export enum ReferralRelationshipStatus {
  /** Relationship has been created */
  Created = 'CREATED',
  /** Relationship is eligible for payout */
  Eligible = 'ELIGIBLE',
  /** Relationship payout has been fulfilled */
  Fulfilled = 'FULFILLED',
  /** Relationship is ineligible for payout */
  Ineligible = 'INELIGIBLE',
  /** Friend has completed first inevestment */
  Invested = 'INVESTED',
  /** Friend has completed registration */
  Registered = 'REGISTERED',
  /** Friend should reinvest since old investement do not qualify */
  ReinvestNeeded = 'REINVEST_NEEDED',
  /** Friend was rewarded */
  Rewarded = 'REWARDED',
  /** Friend reward investment failed - Advocate might have still been rewarded */
  RewardFailed = 'REWARD_FAILED'
}

export type ReferralRelationshipsFilter = {
  friendId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ReferralRelationshipStatus>;
};

/** Object containing reward information for completing a campaign */
export type ReferralReward = {
  __typename?: 'ReferralReward';
  /** Name of the referral reward */
  name?: Maybe<Scalars['String']['output']>;
  /** The date the reward was fulfilled (if applicable) */
  rewardFulfilledAtDate?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the reward associated with activity campaign */
  rewardStatus?: Maybe<ReferralRewardStatus>;
  /** Value of reward for completing all events in a campaign */
  value: Scalars['String']['output'];
  /** Value type for completing all events in a campaign */
  valueType?: Maybe<ReferralValueType>;
};

export type ReferralRewardEdge = {
  __typename?: 'ReferralRewardEdge';
  cursor: Scalars['String']['output'];
  node: ReferralCampaignReward;
};

/** The current status of a referral reward */
export enum ReferralRewardStatus {
  /** User has earned reward by completing all campaign steps, but reward still needs to be issued. */
  Earned = 'EARNED',
  /** Reward has been issued by Acorns */
  Fulfilled = 'FULFILLED',
  /** Reward has not been created */
  NotCreated = 'NOT_CREATED'
}

/** Summary of updated reward */
export type ReferralRewardSummary = {
  __typename?: 'ReferralRewardSummary';
  /** The Acorns User acting as an advocate for this referral reward */
  advocateUserId?: Maybe<Scalars['ID']['output']>;
  /** Status of this referral for Friend/Acorns User */
  status: ReferralRewardStatus;
};

export enum ReferralRewardUpdateStatus {
  /** Referral has been cancelled */
  Cancelled = 'CANCELLED',
  /** User and Friend have been rewarded */
  Rewarded = 'REWARDED'
}

export type ReferralRewardsConnection = {
  __typename?: 'ReferralRewardsConnection';
  edges?: Maybe<Array<ReferralRewardEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export enum ReferralStatus {
  /** Referral has been cancelled */
  Cancelled = 'CANCELLED',
  /** User and Friend have completed referral and should be rewarded */
  Completed = 'COMPLETED',
  /** Referral has expired because events were not finished before campaign end date */
  Expired = 'EXPIRED',
  /** Friend has used referral code but still has events they need to complete */
  Pending = 'PENDING',
  /** User and Friend have been rewarded */
  Rewarded = 'REWARDED',
  /** Referral has been sent to a friend */
  Sent = 'SENT'
}

/** input type specifyig the parameters that can be updated */
export type ReferralUserUpdateInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Value types of reward associated with completion of a referral */
export enum ReferralValueType {
  Usd = 'USD'
}

export type RefreshAuthTokenInput = {
  pin?: InputMaybe<Scalars['String']['input']>;
  refreshToken: Scalars['String']['input'];
};

export type RefreshAuthTokenRateLimitedException = {
  __typename?: 'RefreshAuthTokenRateLimitedException';
  message?: Maybe<Scalars['String']['output']>;
};

export type RefreshAuthTokenResult = AuthSession | InvalidPinException | RefreshAuthTokenRateLimitedException | TokenExpiredException | UserSuspendedException;

export type RefreshTokenNotFoundException = {
  __typename?: 'RefreshTokenNotFoundException';
  userId: Scalars['ID']['output'];
};

/** result from initiating a billing cycle refund */
export type RefundBillingCycleResult = BillingCycle | BillingCycleRefundIneligibleError | InvalidBillingCycleIdError | RefundMoneyTransferError;

/** Failed to create a refund for the specified billing cycle in Finance System */
export type RefundMoneyTransferError = {
  __typename?: 'RefundMoneyTransferError';
  /** error returned from FinSys RefundMoneyTransfer mutation */
  refundError?: Maybe<Scalars['String']['output']>;
};

export type RegisterCredentialsInput = {
  acceptanceDocumentVersionUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['EmailAddress']['input'];
  password: Scalars['String']['input'];
  udid: Scalars['String']['input'];
  usResident?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegisterCredentialsResult = AuthSession | EmailTakenException | InvalidPasswordException | MissingRequiredAgreementsException;

export type RegisterDeviceTokenAndPushAuthenticatorInput = {
  deviceId: Scalars['ID']['input'];
  deviceToken: Scalars['String']['input'];
  deviceType: DeviceType;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterDeviceTokenAndPushAuthenticatorResult = InvalidDeviceParametersException | PushAuthenticator | PushAuthenticatorAlreadyExistsException;

export type RegisterEmailAuthenticatorInput = {
  email: Scalars['EmailAddress']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  setDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegisterEmailAuthenticatorResult = AuthChallengeAnswerAttemptsExhaustedException | AuthChallengeAnswerIncorrectException | AuthChallengeExpiredException | AuthenticatorTypeAlreadyRegisteredException | EmailAuthenticator | ExistingEmailVerifiedException;

export type RegisterOidcCredentialsInput = {
  /** Identity token signed by external Oidc provider */
  idToken: Scalars['String']['input'];
  /** Nonce used in the request to prevent replay attacks. */
  nonce: Scalars['String']['input'];
  oidcProvider: OidcProvider;
  /** A unique identifier representing the Device the client is running on. */
  udid: Scalars['String']['input'];
};

export type RegisterOidcCredentialsResult = AuthSession | EmailTakenException | InvalidAppleAccountException | InvalidCredentialsException | UserSuspendedException;

export type RegisterPhoneAuthenticatorInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['PhoneNumber']['input'];
  setDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegisterPhoneAuthenticatorResult = AuthChallengeAnswerAttemptsExhaustedException | AuthChallengeAnswerIncorrectException | AuthChallengeExpiredException | AuthenticatorTypeAlreadyRegisteredException | InvalidPhoneNumberException | PhoneAuthenticator;

export type RegisterPhoneAuthenticatorWithoutChallengeResult = InvalidPhoneNumberException | PhoneAuthenticator;

export type ReinitiateSmsChallengeInput = {
  challengeId: Scalars['ID']['input'];
};

export type ReinitiateSmsChallengeResult = AuthChallengeExpiredException | ChallengeRateExceededException | EmailAuthChallenge | PhoneNumberOptedOutException | SmsAuthChallenge;

export type ReissueBankCardEligibility = ReissueBankCardEligible | ReissueBankCardIneligible;

export type ReissueBankCardEligible = {
  __typename?: 'ReissueBankCardEligible';
  originalCardCreatedAt: Scalars['Date']['output'];
};

export type ReissueBankCardIneligible = {
  __typename?: 'ReissueBankCardIneligible';
  issues: Array<Maybe<ReissueBankCardIneligibleIssue>>;
};

export enum ReissueBankCardIneligibleIssue {
  ActiveBankCardRequest = 'ACTIVE_BANK_CARD_REQUEST',
  CardAdminLocked = 'CARD_ADMIN_LOCKED',
  FirstCardNotIssuedYet = 'FIRST_CARD_NOT_ISSUED_YET'
}

export type ReissueBankCardInput = {
  reissueReason: BankCardReissueReason;
  tag?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type ReissueBankCardPayload = {
  __typename?: 'ReissueBankCardPayload';
  bankCard?: Maybe<BankCard>;
};

export type RejectUploadedDocumentInput = {
  documentRequestId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: RejectedReason;
  reviewerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export enum RejectedReason {
  DocumentExpired = 'documentExpired',
  IncorrectDocumentType = 'incorrectDocumentType',
  IncorrectName = 'incorrectName',
  InvalidResidentialAddress = 'invalidResidentialAddress',
  MismatchedName = 'mismatchedName',
  MissingName = 'missingName',
  NoVisibleDate = 'noVisibleDate',
  NotEligibleForPromotion = 'notEligibleForPromotion',
  PoorImageQuality = 'poorImageQuality',
  SsnAlreadyUsed = 'ssnAlreadyUsed'
}

export type RelationshipAlreadyQualifiedError = {
  __typename?: 'RelationshipAlreadyQualifiedError';
  message: Scalars['String']['output'];
};

export type ReleaseAdminAppInput = {
  name: Scalars['String']['input'];
  rootPath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
};

/** Attributes for release a new StatementRun */
export type ReleaseStatementRunInput = {
  /** ID of the release statement to be released */
  id: Scalars['ID']['input'];
};

/** Result of release statement run */
export type ReleaseStatementRunResponse = StatementRun | StatementRunNotFoundException;

export type RelevantMacrosResponse = {
  __typename?: 'RelevantMacrosResponse';
  relevant_macros: Array<Scalars['String']['output']>;
};

/** Relink funding source input type. */
export type RelinkFundingSourceInput = {
  /** UUID of the funding source. */
  fundingSourceId: Scalars['ID']['input'];
};

/** Relink Linked Account Alert. */
export type RelinkLinkedAccountAlert = UserAlertsItem & {
  __typename?: 'RelinkLinkedAccountAlert';
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

/** Input payload for re-initiating a link between a funding source and ProfitStars. */
export type RelinkWithProfitStarsInput = {
  /** UUID of the funding source. */
  fundingSourceId: Scalars['ID']['input'];
};

/** Response from removeAccountApproval mutation */
export type RemoveAccountPreApprovalResponse = LegacyUser | UserNotFoundException;

export type RemoveJobAlertResult = RemovedJobAlert;

export type RemovePolicyInput = {
  name: Scalars['String']['input'];
};

export type RemovePolicyResult = PoliciesRecordDoesNotExistException | ValidPolicies;

/** Bundle of user id and document type for use in removing requested documents from backend */
export type RemoveRequestedDocumentInput = {
  /** Document types to request to be removed */
  documentTypes: Array<DocumentTypeEnum>;
  /** User id to request the documents from. */
  userId: Scalars['ID']['input'];
};

/** Response from document request */
export type RemoveRequestedDocumentResponse = {
  __typename?: 'RemoveRequestedDocumentResponse';
  documentTypes: Array<DocumentTypeEnum>;
  userId: Scalars['ID']['output'];
};

/** Indicates remove operation succeeded */
export type RemovedJobAlert = {
  __typename?: 'RemovedJobAlert';
  id: Scalars['ID']['output'];
};

/** Response from reopenAccountForVerification mutation */
export type ReopenAccountForVerificationResponse = LegacyUser | UserNotFoundException;

/** When a reopen request with the provided id is not found */
export type ReopenRequestNotFound = {
  __typename?: 'ReopenRequestNotFound';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Object representing an user */
export type ReopenUserAccountResult = {
  __typename?: 'ReopenUserAccountResult';
  closedAt?: Maybe<Scalars['Date']['output']>;
  lockedAt?: Maybe<Scalars['Date']['output']>;
  /** User uuid */
  userUuid: Scalars['ID']['output'];
};

export type ReportDoesNotExistError = {
  __typename?: 'ReportDoesNotExistError';
  id: Scalars['ID']['output'];
};

/** Bundle of user id, document type, and upload url for use in requesting documents from backend */
export type RequestDocumentInput = {
  /** Document type to request */
  documentTypes: Array<DocumentTypeEnum>;
  /** Type of document the given signature is accepting */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** User id to request the documents from. */
  userId: Scalars['ID']['input'];
};

/** Response from document request */
export type RequestDocumentResponse = {
  __typename?: 'RequestDocumentResponse';
  documentTypes: Array<DocumentTypeEnum>;
  uploadUrl: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type RequestDocumentUploadInput = {
  documentType: DocumentType;
  /** ID of the entity being indirectly referenced by this request */
  externalId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of previously rejected document request */
  parentRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Idempotency key for ensuring that duplicate requests are not made */
  requestKey?: InputMaybe<Scalars['String']['input']>;
  requestedFileCount?: InputMaybe<Scalars['Int']['input']>;
  /** ID of support rep that requested the document */
  requesterId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type RequestSubscriptionMigrationWaiverInput = {
  reason: SubscriptionMigrationWaiverReason;
  subscriptionMigrationId: Scalars['ID']['input'];
};

export type RequestSubscriptionMigrationWaiverResult = InvalidTierForMigrationError | SubscriptionMigrationInvalidError | SubscriptionMigrationWaiver;

export enum RequestVersions {
  September_2022 = 'SEPTEMBER_2022'
}

/** Result of resending files. */
export type ResendFilesResult = {
  __typename?: 'ResendFilesResult';
  date: Scalars['String']['output'];
};

export type ResetPasswordByTokenException = {
  __typename?: 'ResetPasswordByTokenException';
  message?: Maybe<Scalars['String']['output']>;
};

export type ResetPasswordByTokenInput = {
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  newPw: Scalars['String']['input'];
  newPwConfirmation: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
  securityAnswer?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordByTokenResult = IncorrectSecurityAnswerException | IncorrectSsnException | InvalidPasswordException | ResetPasswordByTokenException | ResetPasswordByTokenSuccess | UserCredentialsNotFoundException;

export type ResetPasswordByTokenSuccess = {
  __typename?: 'ResetPasswordByTokenSuccess';
  userId: Scalars['ID']['output'];
};

export type ResetPasswordWithTokenInput = {
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};

export type ResetPasswordWithTokenResult = InvalidPasswordResetException | InvalidPasswordResetTokenException | ResetPasswordWithTokenSuccess | UserCredentialsNotFoundException;

export type ResetPasswordWithTokenSuccess = {
  __typename?: 'ResetPasswordWithTokenSuccess';
  userId: Scalars['ID']['output'];
};

export type ResetRateLimitResult = RateLimitDoesNotExistException | ResetRateLimitSuccess;

export type ResetRateLimitSuccess = {
  __typename?: 'ResetRateLimitSuccess';
  challengeRateLimitReset?: Maybe<Scalars['Boolean']['output']>;
  loginRateLimitReset?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ResourceNotFoundError = {
  __typename?: 'ResourceNotFoundError';
  requestId: Scalars['ID']['output'];
};

export type RestoreLoginAccessInput = {
  userId: Scalars['ID']['input'];
};

export type RestoreLoginAccessResult = AuthProfile | AuthProfileNotFoundException;

export enum RetirementPlanAccess {
  /** Married user and spouse have access to a retirement plan */
  Both = 'both',
  /** Neither married user nor spouse have access to a retirement plan */
  Neither = 'neither',
  /** Single user has no access to retirement plan */
  No = 'no',
  /** Married user has access to a retirement plan without spouse */
  OnlyMe = 'onlyMe',
  /** Married user does not have access to a retirement plan, but spouse does */
  Spouse = 'spouse',
  /** Single user has access to an employer's retirement plan */
  Yes = 'yes'
}

export enum RevenueScheduleType {
  AtInvoice = 'at_invoice',
  AtRangeEnd = 'at_range_end',
  AtRangeStart = 'at_range_start',
  Evenly = 'evenly',
  Never = 'never'
}

/** Response of liquidating fractional shares */
export type ReverseInvestmentAccountNegativeBalanceResponse = ReverseInvestmentAccountNegativeBalanceSuccess;

/** Reverse Negative Balance successfully */
export type ReverseInvestmentAccountNegativeBalanceSuccess = {
  __typename?: 'ReverseInvestmentAccountNegativeBalanceSuccess';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Response of checking address approval */
export type ReviewDocumentsApproveAddressResponse = {
  __typename?: 'ReviewDocumentsApproveAddressResponse';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  user?: Maybe<LegacyUser>;
  uuid: Scalars['ID']['output'];
};

/** Response of mark approved mutation */
export type ReviewDocumentsMarkReviewedResponse = {
  __typename?: 'ReviewDocumentsMarkReviewedResponse';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  reviewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  reviewerUuid?: Maybe<Scalars['ID']['output']>;
  user?: Maybe<LegacyUser>;
  uuid: Scalars['ID']['output'];
};

export enum RevokeAccessReasons {
  CoreAccountReview = 'CORE_ACCOUNT_REVIEW',
  CoreBrokerDealerAssociation = 'CORE_BROKER_DEALER_ASSOCIATION',
  CoreCastleLock = 'CORE_CASTLE_LOCK',
  CoreChargeback = 'CORE_CHARGEBACK',
  CoreCollection = 'CORE_COLLECTION',
  CoreDisputedTransaction = 'CORE_DISPUTED_TRANSACTION',
  CoreLeinLevyLock = 'CORE_LEIN_LEVY_LOCK',
  CorePendingApprovalApplicationWithdrawn = 'CORE_PENDING_APPROVAL_APPLICATION_WITHDRAWN',
  CorePotentialAccountTakeover = 'CORE_POTENTIAL_ACCOUNT_TAKEOVER',
  CoreSuspiciousInvestmentActivity = 'CORE_SUSPICIOUS_INVESTMENT_ACTIVITY',
  CoreW9Required = 'CORE_W9_REQUIRED',
  Deceased = 'DECEASED',
  DuplicateAccount = 'DUPLICATE_ACCOUNT',
  EarlyTransferInProgress = 'EARLY_TRANSFER_IN_PROGRESS',
  Fallback = 'FALLBACK',
  Fraud = 'FRAUD',
  LaterRolloverInProgress = 'LATER_ROLLOVER_IN_PROGRESS',
  OtherNotListed = 'OTHER_NOT_LISTED',
  PlaidMismatch = 'PLAID_MISMATCH',
  ProfitStarsDispute = 'PROFIT_STARS_DISPUTE',
  ReferralPromotionFraud = 'REFERRAL_PROMOTION_FRAUD',
  SharesZeroedOut = 'SHARES_ZEROED_OUT',
  SpendDisputedIncomingTransferR10 = 'SPEND_DISPUTED_INCOMING_TRANSFER_R10',
  SpendGeneralSuspension = 'SPEND_GENERAL_SUSPENSION',
  SpendReturnedTransfer = 'SPEND_RETURNED_TRANSFER',
  SpendSuspiciousTransferActivity = 'SPEND_SUSPICIOUS_TRANSFER_ACTIVITY',
  SuspiciousMrdcContactSpendRisk = 'SUSPICIOUS_MRDC_CONTACT_SPEND_RISK',
  SuspiciousMrdcPendingClosure = 'SUSPICIOUS_MRDC_PENDING_CLOSURE',
  ThreeWayCallRequired = 'THREE_WAY_CALL_REQUIRED',
  Underage = 'UNDERAGE',
  UnsupportedCustomer = 'UNSUPPORTED_CUSTOMER'
}

export type RevokeAdminAppsInput = {
  appNames: Array<Scalars['String']['input']>;
  roleName: Scalars['String']['input'];
};

export type RevokeAdminAppsResult = {
  __typename?: 'RevokeAdminAppsResult';
  apps: Array<Scalars['String']['output']>;
};

export type RevokeLoginAccessInput = {
  reason: RevokeAccessReasons;
  userId: Scalars['ID']['input'];
};

export type RevokeLoginAccessResult = AuthProfile | UserCredentialsNotFoundException;

export type RevokePasswordResetTokenInput = {
  plaintextToken: Scalars['String']['input'];
};

export type RevokePasswordResetTokenResult = InvalidPasswordResetTokenException | RevokePasswordResetTokenSuccess;

export type RevokePasswordResetTokenSuccess = {
  __typename?: 'RevokePasswordResetTokenSuccess';
  userId: Scalars['String']['output'];
};

export enum RewardStatus {
  /** Canceled status */
  Canceled = 'CANCELED',
  /** Confirmed status */
  Confirmed = 'CONFIRMED',
  /** Pending status */
  Pending = 'PENDING',
  /** Pending referree verification */
  PendingReferreeVerification = 'PENDING_REFERREE_VERIFICATION',
  /** Suspended status */
  Suspended = 'SUSPENDED'
}

export enum RiskAccountType {
  Save = 'save',
  Spend = 'spend'
}

export type RiskDecision = {
  createdAt: Scalars['DateTime']['output'];
  evaluatedUserRiskProfile?: Maybe<UserRiskProfile>;
  id: Scalars['ID']['output'];
  input: Scalars['String']['output'];
  ruleVersion: Scalars['String']['output'];
  traceId: Scalars['String']['output'];
};

export type RiskModelFilterInput = {
  actionTaken?: InputMaybe<Scalars['Boolean']['input']>;
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  depositType?: InputMaybe<DepositTypeOptions>;
  maxPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  transactionUuid?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RiskModelResponse = {
  __typename?: 'RiskModelResponse';
  depositModelData: Array<DepositModelDataEntity>;
  transactions: Array<TransactionEntity>;
};

export type RiskModelToDoListFilterInput = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  depositType?: InputMaybe<DepositTypeOptions>;
  maxPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RiskServiceInternalError = {
  __typename?: 'RiskServiceInternalError';
  description?: Maybe<Scalars['String']['output']>;
};

export enum Role {
  AcceptanceDocs = 'ACCEPTANCE_DOCS',
  AcornsCashLedgerViewer = 'ACORNS_CASH_LEDGER_VIEWER',
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE',
  FinancialOperations = 'FINANCIAL_OPERATIONS',
  InvestOperations = 'INVEST_OPERATIONS',
  Portfolios = 'PORTFOLIOS',
  ReferralOperations = 'REFERRAL_OPERATIONS',
  ResqueConsole = 'RESQUE_CONSOLE',
  Securities = 'SECURITIES',
  SpendOperations = 'SPEND_OPERATIONS',
  Support = 'SUPPORT',
  SupportEscalations = 'SUPPORT_ESCALATIONS',
  SupportResolutionSpecialist = 'SUPPORT_RESOLUTION_SPECIALIST',
  SupportTier_1 = 'SUPPORT_TIER_1',
  SupportTier_2 = 'SUPPORT_TIER_2',
  SupportTier_3 = 'SUPPORT_TIER_3'
}

/** A transaction with excess change to invest into an Acorns account */
export type RoundUp = TimestampsInterface & {
  __typename?: 'RoundUp';
  amount: Scalars['Float']['output'];
  change: Scalars['Float']['output'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  instant: Scalars['Boolean']['output'];
  investmentId?: Maybe<Scalars['ID']['output']>;
  investmentNonce?: Maybe<Scalars['ID']['output']>;
  linkedSubaccountId: Scalars['ID']['output'];
  manual: Scalars['Boolean']['output'];
  multiplier?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  roundUpAccount: RoundUpAccount;
  roundUpProfile: RoundUpProfile;
  state: RoundUpState;
  /** The target account in which this round up has been invested. */
  targetAccountId?: Maybe<Scalars['ID']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  transactionDate: Scalars['DateTime']['output'];
  transactionDisplayDate: Scalars['Date']['output'];
  transactionId: Scalars['ID']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

/** Round up settings for a specific linked account */
export type RoundUpAccount = TimestampsInterface & {
  __typename?: 'RoundUpAccount';
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  linkedSubaccountId: Scalars['ID']['output'];
  roundUpProfile: RoundUpProfile;
  roundUps: Array<RoundUp>;
  startDate?: Maybe<Scalars['String']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

/** Round up settings for a user */
export type RoundUpProfile = TimestampsInterface & {
  __typename?: 'RoundUpProfile';
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  multiplier: Scalars['Float']['output'];
  realTimeRoundUpEligible: Scalars['Boolean']['output'];
  roundUpAccounts: Array<RoundUpAccount>;
  roundUpCount: Scalars['Int']['output'];
  roundUpTotal: Scalars['Float']['output'];
  roundUps: Array<RoundUp>;
  roundUpsEnabled: Scalars['Boolean']['output'];
  /** True if user has auto roundups off (making all roundups manual, even from Spend accounts)or at least one enabled non-spend roundup account. */
  showRoundUpsProgress: Scalars['Boolean']['output'];
  /** The target account to which a user's round up investments will be made. */
  targetAccountId?: Maybe<Scalars['ID']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  wholeDollarAmount: Scalars['Float']['output'];
};


/** Round up settings for a user */
export type RoundUpProfileRoundUpCountArgs = {
  spend?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Array<RoundUpState>>;
  targetAccountId?: InputMaybe<Scalars['ID']['input']>;
};


/** Round up settings for a user */
export type RoundUpProfileRoundUpTotalArgs = {
  spend?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Array<RoundUpState>>;
  targetAccountId?: InputMaybe<Scalars['ID']['input']>;
};

/** Changeable attributes for user profiles */
export type RoundUpProfileInput = {
  /** Round up multiplier */
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  /** Toggle global user setting for auto round ups */
  roundUpsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Acorns account ID of roundups destination */
  targetAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Round up to custom dollar amount */
  wholeDollarAmount?: InputMaybe<Scalars['Float']['input']>;
};

export enum RoundUpState {
  /**
   * Round ups that will be invested automatically
   * @deprecated Use waiting state instead
   */
  AutoInvestable = 'autoInvestable',
  /** Round ups that were canceled, either before or after an investment was created */
  Canceled = 'canceled',
  /** Round ups associated with an investment */
  Invested = 'invested',
  /** Round ups that have yet to be invested */
  Pending = 'pending',
  /** Round ups that requested to be invested but have not been transferred */
  RoundedUp = 'roundedUp',
  /** Round ups which are ready to be invested */
  Waiting = 'waiting'
}

/** An individual edge within the paginated list of RoundUpType */
export type RoundUpTypeEdge = {
  __typename?: 'RoundUpTypeEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The RoundUpType record in the edge */
  node: RoundUp;
};

/** Relay style pagination information for RoundUpType */
export type RoundUpTypePagination = {
  __typename?: 'RoundUpTypePagination';
  edges: Array<RoundUpTypeEdge>;
  pageInfo: PageInfo;
};

export enum RuleVersion {
  V1_5 = 'V1_5'
}

/** Response of RunAccountVerification mutation */
export type RunAccountVerificationResponse = IdentityVerificationEnqueued | MissingFieldError | MissingIdentityInfoError | SameInputError;

export type SmsAuthChallenge = AuthChallenge & {
  __typename?: 'SMSAuthChallenge';
  alternateAuthenticators: Array<AuthenticatorInfo>;
  challengeTrigger: ChallengeTriggers;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  maskedPhoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** SSN supporting document requested user alert. */
export type SsnDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'SSNDocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

export enum SalaryInterval {
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** SameInput return type */
export type SameInputError = {
  __typename?: 'SameInputError';
  /** exception details */
  message: Scalars['String']['output'];
  /** user uuid */
  userId: Scalars['ID']['output'];
};

export type SamePasswordsException = {
  __typename?: 'SamePasswordsException';
  message?: Maybe<Scalars['String']['output']>;
};

export type SampleMailInDocument = {
  __typename?: 'SampleMailInDocument';
  letterUrl?: Maybe<Scalars['URL']['output']>;
  mailType: MailInDocumentType;
};

export type SavingsAccountEligibility = {
  __typename?: 'SavingsAccountEligibility';
  isEligibleForOpen: Scalars['Boolean']['output'];
  notEligibleReasons: Array<SavingsAccountEligibilityRequirement>;
};

export enum SavingsAccountEligibilityRequirement {
  NeedsCheckingAccount = 'NEEDS_CHECKING_ACCOUNT',
  NeedsDirectDeposit = 'NEEDS_DIRECT_DEPOSIT',
  NeedsOtherBankingPartner = 'NEEDS_OTHER_BANKING_PARTNER'
}

export enum SavingsAccountType {
  EmergencySavings = 'EMERGENCY_SAVINGS'
}

export type ScheduleInput = {
  type: ScheduleType;
};

export type ScheduleRecurringTransferInput = {
  recurrenceRule: RecurrenceRuleInput;
  transferEvent: RecurringTransferEventInput;
};

export type ScheduleRecurringTransferResult = MalformedRecurringTransferException | RecurringTransfer;

export type ScheduleResult = {
  __typename?: 'ScheduleResult';
  active: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum ScheduleType {
  Chat = 'chat',
  Email = 'email',
  Phone = 'phone'
}

export type Scope = {
  __typename?: 'Scope';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SearchSecuritiesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SearchSecuritiesOrderBy>;
  search: Scalars['String']['input'];
  securityTypes?: InputMaybe<Array<InputMaybe<SecurityType>>>;
};

export enum SearchSecuritiesOrderBy {
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by match score in descending order */
  BestMatch = 'BEST_MATCH',
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by market cap in descending order */
  MarketCap = 'MARKET_CAP',
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by share price (open_price) in descending order */
  SharePrice = 'SHARE_PRICE'
}

export type SearchSecuritiesPageInfo = {
  __typename?: 'SearchSecuritiesPageInfo';
  count: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nextPageCursor?: Maybe<Scalars['String']['output']>;
  prevPageCursor?: Maybe<Scalars['String']['output']>;
  totalMatches?: Maybe<Scalars['Int']['output']>;
};

export type SearchSecuritiesResponse = {
  __typename?: 'SearchSecuritiesResponse';
  pageInfo?: Maybe<SearchSecuritiesPageInfo>;
  securities: Array<Security>;
};

export type SearchSupportArticleResult = {
  __typename?: 'SearchSupportArticleResult';
  author: SupportAuthor;
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  draft: Scalars['Boolean']['output'];
  editedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  outdated: Scalars['Boolean']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  promoted: Scalars['Boolean']['output'];
  resultType: Scalars['String']['output'];
  section: SupportSection;
  slug: Scalars['String']['output'];
  snippet: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SearchSupportResult = {
  __typename?: 'SearchSupportResult';
  relevantSearchArticles: Array<Maybe<SearchSupportArticleResult>>;
  relevantSearchCategories: Array<Maybe<SupportCategory>>;
};

/** Secret Squirrel Error */
export type SecretSquirrelException = {
  __typename?: 'SecretSquirrelException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type SecuritiesBySectorInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecuritiesBySectorOrderBy>;
  sectors: Array<TradingSector>;
  securityTypes?: InputMaybe<Array<InputMaybe<SecurityType>>>;
};

export enum SecuritiesBySectorOrderBy {
  /** Securities that contain the provided trading sector(s) ordered by market cap in descending order */
  MarketCap = 'MARKET_CAP',
  /** Securities that contain the provided trading sector(s) ordered by share price (open_price) in descending order */
  SharePrice = 'SHARE_PRICE'
}

export type SecuritiesBySectorPageInfo = {
  __typename?: 'SecuritiesBySectorPageInfo';
  count: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nextPageCursor?: Maybe<Scalars['String']['output']>;
  prevPageCursor?: Maybe<Scalars['String']['output']>;
  totalMatches?: Maybe<Scalars['Int']['output']>;
};

export type SecuritiesBySectorResponse = {
  __typename?: 'SecuritiesBySectorResponse';
  pageInfo?: Maybe<SecuritiesBySectorPageInfo>;
  securities: Array<Security>;
};

export type SecuritiesBySymbolsInput = {
  symbols: Array<Scalars['TickerSymbol']['input']>;
};

export type SecuritiesBySymbolsResponse = {
  __typename?: 'SecuritiesBySymbolsResponse';
  securities: Array<Security>;
};

export type Security = {
  active: Scalars['Boolean']['output'];
  currentPrice: BigCurrencyAmount;
  currentlySupported: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  earliestPriceDate: Scalars['Date']['output'];
  headlines: Array<SecurityHeadline>;
  id: Scalars['ID']['output'];
  lastClosePrice: BigCurrencyAmount;
  lastUpdatedAt: Scalars['DateTime']['output'];
  longName: Scalars['String']['output'];
  marketCap: Scalars['BigDecimal']['output'];
  openPrice: BigCurrencyAmount;
  profile: SecurityProfile;
  /** @deprecated Use Security.headlines. */
  securityHeadlines: Array<SecurityHeadline>;
  /** @deprecated Use Security.profile. */
  securityProfile: SecurityProfile;
  shortName: Scalars['String']['output'];
  symbol: Scalars['TickerSymbol']['output'];
  type: SecurityType;
  volume: Scalars['BigDecimal']['output'];
  week52High: BigCurrencyAmount;
  week52Low: BigCurrencyAmount;
};

export type SecurityAnswer = {
  questionId: Scalars['ID']['input'];
  response: Scalars['String']['input'];
};

export type SecurityBySymbolInput = {
  symbol: Scalars['TickerSymbol']['input'];
};

export type SecurityGain = {
  __typename?: 'SecurityGain';
  marketValue?: Maybe<BigCurrencyAmount>;
  percent?: Maybe<Scalars['BigDecimal']['output']>;
};

export type SecurityHeadline = {
  __typename?: 'SecurityHeadline';
  createdAt: Scalars['DateTime']['output'];
  headline: Scalars['String']['output'];
  source: Scalars['String']['output'];
  storyUrl: Scalars['URL']['output'];
  thumbnailUrl?: Maybe<Scalars['URL']['output']>;
};

export type SecurityPerformance = {
  __typename?: 'SecurityPerformance';
  gain: SecurityGain;
  prices?: Maybe<Array<SecurityPrice>>;
  symbol: Scalars['TickerSymbol']['output'];
};

export type SecurityPerformanceBySymbolInput = {
  /** Only the Date component is used */
  endDate: Scalars['DateTime']['input'];
  /** Only the Date component is used */
  interval?: InputMaybe<Scalars['Int']['input']>;
  maxPoints?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  symbol: Scalars['TickerSymbol']['input'];
};

export type SecurityPerformancesBySymbolInput = {
  /** Only the Date component is used */
  endDate: Scalars['DateTime']['input'];
  /** Only the Date component is used */
  interval?: InputMaybe<Scalars['Int']['input']>;
  maxPoints?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  symbols: Array<Scalars['TickerSymbol']['input']>;
};

export type SecurityPrice = {
  __typename?: 'SecurityPrice';
  date: Scalars['Date']['output'];
  marketValue: BigCurrencyAmount;
  timestamp: Scalars['DateTime']['output'];
  unadjustedMarketValue?: Maybe<BigCurrencyAmount>;
};

export type SecurityProfile = {
  __typename?: 'SecurityProfile';
  defaultLogoUrl?: Maybe<Scalars['URL']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['URL']['output']>;
  tradingSectors: Array<TradingSector>;
};

export enum SecurityType {
  Bond = 'BOND',
  Etf = 'ETF',
  Stock = 'STOCK'
}

/** User Directed Portfolio Object */
export type SelfDirectedPortfolio = BasePortfolio & {
  __typename?: 'SelfDirectedPortfolio';
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation;
  cashOwed: MonetaryAmount;
  currentAllocationPercentage: Scalars['Float']['output'];
  currentBalance: MonetaryAmount;
  currentBalanceWithPending: MonetaryAmount;
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel?: Maybe<PortfolioCustomizationLevel>;
  /** Description of the portfolio */
  description: Scalars['String']['output'];
  /** ID of the Portfolio */
  id: Scalars['ID']['output'];
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']['output'];
  pendingBalance: MonetaryAmount;
  /** Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount). */
  portfolioSecurities?: Maybe<Array<PortfolioSecurity>>;
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations?: Maybe<Array<PortfolioSecurityAllocation>>;
  /** Contains requirement statuses for removing the portfolio */
  requirements: AccountRequirements;
  status: SelfDirectedPortfolioStatus;
  yearToDateReturn?: Maybe<MarketReturn>;
};

export enum SelfDirectedPortfolioStatus {
  /** Self Directed Portfolio has been removed */
  Closed = 'CLOSED',
  /** Self Directed Portfolio is open */
  Open = 'OPEN',
  /** Self Directed Portfolio has started the closure process */
  PendingClosure = 'PENDING_CLOSURE'
}

export type SendBrazeEventInput = {
  event: BrazeEvent;
  userId: Scalars['ID']['input'];
};

export type SendCheckPaymentInput = {
  amount: CurrencyAmountInput;
  fromAccountId: Scalars['ID']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  nonce: Scalars['String']['input'];
  recipient: CheckPaymentRecipientInput;
  recipientAddress: CheckPaymentAddressInput;
};

/** Check or errors */
export type SendCheckPaymentResult = AuthorizationError | CheckPayment | DuplicateActionError | InvalidAddressError;

export type SendCustomerDueDiligenceAnswersToBankingPartnerInput = {
  bankAccountType?: InputMaybe<BankAccountType>;
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type SendCustomerDueDiligenceAnswersToBankingPartnerPayload = {
  __typename?: 'SendCustomerDueDiligenceAnswersToBankingPartnerPayload';
  userId: Scalars['ID']['output'];
};

export type SendCustomerDueDiligenceToBankingPartnerError = {
  __typename?: 'SendCustomerDueDiligenceToBankingPartnerError';
  failureMessage?: Maybe<Scalars['String']['output']>;
};

export type SendCustomerDueDiligenceToBankingPartnerResult = SendCustomerDueDiligenceAnswersToBankingPartnerPayload | SendCustomerDueDiligenceToBankingPartnerError;

export type ServiceError = {
  __typename?: 'ServiceError';
  reason: Scalars['String']['output'];
  retryable?: Maybe<Scalars['Boolean']['output']>;
};

export type Session = {
  __typename?: 'Session';
  redirectUrl?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['ID']['output']>;
  token: Scalars['ID']['output'];
  uuid: Scalars['ID']['output'];
};

export type SetAuthenticationPinInput = {
  pin: Scalars['String']['input'];
  pinConfirmation: Scalars['String']['input'];
};

export type SetAuthenticationPinResult = InvalidPinException | SetAuthenticationPinSuccess | UserCredentialsNotFoundException;

export type SetAuthenticationPinSuccess = {
  __typename?: 'SetAuthenticationPINSuccess';
  userId: Scalars['ID']['output'];
};

export type SetDefaultAuthenticatorInput = {
  authenticatorId: Scalars['ID']['input'];
};

export type SetDefaultAuthenticatorResult = AuthenticatorAlreadyDefaultException | AuthenticatorNotFoundException | EmailAuthenticator | PhoneAuthenticator;

/** Response from setDepositHold mutation */
export type SetDepositHoldResponse = {
  __typename?: 'SetDepositHoldResponse';
  /** if it was enabled or disabled */
  enabled: Scalars['Boolean']['output'];
  /** InvestmentAccount that had the deposit hold enabled */
  investmentAccountId: Scalars['ID']['output'];
};

export type SetNegotiationStatusInput = {
  negotiationMethod: NegotiationMethod;
  operator: Scalars['String']['input'];
  refundAmount?: InputMaybe<Scalars['Float']['input']>;
  status: BankFeeNegotiationStatus;
  submissionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type SetNegotiationStatusResult = {
  __typename?: 'SetNegotiationStatusResult';
  message: Scalars['String']['output'];
};

/** Parameters needed to create a new webhook to use for callbacks from Pinwheel jobs */
export type SetPinwheelWebhookInput = {
  /** The list of events to enable for this webhook */
  enabledEvents: Array<EnabledPinwheelEvent>;
  /** Status of the webhook */
  status: PinwheelWebhookStatus;
  /** Version of the webhook made */
  version: SetPinwheelWebhookVersionEnum;
};

export type SetPinwheelWebhookPayload = {
  __typename?: 'SetPinwheelWebhookPayload';
  /** The webhook that was created */
  createdWebhook: PinwheelWebhook;
};

export enum SetPinwheelWebhookVersionEnum {
  V2022_09_09 = 'v2022_09_09',
  V2023_04_18 = 'v2023_04_18',
  V2023_07_18 = 'v2023_07_18',
  V2023_11_22 = 'v2023_11_22'
}

export type SetReferralCampaignFlagsInput = {
  autoAdd?: InputMaybe<Scalars['Boolean']['input']>;
  campaignId: Scalars['ID']['input'];
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
  override?: InputMaybe<OverrideInput>;
  qa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetReferralCampaignFlagsResult = {
  __typename?: 'SetReferralCampaignFlagsResult';
  autoAdd: Scalars['Boolean']['output'];
  fallback: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  qa: Scalars['Boolean']['output'];
};

export type SetRiskModelInReviewResponse = AlreadyInReviewError | DepositModelDataEntity | DepositModelNotFoundError;

export enum ShareTransferType {
  /** Move shares from trading account to master holding account */
  Buy = 'BUY',
  /** Move shares from chargeback account to holding account */
  ChargebackBuy = 'CHARGEBACK_BUY',
  /** Move shares from holding account to chargeback account */
  ChargebackSell = 'CHARGEBACK_SELL',
  /** Move shares from error account to holding account */
  CorrectionBuy = 'CORRECTION_BUY',
  /** Move shares from holding account to error account */
  CorrectionSell = 'CORRECTION_SELL',
  /** Move shares from master holding account to trading account */
  Sell = 'SELL'
}

export type Signature = TimestampsInterface & {
  __typename?: 'Signature';
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Type of profile */
  profile?: Maybe<Profile>;
  /** Type of signature */
  signatureType: SignatureType;
  /** SVG file */
  svgFile: Scalars['String']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Internal ID for user */
  userId: Scalars['ID']['output'];
};

/** Signature file information */
export type SignatureInformationType = {
  __typename?: 'SignatureInformationType';
  /** Id of record */
  id: Scalars['String']['output'];
  /** File name sent to CPI */
  imageFileName: Scalars['String']['output'];
};

export enum SignatureType {
  /** A signature used for a user's bank fee negotiation */
  BankFeeNegotiation = 'bankFeeNegotiation',
  /** A signature for the user investment certificate */
  Certificate = 'certificate',
  /** A signature used for the user spend debit card */
  DebitCard = 'debitCard',
  /** A signature used for the user direct deposit PDF form */
  DirectDeposit = 'directDeposit',
  /** A signature used for a user's utility bill negotiation */
  UtilityBillNegotiation = 'utilityBillNegotiation'
}

export type SiteWideBannerContent = {
  __typename?: 'SiteWideBannerContent';
  bannerText: Scalars['String']['output'];
  currentVersion: Scalars['String']['output'];
  publishedVersion?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
};

export type SiteWideBannerContentInput = {
  bannerText?: InputMaybe<Scalars['String']['input']>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmartDepositMetadataInput = {
  supportedTargetAccounts: Array<SplitDepositTargetAccountType>;
};

export type SmartDepositMetadataResult = {
  __typename?: 'SmartDepositMetadataResult';
  recommendedAllocations: Array<SplitDepositAllocation>;
  targetAccounts: Array<SplitDepositTargetAccount>;
};

export enum SocureDecision {
  /** Socure accept response */
  Accept = 'ACCEPT',
  /** Socure soft failure response requiring ID docs */
  Refer = 'REFER',
  /** Socure hard failure response */
  Reject = 'REJECT',
  /** Socure soft failure response requiring ID docs and address verification */
  Review = 'REVIEW'
}

/** Socure response fields */
export type SocureResponse = {
  decision: SocureDecision;
  referenceId: Scalars['ID']['input'];
};

/** Result of processing the Socure response */
export type SocureResult = {
  __typename?: 'SocureResult';
  addressDocumentUploadId?: Maybe<Scalars['String']['output']>;
  identityDocumentUploadId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** Socure upload information */
export type SocureUpload = {
  /** address */
  address: Scalars['String']['input'];
  /** city */
  city: Scalars['String']['input'];
  /** email */
  email: Scalars['String']['input'];
  /** first name */
  firstName: Scalars['String']['input'];
  /** last name */
  lastName: Scalars['String']['input'];
  /** raw response from Socure */
  rawResponse: Scalars['String']['input'];
  /** reference id */
  referenceId: Scalars['ID']['input'];
  /** state */
  state: Scalars['String']['input'];
  /** telephone */
  telephone: Scalars['String']['input'];
  /** zip */
  zip: Scalars['String']['input'];
};

/** Result of processing the Socure response */
export type SocureUploadResponse = {
  __typename?: 'SocureUploadResponse';
  userId: Scalars['ID']['output'];
};

export type SpendAtmReimbursementItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendATMReimbursementItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpendAtmWithdrawalItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendATMWithdrawalItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpendAccount = {
  __typename?: 'SpendAccount';
  accountId?: Maybe<Scalars['ID']['output']>;
  bankCardOrder?: Maybe<BankCardOrder>;
  bankType?: Maybe<BankType>;
  isDirectDepositIncentiveEligible: Scalars['Boolean']['output'];
  isEligible: Scalars['Boolean']['output'];
  isEligibleForPremiumCardUpgrade?: Maybe<Scalars['Boolean']['output']>;
  isReopenable?: Maybe<Scalars['Boolean']['output']>;
  lockReason?: Maybe<BankAccountLockReason>;
  status: SpendAccountStatus;
};

export enum SpendAccountStatus {
  Closed = 'CLOSED',
  Locked = 'LOCKED',
  NotOpened = 'NOT_OPENED',
  Open = 'OPEN',
  Opening = 'OPENING',
  Reopening = 'REOPENING'
}

export type SpendAlert = {
  type: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type SpendAlertsInput = {
  userId: Scalars['ID']['input'];
};

export type SpendBillPayItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendBillPayItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpendCheckDepositItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendCheckDepositItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpendCheckPaymentItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendCheckPaymentItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpendDigitalWalletItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendDigitalWalletItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpendECheckItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendECheckItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpendInterestPaidItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendInterestPaidItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  monthEarned: Scalars['String']['output'];
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpendItem = {
  accountName: Scalars['String']['output'];
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  productAccountType: ProductAccountType;
  summary: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
};

export type SpendPurchaseItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendPurchaseItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpendRealTimeRoundUpItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendRealTimeRoundUpItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  initialAmount: CurrencyAmount;
  multiplier: Scalars['Int']['output'];
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpendTransferInItem = PastItem & PastTargetedTransferItem & PastUserTransferItem & SpendItem & {
  __typename?: 'SpendTransferInItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  estimatedCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpendTransferOutItem = PastItem & PastTargetedTransferItem & PastUserTransferItem & SpendItem & {
  __typename?: 'SpendTransferOutItem';
  accountName: Scalars['String']['output'];
  amount: CurrencyAmount;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  drawerInclusion: Scalars['Boolean']['output'];
  estimatedCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  productAccountType: ProductAccountType;
  productType: ProductType;
  reversible: Scalars['Boolean']['output'];
  sourceAccountTitle?: Maybe<Scalars['String']['output']>;
  status: PastItemStatus;
  summary: Scalars['String']['output'];
  targetAccountTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionType: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SpendUserWhitelistType {
  Reopen = 'REOPEN'
}

export type SplitDeposit = {
  __typename?: 'SplitDeposit';
  allocations: Array<SplitDepositAllocation>;
  createdAt: Scalars['String']['output'];
  distributedAt?: Maybe<Scalars['String']['output']>;
  expectedNextDepositAmount?: Maybe<Scalars['String']['output']>;
  expectedNextDepositAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCancelable: Scalars['Boolean']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isUsingRecommendedAllocations: Scalars['Boolean']['output'];
  /** @deprecated deprecated, use allocations instead */
  savingsRatePercent: Scalars['String']['output'];
  settingsId: Scalars['ID']['output'];
  /** @deprecated deprecated, use allocations instead */
  splitDistribution: DistributionAmounts;
  transactionAmount: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
  willDistributeAutomaticallyAt?: Maybe<Scalars['String']['output']>;
};

export type SplitDepositAllocation = {
  allocationPercent: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  targetAccountId: Scalars['ID']['output'];
  targetAccountType: SplitDepositTargetAccountType;
};

export type SplitDepositAllocationInput = {
  allocationPercent: Scalars['String']['input'];
  nickname?: InputMaybe<Scalars['String']['input']>;
  targetAccountId: Scalars['ID']['input'];
  targetAccountType: SplitDepositTargetAccountType;
};

export type SplitDepositDailyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositDailyRecurrenceRule';
  frequency: SplitDepositRecurrenceFrequency;
};

export type SplitDepositDirectDepositAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositDirectDepositAllocation';
  allocationPercent: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  normalizedAmount?: Maybe<FormattedMonetaryAmount>;
  normalizedDailyAmount?: Maybe<Scalars['String']['output']>;
  targetAccountId: Scalars['ID']['output'];
  targetAccountType: SplitDepositTargetAccountType;
};

export type SplitDepositDirectDepositIntentSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositIntentSetting';
  allocations: Array<SplitDepositDirectDepositAllocation>;
  createdAt: Scalars['String']['output'];
  deposits?: Maybe<Array<SplitDeposit>>;
  /** @deprecated deprecated */
  distributionType: DistributionType;
  /** @deprecated use name instead */
  employer: Scalars['String']['output'];
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']['output'];
  /** @deprecated deprecated */
  employerName: Scalars['String']['output'];
  estimatedPaycheckAmount: CurrencyAmount;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isUsingRecommendedAllocations: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']['output'];
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};


export type SplitDepositDirectDepositIntentSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Order>;
};

export type SplitDepositDirectDepositSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositSetting';
  allocations: Array<SplitDepositDirectDepositAllocation>;
  awaitingConfiguration: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  deposits?: Maybe<Array<SplitDeposit>>;
  /** @deprecated deprecated */
  distributionType: DistributionType;
  /** @deprecated use name instead */
  employer: Scalars['String']['output'];
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']['output'];
  /** @deprecated deprecated */
  employerName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isUsingRecommendedAllocations: Scalars['Boolean']['output'];
  monthlyTotals: Array<MonthlyTotal>;
  name: Scalars['String']['output'];
  normalizedAmount?: Maybe<FormattedMonetaryAmount>;
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']['output'];
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']['output'];
  totalAmounts?: Maybe<TotalAmounts>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};


export type SplitDepositDirectDepositSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Order>;
};

export type SplitDepositMonthlyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositMonthlyRecurrenceRule';
  byMonthDay: Array<Scalars['Int']['output']>;
  frequency: SplitDepositRecurrenceFrequency;
};

export type SplitDepositMutation = {
  __typename?: 'SplitDepositMutation';
  cancel: SplitDeposit;
  execute: SplitDeposit;
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export enum SplitDepositNormalizationFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type SplitDepositRecurrenceAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositRecurrenceAllocation';
  allocationPercent: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  legacyRecurrenceAmount?: Maybe<FormattedMonetaryAmount>;
  legacyRecurrenceRule?: Maybe<SplitDepositRecurrenceRule>;
  nickname?: Maybe<Scalars['String']['output']>;
  targetAccountId: Scalars['ID']['output'];
  targetAccountType: SplitDepositTargetAccountType;
};

export enum SplitDepositRecurrenceFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type SplitDepositRecurrenceRule = {
  frequency: SplitDepositRecurrenceFrequency;
};

export type SplitDepositRecurrenceSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositRecurrenceSetting';
  allocations: Array<SplitDepositRecurrenceAllocation>;
  createdAt: Scalars['String']['output'];
  deposits?: Maybe<Array<SplitDeposit>>;
  /** @deprecated deprecated */
  distributionType: DistributionType;
  /** @deprecated use name instead */
  employer: Scalars['String']['output'];
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']['output'];
  /** @deprecated deprecated */
  employerName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  monthlyTotals: Array<MonthlyTotal>;
  name: Scalars['String']['output'];
  normalizedAmount?: Maybe<FormattedMonetaryAmount>;
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']['output'];
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};


export type SplitDepositRecurrenceSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Order>;
};

export enum SplitDepositSettingType {
  DirectDeposit = 'DIRECT_DEPOSIT',
  DirectDepositIntent = 'DIRECT_DEPOSIT_INTENT',
  Recurrence = 'RECURRENCE'
}

export type SplitDepositSettings = {
  allocations: Array<SplitDepositAllocation>;
  createdAt: Scalars['String']['output'];
  deposits?: Maybe<Array<SplitDeposit>>;
  /** @deprecated deprecated */
  distributionType: DistributionType;
  /** @deprecated use name instead */
  employer: Scalars['String']['output'];
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']['output'];
  /** @deprecated deprecated */
  employerName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']['output'];
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};


export type SplitDepositSettingsDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Order>;
};

export type SplitDepositSettingsFilterInput = {
  settingTypes: Array<SplitDepositSettingType>;
  showHiddenEmployerSettings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SplitDepositSettingsMutation = {
  __typename?: 'SplitDepositSettingsMutation';
  configure: SplitDepositSettings;
  employer: Scalars['String']['output'];
  employerHidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};


export type SplitDepositSettingsMutationConfigureArgs = {
  input: ConfigureSettingsInput;
};

export type SplitDepositTargetAccount = {
  __typename?: 'SplitDepositTargetAccount';
  nickname?: Maybe<Scalars['String']['output']>;
  targetAccountId?: Maybe<Scalars['ID']['output']>;
  targetAccountType: SplitDepositTargetAccountType;
};

export enum SplitDepositTargetAccountType {
  Early = 'EARLY',
  Invest = 'INVEST',
  Later = 'LATER',
  Save = 'SAVE',
  Spend = 'SPEND'
}

export type SplitDepositWeeklyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositWeeklyRecurrenceRule';
  byWeekDay: Array<DayOfWeek>;
  frequency: SplitDepositRecurrenceFrequency;
};

/** This SSN already belongs to another beneficiary for this custodian */
export type SsnAlreadyInUseException = {
  __typename?: 'SsnAlreadyInUseException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** This SSN is a duplicate of the current custodian's SSN */
export type SsnMatchesCustodianException = {
  __typename?: 'SsnMatchesCustodianException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export enum StateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Pw = 'PW',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

/** Statement */
export type Statement = {
  __typename?: 'Statement';
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  archivableId?: Maybe<Scalars['ID']['output']>;
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  archivableType?: Maybe<Scalars['String']['output']>;
  backgroundStatus?: Maybe<StatementStatus>;
  /** created at date and time of Statement */
  createdAt: Scalars['DateTime']['output'];
  day: Scalars['Int']['output'];
  /** update at date and time of Statement */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Deprecated do not use
   * @deprecated Use taxFormType instead
   */
  formType?: Maybe<FormType>;
  id: Scalars['ID']['output'];
  /** Unique identifier of the investment account for which the statement was generated for. */
  investmentAccountId: Scalars['ID']['output'];
  investmentAccountType?: Maybe<InvestmentAccountType>;
  /**
   * Deprecated do not use
   * @deprecated Use statementLink instead
   */
  link?: Maybe<StatementLink>;
  month: Scalars['Int']['output'];
  portfolioType: StatementPortfolioType;
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  s3Filename?: Maybe<Scalars['String']['output']>;
  /** created at date and time of Statement */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  statementLink?: Maybe<Scalars['String']['output']>;
  statementType: StatementType;
  taxFormType?: Maybe<TaxFormType>;
  /** update at date and time of Statement */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploaded?: Maybe<Scalars['Boolean']['output']>;
  year: Scalars['Int']['output'];
};

/** An individual edge within the paginated list of Statement */
export type StatementEdge = {
  __typename?: 'StatementEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The Statement record in the edge */
  node: Statement;
};

/** StatementLink */
export type StatementLink = {
  __typename?: 'StatementLink';
  downloadUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Relay style pagination information for Statement */
export type StatementPagination = {
  __typename?: 'StatementPagination';
  edges: Array<StatementEdge>;
  pageInfo: PageInfo;
};

export enum StatementPortfolioType {
  Customized = 'CUSTOMIZED',
  Managed = 'MANAGED',
  SelfDirected = 'SELF_DIRECTED'
}

/** A batch run of statements for a given period. */
export type StatementRun = {
  __typename?: 'StatementRun';
  /** When the statement run was created */
  createdAt: Scalars['DateTime']['output'];
  /** Date the statement run was executed */
  executionDate: Scalars['Date']['output'];
  /** Expected number of statements in this run */
  expectedStatementCount: Scalars['Int']['output'];
  /** Unique identifier for the statement run */
  id: Scalars['ID']['output'];
  /** Start date of the statement period */
  statementPeriodStart: Scalars['Date']['output'];
  /** Current status of the statement run */
  status: Scalars['String']['output'];
  /** When the statement run was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** ID of the user who initiated the run */
  userId: Scalars['ID']['output'];
};

/** An individual edge within the paginated list of StatementRun */
export type StatementRunEdge = {
  __typename?: 'StatementRunEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The StatementRun record in the edge */
  node: StatementRun;
};

/** Statement run not found. */
export type StatementRunNotFoundException = {
  __typename?: 'StatementRunNotFoundException';
  /** Inputed statement run id */
  statementRunId?: Maybe<Scalars['ID']['output']>;
};

/** Relay style pagination information for StatementRun */
export type StatementRunPagination = {
  __typename?: 'StatementRunPagination';
  edges: Array<StatementRunEdge>;
  pageInfo: PageInfo;
};

/** Result of statement run */
export type StatementRunResponse = StatementRun | StatementRunNotFoundException;

export enum StatementStatus {
  /** canceled status */
  Canceled = 'CANCELED',
  /** fail status */
  Fail = 'FAIL',
  /** initiated status */
  Initiated = 'INITIATED',
  /** processing status */
  Processing = 'PROCESSING',
  /** review status */
  Review = 'REVIEW',
  /** success status */
  Success = 'SUCCESS',
  /** withheld status */
  Withheld = 'WITHHELD'
}

export enum StatementType {
  /** user trade or chargeback confirmation */
  DailyUserTradeConfirmation = 'daily_user_trade_confirmation',
  /** tax statements */
  Tax = 'tax',
  /** monthly statements */
  User = 'user'
}

/** All statement filters */
export enum StatementTypeEnum {
  /** daily user trade confirmation */
  DailyUserTradeConfirmation = 'daily_user_trade_confirmation',
  /** tax statements */
  Tax = 'tax',
  /** monthly statements */
  User = 'user',
  /** user trade cancelation confirmation */
  UserTradeConfirmationChargeback = 'user_trade_confirmation_chargeback'
}

/** Input values from statements by investment account request */
export type StatementsByInvestmentAccountIdFilter = {
  /** Start date to searhe */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** End date to search */
  to?: InputMaybe<Scalars['DateTime']['input']>;
  /** Type of document being requested */
  type?: InputMaybe<StatementTypeEnum>;
};

export type Stock = Security & {
  __typename?: 'Stock';
  active: Scalars['Boolean']['output'];
  currentPrice: BigCurrencyAmount;
  currentlySupported: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  earliestPriceDate: Scalars['Date']['output'];
  headlines: Array<SecurityHeadline>;
  id: Scalars['ID']['output'];
  lastClosePrice: BigCurrencyAmount;
  lastUpdatedAt: Scalars['DateTime']['output'];
  longName: Scalars['String']['output'];
  marketCap: Scalars['BigDecimal']['output'];
  openPrice: BigCurrencyAmount;
  profile: SecurityProfile;
  /** @deprecated Use Security.headlines. */
  securityHeadlines: Array<SecurityHeadline>;
  /** @deprecated Use Security.profile. */
  securityProfile: SecurityProfile;
  shortName: Scalars['String']['output'];
  symbol: Scalars['TickerSymbol']['output'];
  type: SecurityType;
  volume: Scalars['BigDecimal']['output'];
  week52High: BigCurrencyAmount;
  week52Low: BigCurrencyAmount;
};

export type StringKeyAsset = {
  __typename?: 'StringKeyAsset';
  args: Array<Scalars['String']['output']>;
  key: Scalars['StringKey']['output'];
};

export type SubcategoryMessage = {
  __typename?: 'SubcategoryMessage';
  body?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Submission = {
  __typename?: 'Submission';
  bank: BankName;
  created: Scalars['DateTime']['output'];
  feeSynopsis?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  linkedAccountId: Scalars['ID']['output'];
  status: SubmissionStatus;
  updated: Scalars['DateTime']['output'];
};

export type SubmissionError = {
  __typename?: 'SubmissionError';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum SubmissionStatus {
  Collect = 'COLLECT',
  Completed = 'COMPLETED',
  ConnectionError = 'CONNECTION_ERROR',
  DelayCharge = 'DELAY_CHARGE',
  MailInError = 'MAIL_IN_ERROR',
  MailInEscalated = 'MAIL_IN_ESCALATED',
  MailInPending = 'MAIL_IN_PENDING',
  MailInSent = 'MAIL_IN_SENT',
  Pending = 'PENDING'
}

export type SubmitBankFeeNegotiationInput = {
  linkedAccountId: Scalars['ID']['input'];
};

export type SubmitBankFeeNegotiationResponse = {
  __typename?: 'SubmitBankFeeNegotiationResponse';
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type SubmitBankFeeNegotiationResult = LinkedAccountNotFound | SubmitBankFeeNegotiationResponse;

export type SubmitEarnMissingCreditRequestInput = {
  extensionMerchantName?: InputMaybe<Scalars['String']['input']>;
  merchantId: Scalars['ID']['input'];
  method: EarnPurchaseMethod;
  orderNumber: Scalars['String']['input'];
  proofOfPurchaseUrl: Scalars['URL']['input'];
  purchaseDate: Scalars['Date']['input'];
  subTotal: Scalars['Float']['input'];
  total: Scalars['Float']['input'];
};

export type SubmitEarnMissingCreditRequestResult = EarnMissingCreditRequest | EarnMissingCreditRequestPurchaseDateError;

export type SubmitUserReportedBankFeeRefundInput = {
  refundAmount: Scalars['Amount']['input'];
  submissionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type SubmitUserReportedBankFeeRefundResult = {
  __typename?: 'SubmitUserReportedBankFeeRefundResult';
  message: Scalars['String']['output'];
};

export type SubscribeToTierInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  tierId: Scalars['ID']['input'];
  tierPriceId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubscribeToTierResult = InvalidTier | InvalidTierPrice | TierSubscription;

export type SubscribeUserToTierByProductKeyInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>;
  /**
   * Subscription requests with an effective date earlier than the current subscription's createdAt
   * timestamp will be ignored. Defaults to current time.
   */
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  productKey: ProductKey;
  tierGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubscribeUserToTierInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>;
  tierPriceId: Scalars['ID']['input'];
};

export type SubscribeUserToTierResult = InvalidTierPriceId | TierDowngradeActionRequired | TierSubscription;

export type SubscriberIneligibleError = {
  __typename?: 'SubscriberIneligibleError';
  message: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Returns new messages created */
  onMessageCreated: Message;
};


export type SubscriptionOnMessageCreatedArgs = {
  categoryFilters?: InputMaybe<Array<MessageCategory>>;
  typeFilters?: InputMaybe<Array<MessageType>>;
  userId: Scalars['ID']['input'];
};

export type SubscriptionMigration = {
  __typename?: 'SubscriptionMigration';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  effectiveAt: Scalars['DateTime']['output'];
  fromTier: Tier;
  id: Scalars['ID']['output'];
  toTier: Tier;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionMigrationInvalidError = {
  __typename?: 'SubscriptionMigrationInvalidError';
  message: Scalars['String']['output'];
};

export type SubscriptionMigrationWaiver = {
  __typename?: 'SubscriptionMigrationWaiver';
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  migration: SubscriptionMigration;
  reason: SubscriptionMigrationWaiverReason;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SubscriptionMigrationWaiverReason {
  FinancialHardship = 'FINANCIAL_HARDSHIP'
}

export enum SubscriptionPaymentMethod {
  Ach = 'ach',
  Amazon = 'amazon',
  ApplePay = 'apple_pay',
  Bachs = 'bachs',
  Check = 'check',
  CreditCard = 'credit_card',
  Eft = 'eft',
  GooglePay = 'google_pay',
  MoneyOrder = 'money_order',
  Other = 'other',
  Paypal = 'paypal',
  Roku = 'roku',
  Sepadirectdebit = 'sepadirectdebit',
  WireTransfer = 'wire_transfer'
}

/** transition actions for a subscription */
export enum SubscriptionTransitionAction {
  AddPromotion = 'ADD_PROMOTION',
  Deactivate = 'DEACTIVATE',
  Downgrade = 'DOWNGRADE',
  Upgrade = 'UPGRADE'
}

export type SucceedVendorInvoiceResult = BillingVendorError | Invoice;

export type SuggestedMoneyRulesResult = SuggestedMoneyRulesSuccess;

export type SuggestedMoneyRulesSuccess = {
  __typename?: 'SuggestedMoneyRulesSuccess';
  adjustedForIncome: Scalars['Boolean']['output'];
  resultingCategories: Array<MoneyManagerCategory>;
  resultingRuleset: MoneyRulesRuleset;
};

export enum SuitabilityAccountSubtype {
  Individual = 'INDIVIDUAL',
  RothIra = 'ROTH_IRA',
  SepIra = 'SEP_IRA',
  TraditionalIra = 'TRADITIONAL_IRA'
}

export enum SuitabilityAccountType {
  Brokerage = 'BROKERAGE',
  Retirement = 'RETIREMENT'
}

export type SupportArticle = {
  __typename?: 'SupportArticle';
  author: SupportAuthor;
  body: Scalars['String']['output'];
  draft?: Maybe<Scalars['Boolean']['output']>;
  editedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  private?: Maybe<Scalars['Boolean']['output']>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  section: SupportSection;
  sectionId: Scalars['ID']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SupportAuthor = {
  __typename?: 'SupportAuthor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  photo: SupportAuthorPhoto;
};

export type SupportAuthorPhoto = {
  __typename?: 'SupportAuthorPhoto';
  contentUrl: Scalars['String']['output'];
};

export type SupportCategory = {
  __typename?: 'SupportCategory';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SupportSection = {
  __typename?: 'SupportSection';
  articles: Array<Maybe<SupportArticle>>;
  category: SupportCategory;
  categoryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SupportTicket = {
  __typename?: 'SupportTicket';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reportingTag?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SupportTicketForm = {
  __typename?: 'SupportTicketForm';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  ticketFields?: Maybe<Array<Maybe<SupportTicketFormField>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SupportTicketFormField = {
  __typename?: 'SupportTicketFormField';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customFieldOptions?: Maybe<Array<Maybe<CustomFieldOption>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  systemFieldOptions?: Maybe<Array<Maybe<CustomFieldOption>>>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SupportTicketResponse = RecaptchaException | SupportTicket;

export type SupportTicketWithCustomFieldsResponse = SubmissionError | SupportTicket;

export type SupportUser = {
  __typename?: 'SupportUser';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SuppressMoneyManagerRebalancesError = {
  __typename?: 'SuppressMoneyManagerRebalancesError';
  message: Scalars['String']['output'];
};

/** ISO8601 should include timezone */
export type SuppressMoneyManagerRebalancesInput = {
  rebalanceSuppressionSource: MoneyManagerRebalanceSuppressionSource;
};

export type SuppressMoneyManagerRebalancesResult = SuppressMoneyManagerRebalancesError | SuppressMoneyManagerRebalancesSuccess;

export type SuppressMoneyManagerRebalancesSuccess = {
  __typename?: 'SuppressMoneyManagerRebalancesSuccess';
  rebalancesSuppressedFrom: MoneyManagerRebalanceSuppressionSource;
};

/** Response from suspending deposits */
export type SuspendDepositsResponse = {
  __typename?: 'SuspendDepositsResponse';
  userId: Scalars['ID']['output'];
};

/** input to the suspendUserByUserId mutation */
export type SuspendUserByUserIdInput = {
  /** User ID of the Portal/Admin user enacting the suspension */
  suspendedById: Scalars['String']['input'];
  /** Suspension reason */
  suspensionReason: SuspensionReason;
  /** User UUID to be suspended */
  userId: Scalars['ID']['input'];
};

/** suspendUserByUserId response */
export type SuspendUserByUserIdResult = InternalErrorException | UserAlreadySuspendedException | UserSuspensionRecord;

/** Input containing UUID & suspension note. */
export type SuspendUserInput = {
  /** Categories to help admin user classify user notes */
  category?: InputMaybe<UserNoteCategories>;
  /** Suspension note. */
  suspendedNote: RevokeAccessReasons;
  /** UUID of user to suspend/unsuspend. */
  userId: Scalars['ID']['input'];
};

export enum SuspensionReason {
  CashOwedWriteoff = 'CASH_OWED_WRITEOFF',
  CoreAccountReview = 'CORE_ACCOUNT_REVIEW',
  CoreBrokerDealerAssociation = 'CORE_BROKER_DEALER_ASSOCIATION',
  CoreCastleLock = 'CORE_CASTLE_LOCK',
  CoreChargeback = 'CORE_CHARGEBACK',
  CoreCollection = 'CORE_COLLECTION',
  CoreDisputedTransaction = 'CORE_DISPUTED_TRANSACTION',
  CoreLeinLevyLock = 'CORE_LEIN_LEVY_LOCK',
  CorePendingApprovalApplicationWithdrawn = 'CORE_PENDING_APPROVAL_APPLICATION_WITHDRAWN',
  CorePotentialAccountTakeover = 'CORE_POTENTIAL_ACCOUNT_TAKEOVER',
  CoreSuspiciousInvestmentActivity = 'CORE_SUSPICIOUS_INVESTMENT_ACTIVITY',
  CoreW9Required = 'CORE_W9_REQUIRED',
  Deceased = 'DECEASED',
  DuplicateAccount = 'DUPLICATE_ACCOUNT',
  EarlyTransferInProgress = 'EARLY_TRANSFER_IN_PROGRESS',
  LaterRolloverInProgress = 'LATER_ROLLOVER_IN_PROGRESS',
  OtherNotListed = 'OTHER_NOT_LISTED',
  PlaidMismatch = 'PLAID_MISMATCH',
  ProfitStarsDispute = 'PROFIT_STARS_DISPUTE',
  ReferralPromotionFraud = 'REFERRAL_PROMOTION_FRAUD',
  SharesZeroedOut = 'SHARES_ZEROED_OUT',
  SpendDisputedIncomingTransferR10 = 'SPEND_DISPUTED_INCOMING_TRANSFER_R10',
  SpendGeneralSuspension = 'SPEND_GENERAL_SUSPENSION',
  SpendReturnedTransfer = 'SPEND_RETURNED_TRANSFER',
  SpendSuspiciousTransferActivity = 'SPEND_SUSPICIOUS_TRANSFER_ACTIVITY',
  SuspiciousMrdcContactSpendRisk = 'SUSPICIOUS_MRDC_CONTACT_SPEND_RISK',
  SuspiciousMrdcPendingClosure = 'SUSPICIOUS_MRDC_PENDING_CLOSURE',
  ThreeWayCallRequired = 'THREE_WAY_CALL_REQUIRED',
  Underage = 'UNDERAGE',
  UnsupportedCustomer = 'UNSUPPORTED_CUSTOMER'
}

export enum SwitchStatus {
  /** Deposit confirmed in Spend account */
  Completed = 'completed',
  /** New for processing */
  New = 'new',
  /** PDF downloaded */
  PdfDownloaded = 'pdfDownloaded',
  /** PDF generated */
  PdfGenerated = 'pdfGenerated',
  /** Ready for processing */
  Ready = 'ready',
  /** Sent to ClickSwitch */
  Submitted = 'submitted'
}

export enum SwitchType {
  /** Online */
  Online = 'online',
  /** Default PDF */
  Pdf = 'pdf',
  /** Submittable Generic */
  Submittable = 'submittable',
  /** Submittable Custom */
  SubmittableCustom = 'submittableCustom'
}

export type SyncBankAddressesInput = {
  userId: Scalars['ID']['input'];
};

export type SyncBankAddressesPayload = {
  __typename?: 'SyncBankAddressesPayload';
  userId: Scalars['ID']['output'];
};

export type SyncBankCustomerInput = {
  userId: Scalars['ID']['input'];
};

export type SyncBankCustomerPayload = {
  __typename?: 'SyncBankCustomerPayload';
  userId: Scalars['ID']['output'];
};

export type SyncBankFeeTransactionsInput = {
  userId: Scalars['ID']['input'];
};

export type SyncBankFeeTransactionsResult = {
  __typename?: 'SyncBankFeeTransactionsResult';
  message: Scalars['String']['output'];
};

export type SyncBankSocialSecurityNumberInput = {
  userId: Scalars['ID']['input'];
};

export type SyncBankSocialSecurityNumberPayload = {
  __typename?: 'SyncBankSocialSecurityNumberPayload';
  userId: Scalars['ID']['output'];
};

export type SyncFundingSourceToVendorResult = BillingVendorError | DuplicateBillingInfoError | VendorBillingInfo;

export type SyncSupportAccountInput = {
  id: Scalars['ID']['input'];
};

export type SyncSupportAccountResponse = {
  __typename?: 'SyncSupportAccountResponse';
  eventId: Scalars['String']['output'];
};

export type SystemCardLockedSpendAlert = SpendAlert & {
  __typename?: 'SystemCardLockedSpendAlert';
  type: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export enum TaxFormType {
  Form1099 = 'form1099',
  Form1099Bdiv = 'form1099BDIV',
  Form1099Misc = 'form1099MISC',
  Form1099R = 'form1099R',
  Form1099R1 = 'form1099R1',
  Form1099R2 = 'form1099R2',
  Form1099R4 = 'form1099R4',
  Form1099R7 = 'form1099R7',
  Form1099R8 = 'form1099R8',
  Form1099Re = 'form1099RE',
  Form1099Rj = 'form1099RJ',
  Form1099Rq = 'form1099RQ',
  Form1099Rt = 'form1099RT',
  Form5498 = 'form5498',
  Other = 'other'
}

export type TaxWithholdingAmounts = {
  __typename?: 'TaxWithholdingAmounts';
  /**  total amount that will be withheld from the feds */
  federalWithholdingAmount: MonetaryAmount;
  /**  total amount that will be withheld from the state */
  stateWithholdingAmount: MonetaryAmount;
};

/** Tax year must be provided for investment made for IRA account */
export type TaxYearNotEnteredForIraException = {
  __typename?: 'TaxYearNotEnteredForIRAException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export enum TfaNotification {
  PushNotification = 'PUSH_NOTIFICATION'
}

export type TfaOptions = {
  __typename?: 'TfaOptions';
  email?: Maybe<Array<Scalars['String']['output']>>;
  notification?: Maybe<Array<TfaNotification>>;
  phone?: Maybe<Array<Scalars['String']['output']>>;
  question?: Maybe<Array<Scalars['String']['output']>>;
};

export enum TfaStatus {
  Authorized = 'AUTHORIZED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Required = 'REQUIRED'
}

export enum TfaType {
  Email = 'EMAIL',
  Notification = 'NOTIFICATION',
  Pending = 'PENDING',
  Phone = 'PHONE',
  Question = 'QUESTION'
}

export type Tier = {
  __typename?: 'Tier';
  /** Indicates whether a tier is active or deprecated */
  active: Scalars['Boolean']['output'];
  /** Image asset path in CDN */
  assetPath?: Maybe<Scalars['String']['output']>;
  /** Associated grouping of products */
  bundles?: Maybe<Array<Bundle>>;
  description: Scalars['String']['output'];
  /** Name of tier to display in certain positions where space is limited */
  displayName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use Query.products and Tier.products instead. */
  excludedProducts: Array<TierProduct>;
  id: Scalars['ID']['output'];
  /** @deprecated Use Query.products and Tier.products instead. */
  includedProducts: Array<TierProduct>;
  key: TierKey;
  name: Scalars['String']['output'];
  /** Associated Products available when subscribed to this Tier. */
  products?: Maybe<Array<Product>>;
  /**
   * (DONT USE) Internal only, may be removed without warning.
   * @deprecated Use Query.tierGroupForUser to determine the subscriber's Tier Group.
   */
  tierGroupId: Scalars['ID']['output'];
  /** Price of Tier */
  tierPrice: TierPrice;
};

/** Individual action in a list of required actions */
export type TierDowngradeAction = {
  __typename?: 'TierDowngradeAction';
  key: TierDowngradeActionKey;
};

/** Actions that must be taken to complete a downgrade workflow */
export enum TierDowngradeActionKey {
  CloseEarlyAccount = 'CLOSE_EARLY_ACCOUNT',
  CloseEmergencyFundAccount = 'CLOSE_EMERGENCY_FUND_ACCOUNT',
  CloseInvestAccount = 'CLOSE_INVEST_ACCOUNT',
  CloseLaterAccount = 'CLOSE_LATER_ACCOUNT',
  CloseSelfDirectedInvest = 'CLOSE_SELF_DIRECTED_INVEST',
  CloseSpendAccount = 'CLOSE_SPEND_ACCOUNT'
}

/** The list of required actions */
export type TierDowngradeActionRequired = {
  __typename?: 'TierDowngradeActionRequired';
  actions: Array<TierDowngradeAction>;
};

/** Grouping of Tiers w/default tier, etc. */
export type TierGroup = {
  __typename?: 'TierGroup';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Used to key A/B test off of */
  id: Scalars['ID']['output'];
  /** Tier ID which is the "preferred" one (i.e "Acorns recommends") */
  preferredTierId: Scalars['ID']['output'];
  tierOptions: Array<TierOption>;
  updatedAt: Scalars['DateTime']['output'];
  winbackTierOption?: Maybe<TierOption>;
};

export enum TierKey {
  /** Hardship $1 tier for our winback campaign */
  Assist = 'ASSIST',
  /** Legacy $2 SPEND tier */
  Bronze = 'BRONZE',
  Copper = 'COPPER',
  /** Promotional tier for Cricket Wireless subscribers. */
  Cricket = 'CRICKET',
  Gold = 'GOLD',
  /** Promotional free tier for active military and veterans */
  Military = 'MILITARY',
  Null = 'NULL',
  Platinum = 'PLATINUM',
  Silver = 'SILVER'
}

/** Combination of a Tier and available prices to choose from. */
export type TierOption = {
  __typename?: 'TierOption';
  preferredTierPrice: TierPrice;
  tier: Tier;
  tierPrices: Array<TierPrice>;
};

export type TierOptionByTierPriceIdResult = InvalidTierPriceId | TierOption;

/** Pricing configuration used for a tier */
export type TierPrice = {
  __typename?: 'TierPrice';
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `amountV2`. */
  amount: CurrencyAmount;
  amountV2: MicrosMoney;
  billingFrequency: BillingFrequency;
  id: Scalars['ID']['output'];
  /** (DONT USE) Internal only, may be removed without warning. */
  tierId: Scalars['ID']['output'];
};

/** (Deprecated) Minimal representation of an Acorns product. */
export type TierProduct = {
  __typename?: 'TierProduct';
  /** used as unique identifier for this product */
  key: ProductKey;
};

/** Unique combo of Tier and TierPrice tied to a User */
export type TierSubscription = {
  __typename?: 'TierSubscription';
  /** Reference to an Promotion the subscriber is actively consuming. */
  activePromotion?: Maybe<Promotion>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<TierSubscriptionCreatedBy>;
  id: Scalars['ID']['output'];
  migration?: Maybe<SubscriptionMigration>;
  migrationId?: Maybe<Scalars['ID']['output']>;
  /** The Offer the subscriber subscribed to for access to their Tier. */
  offer?: Maybe<Offer>;
  /** Indicates when the subscribers current Offer expires. */
  offerExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Previous tier subscription the user had before this one. */
  previous?: Maybe<TierSubscription>;
  /** Indicates when a promotion was applied to the subscription. */
  promotionAppliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indication of when a subscribers promotion ends. */
  promotionExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  status: TierSubscriptionStatus;
  tier: Tier;
  tierPrice: TierPrice;
  transition?: Maybe<TierSubscriptionTransition>;
  updatedAt: Scalars['DateTime']['output'];
  /** Flag to indicate if the subscription is being managed by our billing/subscription vendor */
  vendorIntegrated?: Maybe<Scalars['Boolean']['output']>;
};

export type TierSubscriptionAlreadyDeactivated = {
  __typename?: 'TierSubscriptionAlreadyDeactivated';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TierSubscriptionConnection = {
  __typename?: 'TierSubscriptionConnection';
  edges: Array<TierSubscription>;
  pageInfo: TierSubscriptionPageInfo;
};

export enum TierSubscriptionCreatedBy {
  /** Subscription created by the pre-launch backfill script */
  Backfill = 'BACKFILL',
  /** Flag to indicate user ought to be billed by the "legacy" billing system */
  LegacyUser = 'LEGACY_USER',
  /** Subscription record that was created as a result of a migration */
  Migration = 'MIGRATION',
  /** User auto-subscribed based on the status of their open accounts */
  SubscribedByOpenAccounts = 'SUBSCRIBED_BY_OPEN_ACCOUNTS',
  /** Subscription created via INTERNAL client request (either an admin or an internal process) */
  System = 'SYSTEM',
  /** Subscription created via EXTERNAL client request */
  User = 'USER'
}

/** account deactivation reasons */
export enum TierSubscriptionDeactivationReason {
  AcornsCostsTooMuch = 'ACORNS_COSTS_TOO_MUCH',
  CantAffordToInvestAtThisTime = 'CANT_AFFORD_TO_INVEST_AT_THIS_TIME',
  ConcernedAboutTheMarket = 'CONCERNED_ABOUT_THE_MARKET',
  DontWantToInvest = 'DONT_WANT_TO_INVEST',
  NotEnoughControlOverMyInvestments = 'NOT_ENOUGH_CONTROL_OVER_MY_INVESTMENTS',
  NotSureHowAcornsWorks = 'NOT_SURE_HOW_ACORNS_WORKS',
  NotTheRightTimeToInvest = 'NOT_THE_RIGHT_TIME_TO_INVEST',
  Other = 'OTHER',
  PoorInvestmentPerformance = 'POOR_INVESTMENT_PERFORMANCE',
  SwitchingToAnotherService = 'SWITCHING_TO_ANOTHER_SERVICE',
  ThisIsTemporaryIllBeBack = 'THIS_IS_TEMPORARY_ILL_BE_BACK',
  TroubleConnectingMyBank = 'TROUBLE_CONNECTING_MY_BANK',
  UnexpectedChargesToMyBank = 'UNEXPECTED_CHARGES_TO_MY_BANK'
}

export type TierSubscriptionForUser = TierSubscription | TierSubscriptionNotFound | TierSubscriptionUnsubscribed;

/** Returned if there is no found tier subscription */
export type TierSubscriptionNotFound = {
  __typename?: 'TierSubscriptionNotFound';
  message: Scalars['String']['output'];
};

/** Metadata for pagination of Tier Subscription History */
export type TierSubscriptionPageInfo = {
  __typename?: 'TierSubscriptionPageInfo';
  cursor?: Maybe<Scalars['String']['output']>;
  hasNext: Scalars['Boolean']['output'];
};

/** Status of a tier subscription */
export enum TierSubscriptionStatus {
  /** An active subscription */
  Active = 'ACTIVE',
  /** A cancelled subscription */
  Inactive = 'INACTIVE',
  /** In the process of either upgrading or downgrading a subscription */
  Transitioning = 'TRANSITIONING'
}

/** Information about a transitioning subscription */
export type TierSubscriptionTransition = {
  __typename?: 'TierSubscriptionTransition';
  desiredTier?: Maybe<Tier>;
  /** Once we've decoupled our Tier and TierPrice, we'll need to make sure we're subscribing the user to the proper Tier and TierPrice */
  desiredTierPrice?: Maybe<TierPrice>;
  initiatedAt: Scalars['DateTime']['output'];
  subscriptionDeactivationReason?: Maybe<TierSubscriptionDeactivationReason>;
  transitionAction: SubscriptionTransitionAction;
};

/** User has unsubscribed from their tier (account closed) */
export type TierSubscriptionUnsubscribed = {
  __typename?: 'TierSubscriptionUnsubscribed';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TimestampsInterface = {
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Tin File Type used in tinVerificationFiles query */
export enum TinFileType {
  Early = 'EARLY',
  User = 'USER'
}

/** A Tin Verification File */
export type TinVerificationFile = {
  __typename?: 'TinVerificationFile';
  expiresAt: Scalars['DateTime']['output'];
  generatedByUserEmail: Scalars['String']['output'];
  generatedByUserUuid: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tinFileType?: Maybe<TinFileType>;
  url?: Maybe<Scalars['URL']['output']>;
};

/** An individual edge within the paginated list of TinVerificationFile */
export type TinVerificationFileEdge = {
  __typename?: 'TinVerificationFileEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The TinVerificationFile record in the edge */
  node: TinVerificationFile;
};

/** Relay style pagination information for TinVerificationFile */
export type TinVerificationFilePagination = {
  __typename?: 'TinVerificationFilePagination';
  edges: Array<TinVerificationFileEdge>;
  pageInfo: PageInfo;
};

/** Presigned url */
export type TinVerificationUploadPresignedUrl = {
  __typename?: 'TinVerificationUploadPresignedUrl';
  url?: Maybe<Scalars['URL']['output']>;
};

export type ToggleMaintenanceFlagInput = {
  flagId: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
};

export type ToggleMaintenanceFlagObject = {
  __typename?: 'ToggleMaintenanceFlagObject';
  enabled: Scalars['Boolean']['output'];
  flagId: Scalars['String']['output'];
};

export type TokenExpiredException = {
  __typename?: 'TokenExpiredException';
  message?: Maybe<Scalars['String']['output']>;
};

export type TopHolding = {
  __typename?: 'TopHolding';
  /** The market value that this security makes up of the ETF */
  marketValue: BigCurrencyAmount;
  /** The number of shares that this security makes up of the ETF */
  numberOfShares?: Maybe<Scalars['BigDecimal']['output']>;
  securityName: Scalars['String']['output'];
  /** The percentage of shares that this security makes up of the ETF */
  sharePercentage: Scalars['BigDecimal']['output'];
  symbol?: Maybe<Scalars['TickerSymbol']['output']>;
};

export type TotalAmounts = {
  __typename?: 'TotalAmounts';
  totalContributedAmount: CurrencyAmount;
  totalDepositedAmount: CurrencyAmount;
};

export enum TradingSector {
  BasicMaterials = 'BASIC_MATERIALS',
  CommunicationServices = 'COMMUNICATION_SERVICES',
  ConsumerCyclical = 'CONSUMER_CYCLICAL',
  ConsumerDefensive = 'CONSUMER_DEFENSIVE',
  Energy = 'ENERGY',
  FinancialServices = 'FINANCIAL_SERVICES',
  HealthCare = 'HEALTH_CARE',
  Industrials = 'INDUSTRIALS',
  RealEstate = 'REAL_ESTATE',
  Technology = 'TECHNOLOGY',
  Utilities = 'UTILITIES'
}

export type Transaction = {
  __typename?: 'Transaction';
  amount?: Maybe<Scalars['Float']['output']>;
  /** authorized date */
  authorizedDate?: Maybe<Scalars['DateTime']['output']>;
  backupPaymentMethodUsed?: Maybe<Scalars['Boolean']['output']>;
  /** array of categories, e.g. ['Payment', 'Credit Card'] */
  categories?: Maybe<Array<Scalars['String']['output']>>;
  collectedAt?: Maybe<Scalars['DateTime']['output']>;
  collectionMethod?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** transaction description */
  description?: Maybe<Scalars['String']['output']>;
  /** account external id */
  externalId: Scalars['ID']['output'];
  id?: Maybe<Scalars['String']['output']>;
  linkedSubaccount: InternalLinkedSubaccount;
  /** time transaction was received */
  location?: Maybe<Scalars['String']['output']>;
  /** merchant name, e.g. 'Burger King' */
  merchantName?: Maybe<Scalars['String']['output']>;
  /** transaction name, e.g. 'CREDIT CARD 3333 PAYMENT *\//' */
  name: Scalars['String']['output'];
  object?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  originalTransactionId?: Maybe<Scalars['String']['output']>;
  /** payment channel, e.g. 'in store', 'online' */
  paymentChannel?: Maybe<Scalars['String']['output']>;
  /** pending flag */
  pending?: Maybe<Scalars['Boolean']['output']>;
  /** JSON representation of transactions */
  raw: Scalars['String']['output'];
  /** time received */
  receivedAt: Scalars['DateTime']['output'];
  refunded?: Maybe<Scalars['Boolean']['output']>;
  /** transaction source */
  source: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  /** sub type */
  subType?: Maybe<Scalars['String']['output']>;
  /** sub type code */
  subTypeCode?: Maybe<Scalars['String']['output']>;
  subscriptionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  /** transaction date */
  transactionDate: Scalars['DateTime']['output'];
  type?: Maybe<Scalars['String']['output']>;
  /** type code */
  typeCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** user */
  user: Scalars['String']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum TransactionCategory {
  Fee = 'FEE',
  Refund = 'REFUND'
}

export type TransactionEntity = {
  __typename?: 'TransactionEntity';
  amount?: Maybe<Scalars['Float']['output']>;
  bankType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  fromInstitution?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  transactionCreatedAt?: Maybe<Scalars['Date']['output']>;
  transactionId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated This is not used anymore and will be removed. */
  transactionSettledAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated This is not used anymore and will be removed. */
  userHasDirectDeposit?: Maybe<Scalars['Boolean']['output']>;
  userUuid?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Transaction page returned from transactions query */
export type TransactionPage = {
  __typename?: 'TransactionPage';
  /** transaction page information */
  pageInfo: TransactionPageInfo;
  /** array of transactions */
  transactions: Array<Transaction>;
};

/** Transaction page info from transactions query */
export type TransactionPageInfo = {
  __typename?: 'TransactionPageInfo';
  /** total number of transactions being requested */
  limit: Scalars['Int']['output'];
  /** input to the offset parameter of the query */
  nextOffset?: Maybe<Scalars['String']['output']>;
  /** total number of available transactions */
  totalTransactions: Scalars['Int']['output'];
};

export enum TransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type TransferInternalSharesInput = {
  /**
   * Optonal Input: if used must also provide accountTo, and leave shareTransferType
   * empty. For manual input of the source account that shares will transfer out of
   * for the share transfer.
   */
  accountFrom?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optonal Input: if used must also provide accountFrom, and leave shareTransferType
   * empty. For manual input of the destination account that shares will transfer in to
   * for the share transfer.
   */
  accountTo?: InputMaybe<Scalars['String']['input']>;
  /**
   * The key associated to the share transfer that invest ops will use to verify
   * the transfer is occurring at DW.
   */
  idempotencyKey: Scalars['String']['input'];
  /**
   * Array of symbols and the share quantities associated to each that will be
   * transferred during the mutation.
   */
  internalShareTransfer: Array<InternalShareTransferInput>;
  /**
   * Optional Input: if used must leave accountFrom and accountTo fields empty.
   * Determines the source and destination accounts of the transfer based
   * off the type of transfer being attempted.
   */
  shareTransferType?: InputMaybe<ShareTransferType>;
};

export type TransferInternalSharesResult = InternalShareTransferFailed | OmnibusShareTransferId;

export enum TransferSource {
  Check = 'check',
  PayAdv = 'payAdv',
  Plan = 'plan',
  Recurring = 'recurring',
  Rtru = 'rtru',
  Xfer = 'xfer'
}

export enum TransferableAccountTypeEnum {
  Core = 'core',
  Early = 'early',
  External = 'external',
  Later = 'later',
  Save = 'save',
  Spend = 'spend'
}

/** Response from triggering RDV */
export type TriggerRdvResponse = {
  __typename?: 'TriggerRdvResponse';
  userId: Scalars['ID']['output'];
};

/** An entity representing a Trusted Contact designated for a user's investment account(s) */
export type TrustedContact = {
  __typename?: 'TrustedContact';
  /** Email of trusted contact */
  email: Scalars['Email']['output'];
  /** First name of the trusted contact */
  firstName: Scalars['String']['output'];
  /** ID of the trusted contact */
  id: Scalars['ID']['output'];
  investmentAccounts: Array<Maybe<InvestmentAccount>>;
  /** Last name of the trusted contact */
  lastName: Scalars['String']['output'];
  /** Phone number of trusted contact */
  phoneNumber: Scalars['PhoneNumber']['output'];
  /** ID of the user that the contact belongs to */
  userId: Scalars['ID']['output'];
};

/** Trusted contact email/phone not unique under user scope */
export type TrustedContactAlreadyExistsException = {
  __typename?: 'TrustedContactAlreadyExistsException';
  /** attributes that failed uniqueness check */
  attributes: Array<Scalars['String']['output']>;
  /** error message */
  message: Scalars['String']['output'];
};

/** Fields for adding/editing a trusted contact. */
export type TrustedContactInput = {
  /** Email of trusted contact */
  email: Scalars['Email']['input'];
  /** First name of the trusted contact */
  firstName: Scalars['String']['input'];
  /** All investment account ids that this TrustedContact should be assigned to */
  investmentAccountIds: Array<Scalars['ID']['input']>;
  /** Last name of the trusted contact */
  lastName: Scalars['String']['input'];
  /** Phone number of trusted contact */
  phoneNumber: Scalars['PhoneNumber']['input'];
};

/** Trusted contact email invalid */
export type TrustedContactInvalidEmail = {
  __typename?: 'TrustedContactInvalidEmail';
  /** error message */
  message: Scalars['String']['output'];
};

/** Trusted contact phone number invalid */
export type TrustedContactInvalidPhoneNumber = {
  __typename?: 'TrustedContactInvalidPhoneNumber';
  /** error message */
  message: Scalars['String']['output'];
};

/** TrustedContact does not exist */
export type TrustedContactNotFoundException = {
  __typename?: 'TrustedContactNotFoundException';
  /** message */
  message: Scalars['String']['output'];
};

export enum Type {
  Charge = 'charge',
  Credit = 'credit'
}

export enum UsStateCodes {
  /** Armed Forces America */
  Aa = 'AA',
  /** Armed Forces Europe */
  Ae = 'AE',
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Armed Forces Pacific */
  Ap = 'AP',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** U.S. Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY'
}

export type UnableToCancelCheckError = {
  __typename?: 'UnableToCancelCheckError';
  requestId: Scalars['ID']['output'];
};

export type UnauthorizedException = {
  __typename?: 'UnauthorizedException';
  message?: Maybe<Scalars['String']['output']>;
};

export type UnblockDeviceInput = {
  deviceId: Scalars['ID']['input'];
};

export type UnblockDeviceResult = Device | DeviceNotFoundException;

/** Result from unflagging a user as suspicious. */
export type UnflagUserAsSuspiciousResponse = LegacyUser | UserNotFlaggedAsSuspicious | UserNotFoundException;

/** input to the UnflagUserByUserIdInput mutation */
export type UnflagUserByUserIdInput = {
  /** Flag type */
  flagType: UserFlagType;
  /** User UUID to be unflagged */
  userId: Scalars['ID']['input'];
};

/** unflagUser response */
export type UnflagUserByUserIdResult = InternalErrorException | MissingAdminIdentifierException | UserFlag | UserFlagDoesNotExistsException;

/** Unknown error occurred. Please reach out to engineering. */
export type UnknownException = {
  __typename?: 'UnknownException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

export type UnlinkOidcCredentialsInput = {
  oidcProvider: OidcProvider;
};

export type UnlinkOidcCredentialsResult = OidcCredentialsNotFoundException | UnlinkOidcCredentialsSuccess;

export type UnlinkOidcCredentialsSuccess = {
  __typename?: 'UnlinkOidcCredentialsSuccess';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  oidcProvider?: Maybe<OidcProvider>;
  status?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['ID']['output'];
};

/** Unlinking paypal account input type */
export type UnlinkPaypalAccountInput = {
  /** UUID of the funding source. */
  fundingSourceId: Scalars['ID']['input'];
};

export type UnlockBankAccountError = {
  __typename?: 'UnlockBankAccountError';
  failureMessage: Array<Maybe<Scalars['String']['output']>>;
  userId: Scalars['ID']['output'];
};

export type UnlockBankAccountsError = {
  __typename?: 'UnlockBankAccountsError';
  requestId: Scalars['ID']['output'];
  unProcessedUsers: Array<UnlockBankAccountError>;
};

export type UnlockBankAccountsInput = {
  userIds: Array<Scalars['ID']['input']>;
};

export type UnlockBankAccountsResult = UnlockBankAccountsError | UnlockBankAccountsSuccess;

export type UnlockBankAccountsSuccess = {
  __typename?: 'UnlockBankAccountsSuccess';
  requestId: Scalars['ID']['output'];
};

export type UnlockBankCardInput = {
  userId: Scalars['ID']['input'];
};

export type UnlockBankCardPayload = {
  __typename?: 'UnlockBankCardPayload';
  bankCard?: Maybe<BankCard>;
};

/** Response from user unlock */
export type UnlockUserResponse = {
  __typename?: 'UnlockUserResponse';
  userId: Scalars['ID']['output'];
};

/** Input to unpin note by removing pinned_at field */
export type UnpinNoteInput = {
  /** Note id to update */
  noteId: Scalars['ID']['input'];
};

/** Response of pinning a note */
export type UnpinNoteResponse = NoteNotFoundException | UserNote;

/** User UUID and notification channel they whish to disable. */
export type UnsubscribeNotificationsInput = {
  /** Notification channel that will be disabled */
  channel: NotificationChannel;
  /** User UUID for locating user. */
  userId: Scalars['ID']['input'];
};

/** Response from notification unsubscription */
export type UnsubscribeNotificationsResponse = {
  __typename?: 'UnsubscribeNotificationsResponse';
  channel: NotificationChannel;
  userId: Scalars['ID']['output'];
};

export type UnsubscribeUserFromTierInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>;
};

export type UnsubscribeUserFromTierResult = TierDowngradeActionRequired | TierSubscriptionUnsubscribed;

/** Response from unsuspending deposits */
export type UnsuspendDepositsResponse = {
  __typename?: 'UnsuspendDepositsResponse';
  userId: Scalars['ID']['output'];
};

/** input to the unsuspendUserByUserId mutation */
export type UnsuspendUserByUserIdInput = {
  /** User ID of the Portal/Admin user enacting the unsuspension */
  unsuspendedById: Scalars['String']['input'];
  /** User UUID to be unsuspended */
  userId: Scalars['ID']['input'];
};

/** unsuspendUserByUserId response */
export type UnsuspendUserByUserIdResult = InternalErrorException | UserNotSuspendedException | UserSuspensionRecord;

/** Input containing UUID of user to unsuspend. */
export type UnsuspendUserInput = {
  /** Categories to help admin user classify user notes */
  category?: InputMaybe<UserNoteCategories>;
  /** UUID of user to unsuspend. */
  userId: Scalars['ID']['input'];
};

/** The associated beneficiary does not have a verified SSN */
export type UnverifiedBeneficiarySsnAlertItem = UserAlertsItem & {
  __typename?: 'UnverifiedBeneficiarySsnAlertItem';
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary;
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

/** Result of acceptance document update */
export type UpdateAcceptanceDocumentResponse = AcceptanceDocument | AcceptanceDocumentNotFoundException | InvalidAcceptanceDocumentException;

/** Parameters to update an Acceptance Document Version Filter */
export type UpdateAcceptanceDocumentVersionFilterInput = {
  /** ID of the filter to update */
  id: Scalars['ID']['input'];
  /** New name for the filter */
  name: Scalars['String']['input'];
};

/** Result of acceptance document version filter update */
export type UpdateAcceptanceDocumentVersionFilterResponse = AcceptanceDocumentVersionFilter | AcceptanceDocumentVersionFilterNotFoundException | InvalidAcceptanceDocumentVersionFilterException;

/** Attributes for updating an acceptance document version */
export type UpdateAcceptanceDocumentVersionInput = {
  /** UUID of the AcceptanceDocumentVersion */
  id: Scalars['ID']['input'];
  /** Whether user must scroll to bottom before accepting */
  mustScrollToBottom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this version should be required */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the summary */
  summaryName?: InputMaybe<Scalars['String']['input']>;
  /** URL to the summary */
  summaryUrl?: InputMaybe<Scalars['URL']['input']>;
  /** URL to the document */
  url?: InputMaybe<Scalars['URL']['input']>;
  /** Version number of the document */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Result of acceptance document version update */
export type UpdateAcceptanceDocumentVersionResponse = AcceptanceDocumentVersion | AcceptanceDocumentVersionNotFoundException | InvalidAcceptanceDocumentVersionException;

/** Input to update account portfolio */
export type UpdateAccountPortfolioInput = {
  /** Investment account ID */
  investmentAccountId: Scalars['ID']['input'];
  /** Portfolio Risk Type */
  riskLevel: PortfolioRiskLevel;
  /** Portfolio theme */
  theme: PortfolioTheme;
};

/** Update Account Portfolio Response */
export type UpdateAccountPortfolioResponse = InvalidActionOnAccount | InvestmentAccount | InvestmentAccountNotFoundException | PortfolioNotFoundException | PortfolioUpdateFailedException;

export type UpdateAuthEmailInput = {
  email: Scalars['EmailAddress']['input'];
};

export type UpdateAuthEmailResult = AuthProfile | ExistingEmailVerifiedException;

export type UpdateAuthPhoneNumberInput = {
  phoneNumber: Scalars['PhoneNumber']['input'];
};

export type UpdateAuthPhoneNumberResult = AuthProfile | InvalidPhoneNumberException;

export type UpdateBankAccountInput = {
  accountId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateBankAccountPayload = {
  __typename?: 'UpdateBankAccountPayload';
  requestId: Scalars['ID']['output'];
};

export type UpdateBankAccountResult = UpdateBankAccountPayload;

export type UpdateBannersInput = {
  helpcenter?: InputMaybe<HelpcenterContentInput>;
  sitewide?: InputMaybe<SiteWideBannerContentInput>;
};

/** Response to a beneficiary update */
export type UpdateBeneficiaryInfoResult = BeneficiaryExceedsAgeLimitException | BeneficiaryNotFoundException | InternalBeneficiary | InternalErrorException | InvalidAddressException | InvalidDateOfBirthException | InvalidEmailException | InvalidFirstNameException | InvalidLastNameException | InvalidPhoneException | InvalidSsnException | SecretSquirrelException | SsnAlreadyInUseException | SsnMatchesCustodianException;

export type UpdateBenefitStatusInput = {
  benefitProductKey: BenefitsTrackerProducts;
  claimStatus: ClaimStatus;
  claimedOn?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Array<InputMaybe<BenefitStatusDetail>>>;
  expiresOn?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy: Scalars['String']['input'];
};

export type UpdateBenefitStatusResponse = {
  __typename?: 'UpdateBenefitStatusResponse';
  message: Scalars['String']['output'];
};

/** result from attempting to update a billing cycle's invoice date */
export type UpdateBillingCycleInvoiceDateResult = BillingCycle | InvalidDateException | NoEligibleBillingCyclesException | UnknownException;

export type UpdateCheckPaymentRecipientAddressInputType = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

/** Result of the updateContribution mutation */
export type UpdateContributionResponse = {
  __typename?: 'UpdateContributionResponse';
  /** ID of the investment to be updated */
  investmentUuid: Scalars['ID']['output'];
  /** Tax year to be updated */
  taxYear: Scalars['Int']['output'];
};

export type UpdateCredentialsResult = BlockedEmailDomainException | Credentials | EmailTakenException | UserCredentialsNotFoundException;

/** input to the updateCustomerAccountClosure mutation */
export type UpdateCustomerAccountClosureInput = {
  /** The date the user was closed */
  closedAt: Scalars['Date']['input'];
  /** DateTime that the account closure was requested */
  requestedAt: Scalars['String']['input'];
  /** User uuid */
  userId: Scalars['ID']['input'];
};

/** updateCustomerAccountClosure mutation response */
export type UpdateCustomerAccountClosureResult = CustomerAccountClosure | CustomerClosureDoesNotExistException | InternalErrorException;

export type UpdateDocumentVerificationError = {
  __typename?: 'UpdateDocumentVerificationError';
  failureMessage: Scalars['String']['output'];
};

export type UpdateDocumentVerificationResponseInput = {
  /** Acorns-related field: The request ID which corresponds to the ID in the document-requests table. This is used for internal tracking of document requests. */
  documentRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Unique reference ID for document verification */
  referenceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateDocumentVerificationResult = UpdateDocumentVerificationError | UpdateDocumentVerificationSuccess;

export type UpdateDocumentVerificationSuccess = {
  __typename?: 'UpdateDocumentVerificationSuccess';
  userId: Scalars['ID']['output'];
};

/** Funding source uuid and action: approve or reject. */
export type UpdateFundingSourceChangeInput = {
  /** Approve or reject funding source request change */
  action: FundingSourceChangeAction;
  /** Funding source uuid for find */
  fundingSourceId: Scalars['ID']['input'];
};

/** Input to filter investment account reopen requests by for the InvestmentAccountReopenRequests query */
export type UpdateInvestmentAccountReopenRequestInput = {
  /** The ID of the investment account reopen request to update */
  accountReopenRequestId: Scalars['Int']['input'];
  /** The UUID of the admin user performing this update */
  adminUuid: Scalars['ID']['input'];
  /** The state to which the request will be transitioned */
  reopenRequestToState: InvestmentAccountReopenRequestState;
  /** Email note to be sent to the user */
  updateNote?: InputMaybe<Scalars['String']['input']>;
};

/** Response from updating an investment account reopen request */
export type UpdateInvestmentAccountReopenRequestResponse = AdminUserNotFound | InvalidStateTransition | InvestmentAccountReopenRequest | ReopenRequestNotFound;

/** Attributes for updating the linked subaccount */
export type UpdateLinkedSubaccountInput = {
  /** The role of the linked subaccount */
  role?: InputMaybe<LinkedSubaccountRoleEnum>;
  /** The status of the linked subaccount */
  status?: InputMaybe<FundingSourceStatusEnum>;
};

export type UpdateMaintenanceFlagInput = {
  flagId: Scalars['String']['input'];
  variables: Array<UpdateMaintenanceFlagVariableInput>;
};

export type UpdateMaintenanceFlagObject = {
  __typename?: 'UpdateMaintenanceFlagObject';
  flagId: Scalars['String']['output'];
  variables?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
};

export type UpdateMaintenanceFlagVariableInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateMessageFailed = {
  __typename?: 'UpdateMessageFailed';
  errorMessage: Scalars['String']['output'];
};

export type UpdateMessageIgnored = {
  __typename?: 'UpdateMessageIgnored';
  requestId: Scalars['ID']['output'];
};

export type UpdateMessageResult = AlertMessage | LegacyAlertDismissalSuccess | NotificationMessage | UpdateMessageIgnored;

export type UpdateMessagesFailure = {
  __typename?: 'UpdateMessagesFailure';
  errorMessage: Scalars['String']['output'];
};

/** Input type for updating MoneyManager allocations. */
export type UpdateMoneyManagerAllocationsInput = {
  allocations: Array<MoneyManagerStagedRulesInput>;
  archetype?: InputMaybe<MoneyRulesArchetype>;
  isCustomized: Scalars['Boolean']['input'];
};

/** Represents the result of the updateMoneyManagerAllocations mutation, which can be either a success or an error. */
export type UpdateMoneyManagerAllocationsResult = AcornsValidationError | AllocationAmountsSumExceedingMaxError | InvalidSingleRuleIdError | MismatchedDistributionUnitsError | MissingValidRulesetError | NonUniqueSingleRuleIdsError | UpdateMoneyManagerAllocationsSuccess;

/**
 * Represents a successful update of MoneyManager allocations.
 * Returns the list of money rules after the change.
 */
export type UpdateMoneyManagerAllocationsSuccess = {
  __typename?: 'UpdateMoneyManagerAllocationsSuccess';
  categories: Array<MoneyManagerCategory>;
  rules: Array<MoneyRulesRule>;
};

export type UpdateMoneyManagerAutomationTargetInput = {
  amount: MoneyRulesCurrencyAmountInput;
  customSelection: Scalars['Boolean']['input'];
  suggestedPeriod?: InputMaybe<MoneyManagerPeriodInput>;
  type: MoneyManagerAutomationTargetType;
};

export type UpdateMoneyManagerAutomationTargetResult = MoneyManagerInputError | UpdateMoneyManagerAutomationTargetSuccess;

/** The new state of the user's automation targets */
export type UpdateMoneyManagerAutomationTargetSuccess = {
  __typename?: 'UpdateMoneyManagerAutomationTargetSuccess';
  automationTargets: Array<Maybe<MoneyManagerAutomationTarget>>;
};

export type UpdateMoneyManagerSettingsFailure = {
  __typename?: 'UpdateMoneyManagerSettingsFailure';
  reason: Scalars['String']['output'];
};

export type UpdateMoneyManagerSettingsInput = {
  moneyManagerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  processRecurringDeposits?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMoneyManagerSettingsResult = UpdateMoneyManagerSettingsFailure | UpdateMoneyManagerSettingsSuccess;

export type UpdateMoneyManagerSettingsSuccess = {
  __typename?: 'UpdateMoneyManagerSettingsSuccess';
  settings?: Maybe<MoneyManagerSettings>;
};

export type UpdateMoneyRulesSourceSettingsFailure = {
  __typename?: 'UpdateMoneyRulesSourceSettingsFailure';
  reason: Scalars['String']['output'];
};

export type UpdateMoneyRulesSourceSettingsInput = {
  moneyManagerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  processRecurringDeposits?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMoneyRulesSourceSettingsResult = UpdateMoneyRulesSourceSettingsFailure | UpdateMoneyRulesSourceSettingsSuccess;

export type UpdateMoneyRulesSourceSettingsSuccess = {
  __typename?: 'UpdateMoneyRulesSourceSettingsSuccess';
  settings?: Maybe<MoneyRulesSettings>;
};

export type UpdateOauthAppInput = {
  accessTokenAudience?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accessTokenExpiry?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  externalApp?: InputMaybe<Scalars['Boolean']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiry?: InputMaybe<Scalars['Int']['input']>;
  scopeIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<OauthAppType>;
};

export type UpdateOauthAppResult = OauthApp | OauthAppNotFoundException;

/** Parameters needed to update a webhook to use for callbacks from Pinwheel jobs */
export type UpdatePinwheelWebhookInput = {
  /** The list of events to enable for this webhook */
  enabledEvents: Array<EnabledPinwheelEvent>;
  /** Status of the webhook */
  status: PinwheelWebhookStatus;
  /** Webhook ID */
  webhookId: Scalars['ID']['input'];
};

export type UpdatePinwheelWebhookPayload = {
  __typename?: 'UpdatePinwheelWebhookPayload';
  /** The webhook that was updated */
  updatedWebhook: PinwheelWebhook;
};

/** Parameters to update a Portfolio */
export type UpdatePortfolioInput = {
  /** Active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Color 1 */
  color1: Scalars['String']['input'];
  /** Color 2 */
  color2: Scalars['String']['input'];
  /** Description of the portfolio */
  description: Scalars['String']['input'];
  /** Funding Ratios */
  fundingRatiosAttributes: Array<FundingRatiosInput>;
  /** Growth rate average */
  growthRateAverage: Scalars['Float']['input'];
  /** Growth rate highest */
  growthRateHighest: Scalars['Float']['input'];
  /** Growth rate lowest */
  growthRateLowest: Scalars['Float']['input'];
  /** Portfolio ID */
  id: Scalars['ID']['input'];
  /** Name of the portfolio */
  name: Scalars['String']['input'];
  /** Portfolio Tag IDs */
  portfolioTagIds: Array<Scalars['ID']['input']>;
  /** Portfolio type */
  portfolioType: PortfolioTypeEnum;
  /** Position */
  position: Scalars['Int']['input'];
};

export type UpdatePromoCodeInput = {
  businessLine: PromoCodeBusinessLine;
  channel: Scalars['String']['input'];
  condensedTitle: Scalars['String']['input'];
  cursor: Scalars['String']['input'];
  description: Scalars['String']['input'];
  internalMemo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  publishEnd?: InputMaybe<Scalars['DateTime']['input']>;
  publishStart: Scalars['DateTime']['input'];
  qualificationAction: PromoCodeQualificationAction;
  qualificationAmount: Scalars['Int']['input'];
  rewards?: InputMaybe<Array<Scalars['ID']['input']>>;
  status: PromoCodeStatus;
  termsUrl?: InputMaybe<Scalars['URL']['input']>;
  title: Scalars['String']['input'];
};

export type UpdatePromoCodeResult = DuplicatePromoCodeError | PromoCode | PromoCodeFieldLengthError;

export type UpdatePromotedCampaignsInput = {
  campaignIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type UpdatePromotedCampaignsResult = PromotedCampaigns;

/** Response from recurring deposit settings update */
export type UpdateRecurringDepositSettingsResult = InvestmentAccountNotFoundException | RecurringDepositSettings;

export type UpdateReferralCampaignInput = {
  actionFeedDesc?: InputMaybe<Scalars['String']['input']>;
  background?: InputMaybe<CampaignBackgroundType>;
  condensedTitle?: InputMaybe<Scalars['String']['input']>;
  cursor: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  eligibilityEnd?: InputMaybe<Scalars['DateTime']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<CampaignIconType>;
  internalMemo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishEnd?: InputMaybe<Scalars['DateTime']['input']>;
  publishStart?: InputMaybe<Scalars['DateTime']['input']>;
  qualificationAction?: InputMaybe<CampaignQualificationActionType>;
  qualificationAmount?: InputMaybe<Scalars['Int']['input']>;
  rewards?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<CampaignStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReferralCampaignResult = ReferralCampaignV2;

export type UpdateReferralPayoutInput = {
  advocateOfferId?: InputMaybe<Scalars['String']['input']>;
  friendOfferId?: InputMaybe<Scalars['String']['input']>;
  payoutId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: ReferralPayoutStatus;
  statusChangeBy: Scalars['String']['input'];
};

export type UpdateReferralPayoutResult = ReferralPayout;

export type UpdateReferralRelationshipInput = {
  friendId: Scalars['ID']['input'];
  status: ReferralRelationshipStatus;
  /** Status of the referral relationship */
  statusDetails?: InputMaybe<ReferralStatusDetails>;
};

export type UpdateReferralRelationshipResult = ReferralRelationship;

/** Returned if failure updating reward */
export type UpdateReferralRewardError = {
  __typename?: 'UpdateReferralRewardError';
  message: Scalars['String']['output'];
};

export type UpdateReferralRewardResponse = ReferralRewardSummary | UpdateReferralRewardError;

export type UpdateScopeException = {
  __typename?: 'UpdateScopeException';
  message: Scalars['String']['output'];
};

export type UpdateScopeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScopeResult = Scope | UpdateScopeException;

export type UpdateSpendEligibilityInput = {
  isEligible: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateSpendEligibilityPayload = {
  __typename?: 'UpdateSpendEligibilityPayload';
  accountId: Scalars['ID']['output'];
  isEligible: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

/** Attributes for Updating Tracking Status */
export type UpdateTrackingStatusInput = {
  /** Card Reference ID */
  referenceId: Scalars['String']['input'];
  /** Status to update to */
  status: PackageStatus;
};

/** Response to a trusted contact update/insert */
export type UpdateTrustedContactResult = InternalErrorException | TrustedContact | TrustedContactAlreadyExistsException | TrustedContactInvalidEmail | TrustedContactInvalidPhoneNumber | TrustedContactNotFoundException;

/** Input type for updating user profile and automation target. */
export type UpdateUserProfileAndAutomationTargetInput = {
  /** The annual income of the user. */
  annualIncome: Scalars['Int']['input'];
};

/** Represents the result of the updateUserProfileAndAutomationTarget mutation, which can be either a success or an error. */
export type UpdateUserProfileAndAutomationTargetResult = UpdateUserProfileAndAutomationTargetSuccess;

/** Represents a successful update of user profile and automation target. */
export type UpdateUserProfileAndAutomationTargetSuccess = {
  __typename?: 'UpdateUserProfileAndAutomationTargetSuccess';
  /** The updated annual income of the user. */
  annualIncome: Scalars['Int']['output'];
  /** The newly updated automation targets of the user. */
  automationTargets: Array<MoneyManagerAutomationTarget>;
  /** The newly updated objective progress data. */
  cascadeObjectives: Array<MoneyManagerCascadeObjective>;
  /** The types of the updated automation targets. */
  updatedTargetTypes: Array<MoneyManagerAutomationTargetType>;
};

/** Subset of user profile fields. */
export type UpdateUserProfileInput = {
  /** User's phone number. */
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Backup withholding flag */
  subjectToBackupWithholding?: InputMaybe<Scalars['Boolean']['input']>;
  /** US citizenship of user. */
  usCitizen?: InputMaybe<Scalars['Boolean']['input']>;
  /** US residential status of user. */
  usResident?: InputMaybe<Scalars['Boolean']['input']>;
  /** User uuid for locating user. */
  userId: Scalars['ID']['input'];
};

/** Response from profile update */
export type UpdateUserProfileResponse = {
  __typename?: 'UpdateUserProfileResponse';
  phoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
  subjectToBackupWithholding?: Maybe<Scalars['Boolean']['output']>;
  usCitizen?: Maybe<Scalars['Boolean']['output']>;
  usResident?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['ID']['output'];
};

export type UpdateVerificationProfileResult = VerificationProfile;

export type UpgradeAuthenticationResult = AuthSession | AuthenticationAlreadyUpgradedException | UserCredentialsNotFoundException;

/** Input for uploading a user's bank document */
export type UploadBankDocumentInput = {
  /** Bank Account Type The Document is for */
  bankAccountType?: InputMaybe<BankAccountType>;
  /**
   * A base64-encoded representation of the actual content of the document.
   * NOTE: 1048576 bytes (1 MB) is the maximum file size. This limit applies to the raw, non-base64-encoded byte count.
   */
  contents: Scalars['String']['input'];
  /**
   * A caller-specified, user-friendly name for this document. Maximum length is 50 characters. Must have one of the following extensions:
   *  * .jpg
   *  * .jpeg
   *  * .gif
   *  * .png
   *  * .pdf
   */
  fileName: Scalars['String']['input'];
  /** The reason for uploading the document */
  reason: BankDocumentReason;
  /** The type of document */
  type: BankDocumentType;
  /** Acorns user ID */
  userId: Scalars['ID']['input'];
};

export type UploadBankDocumentPayload = {
  __typename?: 'UploadBankDocumentPayload';
  success: Scalars['Boolean']['output'];
};

/** Result of sending signature files to s3. */
export type UploadDebitSignatureFileResponse = {
  __typename?: 'UploadDebitSignatureFileResponse';
  userId: Scalars['ID']['output'];
};

/** Bundle of user id, document type, and upload url for use in requesting documents from backend */
export type UploadDocumentInput = {
  /** Base 64 encoded file to upload */
  document: Scalars['String']['input'];
  /** Document type to upload */
  documentType: DocumentTypeEnum;
  /** Name of file to upload */
  filename: Scalars['String']['input'];
  /** User id to request the documents from. */
  userId: Scalars['ID']['input'];
};

/** Response from document request */
export type UploadDocumentResponse = {
  __typename?: 'UploadDocumentResponse';
  fileUploaded: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

export enum UploadDocumentType {
  /** Proof of address */
  Address = 'address',
  /** Bank statement from the previous month */
  Currentbankstatement = 'currentbankstatement',
  /** Bank statement from upcoming month */
  Futurebankstatement = 'futurebankstatement',
  /** Valid ID such as a drivers license */
  Id = 'id',
  /** Any other document type */
  Miscellaneous = 'miscellaneous',
  /** SSN card */
  Ssn = 'ssn',
  /** Valid W9 from previous or current employer */
  W9 = 'w9'
}

export type UploadDocumentsInput = {
  documentRequestId: Scalars['ID']['input'];
  documentType: DocumentType;
  documents: Array<Scalars['Upload']['input']>;
  userId: Scalars['ID']['input'];
};

export type UploadFailedError = {
  __typename?: 'UploadFailedError';
  message: Scalars['String']['output'];
};

export type UploadOauthAppImageResult = InvalidContentTypeException | OauthAppImageUpload;

export type UploadUnsolicitedDocumentsInput = {
  documentType: DocumentType;
  documents: Array<Scalars['Upload']['input']>;
  /** Idempotency key for ensuring that duplicate requests are not made */
  requestKey?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentStatus>;
  userId: Scalars['ID']['input'];
};

export type UpsertBankExternalAccountData = {
  __typename?: 'UpsertBankExternalAccountData';
  /** Acorns' user id */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UpsertBankExternalAccountInput = {
  /** accountNumber to be linked as external account */
  accountNumber: Scalars['String']['input'];
  /**
   * linked subaccount or funding source ID Used on upsert to ensure the account is linked
   * within Acorns.
   */
  accountReferenceId: Scalars['String']['input'];
  /** routingNumber to be linked as external account */
  routingNumber: Scalars['String']['input'];
  /** Acorns' user id */
  userId: Scalars['ID']['input'];
};

/** General user information */
export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  /** Internal ID for user */
  id: Scalars['ID']['output'];
  identityVerificationResponses: Array<Maybe<IdentityVerificationResponse>>;
  /** Spend VIP */
  isSpendVip: Scalars['Boolean']['output'];
  /** Uploads */
  uploads: Array<Maybe<UserUpload>>;
  uuid: Scalars['ID']['output'];
};


/** General user information */
export type UserIdentityVerificationResponsesArgs = {
  result?: InputMaybe<Array<InputMaybe<IdentityVerificationResponseResult>>>;
};

/** Fetch agreements from user */
export type UserAgreement = {
  __typename?: 'UserAgreement';
  /** Information on the most recent required version of the relevant acceptance document */
  acceptanceDocument: AcceptanceDocument;
  /** Date of when the customer signed the given document */
  acceptedDate: Scalars['String']['output'];
  /** Timestamp of when the customer signed the given document */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Id of the given UserAgreement record */
  id: Scalars['Int']['output'];
  /** The version of the given document that the user signed on the associated created_at timestamp */
  versionSigned: Scalars['String']['output'];
};

/** A user alert. */
export type UserAlert = UserAlertsItem & {
  __typename?: 'UserAlert';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

export type UserAlertsItem = {
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

/** Response from user alert query */
export type UserAlertsResponse = AddressDocumentRequestedUserAlert | BankDocumentRequestedUserAlert | IdentityDocumentRequestedUserAlert | InsufficientFundsUserAlert | InvestmentsPausedUserAlert | MiscDocumentRequestedUserAlert | NoFundingSourceUserAlert | RdvRequiredUserAlert | SsnDocumentRequestedUserAlert | UserAlert | W9DocumentRequestedUserAlert;

/** User already flagged as suspicious */
export type UserAlreadyFlaggedAsSuspicious = {
  __typename?: 'UserAlreadyFlaggedAsSuspicious';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
  /** The provided user id */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** User is already flagged with this flag type */
export type UserAlreadyFlaggedException = {
  __typename?: 'UserAlreadyFlaggedException';
  /** provided user flag type */
  flagType: UserFlagType;
  /** provided user ID to be flagged */
  userId: Scalars['ID']['output'];
};

/** User is already suspended */
export type UserAlreadySuspendedException = {
  __typename?: 'UserAlreadySuspendedException';
  /** provided user ID to be suspended */
  userId: Scalars['ID']['output'];
};

/** Fetch breadcrumbs from user */
export type UserBreadcrumb = {
  __typename?: 'UserBreadcrumb';
  affectedUser?: Maybe<LegacyUser>;
  breadcrumbType?: Maybe<Scalars['String']['output']>;
  changedValues?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  loggableId?: Maybe<Scalars['ID']['output']>;
  loggableType?: Maybe<Scalars['String']['output']>;
  user?: Maybe<LegacyUser>;
};

/** An individual edge within the paginated list of UserBreadcrumbType */
export type UserBreadcrumbTypeEdge = {
  __typename?: 'UserBreadcrumbTypeEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID']['output'];
  /** The UserBreadcrumbType record in the edge */
  node: UserBreadcrumb;
};

/** Relay style pagination information for UserBreadcrumbType */
export type UserBreadcrumbTypePagination = {
  __typename?: 'UserBreadcrumbTypePagination';
  edges: Array<UserBreadcrumbTypeEdge>;
  pageInfo: PageInfo;
};

export type UserCardLockedSpendAlert = SpendAlert & {
  __typename?: 'UserCardLockedSpendAlert';
  type: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type UserCredentials = {
  __typename?: 'UserCredentials';
  identifier: Scalars['String']['output'];
  type: CredentialsType;
  userId: Scalars['ID']['output'];
};

export type UserCredentialsInput = {
  email: Scalars['EmailAddress']['input'];
};

export type UserCredentialsNotFoundException = {
  __typename?: 'UserCredentialsNotFoundException';
  message?: Maybe<Scalars['String']['output']>;
};

/** record of a user flag */
export type UserFlag = {
  __typename?: 'UserFlag';
  flagType: UserFlagType;
  flaggedAt: Scalars['DateTime']['output'];
  flaggedBy: Scalars['String']['output'];
};

/** This Flag does not exists */
export type UserFlagDoesNotExistsException = {
  __typename?: 'UserFlagDoesNotExistsException';
  /** provided user flag type */
  flagType: UserFlagType;
  /** provided user ID to be unflagged */
  userId: Scalars['ID']['output'];
};

export enum UserFlagType {
  Banking = 'BANKING',
  Suspicious = 'SUSPICIOUS',
  SystemSuspicious = 'SYSTEM_SUSPICIOUS'
}

export type UserHit = {
  __typename?: 'UserHit';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  ciy?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  registrationComplete?: Maybe<Scalars['Boolean']['output']>;
  registrationCompletedAt?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  usCitizen?: Maybe<Scalars['Boolean']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** A reopen check for an investment account reopen request. */
export type UserInvestmentAccountReopenCheck = TimestampsInterface & {
  __typename?: 'UserInvestmentAccountReopenCheck';
  /** The ID of the reopen request to which this check belongs. */
  accountReopenRequestId: Scalars['Int']['output'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** The UUID of the investment account for which this check was made. */
  investmentAccountId: Scalars['ID']['output'];
  /** A boolean indicating whether this check passed or failed.  */
  passed: Scalars['Boolean']['output'];
  /** The check type. */
  reopenCheckType: InvestmentAccountReopenCheck;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** UUID of the user to whom the account the reopen request was made for belongs. */
  userUuid: Scalars['ID']['output'];
};

/** Invitation information for a given user */
export type UserInvitation = {
  __typename?: 'UserInvitation';
  code?: Maybe<Scalars['String']['output']>;
};

export type UserLockedException = {
  __typename?: 'UserLockedException';
  message?: Maybe<Scalars['String']['output']>;
};

/** record of a user matching in an external system */
export type UserMatch = {
  __typename?: 'UserMatch';
  /** Id of user in external system */
  externalId: Scalars['ID']['output'];
  externalSource: ExternalUserSource;
  /** Acorns user id */
  id: Scalars['ID']['output'];
  matchedAt: Scalars['DateTime']['output'];
  matchedCriteria?: Maybe<Array<Scalars['String']['output']>>;
  matchedStatus: UserMatchStatus;
};

export enum UserMatchStatus {
  UserMatchStatusEligible = 'USER_MATCH_STATUS_ELIGIBLE',
  UserMatchStatusIneligibleCancelled = 'USER_MATCH_STATUS_INELIGIBLE_CANCELLED',
  UserMatchStatusIneligibleIncorrectTier = 'USER_MATCH_STATUS_INELIGIBLE_INCORRECT_TIER',
  UserMatchStatusInvalid = 'USER_MATCH_STATUS_INVALID'
}

/** User is not flagged as suspicious */
export type UserNotFlaggedAsSuspicious = {
  __typename?: 'UserNotFlaggedAsSuspicious';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
  /** The provided user id */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** No user was found for the ID provided */
export type UserNotFoundException = {
  __typename?: 'UserNotFoundException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
  /** The provided user id */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** The provided user is not suspended */
export type UserNotSuspendedError = {
  __typename?: 'UserNotSuspendedError';
  /** The provided user email */
  email?: Maybe<Scalars['String']['output']>;
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** User is not currently suspended */
export type UserNotSuspendedException = {
  __typename?: 'UserNotSuspendedException';
  /** provided user ID to be unsuspended */
  userId: Scalars['ID']['output'];
};

/** User must be verified to make an investment */
export type UserNotVerifiedException = {
  __typename?: 'UserNotVerifiedException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
};

/** A user note */
export type UserNote = TimestampsInterface & {
  __typename?: 'UserNote';
  body: Scalars['String']['output'];
  /** Category reference to admin */
  category?: Maybe<UserNoteCategories>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: LegacyUser;
  id: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  pinnedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export enum UserNoteCategories {
  Fraud = 'FRAUD',
  FundingSourcesRdv = 'FUNDING_SOURCES_RDV',
  General = 'GENERAL',
  Investments = 'INVESTMENTS',
  Suspension = 'SUSPENSION',
  Verification = 'VERIFICATION'
}

/** Fetch user performance calculations */
export type UserPerformanceResponse = {
  __typename?: 'UserPerformanceResponse';
  basePerformanceCalculator?: Maybe<PerformanceCalculation>;
  /** Allocation group performance */
  combinedPerformanceCalculator?: Maybe<PerformanceCalculation>;
  customPerformanceCalculator?: Maybe<PerformanceCalculation>;
  dailyPerformanceCalculator?: Maybe<PerformanceIntervalCalculation>;
  hasSelfDirected: Scalars['Boolean']['output'];
  previousPerformanceCalculator?: Maybe<PerformanceIntervalCalculation>;
};

/** Subset of user information for user referrer */
export type UserReferredBy = {
  __typename?: 'UserReferredBy';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type UserRiskProfile = {
  __typename?: 'UserRiskProfile';
  bankAccountCreateDateTime: Scalars['DateTime']['output'];
  bankDepositVoidCountLast60Days: Scalars['Int']['output'];
  bankDepositsCountLast90Days: Scalars['Int']['output'];
  bankDepositsTotalLast120Days: Scalars['BigDecimal']['output'];
  bankReturnAmountLast60Days: Scalars['BigDecimal']['output'];
  bankReturnAmountLast90Days: Scalars['BigDecimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  hasDirectDepositSetup: Scalars['Boolean']['output'];
  investBalance: Scalars['BigDecimal']['output'];
  investReturnAmountLast30Days: Scalars['BigDecimal']['output'];
  investReturnAmountLast90Days: Scalars['BigDecimal']['output'];
  lastBankDepositAmount: Scalars['BigDecimal']['output'];
  userUuid: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

/** Extra detailed attributes for source of user's arrival */
export type UserSourceAttributes = {
  __typename?: 'UserSourceAttributes';
  /** Carrier associated with user's source */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Tracking ID of partner/affiliate for Impact Radius referrals */
  clickid?: Maybe<Scalars['String']['output']>;
  /** Attribution code associated with user's source */
  code?: Maybe<Scalars['String']['output']>;
  /** Invitation code used for referral */
  referralCode?: Maybe<Scalars['String']['output']>;
  /** Source of user's arrival */
  s1?: Maybe<Scalars['String']['output']>;
  /** Partner/affiliate or campaign associated with referral */
  s2?: Maybe<Scalars['String']['output']>;
};

/** Describes a user state for all its direct deposit switches. */
export type UserState = {
  __typename?: 'UserState';
  /** Creation Date */
  createdAt: Scalars['String']['output'];
  /** Switch Method */
  switchMethod: Scalars['String']['output'];
  /** Switch State */
  switchState: Scalars['String']['output'];
  /** Last Updated Date */
  updatedAt: Scalars['String']['output'];
  /** User ID */
  userId: Scalars['ID']['output'];
};

/** Query attributes for User State */
export type UserStateInput = {
  /** User ID */
  userId: Scalars['ID']['input'];
};

/** Direct Deposit User State */
export type UserStatePayload = {
  __typename?: 'UserStatePayload';
  /** User State */
  userState?: Maybe<UserState>;
};

/** User is suspended */
export type UserSuspendedException = {
  __typename?: 'UserSuspendedException';
  /** message */
  message?: Maybe<Scalars['String']['output']>;
  suspendedToken?: Maybe<Scalars['String']['output']>;
  suspensionReasonValid?: Maybe<Scalars['Boolean']['output']>;
};

/** Upload url for suspended user */
export type UserSuspendedUploadTokenUrl = {
  __typename?: 'UserSuspendedUploadTokenUrl';
  email: Scalars['String']['output'];
  token: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** A user's suspension record */
export type UserSuspensionRecord = TimestampsInterface & {
  __typename?: 'UserSuspensionRecord';
  /** Date time the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Suspended at timestamp */
  suspendedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User ID of the Portal/Admin user that enacted the suspension */
  suspendedById?: Maybe<Scalars['String']['output']>;
  /** Provided suspension reason */
  suspensionReason?: Maybe<SuspensionReason>;
  /** Unsuspended at timestamp */
  unsuspendedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User ID of the Portal/Admin user that enacted the unsuspension */
  unsuspendedById?: Maybe<Scalars['String']['output']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User UUID */
  userId: Scalars['ID']['output'];
};

/** Result from suspending/unsuspending a user. */
export type UserSuspensionResult = LegacyUser | UserNotFoundException;

/** Describes a user request for a direct deposit switch. */
export type UserSwitch = {
  __typename?: 'UserSwitch';
  /** Creation Date */
  createdAt: Scalars['String']['output'];
  /** Switch ID */
  id: Scalars['ID']['output'];
  /** Indicates whether the user is already depositing on the Spend account or not. */
  isComplete: Scalars['Boolean']['output'];
  /** Status of the direct deposit switch. */
  status: SwitchStatus;
  /** Switch Type */
  switchType: SwitchType;
  /** Last Updated Date */
  updatedAt: Scalars['String']['output'];
  /** User ID */
  userId: Scalars['ID']['output'];
  /** Switch ID provided by the vendor. */
  vendorSwitchId?: Maybe<Scalars['ID']['output']>;
};

/** Query attributes for User Switches */
export type UserSwitchesInput = {
  /** Switch Type */
  switchType?: InputMaybe<SwitchType>;
  /** User ID */
  userId: Scalars['ID']['input'];
};

/** Direct Deposit User Switches */
export type UserSwitchesPayload = {
  __typename?: 'UserSwitchesPayload';
  /** User Switches */
  switches: Array<UserSwitch>;
};

export type UserToken = {
  __typename?: 'UserToken';
  consumedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  oauthAppClientId?: Maybe<Scalars['ID']['output']>;
  oauthAppId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  userScopes: Array<Maybe<Scalars['String']['output']>>;
  userTokenId: Scalars['ID']['output'];
};

/** A document upload from a user */
export type UserUpload = {
  __typename?: 'UserUpload';
  documentType: UploadDocumentType;
  /** Internal id or type */
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

/** Object representing an acorns user */
export type User_V2 = {
  __typename?: 'User_v2';
  closedAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  pageInput?: InputMaybe<UsersPageInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type UsersPageInfo = {
  __typename?: 'UsersPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
};

export type UsersPageInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersResponse = {
  __typename?: 'UsersResponse';
  pageInfo?: Maybe<UsersPageInfo>;
  users?: Maybe<Array<UserHit>>;
};

export type ValidPolicies = {
  __typename?: 'ValidPolicies';
  policies?: Maybe<Array<Maybe<Policy>>>;
};

export type ValidateCredentialsInput = {
  credentialsType?: CredentialsType;
  nativeLoginInput?: InputMaybe<NativeLoginInput>;
  oidcLoginInput?: InputMaybe<OidcLoginInput>;
  udid: Scalars['String']['input'];
};

export type ValidateCredentialsResult = AuthSession | DeviceBlockedException | InvalidCredentialsException | LoginRateLimitedException | OidcCredentialsNotFoundException | UserSuspendedException | ValidateCredentialsSuccess;

export type ValidateCredentialsSuccess = {
  __typename?: 'ValidateCredentialsSuccess';
  authenticators?: Maybe<Array<Authenticator>>;
  mfaToken: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type ValidateDocumentsInput = {
  /** Acorns subaccount for processing uploaded documents */
  product?: InputMaybe<IdentitySubaccount>;
  /** Token retrieved from the API response of the Document Request endpoint */
  transactionToken?: InputMaybe<Scalars['String']['input']>;
};

export type ValidatePasswordResetTokenResult = InvalidPasswordResetTokenException | ValidatePasswordResetTokenSuccess;

export type ValidatePasswordResetTokenSuccess = {
  __typename?: 'ValidatePasswordResetTokenSuccess';
  displaySsnField: Scalars['Boolean']['output'];
};

export type VendAuthSessionInput = {
  challengeAnswerInput: ChallengeAnswerInput;
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  udid: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type VendAuthSessionResult = AuthChallengeAnswerAttemptsExhaustedException | AuthChallengeAnswerIncorrectException | AuthChallengeExpiredException | AuthSession | ChallengeRateExceededException | DeviceBlockedException | UserSuspendedException;

export type VendorBillingInfo = {
  __typename?: 'VendorBillingInfo';
  accountType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
};

export type VendorCustomerAccount = {
  __typename?: 'VendorCustomerAccount';
  billTo?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  dunningCampaignId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  parentAccountId?: Maybe<Scalars['String']['output']>;
};

export type VendorIntegrationError = {
  __typename?: 'VendorIntegrationError';
  message: Scalars['String']['output'];
};

export type VendorRefundInvoiceError = {
  __typename?: 'VendorRefundInvoiceError';
  message: Scalars['String']['output'];
};

export type VerificationDetails = {
  __typename?: 'VerificationDetails';
  /**
   * This field indicates whether this KYC verification result is still valid and usable for the user today, regardless of its status (e.g., success, soft fail, hard fail).
   * When true, the banking KYC is either tied to an active account or part of an ongoing KYC process. When false, the user’s account may be closed or archived, making this KYC result no longer reusable.
   *
   * Per our current approved BANK guidelines, a new KYC verification must be initiated within banking if the user goes through a reopen process.
   */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type VerificationProfile = {
  __typename?: 'VerificationProfile';
  /** Session ID calculated by Socure */
  deviceSessionId?: Maybe<Scalars['String']['output']>;
  /** Status of submitted documents after initial identity verification */
  documentVerification?: Maybe<DocumentVerification>;
  /** SSN verification consent */
  eCBSV: Ecbsv;
  /**
   * Flag indicating whether eCBSV can be used or not for verification
   * @deprecated Use `eCBSV.consent` instead
   */
  eCBSVConsent: Scalars['Boolean']['output'];
  /** Customer's IP address used during registration */
  ipAddress?: Maybe<Scalars['String']['output']>;
};

export type VerificationProfileInput = {
  /** Session ID calculated by Socure */
  deviceSessionId?: InputMaybe<Scalars['String']['input']>;
  /** Customer's acceptance or declination of consent to utilize eCBSV */
  eCBSVConsent?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum VerificationStatus {
  ActionRequired = 'actionRequired',
  ActionRequiredDueToFailure = 'actionRequiredDueToFailure',
  Failure = 'failure',
  Pending = 'pending',
  Success = 'success'
}

/** Result from verificationUploads query */
export type VerificationUploadsResponse = {
  __typename?: 'VerificationUploadsResponse';
  createdAt: Scalars['DateTime']['output'];
  documentType: DocumentTypeEnum;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewer?: Maybe<LegacyUser>;
  uploader?: Maybe<LegacyUser>;
  url?: Maybe<Scalars['String']['output']>;
  /** Upload identifier */
  uuid: Scalars['ID']['output'];
};

/** Response to verifying a beneficiary's SSN */
export type VerifyBeneficiarySsnResult = BeneficiaryNotFoundException | InternalBeneficiary | InternalErrorException;

export type VerifyCheckPaymentRecipientAddressInputType = {
  recipient: CheckPaymentRecipientInput;
  recipientAddress: CheckPaymentAddressInput;
};

/** Address deliverable by mail carrier or InvalidAddressError */
export type VerifyCheckPaymentRecipientAddressResult = AuthorizationError | CheckPaymentRecipientAddressType | InvalidAddressError;

export type VerifyDeviceInput = {
  deviceId: Scalars['ID']['input'];
};

export type VerifyDeviceResult = DeviceNotFoundException | EmailAuthChallenge | SmsAuthChallenge;

export type VerifyIdentityByDocumentsResult = DocumentVerification;

export type VerifyPasswordsInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type VerifyPasswordsResult = IncorrectOldPasswordException | InvalidPasswordException | SamePasswordsException | UnauthorizedException | VerifyPasswordsSuccess;

export type VerifyPasswordsSuccess = {
  __typename?: 'VerifyPasswordsSuccess';
  isValid: Scalars['Boolean']['output'];
};

export type VerifyPromoCodeResponse = InvalidPromoCodeError | PromoCode;

/** Verify RDV input type. */
export type VerifyRdvInput = {
  /** UUID of the funding source. */
  fundingSourceId: Scalars['ID']['input'];
};

export type VersionMismatchException = {
  __typename?: 'VersionMismatchException';
  latestVersion?: Maybe<Scalars['ID']['output']>;
};

export type VoidBankTransactionsInput = {
  userIds: Array<Scalars['ID']['input']>;
};

export type VoidBankTransactionsPayload = {
  __typename?: 'VoidBankTransactionsPayload';
  requestId: Scalars['ID']['output'];
};

export type VoidBankTransactionsResult = VoidBankTransactionsPayload;

/** W9 document requested. */
export type W9DocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'W9DocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String']['output'];
  /** The user ID associated to the alert */
  userId: Scalars['ID']['output'];
};

export enum WaitingPreApprovalProvider {
  /** Idology Provider Filter */
  Idology = 'IDOLOGY',
  /** Socure Provider Filter */
  Socure = 'SOCURE',
  /** Veratad Provider Filter */
  Veratad = 'VERATAD'
}

/** result from attempting to create a provisional waiver for a user */
export type Waiver = MightyOakCardWaiver | PromotionalWaiver | ProvisionalWaiver;

export type WaiverCoupon = {
  __typename?: 'WaiverCoupon';
  couponId: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  discountType: Scalars['String']['output'];
  monthsToWaive: Scalars['Int']['output'];
  waiverType: Scalars['String']['output'];
};

export type WaiverCreationException = {
  __typename?: 'WaiverCreationException';
  message: Scalars['String']['output'];
};

export type WaiverDeletionException = {
  __typename?: 'WaiverDeletionException';
  message: Scalars['String']['output'];
};

/** The waiver end date is before the current day */
export type WaiverEndDateInPastError = {
  __typename?: 'WaiverEndDateInPastError';
  /** today's date string */
  today: Scalars['String']['output'];
  /** given waiver end date */
  waiverEndDate: Scalars['String']['output'];
};

/** Waiver not found */
export type WaiverNotFoundException = {
  __typename?: 'WaiverNotFoundException';
  /** message */
  message: Scalars['String']['output'];
};

export enum WaiverPromotion {
  /** Cricket Wireless Promotion */
  Cricket = 'CRICKET',
  /** Mighty Oak Card Promotion */
  MightyOakCard = 'MIGHTY_OAK_CARD'
}

export enum WaiverPromotion_V2 {
  Cricket = 'CRICKET',
  MightyOakCard = 'MIGHTY_OAK_CARD'
}

/** Withdrawal Investment Object */
export type Withdrawal = {
  __typename?: 'Withdrawal';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  presentableWithdrawalStatus: PresentableWithdrawalStatus;
};

export type WithholdingEstimates = {
  __typename?: 'WithholdingEstimates';
  /**  estimated amount that will be delivered to the customer */
  estimatedCustomerAmount: MonetaryAmount;
  /**  estimated total amount that will be withheld for federal taxes */
  estimatedFederalWithholdingAmount: MonetaryAmount;
  /**  estimated total amount that will be withheld for state taxes */
  estimatedStateWithholdingAmount: MonetaryAmount;
  /**  estimated earnings that will be taxed */
  estimatedTaxableEarnings: MonetaryAmount;
  /**  estimated total amount that will be withheld (state and federal) */
  estimatedTotalWithholdingAmount: MonetaryAmount;
};

export type YearLaterReport = {
  __typename?: 'YearLaterReport';
  accountBalance: Scalars['Float']['output'];
  accountCreationDate: Scalars['String']['output'];
  accountPerformance: Scalars['Float']['output'];
  accountType: Scalars['String']['output'];
  firstDepositAmountForYear?: Maybe<Scalars['Float']['output']>;
  firstDepositDateForYear?: Maybe<Scalars['String']['output']>;
  recurringContributionAmount: Scalars['Float']['output'];
  recurringContributionFrequency?: Maybe<InvestmentFrequency>;
  totalDeposits: Scalars['Float']['output'];
  totalDepositsForYear: Scalars['Float']['output'];
  totalDividends: Scalars['Float']['output'];
  totalNetReturns: Scalars['Float']['output'];
  totalWithdrawals: Scalars['Float']['output'];
  userAge: Scalars['Int']['output'];
};

export type _Service = {
  __typename?: '_Service';
  version: Scalars['String']['output'];
};

export type HelpcenterBannerResponse = HelpcenterBannerContent | HelpcenterBannerErrors;

export type Jobs_Article = {
  __typename?: 'jobs_Article';
  body: Scalars['String']['output'];
  cta?: Maybe<Cta>;
  eyebrow: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  title: Scalars['String']['output'];
};

export type Jobs_Education = {
  __typename?: 'jobs_Education';
  articles: Array<Jobs_Article>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type Jobs_Offer = {
  __typename?: 'jobs_Offer';
  /** Company logo or generic default */
  companyLogo: Image;
  /** Hiring company */
  companyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Relevant job industry */
  industryName?: Maybe<Scalars['String']['output']>;
  /** Job role */
  jobName: Scalars['String']['output'];
  /** Job location */
  location: JobLocation;
  /** Salary details */
  salary?: Maybe<Jobs_OfferSalary>;
  /** List of tags to display */
  tags: Array<Scalars['String']['output']>;
  /** Redirect URL for job posting */
  url: Scalars['URL']['output'];
};

/** Specifies a Job Offer Connection */
export type Jobs_OfferConnection = {
  __typename?: 'jobs_OfferConnection';
  edges: Array<Jobs_OfferEdge>;
  pageInfo: PageInfo;
};

/** Specifies a Job Offer Edge */
export type Jobs_OfferEdge = {
  __typename?: 'jobs_OfferEdge';
  cursor: Scalars['ID']['output'];
  node: Jobs_Offer;
};

export type Jobs_OfferSalary = {
  __typename?: 'jobs_OfferSalary';
  interval: SalaryInterval;
  maxValue: Scalars['Float']['output'];
  minValue: Scalars['Float']['output'];
};

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type ManagePayoutRelationshipInput = {
  action: ManagePayoutRelationshipAction;
  payoutId: Scalars['ID']['input'];
  relationshipId: Scalars['ID']['input'];
};

export enum ReferralStatusDetails {
  AcornsEmployee = 'ACORNS_EMPLOYEE',
  CampaignExpired = 'CAMPAIGN_EXPIRED',
  InactiveSubscription = 'INACTIVE_SUBSCRIPTION',
  InvestAccountClosed = 'INVEST_ACCOUNT_CLOSED',
  ManualPayout = 'MANUAL_PAYOUT',
  UserSuspened = 'USER_SUSPENED'
}

/** History Result */
export type Suitability_HistoryResult = {
  __typename?: 'suitability_HistoryResult';
  historyResult?: Maybe<Array<Suitability_SuitabilityResponseHistory>>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
};

/** Recommended portfolio for user based off their suitability responses */
export type Suitability_Portfolio = {
  __typename?: 'suitability_Portfolio';
  /** the portfolio description */
  description: Scalars['String']['output'];
  /** The portfolio ID */
  id: Scalars['ID']['output'];
  /** The portfolio name */
  name: Scalars['String']['output'];
};

/** Possible answer for a suitability question */
export type Suitability_SuitabilityAnswer = {
  __typename?: 'suitability_SuitabilityAnswer';
  /** Human readable text to display a description to an answer */
  description?: Maybe<Scalars['String']['output']>;
  /** Internal ID for a suitability answer */
  id: Scalars['ID']['output'];
  /** Value for clients to use to fetch strings */
  key: Scalars['String']['output'];
  /** Summary of an answer used for displaying why a portfolio was recommended */
  summary?: Maybe<Scalars['String']['output']>;
  /** Human readable text to display an answer to a suitability question */
  text: Scalars['String']['output'];
};

/** Suitability question asked for recommending portfolios */
export type Suitability_SuitabilityQuestion = {
  __typename?: 'suitability_SuitabilityQuestion';
  /** Default answer to the related suitability question */
  defaultAnswer?: Maybe<Suitability_SuitabilityAnswer>;
  /** Internal ID for a suitability question */
  id: Scalars['ID']['output'];
  /** Value for clients to use to fetch strings */
  key: Scalars['String']['output'];
  /** Possible answers to be selected for the related question */
  possibleAnswers: Array<Suitability_SuitabilityAnswer>;
  /** Human readable text to display the suitability question */
  text: Scalars['String']['output'];
};

/** A given user's suitability response for each question and answer */
export type Suitability_SuitabilityResponse = {
  __typename?: 'suitability_SuitabilityResponse';
  /** Associated answer to the suitability question */
  answer?: Maybe<Suitability_SuitabilityAnswer>;
  /** Default answer to the related suitability question */
  question: Suitability_SuitabilityQuestion;
};

/** History Result */
export type Suitability_SuitabilityResponseHistory = {
  __typename?: 'suitability_SuitabilityResponseHistory';
  /** Whether or not the suitability was changed by an admin */
  changedByAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** The portfolio that was recommended based on their suitability responses */
  recommendedPortfolio?: Maybe<Suitability_Portfolio>;
  /** The question and answer pairs for an update */
  responses?: Maybe<Array<Suitability_SuitabilityResponse>>;
  /** The score based on their suitability responses */
  score?: Maybe<Scalars['Float']['output']>;
  /** The timestamp of the suitability update */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type UploadAudienceListInput = {
  cohortName: Scalars['String']['input'];
};

export type UserWinbackErrors = {
  __typename?: 'userWinbackErrors';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UserWinbackScore = {
  __typename?: 'userWinbackScore';
  churnProbability?: Maybe<Scalars['Float']['output']>;
  predictedRevenue?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserWinbackScoreRes = UserWinbackErrors | UserWinbackScore;
